const xSmall = "2";
const small = "4";
const medium$1 = "8";
const large = "16";
const xl$2 = "24";
const xxl$2 = "32";
const pill = "25000";
const custom_1$3 = "12";
const custom_2$3 = "48";
const custom_3$2 = "250";
const borderRadius = {
	xSmall: xSmall,
	small: small,
	medium: medium$1,
	large: large,
	xl: xl$2,
	xxl: xxl$2,
	pill: pill,
	custom_1: custom_1$3,
	custom_2: custom_2$3,
	custom_3: custom_3$2
};

const border_none = "0";
const border_thin = "1";
const border_normal = "2";
const border_thick = "3";
const border_focus = "4";
const borderWidth = {
	border_none: border_none,
	border_thin: border_thin,
	border_normal: border_normal,
	border_thick: border_thick,
	border_focus: border_focus
};

const primary20 = "{color.$mode.$primary.20}";
const primary30 = "{color.$mode.$primary.30}";
const primary40 = "{color.$mode.$primary.40}";
const primary50 = "{color.$mode.$primary.50}";
const primary60 = "{color.$mode.$primary.60}";
const primary70 = "{color.$mode.$primary.70}";
const primary80 = "{color.$mode.$primary.80}";
const primaryInverse = "{color.$mode.$primary.inverse}";
const primaryBackground = "{color.$mode.$primary.background}";
const primaryGrey100 = "{color.$mode.$primary.grey.100}";
const primaryGrey80 = "{color.$mode.$primary.grey.80}";
const primaryGrey60 = "{color.$mode.$primary.grey.60}";
const primaryGrey40 = "{color.$mode.$primary.grey.40}";
const primaryGrey20 = "{color.$mode.$primary.grey.20}";
const secondary20 = "{color.$mode.$secondary.20}";
const secondary30 = "{color.$mode.$secondary.30}";
const secondary40 = "{color.$mode.$secondary.40}";
const secondary50 = "{color.$mode.$secondary.50}";
const secondary60 = "{color.$mode.$secondary.60}";
const secondary70 = "{color.$mode.$secondary.70}";
const secondary80 = "{color.$mode.$secondary.80}";
const secondaryInverse = "{color.$mode.$secondary.inverse}";
const secondaryBackground = "{color.$mode.$secondary.background}";
const secondaryGrey100 = "{color.$mode.$secondary.grey.100}";
const secondaryGrey80 = "{color.$mode.$secondary.grey.80}";
const secondaryGrey60 = "{color.$mode.$secondary.grey.60}";
const secondaryGrey40 = "{color.$mode.$secondary.grey.40}";
const secondaryGrey20 = "{color.$mode.$secondary.grey.20}";
const sparkle20 = "{color.$mode.$sparkle.20}";
const sparkle30 = "{color.$mode.$sparkle.30}";
const sparkle40 = "{color.$mode.$sparkle.40}";
const sparkle50 = "{color.$mode.$sparkle.50}";
const sparkle60 = "{color.$mode.$sparkle.60}";
const sparkle70 = "{color.$mode.$sparkle.70}";
const sparkle80 = "{color.$mode.$sparkle.80}";
const sparkleInverse = "{color.$mode.$sparkle.inverse}";
const sparkleBackground = "{color.$mode.$sparkle.background}";
const sparkleGrey100 = "{color.$mode.$sparkle.grey.100}";
const sparkleGrey80 = "{color.$mode.$sparkle.grey.80}";
const sparkleGrey60 = "{color.$mode.$sparkle.grey.60}";
const sparkleGrey40 = "{color.$mode.$sparkle.grey.40}";
const sparkleGrey20 = "{color.$mode.$sparkle.grey.20}";
const feedbackError80 = "{color.$mode.feedback.error.80}";
const feedbackError50 = "{color.$mode.feedback.error.50}";
const feedbackError20 = "{color.$mode.feedback.error.20}";
const feedbackWarning80 = "{color.$mode.feedback.warning.80}";
const feedbackWarning50 = "{color.$mode.feedback.warning.50}";
const feedbackWarning20 = "{color.$mode.feedback.warning.20}";
const feedbackSuccess80 = "{color.$mode.feedback.success.80}";
const feedbackSuccess50 = "{color.$mode.feedback.success.50}";
const feedbackSuccess20 = "{color.$mode.feedback.success.20}";
const elevation1 = "{elevation1.$mode}";
const custom_color_1 = "";
const custom_color_2 = "#75757580";
const custom_color_3 = "#000000D9";
const custom_color_4 = "#75757580";
const custom_color_5 = "#00000029";
const custom_color_6 = "#14151775";
const custom_dark_primary_40 = "{color.dark.$primary.40}";
const custom_dark_primary_60 = "{color.dark.$primary.60}";
const custom_dark_primary_grey_80 = "{color.dark.$primary.grey.80}";
const custom_dark_primary_grey_100 = "{color.dark.$primary.grey.100}";
const color = {
	primary20: primary20,
	primary30: primary30,
	primary40: primary40,
	primary50: primary50,
	primary60: primary60,
	primary70: primary70,
	primary80: primary80,
	primaryInverse: primaryInverse,
	primaryBackground: primaryBackground,
	primaryGrey100: primaryGrey100,
	primaryGrey80: primaryGrey80,
	primaryGrey60: primaryGrey60,
	primaryGrey40: primaryGrey40,
	primaryGrey20: primaryGrey20,
	secondary20: secondary20,
	secondary30: secondary30,
	secondary40: secondary40,
	secondary50: secondary50,
	secondary60: secondary60,
	secondary70: secondary70,
	secondary80: secondary80,
	secondaryInverse: secondaryInverse,
	secondaryBackground: secondaryBackground,
	secondaryGrey100: secondaryGrey100,
	secondaryGrey80: secondaryGrey80,
	secondaryGrey60: secondaryGrey60,
	secondaryGrey40: secondaryGrey40,
	secondaryGrey20: secondaryGrey20,
	sparkle20: sparkle20,
	sparkle30: sparkle30,
	sparkle40: sparkle40,
	sparkle50: sparkle50,
	sparkle60: sparkle60,
	sparkle70: sparkle70,
	sparkle80: sparkle80,
	sparkleInverse: sparkleInverse,
	sparkleBackground: sparkleBackground,
	sparkleGrey100: sparkleGrey100,
	sparkleGrey80: sparkleGrey80,
	sparkleGrey60: sparkleGrey60,
	sparkleGrey40: sparkleGrey40,
	sparkleGrey20: sparkleGrey20,
	"global.white": "{color.$mode.white}",
	"global.black": "{color.$mode.black}",
	"global.transparent": "transparent",
	feedbackError80: feedbackError80,
	feedbackError50: feedbackError50,
	feedbackError20: feedbackError20,
	feedbackWarning80: feedbackWarning80,
	feedbackWarning50: feedbackWarning50,
	feedbackWarning20: feedbackWarning20,
	feedbackSuccess80: feedbackSuccess80,
	feedbackSuccess50: feedbackSuccess50,
	feedbackSuccess20: feedbackSuccess20,
	"color.bold.crimson_midnight.20": "#f98ba133",
	"color.bold.crimson_midnight.30": "#f98ba166",
	"color.bold.crimson_midnight.40": "#f98ba199",
	"color.bold.crimson_midnight.50": "#f98ba1ff",
	"color.bold.crimson_midnight.60": "#fbb7c0ff",
	"color.bold.crimson_midnight.70": "#fdd2d8ff",
	"color.bold.crimson_midnight.80": "#feecefff",
	"color.bold.crimson_midnight.inverse": "#38000cff",
	"color.bold.crimson_midnight.background": "#700017ff",
	"color.bold.crimson_midnight.grey.100": "#ffffffff",
	"color.bold.crimson_midnight.grey.80": "#ffffffc7",
	"color.bold.crimson_midnight.grey.60": "#ffffff87",
	"color.bold.crimson_midnight.grey.40": "#ffffff4f",
	"color.bold.crimson_midnight.grey.20": "#ffffff1f",
	"color.dark.crimson_midnight.20": "#3a0611ff",
	"color.dark.crimson_midnight.30": "#600a1cff",
	"color.dark.crimson_midnight.40": "#870f28ff",
	"color.dark.crimson_midnight.50": "#c11539ff",
	"color.dark.crimson_midnight.60": "#d45b74ff",
	"color.dark.crimson_midnight.70": "#e396a6ff",
	"color.dark.crimson_midnight.80": "#f3d0d7ff",
	"color.dark.crimson_midnight.inverse": "#ffffffff",
	"color.dark.crimson_midnight.background": "#141414ff",
	"color.dark.crimson_midnight.grey.100": "#ffffffff",
	"color.dark.crimson_midnight.grey.80": "#ffffffc7",
	"color.dark.crimson_midnight.grey.60": "#a1a1a1ff",
	"color.dark.crimson_midnight.grey.40": "#5a5a5aff",
	"color.dark.crimson_midnight.grey.20": "#2b2b2bff",
	"color.light.crimson_midnight.20": "#f7e5e9ff",
	"color.light.crimson_midnight.30": "#f98ba1ff",
	"color.light.crimson_midnight.40": "#aa0023ff",
	"color.light.crimson_midnight.50": "#700017ff",
	"color.light.crimson_midnight.60": "#4e0010ff",
	"color.light.crimson_midnight.70": "#38000cff",
	"color.light.crimson_midnight.80": "#220007ff",
	"color.light.crimson_midnight.inverse": "#ffffffff",
	"color.light.crimson_midnight.background": "#ffffffff",
	"color.light.crimson_midnight.grey.100": "#141414ff",
	"color.light.crimson_midnight.grey.80": "#000000a6",
	"color.light.crimson_midnight.grey.60": "#b5b5b5ff",
	"color.light.crimson_midnight.grey.40": "#e0e0e0ff",
	"color.light.crimson_midnight.grey.20": "#f5f5f5ff",
	"color.bold.crimson.20": "#f98ba133",
	"color.bold.crimson.30": "#f98ba166",
	"color.bold.crimson.40": "#f98ba199",
	"color.bold.crimson.50": "#f98ba1ff",
	"color.bold.crimson.60": "#fbc0cbff",
	"color.bold.crimson.70": "#fddae1ff",
	"color.bold.crimson.80": "#feedf0ff",
	"color.bold.crimson.inverse": "#4d0010ff",
	"color.bold.crimson.background": "#aa0023ff",
	"color.bold.crimson.grey.100": "#ffffffff",
	"color.bold.crimson.grey.80": "#ffffffc7",
	"color.bold.crimson.grey.60": "#ffffff87",
	"color.bold.crimson.grey.40": "#ffffff4f",
	"color.bold.crimson.grey.20": "#ffffff1f",
	"color.dark.crimson.20": "#3a0611ff",
	"color.dark.crimson.30": "#600a1cff",
	"color.dark.crimson.40": "#870f28ff",
	"color.dark.crimson.50": "#c11539ff",
	"color.dark.crimson.60": "#d45b74ff",
	"color.dark.crimson.70": "#e396a6ff",
	"color.dark.crimson.80": "#f3d0d7ff",
	"color.dark.crimson.inverse": "#ffffffff",
	"color.dark.crimson.background": "#141414ff",
	"color.dark.crimson.grey.100": "#ffffffff",
	"color.dark.crimson.grey.80": "#ffffffc7",
	"color.dark.crimson.grey.60": "#a1a1a1ff",
	"color.dark.crimson.grey.40": "#5a5a5aff",
	"color.dark.crimson.grey.20": "#2b2b2bff",
	"color.light.crimson.20": "#f7e5e9ff",
	"color.light.crimson.30": "#f98ba1ff",
	"color.light.crimson.40": "#ed617fff",
	"color.light.crimson.50": "#aa0023ff",
	"color.light.crimson.60": "#700017ff",
	"color.light.crimson.70": "#4d0010ff",
	"color.light.crimson.80": "#2a0009ff",
	"color.light.crimson.inverse": "#ffffffff",
	"color.light.crimson.background": "#ffffffff",
	"color.light.crimson.grey.100": "#141414ff",
	"color.light.crimson.grey.80": "#000000a6",
	"color.light.crimson.grey.60": "#b5b5b5ff",
	"color.light.crimson.grey.40": "#e0e0e0ff",
	"color.light.crimson.grey.20": "#f5f5f5ff",
	"color.bold.green_midnight.20": "#94f6c533",
	"color.bold.green_midnight.30": "#94f6c566",
	"color.bold.green_midnight.40": "#94f6c599",
	"color.bold.green_midnight.50": "#94f6c5ff",
	"color.bold.green_midnight.60": "#c5fadfff",
	"color.bold.green_midnight.70": "#dcfcebff",
	"color.bold.green_midnight.80": "#f3fef8ff",
	"color.bold.green_midnight.inverse": "#013a1eff",
	"color.bold.green_midnight.background": "#03753cff",
	"color.bold.green_midnight.grey.100": "#ffffffff",
	"color.bold.green_midnight.grey.80": "#ffffffd4",
	"color.bold.green_midnight.grey.60": "#ffffff87",
	"color.bold.green_midnight.grey.40": "#ffffff4f",
	"color.bold.green_midnight.grey.20": "#ffffff1f",
	"color.dark.green_midnight.20": "#06371fff",
	"color.dark.green_midnight.30": "#0a5c33ff",
	"color.dark.green_midnight.40": "#0e8147ff",
	"color.dark.green_midnight.50": "#14b866ff",
	"color.dark.green_midnight.60": "#5acd94ff",
	"color.dark.green_midnight.70": "#95dfbaff",
	"color.dark.green_midnight.80": "#d0f1e0ff",
	"color.dark.green_midnight.inverse": "#06371fff",
	"color.dark.green_midnight.background": "#141414ff",
	"color.dark.green_midnight.grey.100": "#ffffffff",
	"color.dark.green_midnight.grey.80": "#ffffffc7",
	"color.dark.green_midnight.grey.60": "#a1a1a1ff",
	"color.dark.green_midnight.grey.40": "#5a5a5aff",
	"color.dark.green_midnight.grey.20": "#2b2b2bff",
	"color.light.green_midnight.20": "#e5f7eeff",
	"color.light.green_midnight.30": "#94f6c5ff",
	"color.light.green_midnight.40": "#00b259ff",
	"color.light.green_midnight.50": "#03753cff",
	"color.light.green_midnight.60": "#02522aff",
	"color.light.green_midnight.70": "#013a1eff",
	"color.light.green_midnight.80": "#012312ff",
	"color.light.green_midnight.inverse": "#ffffffff",
	"color.light.green_midnight.background": "#ffffffff",
	"color.light.green_midnight.grey.100": "#141414ff",
	"color.light.green_midnight.grey.80": "#000000a6",
	"color.light.green_midnight.grey.60": "#b5b5b5ff",
	"color.light.green_midnight.grey.40": "#e0e0e0ff",
	"color.light.green_midnight.grey.20": "#f5f5f5ff",
	"color.bold.green.20": "#00502833",
	"color.bold.green.30": "#00502866",
	"color.bold.green.40": "#00502899",
	"color.bold.green.50": "#005028ff",
	"color.bold.green.60": "#003b1dff",
	"color.bold.green.70": "#002613ff",
	"color.bold.green.80": "#00170cff",
	"color.bold.green.inverse": "#e5f7eeff",
	"color.bold.green.background": "#00b259ff",
	"color.bold.green.grey.100": "#002d16ff",
	"color.bold.green.grey.80": "#002d16e3",
	"color.bold.green.grey.60": "#002d1687",
	"color.bold.green.grey.40": "#002d164d",
	"color.bold.green.grey.20": "#002d161f",
	"color.dark.green.20": "#06371fff",
	"color.dark.green.30": "#0a5c33ff",
	"color.dark.green.40": "#0e8147ff",
	"color.dark.green.50": "#14b866ff",
	"color.dark.green.60": "#5acd94ff",
	"color.dark.green.70": "#95dfbaff",
	"color.dark.green.80": "#d0f1e0ff",
	"color.dark.green.inverse": "#06371fff",
	"color.dark.green.background": "#141414ff",
	"color.dark.green.grey.100": "#ffffffff",
	"color.dark.green.grey.80": "#ffffffc7",
	"color.dark.green.grey.60": "#a1a1a1ff",
	"color.dark.green.grey.40": "#5a5a5aff",
	"color.dark.green.grey.20": "#2b2b2bff",
	"color.light.green.20": "#e5f7eeff",
	"color.light.green.30": "#94f6c5ff",
	"color.light.green.40": "#10d974ff",
	"color.light.green.50": "#00b259ff",
	"color.light.green.60": "#03753cff",
	"color.light.green.70": "#005028ff",
	"color.light.green.80": "#002d16ff",
	"color.light.green.inverse": "#002d16ff",
	"color.light.green.background": "#ffffffff",
	"color.light.green.grey.100": "#141414ff",
	"color.light.green.grey.80": "#000000a6",
	"color.light.green.grey.60": "#b5b5b5ff",
	"color.light.green.grey.40": "#e0e0e0ff",
	"color.light.green.grey.20": "#f5f5f5ff",
	"color.bold.marigold_midnight.20": "#ffe3ae33",
	"color.bold.marigold_midnight.30": "#ffe3ae66",
	"color.bold.marigold_midnight.40": "#ffe3ae99",
	"color.bold.marigold_midnight.50": "#ffe3aeff",
	"color.bold.marigold_midnight.60": "#ffffffff",
	"color.bold.marigold_midnight.70": "#ffffffff",
	"color.bold.marigold_midnight.80": "#ffffffff",
	"color.bold.marigold_midnight.inverse": "#401d0cff",
	"color.bold.marigold_midnight.background": "#ac660cff",
	"color.bold.marigold_midnight.grey.100": "#ffffffff",
	"color.bold.marigold_midnight.grey.80": "#ffffffff",
	"color.bold.marigold_midnight.grey.60": "#ffffff87",
	"color.bold.marigold_midnight.grey.40": "#ffffff4f",
	"color.bold.marigold_midnight.grey.20": "#ffffff1f",
	"color.dark.marigold_midnight.20": "#3c2e16ff",
	"color.dark.marigold_midnight.30": "#675228ff",
	"color.dark.marigold_midnight.40": "#8d713aff",
	"color.dark.marigold_midnight.50": "#f9be53ff",
	"color.dark.marigold_midnight.60": "#fbd187ff",
	"color.dark.marigold_midnight.70": "#fce2b2ff",
	"color.dark.marigold_midnight.80": "#fef2ddff",
	"color.dark.marigold_midnight.inverse": "#3c2e16ff",
	"color.dark.marigold_midnight.background": "#141414ff",
	"color.dark.marigold_midnight.grey.100": "#ffffffff",
	"color.dark.marigold_midnight.grey.80": "#ffffffc7",
	"color.dark.marigold_midnight.grey.60": "#a1a1a1ff",
	"color.dark.marigold_midnight.grey.40": "#5a5a5aff",
	"color.dark.marigold_midnight.grey.20": "#2b2b2bff",
	"color.light.marigold_midnight.20": "#fef7e9ff",
	"color.light.marigold_midnight.30": "#ffe3aeff",
	"color.light.marigold_midnight.40": "#ffd947ff",
	"color.light.marigold_midnight.50": "#ac660cff",
	"color.light.marigold_midnight.60": "#7f4b10ff",
	"color.light.marigold_midnight.70": "#401d0cff",
	"color.light.marigold_midnight.80": "#341709ff",
	"color.light.marigold_midnight.inverse": "#ffffffff",
	"color.light.marigold_midnight.background": "#ffffffff",
	"color.light.marigold_midnight.grey.100": "#141414ff",
	"color.light.marigold_midnight.grey.80": "#000000a6",
	"color.light.marigold_midnight.grey.60": "#b5b5b5ff",
	"color.light.marigold_midnight.grey.40": "#e0e0e0ff",
	"color.light.marigold_midnight.grey.20": "#f5f5f5ff",
	"color.bold.marigold.20": "#92551b33",
	"color.bold.marigold.30": "#92551b66",
	"color.bold.marigold.40": "#92551b99",
	"color.bold.marigold.50": "#8a3200ff",
	"color.bold.marigold.60": "#5e2200ff",
	"color.bold.marigold.70": "#3d1600ff",
	"color.bold.marigold.80": "#2e1100ff",
	"color.bold.marigold.inverse": "#fef7e9ff",
	"color.bold.marigold.background": "#f7ab20ff",
	"color.bold.marigold.grey.100": "#401d0cff",
	"color.bold.marigold.grey.80": "#401d0cc7",
	"color.bold.marigold.grey.60": "#401d0c87",
	"color.bold.marigold.grey.40": "#401d0c4d",
	"color.bold.marigold.grey.20": "#401d0c1f",
	"color.dark.marigold.20": "#3c2e16ff",
	"color.dark.marigold.30": "#675228ff",
	"color.dark.marigold.40": "#8d713aff",
	"color.dark.marigold.50": "#f9be53ff",
	"color.dark.marigold.60": "#fbd187ff",
	"color.dark.marigold.70": "#fce2b2ff",
	"color.dark.marigold.80": "#fef2ddff",
	"color.dark.marigold.inverse": "#3c2e16ff",
	"color.dark.marigold.background": "#141414ff",
	"color.dark.marigold.grey.100": "#ffffffff",
	"color.dark.marigold.grey.80": "#ffffffc7",
	"color.dark.marigold.grey.60": "#a1a1a1ff",
	"color.dark.marigold.grey.40": "#5a5a5aff",
	"color.dark.marigold.grey.20": "#2b2b2bff",
	"color.light.marigold.20": "#fef7e9ff",
	"color.light.marigold.30": "#ffe3aeff",
	"color.light.marigold.40": "#ffd947ff",
	"color.light.marigold.50": "#f7ab20ff",
	"color.light.marigold.60": "#ac660cff",
	"color.light.marigold.70": "#7f4b10ff",
	"color.light.marigold.80": "#401d0cff",
	"color.light.marigold.inverse": "#401d0cff",
	"color.light.marigold.background": "#ffffffff",
	"color.light.marigold.grey.100": "#141414ff",
	"color.light.marigold.grey.80": "#000000a6",
	"color.light.marigold.grey.60": "#b5b5b5ff",
	"color.light.marigold.grey.40": "#e0e0e0ff",
	"color.light.marigold.grey.20": "#f5f5f5ff",
	"color.bold.mint_midnight.20": "#a7f6e933",
	"color.bold.mint_midnight.30": "#a7f6e966",
	"color.bold.mint_midnight.40": "#a7f6e999",
	"color.bold.mint_midnight.50": "#a7f6e9ff",
	"color.bold.mint_midnight.60": "#c9f9f1ff",
	"color.bold.mint_midnight.70": "#e0fcf7ff",
	"color.bold.mint_midnight.80": "#f3fefcff",
	"color.bold.mint_midnight.inverse": "#0f3e3aff",
	"color.bold.mint_midnight.background": "#1e7b74ff",
	"color.bold.mint_midnight.grey.100": "#ffffffff",
	"color.bold.mint_midnight.grey.80": "#ffffffe8",
	"color.bold.mint_midnight.grey.60": "#ffffff87",
	"color.bold.mint_midnight.grey.40": "#ffffff4f",
	"color.bold.mint_midnight.grey.20": "#ffffff1f",
	"color.dark.mint_midnight.20": "#1a413bff",
	"color.dark.mint_midnight.30": "#245a51ff",
	"color.dark.mint_midnight.40": "#348376ff",
	"color.dark.mint_midnight.50": "#58dac5ff",
	"color.dark.mint_midnight.60": "#8ae5d6ff",
	"color.dark.mint_midnight.70": "#b4eee5ff",
	"color.dark.mint_midnight.80": "#def8f3ff",
	"color.dark.mint_midnight.inverse": "#1a413bff",
	"color.dark.mint_midnight.background": "#141414ff",
	"color.dark.mint_midnight.grey.100": "#ffffffff",
	"color.dark.mint_midnight.grey.80": "#ffffffc7",
	"color.dark.mint_midnight.grey.60": "#a1a1a1ff",
	"color.dark.mint_midnight.grey.40": "#5a5a5aff",
	"color.dark.mint_midnight.grey.20": "#2b2b2bff",
	"color.light.mint_midnight.20": "#e8faf7ff",
	"color.light.mint_midnight.30": "#a7f6e9ff",
	"color.light.mint_midnight.40": "#1eccb0ff",
	"color.light.mint_midnight.50": "#1e7b74ff",
	"color.light.mint_midnight.60": "#155651ff",
	"color.light.mint_midnight.70": "#0f3e3aff",
	"color.light.mint_midnight.80": "#092523ff",
	"color.light.mint_midnight.inverse": "#ffffffff",
	"color.light.mint_midnight.background": "#ffffffff",
	"color.light.mint_midnight.grey.100": "#141414ff",
	"color.light.mint_midnight.grey.80": "#000000a6",
	"color.light.mint_midnight.grey.60": "#b5b5b5ff",
	"color.light.mint_midnight.grey.40": "#e0e0e0ff",
	"color.light.mint_midnight.grey.20": "#f5f5f5ff",
	"color.bold.mint.20": "#0e5c4f33",
	"color.bold.mint.30": "#0e5c4f66",
	"color.bold.mint.40": "#0e5c4f99",
	"color.bold.mint.50": "#0e5c4fff",
	"color.bold.mint.60": "#0a493fff",
	"color.bold.mint.70": "#07362eff",
	"color.bold.mint.80": "#052923ff",
	"color.bold.mint.inverse": "#e8faf7ff",
	"color.bold.mint.background": "#1eccb0ff",
	"color.bold.mint.grey.100": "#08332cff",
	"color.bold.mint.grey.80": "#08332ccf",
	"color.bold.mint.grey.60": "#08332c87",
	"color.bold.mint.grey.40": "#08332c4d",
	"color.bold.mint.grey.20": "#08332c1f",
	"color.dark.mint.20": "#1a413bff",
	"color.dark.mint.30": "#245a51ff",
	"color.dark.mint.40": "#348376ff",
	"color.dark.mint.50": "#58dac5ff",
	"color.dark.mint.60": "#8ae5d6ff",
	"color.dark.mint.70": "#b4eee5ff",
	"color.dark.mint.80": "#def8f3ff",
	"color.dark.mint.inverse": "#1a413bff",
	"color.dark.mint.background": "#141414ff",
	"color.dark.mint.grey.100": "#ffffffff",
	"color.dark.mint.grey.80": "#ffffffc7",
	"color.dark.mint.grey.60": "#a1a1a1ff",
	"color.dark.mint.grey.40": "#5a5a5aff",
	"color.dark.mint.grey.20": "#2b2b2bff",
	"color.light.mint.20": "#e8faf7ff",
	"color.light.mint.30": "#a7f6e9ff",
	"color.light.mint.40": "#7aebd9ff",
	"color.light.mint.50": "#1eccb0ff",
	"color.light.mint.60": "#1e7b74ff",
	"color.light.mint.70": "#0e5c4fff",
	"color.light.mint.80": "#08332cff",
	"color.light.mint.inverse": "#08332cff",
	"color.light.mint.background": "#ffffffff",
	"color.light.mint.grey.100": "#141414ff",
	"color.light.mint.grey.80": "#000000a6",
	"color.light.mint.grey.60": "#b5b5b5ff",
	"color.light.mint.grey.40": "#e0e0e0ff",
	"color.light.mint.grey.20": "#f5f5f5ff",
	"color.bold.navi_midnight.20": "#9999ff33",
	"color.bold.navi_midnight.30": "#9999ff66",
	"color.bold.navi_midnight.40": "#9999ff99",
	"color.bold.navi_midnight.50": "#9999ffff",
	"color.bold.navi_midnight.60": "#b9b9ffff",
	"color.bold.navi_midnight.70": "#ddddffff",
	"color.bold.navi_midnight.80": "#ffffffff",
	"color.bold.navi_midnight.inverse": "#00004aff",
	"color.bold.navi_midnight.background": "#000093ff",
	"color.bold.navi_midnight.grey.100": "#ffffffff",
	"color.bold.navi_midnight.grey.80": "#ffffffc7",
	"color.bold.navi_midnight.grey.60": "#ffffff87",
	"color.bold.navi_midnight.grey.40": "#ffffff4f",
	"color.bold.navi_midnight.grey.20": "#ffffff1f",
	"color.dark.navi_midnight.20": "#16164bff",
	"color.dark.navi_midnight.30": "#24247dff",
	"color.dark.navi_midnight.40": "#3232aeff",
	"color.dark.navi_midnight.50": "#4848f9ff",
	"color.dark.navi_midnight.60": "#7f7ffbff",
	"color.dark.navi_midnight.70": "#adadfcff",
	"color.dark.navi_midnight.80": "#dadafeff",
	"color.dark.navi_midnight.inverse": "#ffffffff",
	"color.dark.navi_midnight.background": "#141414ff",
	"color.dark.navi_midnight.grey.100": "#ffffffff",
	"color.dark.navi_midnight.grey.80": "#ffffffc7",
	"color.dark.navi_midnight.grey.60": "#a1a1a1ff",
	"color.dark.navi_midnight.grey.40": "#5a5a5aff",
	"color.dark.navi_midnight.grey.20": "#2b2b2bff",
	"color.light.navi_midnight.20": "#e8e8fcff",
	"color.light.navi_midnight.30": "#9999ffff",
	"color.light.navi_midnight.40": "#3535f3ff",
	"color.light.navi_midnight.50": "#000093ff",
	"color.light.navi_midnight.60": "#000067ff",
	"color.light.navi_midnight.70": "#00004aff",
	"color.light.navi_midnight.80": "#00002cff",
	"color.light.navi_midnight.inverse": "#ffffffff",
	"color.light.navi_midnight.background": "#ffffffff",
	"color.light.navi_midnight.grey.100": "#141414ff",
	"color.light.navi_midnight.grey.80": "#000000a6",
	"color.light.navi_midnight.grey.60": "#b5b5b5ff",
	"color.light.navi_midnight.grey.40": "#e0e0e0ff",
	"color.light.navi_midnight.grey.20": "#f5f5f5ff",
	"color.bold.navi.20": "#9999ff33",
	"color.bold.navi.30": "#9999ff66",
	"color.bold.navi.40": "#9999ff99",
	"color.bold.navi.50": "#9999ffff",
	"color.bold.navi.60": "#ceceffff",
	"color.bold.navi.70": "#ddddffff",
	"color.bold.navi.80": "#fafaffff",
	"color.bold.navi.inverse": "#00004cff",
	"color.bold.navi.background": "#3535f3ff",
	"color.bold.navi.grey.100": "#ffffffff",
	"color.bold.navi.grey.80": "#ffffffc7",
	"color.bold.navi.grey.60": "#ffffff87",
	"color.bold.navi.grey.40": "#ffffff4f",
	"color.bold.navi.grey.20": "#ffffff1f",
	"color.dark.navi.20": "#16164bff",
	"color.dark.navi.30": "#24247dff",
	"color.dark.navi.40": "#3232aeff",
	"color.dark.navi.50": "#4848f9ff",
	"color.dark.navi.60": "#7f7ffbff",
	"color.dark.navi.70": "#adadfcff",
	"color.dark.navi.80": "#dadafeff",
	"color.dark.navi.inverse": "#ffffffff",
	"color.dark.navi.background": "#141414ff",
	"color.dark.navi.grey.100": "#ffffffff",
	"color.dark.navi.grey.80": "#ffffffc7",
	"color.dark.navi.grey.60": "#a1a1a1ff",
	"color.dark.navi.grey.40": "#5a5a5aff",
	"color.dark.navi.grey.20": "#2b2b2bff",
	"color.light.navi.20": "#e8e8fcff",
	"color.light.navi.30": "#9999ffff",
	"color.light.navi.40": "#6464ffff",
	"color.light.navi.50": "#3535f3ff",
	"color.light.navi.60": "#000093ff",
	"color.light.navi.70": "#00004cff",
	"color.light.navi.80": "#010029ff",
	"color.light.navi.inverse": "#ffffffff",
	"color.light.navi.background": "#ffffffff",
	"color.light.navi.grey.100": "#141414ff",
	"color.light.navi.grey.80": "#000000a6",
	"color.light.navi.grey.60": "#b5b5b5ff",
	"color.light.navi.grey.40": "#e0e0e0ff",
	"color.light.navi.grey.20": "#f5f5f5ff",
	"color.bold.orange_midnight.20": "#ffd2ad33",
	"color.bold.orange_midnight.30": "#ffd2ad66",
	"color.bold.orange_midnight.40": "#ffd2ad99",
	"color.bold.orange_midnight.50": "#ffd2adff",
	"color.bold.orange_midnight.60": "#ffead9ff",
	"color.bold.orange_midnight.70": "#fff5eeff",
	"color.bold.orange_midnight.80": "#ffffffff",
	"color.bold.orange_midnight.inverse": "#661f00ff",
	"color.bold.orange_midnight.background": "#cd3d00ff",
	"color.bold.orange_midnight.grey.100": "#ffffffff",
	"color.bold.orange_midnight.grey.80": "#fffffffc",
	"color.bold.orange_midnight.grey.60": "#ffffff87",
	"color.bold.orange_midnight.grey.40": "#ffffff4f",
	"color.bold.orange_midnight.grey.20": "#ffffff1f",
	"color.dark.orange_midnight.20": "#492b13ff",
	"color.dark.orange_midnight.30": "#7a471fff",
	"color.dark.orange_midnight.40": "#ab642bff",
	"color.dark.orange_midnight.50": "#f48f3eff",
	"color.dark.orange_midnight.60": "#f7b178ff",
	"color.dark.orange_midnight.70": "#facda8ff",
	"color.dark.orange_midnight.80": "#fde9d8ff",
	"color.dark.orange_midnight.inverse": "#492b13ff",
	"color.dark.orange_midnight.background": "#141414ff",
	"color.dark.orange_midnight.grey.100": "#ffffffff",
	"color.dark.orange_midnight.grey.80": "#ffffffc7",
	"color.dark.orange_midnight.grey.60": "#a1a1a1ff",
	"color.dark.orange_midnight.grey.40": "#5a5a5aff",
	"color.dark.orange_midnight.grey.20": "#2b2b2bff",
	"color.light.orange_midnight.20": "#fef2e9ff",
	"color.light.orange_midnight.30": "#ffd2adff",
	"color.light.orange_midnight.40": "#fa7d19ff",
	"color.light.orange_midnight.50": "#cd3d00ff",
	"color.light.orange_midnight.60": "#902b00ff",
	"color.light.orange_midnight.70": "#661f00ff",
	"color.light.orange_midnight.80": "#3d1200ff",
	"color.light.orange_midnight.inverse": "#ffffffff",
	"color.light.orange_midnight.background": "#ffffffff",
	"color.light.orange_midnight.grey.100": "#141414ff",
	"color.light.orange_midnight.grey.80": "#000000a6",
	"color.light.orange_midnight.grey.60": "#b5b5b5ff",
	"color.light.orange_midnight.grey.40": "#e0e0e0ff",
	"color.light.orange_midnight.grey.20": "#f5f5f5ff",
	"color.bold.orange.20": "#7b160433",
	"color.bold.orange.30": "#7b160466",
	"color.bold.orange.40": "#7b160499",
	"color.bold.orange.50": "#7b1604ff",
	"color.bold.orange.60": "#5c1700ff",
	"color.bold.orange.70": "#3d0f00ff",
	"color.bold.orange.80": "#2e0b00ff",
	"color.bold.orange.inverse": "#fef2e9ff",
	"color.bold.orange.background": "#fa7d19ff",
	"color.bold.orange.grey.100": "#46070bff",
	"color.bold.orange.grey.80": "#46070bcf",
	"color.bold.orange.grey.60": "#46070b87",
	"color.bold.orange.grey.40": "#46070b4f",
	"color.bold.orange.grey.20": "#46070b33",
	"color.dark.orange.20": "#492b13ff",
	"color.dark.orange.30": "#7a471fff",
	"color.dark.orange.40": "#ab642bff",
	"color.dark.orange.50": "#f48f3eff",
	"color.dark.orange.60": "#f7b178ff",
	"color.dark.orange.70": "#facda8ff",
	"color.dark.orange.80": "#fde9d8ff",
	"color.dark.orange.inverse": "#492b13ff",
	"color.dark.orange.background": "#141414ff",
	"color.dark.orange.grey.100": "#ffffffff",
	"color.dark.orange.grey.80": "#ffffffc7",
	"color.dark.orange.grey.60": "#a1a1a1ff",
	"color.dark.orange.grey.40": "#5a5a5aff",
	"color.dark.orange.grey.20": "#2b2b2bff",
	"color.light.orange.20": "#fef2e9ff",
	"color.light.orange.30": "#ffd2adff",
	"color.light.orange.40": "#ffaa66ff",
	"color.light.orange.50": "#fa7d19ff",
	"color.light.orange.60": "#cd3d00ff",
	"color.light.orange.70": "#7b1604ff",
	"color.light.orange.80": "#46070bff",
	"color.light.orange.inverse": "#46070bff",
	"color.light.orange.background": "#ffffffff",
	"color.light.orange.grey.100": "#141414ff",
	"color.light.orange.grey.80": "#000000a6",
	"color.light.orange.grey.60": "#b5b5b5ff",
	"color.light.orange.grey.40": "#e0e0e0ff",
	"color.light.orange.grey.20": "#f5f5f5ff",
	"color.bold.pink_midnight.20": "#ff99db33",
	"color.bold.pink_midnight.30": "#ff99db66",
	"color.bold.pink_midnight.40": "#ff99db99",
	"color.bold.pink_midnight.50": "#ff99dbff",
	"color.bold.pink_midnight.60": "#ffbfe9ff",
	"color.bold.pink_midnight.70": "#ffeaf8ff",
	"color.bold.pink_midnight.80": "#fff6fcff",
	"color.bold.pink_midnight.inverse": "#47002fff",
	"color.bold.pink_midnight.background": "#8f005dff",
	"color.bold.pink_midnight.grey.100": "#ffffffff",
	"color.bold.pink_midnight.grey.80": "#ffffffc7",
	"color.bold.pink_midnight.grey.60": "#ffffff87",
	"color.bold.pink_midnight.grey.40": "#ffffff4f",
	"color.bold.pink_midnight.grey.20": "#ffffff1f",
	"color.dark.pink_midnight.20": "#360023ff",
	"color.dark.pink_midnight.30": "#62003fff",
	"color.dark.pink_midnight.40": "#8f005dff",
	"color.dark.pink_midnight.50": "#d9008dff",
	"color.dark.pink_midnight.60": "#ff6dccff",
	"color.dark.pink_midnight.70": "#ff99dbff",
	"color.dark.pink_midnight.80": "#fbe5f4ff",
	"color.dark.pink_midnight.inverse": "#ffffffff",
	"color.dark.pink_midnight.background": "#141414ff",
	"color.dark.pink_midnight.grey.100": "#ffffffff",
	"color.dark.pink_midnight.grey.80": "#ffffffc7",
	"color.dark.pink_midnight.grey.60": "#a1a1a1ff",
	"color.dark.pink_midnight.grey.40": "#5a5a5aff",
	"color.dark.pink_midnight.grey.20": "#2b2b2bff",
	"color.light.pink_midnight.20": "#fbe5f4ff",
	"color.light.pink_midnight.30": "#ff99dbff",
	"color.light.pink_midnight.40": "#d9008dff",
	"color.light.pink_midnight.50": "#8f005dff",
	"color.light.pink_midnight.60": "#640041ff",
	"color.light.pink_midnight.70": "#47002fff",
	"color.light.pink_midnight.80": "#2b001cff",
	"color.light.pink_midnight.inverse": "#ffffffff",
	"color.light.pink_midnight.background": "#ffffffff",
	"color.light.pink_midnight.grey.100": "#141414ff",
	"color.light.pink_midnight.grey.80": "#000000a6",
	"color.light.pink_midnight.grey.60": "#b5b5b5ff",
	"color.light.pink_midnight.grey.40": "#e0e0e0ff",
	"color.light.pink_midnight.grey.20": "#f5f5f5ff",
	"color.bold.pink.20": "#ff99db33",
	"color.bold.pink.30": "#ff99db66",
	"color.bold.pink.40": "#ff99db99",
	"color.bold.pink.50": "#ff99dbff",
	"color.bold.pink.60": "#fff7fcff",
	"color.bold.pink.70": "#ffffffff",
	"color.bold.pink.80": "#ffffffff",
	"color.bold.pink.inverse": "#62003fff",
	"color.bold.pink.background": "#d9008dff",
	"color.bold.pink.grey.100": "#ffffffff",
	"color.bold.pink.grey.80": "#fffffff5",
	"color.bold.pink.grey.60": "#ffffff87",
	"color.bold.pink.grey.40": "#ffffff4f",
	"color.bold.pink.grey.20": "#ffffff1f",
	"color.dark.pink.20": "#360023ff",
	"color.dark.pink.30": "#62003fff",
	"color.dark.pink.40": "#8f005dff",
	"color.dark.pink.50": "#d9008dff",
	"color.dark.pink.60": "#ff6dccff",
	"color.dark.pink.70": "#ff99dbff",
	"color.dark.pink.80": "#fbe5f4ff",
	"color.dark.pink.inverse": "#ffffffff",
	"color.dark.pink.background": "#141414ff",
	"color.dark.pink.grey.100": "#ffffffff",
	"color.dark.pink.grey.80": "#ffffffc7",
	"color.dark.pink.grey.60": "#a1a1a1ff",
	"color.dark.pink.grey.40": "#5a5a5aff",
	"color.dark.pink.grey.20": "#2b2b2bff",
	"color.light.pink.20": "#fbe5f4ff",
	"color.light.pink.30": "#ff99dbff",
	"color.light.pink.40": "#ff6dccff",
	"color.light.pink.50": "#d9008dff",
	"color.light.pink.60": "#8f005dff",
	"color.light.pink.70": "#62003fff",
	"color.light.pink.80": "#360023ff",
	"color.light.pink.inverse": "#ffffffff",
	"color.light.pink.background": "#ffffffff",
	"color.light.pink.grey.100": "#141414ff",
	"color.light.pink.grey.80": "#000000a6",
	"color.light.pink.grey.60": "#b5b5b5ff",
	"color.light.pink.grey.40": "#e0e0e0ff",
	"color.light.pink.grey.20": "#f5f5f5ff",
	"color.bold.purple_midnight.20": "#cba2fa33",
	"color.bold.purple_midnight.30": "#cba2fa66",
	"color.bold.purple_midnight.40": "#cba2fa99",
	"color.bold.purple_midnight.50": "#cba2faff",
	"color.bold.purple_midnight.60": "#e4cffcff",
	"color.bold.purple_midnight.70": "#eee1fdff",
	"color.bold.purple_midnight.80": "#fbf9ffff",
	"color.bold.purple_midnight.inverse": "#1f0042ff",
	"color.bold.purple_midnight.background": "#3e0084ff",
	"color.bold.purple_midnight.grey.100": "#ffffffff",
	"color.bold.purple_midnight.grey.80": "#ffffffc7",
	"color.bold.purple_midnight.grey.60": "#ffffff87",
	"color.bold.purple_midnight.grey.40": "#ffffff4f",
	"color.bold.purple_midnight.grey.20": "#ffffff1f",
	"color.dark.purple_midnight.20": "#281240ff",
	"color.dark.purple_midnight.30": "#421f6bff",
	"color.dark.purple_midnight.40": "#5d2b96ff",
	"color.dark.purple_midnight.50": "#853dd6ff",
	"color.dark.purple_midnight.60": "#aa77e2ff",
	"color.dark.purple_midnight.70": "#c8a8edff",
	"color.dark.purple_midnight.80": "#e7d8f7ff",
	"color.dark.purple_midnight.inverse": "#ffffffff",
	"color.dark.purple_midnight.background": "#141414ff",
	"color.dark.purple_midnight.grey.100": "#ffffffff",
	"color.dark.purple_midnight.grey.80": "#ffffffc7",
	"color.dark.purple_midnight.grey.60": "#a1a1a1ff",
	"color.dark.purple_midnight.grey.40": "#5a5a5aff",
	"color.dark.purple_midnight.grey.20": "#2b2b2bff",
	"color.light.purple_midnight.20": "#f0e8faff",
	"color.light.purple_midnight.30": "#cba2faff",
	"color.light.purple_midnight.40": "#6d17ceff",
	"color.light.purple_midnight.50": "#3e0084ff",
	"color.light.purple_midnight.60": "#2b005cff",
	"color.light.purple_midnight.70": "#1f0042ff",
	"color.light.purple_midnight.80": "#130028ff",
	"color.light.purple_midnight.inverse": "#ffffffff",
	"color.light.purple_midnight.background": "#ffffffff",
	"color.light.purple_midnight.grey.100": "#141414ff",
	"color.light.purple_midnight.grey.80": "#000000a6",
	"color.light.purple_midnight.grey.60": "#b5b5b5ff",
	"color.light.purple_midnight.grey.40": "#e0e0e0ff",
	"color.light.purple_midnight.grey.20": "#f5f5f5ff",
	"color.bold.purple.20": "#cba2fa33",
	"color.bold.purple.30": "#cba2fa66",
	"color.bold.purple.40": "#cba2fa99",
	"color.bold.purple.50": "#cba2faff",
	"color.bold.purple.60": "#dbbefbff",
	"color.bold.purple.70": "#e4cffcff",
	"color.bold.purple.80": "#ecddfdff",
	"color.bold.purple.inverse": "#310a5dff",
	"color.bold.purple.background": "#6d17ceff",
	"color.bold.purple.grey.100": "#ffffffff",
	"color.bold.purple.grey.80": "#ffffffc7",
	"color.bold.purple.grey.60": "#ffffff87",
	"color.bold.purple.grey.40": "#ffffff4f",
	"color.bold.purple.grey.20": "#ffffff1f",
	"color.dark.purple.20": "#281240ff",
	"color.dark.purple.30": "#421f6bff",
	"color.dark.purple.40": "#5d2b96ff",
	"color.dark.purple.50": "#853dd6ff",
	"color.dark.purple.60": "#aa77e2ff",
	"color.dark.purple.70": "#c8a8edff",
	"color.dark.purple.80": "#e7d8f7ff",
	"color.dark.purple.inverse": "#ffffffff",
	"color.dark.purple.background": "#141414ff",
	"color.dark.purple.grey.100": "#ffffffff",
	"color.dark.purple.grey.80": "#ffffffc7",
	"color.dark.purple.grey.60": "#a1a1a1ff",
	"color.dark.purple.grey.40": "#5a5a5aff",
	"color.dark.purple.grey.20": "#2b2b2bff",
	"color.light.purple.20": "#f0e8faff",
	"color.light.purple.30": "#cba2faff",
	"color.light.purple.40": "#a680ffff",
	"color.light.purple.50": "#6d17ceff",
	"color.light.purple.60": "#3e0084ff",
	"color.light.purple.70": "#310a5dff",
	"color.light.purple.80": "#1b0633ff",
	"color.light.purple.inverse": "#ffffffff",
	"color.light.purple.background": "#ffffffff",
	"color.light.purple.grey.100": "#141414ff",
	"color.light.purple.grey.80": "#000000a6",
	"color.light.purple.grey.60": "#b5b5b5ff",
	"color.light.purple.grey.40": "#e0e0e0ff",
	"color.light.purple.grey.20": "#f5f5f5ff",
	"color.bold.red_midnight.20": "#ff9da333",
	"color.bold.red_midnight.30": "#ff9da366",
	"color.bold.red_midnight.40": "#ff9da399",
	"color.bold.red_midnight.50": "#ff9da3ff",
	"color.bold.red_midnight.60": "#ffccd1ff",
	"color.bold.red_midnight.70": "#ffe5e8ff",
	"color.bold.red_midnight.80": "#fff4f5ff",
	"color.bold.red_midnight.inverse": "#540000ff",
	"color.bold.red_midnight.background": "#a80000ff",
	"color.bold.red_midnight.grey.100": "#ffffffff",
	"color.bold.red_midnight.grey.80": "#ffffffc7",
	"color.bold.red_midnight.grey.60": "#ffffff87",
	"color.bold.red_midnight.grey.40": "#ffffff4f",
	"color.bold.red_midnight.grey.20": "#ffffff1f",
	"color.dark.red_midnight.20": "#430c10ff",
	"color.dark.red_midnight.30": "#70141aff",
	"color.dark.red_midnight.40": "#9d1d24ff",
	"color.dark.red_midnight.50": "#e02934ff",
	"color.dark.red_midnight.60": "#e96971ff",
	"color.dark.red_midnight.70": "#f19fa4ff",
	"color.dark.red_midnight.80": "#f9d4d6ff",
	"color.dark.red_midnight.inverse": "#ffffffff",
	"color.dark.red_midnight.background": "#141414ff",
	"color.dark.red_midnight.grey.100": "#ffffffff",
	"color.dark.red_midnight.grey.80": "#ffffffc7",
	"color.dark.red_midnight.grey.60": "#a1a1a1ff",
	"color.dark.red_midnight.grey.40": "#5a5a5aff",
	"color.dark.red_midnight.grey.20": "#2b2b2bff",
	"color.light.red_midnight.20": "#fce6e7ff",
	"color.light.red_midnight.30": "#ff9da3ff",
	"color.light.red_midnight.40": "#e30513ff",
	"color.light.red_midnight.50": "#a80000ff",
	"color.light.red_midnight.60": "#760000ff",
	"color.light.red_midnight.70": "#540000ff",
	"color.light.red_midnight.80": "#320000ff",
	"color.light.red_midnight.inverse": "#ffffffff",
	"color.light.red_midnight.background": "#ffffffff",
	"color.light.red_midnight.grey.100": "#141414ff",
	"color.light.red_midnight.grey.80": "#000000a6",
	"color.light.red_midnight.grey.60": "#b5b5b5ff",
	"color.light.red_midnight.grey.40": "#e0e0e0ff",
	"color.light.red_midnight.grey.20": "#f5f5f5ff",
	"color.bold.red.20": "#ff9da333",
	"color.bold.red.30": "#ff9da366",
	"color.bold.red.40": "#ff9da399",
	"color.bold.red.50": "#ff9da3ff",
	"color.bold.red.60": "#fff6f7ff",
	"color.bold.red.70": "#ffffffff",
	"color.bold.red.80": "#ffffffff",
	"color.bold.red.inverse": "#660209ff",
	"color.bold.red.background": "#e30513ff",
	"color.bold.red.grey.100": "#ffffffff",
	"color.bold.red.grey.80": "#fffffff5",
	"color.bold.red.grey.60": "#ffffff87",
	"color.bold.red.grey.40": "#ffffff4f",
	"color.bold.red.grey.20": "#ffffff1f",
	"color.dark.red.20": "#430c10ff",
	"color.dark.red.30": "#70141aff",
	"color.dark.red.40": "#9d1d24ff",
	"color.dark.red.50": "#e02934ff",
	"color.dark.red.60": "#e96971ff",
	"color.dark.red.70": "#f19fa4ff",
	"color.dark.red.80": "#f9d4d6ff",
	"color.dark.red.inverse": "#ffffffff",
	"color.dark.red.background": "#141414ff",
	"color.dark.red.grey.100": "#ffffffff",
	"color.dark.red.grey.80": "#ffffffc7",
	"color.dark.red.grey.60": "#a1a1a1ff",
	"color.dark.red.grey.40": "#5a5a5aff",
	"color.dark.red.grey.20": "#2b2b2bff",
	"color.light.red.20": "#fce6e7ff",
	"color.light.red.30": "#ff9da3ff",
	"color.light.red.40": "#fc6770ff",
	"color.light.red.50": "#e30513ff",
	"color.light.red.60": "#a80000ff",
	"color.light.red.70": "#660209ff",
	"color.light.red.80": "#390105ff",
	"color.light.red.inverse": "#ffffffff",
	"color.light.red.background": "#ffffffff",
	"color.light.red.grey.100": "#141414ff",
	"color.light.red.grey.80": "#000000a6",
	"color.light.red.grey.60": "#b5b5b5ff",
	"color.light.red.grey.40": "#e0e0e0ff",
	"color.light.red.grey.20": "#f5f5f5ff",
	"color.bold.reliance_midnight.20": "#9eb5fa33",
	"color.bold.reliance_midnight.30": "#9eb5fa66",
	"color.bold.reliance_midnight.40": "#9eb5fa99",
	"color.bold.reliance_midnight.50": "#9eb5faff",
	"color.bold.reliance_midnight.60": "#c7d4fcff",
	"color.bold.reliance_midnight.70": "#dce4fdff",
	"color.bold.reliance_midnight.80": "#f3f5feff",
	"color.bold.reliance_midnight.inverse": "#051442ff",
	"color.bold.reliance_midnight.background": "#0a2885ff",
	"color.bold.reliance_midnight.grey.100": "#ffffffff",
	"color.bold.reliance_midnight.grey.80": "#ffffffc7",
	"color.bold.reliance_midnight.grey.60": "#ffffff87",
	"color.bold.reliance_midnight.grey.40": "#ffffff4f",
	"color.bold.reliance_midnight.grey.20": "#ffffff1f",
	"color.dark.reliance_midnight.20": "#051444ff",
	"color.dark.reliance_midnight.30": "#092272ff",
	"color.dark.reliance_midnight.40": "#0c30a0ff",
	"color.dark.reliance_midnight.50": "#1144e4ff",
	"color.dark.reliance_midnight.60": "#587cecff",
	"color.dark.reliance_midnight.70": "#94abf3ff",
	"color.dark.reliance_midnight.80": "#cfdafaff",
	"color.dark.reliance_midnight.inverse": "#ffffffff",
	"color.dark.reliance_midnight.background": "#141414ff",
	"color.dark.reliance_midnight.grey.100": "#ffffffff",
	"color.dark.reliance_midnight.grey.80": "#ffffffc7",
	"color.dark.reliance_midnight.grey.60": "#a1a1a1ff",
	"color.dark.reliance_midnight.grey.40": "#5a5a5aff",
	"color.dark.reliance_midnight.grey.20": "#2b2b2bff",
	"color.light.reliance_midnight.20": "#e7ebf8ff",
	"color.light.reliance_midnight.30": "#9eb5faff",
	"color.light.reliance_midnight.40": "#0f3cc9ff",
	"color.light.reliance_midnight.50": "#0a2885ff",
	"color.light.reliance_midnight.60": "#071c5dff",
	"color.light.reliance_midnight.70": "#051442ff",
	"color.light.reliance_midnight.80": "#030c28ff",
	"color.light.reliance_midnight.inverse": "#ffffffff",
	"color.light.reliance_midnight.background": "#ffffffff",
	"color.light.reliance_midnight.grey.100": "#141414ff",
	"color.light.reliance_midnight.grey.80": "#000000a6",
	"color.light.reliance_midnight.grey.60": "#b5b5b5ff",
	"color.light.reliance_midnight.grey.40": "#e0e0e0ff",
	"color.light.reliance_midnight.grey.20": "#f5f5f5ff",
	"color.bold.reliance.20": "#9eb5fa33",
	"color.bold.reliance.30": "#9eb5fa66",
	"color.bold.reliance.40": "#9eb5fa99",
	"color.bold.reliance.50": "#9eb5faff",
	"color.bold.reliance.60": "#becefbff",
	"color.bold.reliance.70": "#d0dcfdff",
	"color.bold.reliance.80": "#e8eefeff",
	"color.bold.reliance.inverse": "#061951ff",
	"color.bold.reliance.background": "#0f3cc9ff",
	"color.bold.reliance.grey.100": "#ffffffff",
	"color.bold.reliance.grey.80": "#ffffffc7",
	"color.bold.reliance.grey.60": "#ffffff87",
	"color.bold.reliance.grey.40": "#ffffff4f",
	"color.bold.reliance.grey.20": "#ffffff1f",
	"color.dark.reliance.20": "#051444ff",
	"color.dark.reliance.30": "#092272ff",
	"color.dark.reliance.40": "#0c30a0ff",
	"color.dark.reliance.50": "#1144e4ff",
	"color.dark.reliance.60": "#587cecff",
	"color.dark.reliance.70": "#94abf3ff",
	"color.dark.reliance.80": "#cfdafaff",
	"color.dark.reliance.inverse": "#ffffffff",
	"color.dark.reliance.background": "#141414ff",
	"color.dark.reliance.grey.100": "#ffffffff",
	"color.dark.reliance.grey.80": "#ffffffc7",
	"color.dark.reliance.grey.60": "#a1a1a1ff",
	"color.dark.reliance.grey.40": "#5a5a5aff",
	"color.dark.reliance.grey.20": "#2b2b2bff",
	"color.light.reliance.20": "#e7ebf8ff",
	"color.light.reliance.30": "#9eb5faff",
	"color.light.reliance.40": "#6789f4ff",
	"color.light.reliance.50": "#0f3cc9ff",
	"color.light.reliance.60": "#0a2885ff",
	"color.light.reliance.70": "#061951ff",
	"color.light.reliance.80": "#070e21ff",
	"color.light.reliance.inverse": "#ffffffff",
	"color.light.reliance.background": "#ffffffff",
	"color.light.reliance.grey.100": "#141414ff",
	"color.light.reliance.grey.80": "#000000a6",
	"color.light.reliance.grey.60": "#b5b5b5ff",
	"color.light.reliance.grey.40": "#e0e0e0ff",
	"color.light.reliance.grey.20": "#f5f5f5ff",
	"color.bold.sky_midnight.20": "#89dcff33",
	"color.bold.sky_midnight.30": "#89dcff66",
	"color.bold.sky_midnight.40": "#89dcff99",
	"color.bold.sky_midnight.50": "#89dcffff",
	"color.bold.sky_midnight.60": "#bceaffff",
	"color.bold.sky_midnight.70": "#d4f2ffff",
	"color.bold.sky_midnight.80": "#f2fbffff",
	"color.bold.sky_midnight.inverse": "#062939ff",
	"color.bold.sky_midnight.background": "#0c5273ff",
	"color.bold.sky_midnight.grey.100": "#ffffffff",
	"color.bold.sky_midnight.grey.80": "#ffffffc7",
	"color.bold.sky_midnight.grey.60": "#ffffff87",
	"color.bold.sky_midnight.grey.40": "#ffffff4f",
	"color.bold.sky_midnight.grey.20": "#ffffff1f",
	"color.dark.sky_midnight.20": "#002b3dff",
	"color.dark.sky_midnight.30": "#004766ff",
	"color.dark.sky_midnight.40": "#00638fff",
	"color.dark.sky_midnight.50": "#007fadff",
	"color.dark.sky_midnight.60": "#4ca5c6ff",
	"color.dark.sky_midnight.70": "#8cc5daff",
	"color.dark.sky_midnight.80": "#cce5efff",
	"color.dark.sky_midnight.inverse": "#ffffffff",
	"color.dark.sky_midnight.background": "#141414ff",
	"color.dark.sky_midnight.grey.100": "#ffffffff",
	"color.dark.sky_midnight.grey.80": "#ffffffc7",
	"color.dark.sky_midnight.grey.60": "#a1a1a1ff",
	"color.dark.sky_midnight.grey.40": "#5a5a5aff",
	"color.dark.sky_midnight.grey.20": "#2b2b2bff",
	"color.light.sky_midnight.20": "#e5f1f7ff",
	"color.light.sky_midnight.30": "#89dcffff",
	"color.light.sky_midnight.40": "#0078adff",
	"color.light.sky_midnight.50": "#0c5273ff",
	"color.light.sky_midnight.60": "#083950ff",
	"color.light.sky_midnight.70": "#062939ff",
	"color.light.sky_midnight.80": "#041922ff",
	"color.light.sky_midnight.inverse": "#ffffffff",
	"color.light.sky_midnight.background": "#ffffffff",
	"color.light.sky_midnight.grey.100": "#141414ff",
	"color.light.sky_midnight.grey.80": "#000000a6",
	"color.light.sky_midnight.grey.60": "#b5b5b5ff",
	"color.light.sky_midnight.grey.40": "#e0e0e0ff",
	"color.light.sky_midnight.grey.20": "#f5f5f5ff",
	"color.bold.sky.20": "#89dcff33",
	"color.bold.sky.30": "#89dcff66",
	"color.bold.sky.40": "#89dcff99",
	"color.bold.sky.50": "#89dcffff",
	"color.bold.sky.60": "#eefaffff",
	"color.bold.sky.70": "#ffffffff",
	"color.bold.sky.80": "#ffffffff",
	"color.bold.sky.inverse": "#00364eff",
	"color.bold.sky.background": "#0078adff",
	"color.bold.sky.grey.100": "#ffffffff",
	"color.bold.sky.grey.80": "#fffffff0",
	"color.bold.sky.grey.60": "#ffffff87",
	"color.bold.sky.grey.40": "#ffffff4f",
	"color.bold.sky.grey.20": "#ffffff1f",
	"color.dark.sky.20": "#002b3dff",
	"color.dark.sky.30": "#004766ff",
	"color.dark.sky.40": "#00638fff",
	"color.dark.sky.50": "#007fadff",
	"color.dark.sky.60": "#4ca5c6ff",
	"color.dark.sky.70": "#8cc5daff",
	"color.dark.sky.80": "#cce5efff",
	"color.dark.sky.inverse": "#ffffffff",
	"color.dark.sky.background": "#141414ff",
	"color.dark.sky.grey.100": "#ffffffff",
	"color.dark.sky.grey.80": "#ffffffc7",
	"color.dark.sky.grey.60": "#a1a1a1ff",
	"color.dark.sky.grey.40": "#5a5a5aff",
	"color.dark.sky.grey.20": "#2b2b2bff",
	"color.light.sky.20": "#e5f1f7ff",
	"color.light.sky.30": "#89dcffff",
	"color.light.sky.40": "#67c3efff",
	"color.light.sky.50": "#0078adff",
	"color.light.sky.60": "#0c5273ff",
	"color.light.sky.70": "#00364eff",
	"color.light.sky.80": "#001e2bff",
	"color.light.sky.inverse": "#ffffffff",
	"color.light.sky.background": "#ffffffff",
	"color.light.sky.grey.100": "#141414ff",
	"color.light.sky.grey.80": "#000000a6",
	"color.light.sky.grey.60": "#b5b5b5ff",
	"color.light.sky.grey.40": "#e0e0e0ff",
	"color.light.sky.grey.20": "#f5f5f5ff",
	"color.bold.violet_midnight.20": "#f7a8fa33",
	"color.bold.violet_midnight.30": "#f7a8fa66",
	"color.bold.violet_midnight.40": "#f7a8fa99",
	"color.bold.violet_midnight.50": "#f7a8faff",
	"color.bold.violet_midnight.60": "#fbd1fcff",
	"color.bold.violet_midnight.70": "#fbd3fcff",
	"color.bold.violet_midnight.80": "#fef3feff",
	"color.bold.violet_midnight.inverse": "#3d0040ff",
	"color.bold.violet_midnight.background": "#79007fff",
	"color.bold.violet_midnight.grey.100": "#ffffffff",
	"color.bold.violet_midnight.grey.80": "#ffffffc7",
	"color.bold.violet_midnight.grey.60": "#ffffff87",
	"color.bold.violet_midnight.grey.40": "#ffffff4f",
	"color.bold.violet_midnight.grey.20": "#ffffff1f",
	"color.dark.violet_midnight.20": "#300d31ff",
	"color.dark.violet_midnight.30": "#571859ff",
	"color.dark.violet_midnight.40": "#79007fff",
	"color.dark.violet_midnight.50": "#c135c5ff",
	"color.dark.violet_midnight.60": "#f680f9ff",
	"color.dark.violet_midnight.70": "#f7a8faff",
	"color.dark.violet_midnight.80": "#f9ebf9ff",
	"color.dark.violet_midnight.inverse": "#ffffffff",
	"color.dark.violet_midnight.background": "#141414ff",
	"color.dark.violet_midnight.grey.100": "#ffffffff",
	"color.dark.violet_midnight.grey.80": "#ffffffc7",
	"color.dark.violet_midnight.grey.60": "#a1a1a1ff",
	"color.dark.violet_midnight.grey.40": "#5a5a5aff",
	"color.dark.violet_midnight.grey.20": "#2b2b2bff",
	"color.light.violet_midnight.20": "#f9ebf9ff",
	"color.light.violet_midnight.30": "#f7a8faff",
	"color.light.violet_midnight.40": "#c135c5ff",
	"color.light.violet_midnight.50": "#79007fff",
	"color.light.violet_midnight.60": "#550059ff",
	"color.light.violet_midnight.70": "#3d0040ff",
	"color.light.violet_midnight.80": "#240026ff",
	"color.light.violet_midnight.inverse": "#ffffffff",
	"color.light.violet_midnight.background": "#ffffffff",
	"color.light.violet_midnight.grey.100": "#141414ff",
	"color.light.violet_midnight.grey.80": "#000000a6",
	"color.light.violet_midnight.grey.60": "#b5b5b5ff",
	"color.light.violet_midnight.grey.40": "#e0e0e0ff",
	"color.light.violet_midnight.grey.20": "#f5f5f5ff",
	"color.bold.violet.20": "#f7a8fa33",
	"color.bold.violet.30": "#f7a8fa66",
	"color.bold.violet.40": "#f7a8fa99",
	"color.bold.violet.50": "#f7a8faff",
	"color.bold.violet.60": "#fefdffff",
	"color.bold.violet.70": "#ffffffff",
	"color.bold.violet.80": "#ffffffff",
	"color.bold.violet.inverse": "#571859ff",
	"color.bold.violet.background": "#c135c5ff",
	"color.bold.violet.grey.100": "#ffffffff",
	"color.bold.violet.grey.80": "#fffffffc",
	"color.bold.violet.grey.60": "#ffffff87",
	"color.bold.violet.grey.40": "#ffffff4f",
	"color.bold.violet.grey.20": "#ffffff1f",
	"color.dark.violet.20": "#300d31ff",
	"color.dark.violet.30": "#571859ff",
	"color.dark.violet.40": "#79007fff",
	"color.dark.violet.50": "#c135c5ff",
	"color.dark.violet.60": "#f680f9ff",
	"color.dark.violet.70": "#f7a8faff",
	"color.dark.violet.80": "#f9ebf9ff",
	"color.dark.violet.inverse": "#ffffffff",
	"color.dark.violet.background": "#141414ff",
	"color.dark.violet.grey.100": "#ffffffff",
	"color.dark.violet.grey.80": "#ffffffc7",
	"color.dark.violet.grey.60": "#a1a1a1ff",
	"color.dark.violet.grey.40": "#5a5a5aff",
	"color.dark.violet.grey.20": "#2b2b2bff",
	"color.light.violet.20": "#f9ebf9ff",
	"color.light.violet.30": "#f7a8faff",
	"color.light.violet.40": "#f680f9ff",
	"color.light.violet.50": "#c135c5ff",
	"color.light.violet.60": "#79007fff",
	"color.light.violet.70": "#571859ff",
	"color.light.violet.80": "#300d31ff",
	"color.light.violet.inverse": "#ffffffff",
	"color.light.violet.background": "#ffffffff",
	"color.light.violet.grey.100": "#141414ff",
	"color.light.violet.grey.80": "#000000a6",
	"color.light.violet.grey.60": "#b5b5b5ff",
	"color.light.violet.grey.40": "#e0e0e0ff",
	"color.light.violet.grey.20": "#f5f5f5ff",
	"color.light.white": "#ffffff",
	"color.light.black": "#141414",
	"color.light.feedback.error.80": "#660014",
	"color.light.feedback.error.50": "#f50031",
	"color.light.feedback.error.20": "#fee6ea",
	"color.light.feedback.warning.80": "#7d2f08",
	"color.light.feedback.warning.50": "#f06d0f",
	"color.light.feedback.warning.20": "#fef0e7",
	"color.light.feedback.success.80": "#135610",
	"color.light.feedback.success.50": "#25ab21",
	"color.light.feedback.success.20": "#e9f7e9",
	"color.bold.white": "#ffffff",
	"color.bold.black": "#141414",
	"color.bold.feedback.error.80": "#660014",
	"color.bold.feedback.error.50": "#f50031",
	"color.bold.feedback.error.20": "#fee6ea",
	"color.bold.feedback.warning.80": "#7d2f08",
	"color.bold.feedback.warning.50": "#f06d0f",
	"color.bold.feedback.warning.20": "#fef0e7",
	"color.bold.feedback.success.80": "#135610",
	"color.bold.feedback.success.50": "#25ab21",
	"color.bold.feedback.success.20": "#e9f7e9",
	"color.dark.white": "#ffffff",
	"color.dark.black": "#141414",
	"color.dark.feedback.error.80": "#fee6ea",
	"color.dark.feedback.error.50": "#f50031",
	"color.dark.feedback.error.20": "#660014",
	"color.dark.feedback.warning.80": "#fef0e7",
	"color.dark.feedback.warning.50": "#f06d0f",
	"color.dark.feedback.warning.20": "#7d2f08",
	"color.dark.feedback.success.80": "#e9f7e9",
	"color.dark.feedback.success.50": "#25ab21",
	"color.dark.feedback.success.20": "#135610",
	"color.light.gold.20": "#f9f6efFF",
	"color.dark.gold.20": "#3f3721FF",
	"color.bold.gold.20": "#211d14FF",
	"color.light.gold.30": "#f4ead4FF",
	"color.dark.gold.30": "#746640FF",
	"color.bold.gold.30": "#3f3721FF",
	"color.light.gold.40": "#f0deb2FF",
	"color.dark.gold.40": "#a18e5bFF",
	"color.bold.gold.40": "#746640FF",
	"color.light.gold.50": "#c9b273FF",
	"color.dark.gold.50": "#d2ba78FF",
	"color.bold.gold.50": "#a18e5bFF",
	"color.light.gold.60": "#968454FF",
	"color.dark.gold.60": "#f0deb2FF",
	"color.bold.gold.60": "#f0deb2FF",
	"color.light.gold.70": "#6a5d3aFF",
	"color.dark.gold.70": "#f4ead4FF",
	"color.bold.gold.70": "#f4ead4FF",
	"color.light.gold.80": "#352e1dFF",
	"color.dark.gold.80": "#f9f6efFF",
	"color.bold.gold.80": "#f9f6efFF",
	"color.light.gold.grey.20": "#f5f5f5FF",
	"color.dark.gold.grey.20": "#2b2b2bFF",
	"color.bold.gold.grey.20": "#ffffff1F",
	"color.light.gold.grey.40": "#e0e0e0FF",
	"color.dark.gold.grey.40": "#5a5a5aFF",
	"color.bold.gold.grey.40": "#ffffff52",
	"color.light.gold.grey.60": "#b5b5b5FF",
	"color.dark.gold.grey.60": "#a1a1a1FF",
	"color.bold.gold.grey.60": "#ffffff87",
	"color.light.gold.grey.80": "#000000A6",
	"color.dark.gold.grey.80": "#ffffffC7",
	"color.bold.gold.grey.80": "#ffffffC7",
	"color.light.gold.grey.100": "#141414FF",
	"color.dark.gold.grey.100": "#ffffffFF",
	"color.bold.gold.grey.100": "#ffffffFF",
	"color.light.gold.background": "#ffffffFF",
	"color.dark.gold.background": "#141414FF",
	"color.bold.gold.background": "#c9b273FF",
	"color.light.gold.inverse": "#352e1dFF",
	"color.dark.gold.inverse": "#3f3721FF",
	"color.bold.gold.inverse": "#211d14FF",
	"color.light.rose.20": "#fcf5f5FF",
	"color.dark.rose.20": "#2e070aFF",
	"color.bold.rose.20": "#4e0b19FF",
	"color.light.rose.30": "#fad8d8FF",
	"color.dark.rose.30": "#700b25FF",
	"color.bold.rose.30": "#d8214fFF",
	"color.light.rose.40": "#f9c9caFF",
	"color.dark.rose.40": "#c61d48FF",
	"color.bold.rose.40": "#f8536eFF",
	"color.light.rose.50": "#fa969dFF",
	"color.dark.rose.50": "#f8536eFF",
	"color.bold.rose.50": "#f96e7eFF",
	"color.light.rose.60": "#f96e7eFF",
	"color.dark.rose.60": "#fba5aaFF",
	"color.bold.rose.60": "#fab6b9FF",
	"color.light.rose.70": "#720c26FF",
	"color.dark.rose.70": "#fad7d8FF",
	"color.bold.rose.70": "#fad7d8FF",
	"color.light.rose.80": "#3d0912FF",
	"color.dark.rose.80": "#fae6e7FF",
	"color.bold.rose.80": "#fcf5f5FF",
	"color.light.rose.grey.20": "#f5f5f5FF",
	"color.dark.rose.grey.20": "#2b2b2bFF",
	"color.bold.rose.grey.20": "#ffffff1F",
	"color.light.rose.grey.40": "#e0e0e0FF",
	"color.dark.rose.grey.40": "#5a5a5aFF",
	"color.bold.rose.grey.40": "#ffffff52",
	"color.light.rose.grey.60": "#b5b5b5FF",
	"color.dark.rose.grey.60": "#a1a1a1FF",
	"color.bold.rose.grey.60": "#ffffff87",
	"color.light.rose.grey.80": "#000000A6",
	"color.dark.rose.grey.80": "#ffffffC7",
	"color.bold.rose.grey.80": "#ffffffC7",
	"color.light.rose.grey.100": "#141414FF",
	"color.dark.rose.grey.100": "#ffffffFF",
	"color.bold.rose.grey.100": "#ffffffFF",
	"color.light.rose.background": "#3d0912FF",
	"color.dark.rose.background": "#141414FF",
	"color.bold.rose.background": "#141414FF",
	"color.light.rose.inverse": "#3d0912FF",
	"color.dark.rose.inverse": "#ffffffFF",
	"color.bold.rose.inverse": "#2e070aFF",
	"color.light.warm_gold.20": "#FEF7EF",
	"color.light.warm_gold.30": "#F9D4A9",
	"color.light.warm_gold.40": "#F3B561",
	"color.light.warm_gold.50": "#E39B2B",
	"color.light.warm_gold.60": "#9B6817",
	"color.light.warm_gold.70": "#67440C",
	"color.light.warm_gold.80": "#312109",
	"color.light.warm_gold.grey.20": "#F5F5F5",
	"color.light.warm_gold.grey.40": "#E0E0E0",
	"color.light.warm_gold.grey.60": "#B5B5B5",
	"color.light.warm_gold.grey.80": "#000000A5",
	"color.light.warm_gold.grey.100": "#141414",
	"color.light.warm_gold.background": "#FFFFFF",
	"color.light.warm_gold.inverse": "#312109",
	"color.dark.warm_gold.20": "#312109",
	"color.dark.warm_gold.30": "#67440C",
	"color.dark.warm_gold.40": "#A8711A",
	"color.dark.warm_gold.50": "#EFA73D",
	"color.dark.warm_gold.60": "#F6C586",
	"color.dark.warm_gold.70": "#FCE7D0",
	"color.dark.warm_gold.80": "#FDFDFD",
	"color.dark.warm_gold.grey.20": "#2B2B2B",
	"color.dark.warm_gold.grey.40": "#5A5A5A",
	"color.dark.warm_gold.grey.60": "#A1A1A1",
	"color.dark.warm_gold.grey.80": "#FFFFFFC7",
	"color.dark.warm_gold.grey.100": "#FFFFFF",
	"color.dark.warm_gold.background": "#120C04",
	"color.dark.warm_gold.inverse": "#312109",
	"color.bold.warm_gold.20": "#EFA73D",
	"color.bold.warm_gold.30": "#C78724",
	"color.bold.warm_gold.40": "#8E5F15",
	"color.bold.warm_gold.50": "#67440C",
	"color.bold.warm_gold.60": "#452D09",
	"color.bold.warm_gold.70": "#312109",
	"color.bold.warm_gold.80": "#241908",
	"color.bold.warm_gold.grey.20": "#401D0C1E",
	"color.bold.warm_gold.grey.40": "#401D0C4D",
	"color.bold.warm_gold.grey.60": "#401D0C87",
	"color.bold.warm_gold.grey.80": "#401D0CBF",
	"color.bold.warm_gold.grey.100": "#401D0C",
	"color.bold.warm_gold.background": "#E39B2B",
	"color.bold.warm_gold.inverse": "#FEF7EF",
	elevation1: elevation1,
	"elevation1.light": "{color.light.$primary.background}",
	"elevation1.dark": "{color.dark.$primary.grey.20}",
	"elevation1.bold": "{color.bold.$primary.background}",
	custom_color_1: custom_color_1,
	custom_color_2: custom_color_2,
	custom_color_3: custom_color_3,
	custom_color_4: custom_color_4,
	custom_color_5: custom_color_5,
	custom_color_6: custom_color_6,
	custom_dark_primary_40: custom_dark_primary_40,
	custom_dark_primary_60: custom_dark_primary_60,
	custom_dark_primary_grey_80: custom_dark_primary_grey_80,
	custom_dark_primary_grey_100: custom_dark_primary_grey_100
};

const headingXl$4 = "{$lang.$platform.headingXl}";
const headingL$4 = "{$lang.$platform.headingL}";
const headingM$4 = "{$lang.$platform.headingM}";
const headingS$4 = "{$lang.$platform.headingS}";
const headingXs$4 = "{$lang.$platform.headingXs}";
const headingXxs$4 = "{$lang.$platform.headingXxs}";
const overline$5 = "{$lang.$platform.overline}";
const bodyL$4 = "{$lang.$platform.bodyL}";
const bodyLBold$4 = "{$lang.$platform.bodyLBold}";
const bodyLLink$4 = "{$lang.$platform.bodyLLink}";
const bodyM$4 = "{$lang.$platform.bodyM}";
const bodyMBold$4 = "{$lang.$platform.bodyMBold}";
const bodyMLink$4 = "{$lang.$platform.bodyMLink}";
const bodyS$4 = "{$lang.$platform.bodyS}";
const bodySBold$4 = "{$lang.$platform.bodySBold}";
const bodySLink$4 = "{$lang.$platform.bodySLink}";
const bodyXs$4 = "{$lang.$platform.bodyXs}";
const bodyXsBold$4 = "{$lang.$platform.bodyXsBold}";
const bodyXsLink$4 = "{$lang.$platform.bodyXsLink}";
const bodyXxs$4 = "{$lang.$platform.bodyXxs}";
const bodyXxsBold$4 = "{$lang.$platform.bodyXxsBold}";
const bodyXxsLink$4 = "{$lang.$platform.bodyXxsLink}";
const listTitle$4 = "{$lang.$platform.listTitle}";
const button$4 = "{$lang.$platform.button}";
const code$4 = "{$lang.$platform.code}";
const fontFamilies = {
	"as.desktop.headingXl": "Noto Sans",
	"as.desktop.headingL": "Noto Sans",
	"as.desktop.headingM": "Noto Sans",
	"as.desktop.headingS": "Noto Sans",
	"as.desktop.headingXs": "Noto Sans",
	"as.desktop.headingXxs": "Noto Sans",
	"as.desktop.overline": "Noto Sans",
	"as.desktop.bodyL": "Noto Sans",
	"as.desktop.bodyLBold": "Noto Sans",
	"as.desktop.bodyLLink": "Noto Sans",
	"as.desktop.bodyM": "Noto Sans",
	"as.desktop.bodyMBold": "Noto Sans",
	"as.desktop.bodyMLink": "Noto Sans",
	"as.desktop.bodyS": "Noto Sans",
	"as.desktop.bodySBold": "Noto Sans",
	"as.desktop.bodySLink": "Noto Sans",
	"as.desktop.bodyXs": "Noto Sans",
	"as.desktop.bodyXsBold": "Noto Sans",
	"as.desktop.bodyXsLink": "Noto Sans",
	"as.desktop.bodyXxs": "Noto Sans",
	"as.desktop.bodyXxsBold": "Noto Sans",
	"as.desktop.bodyXxsLink": "Noto Sans",
	"as.desktop.listTitle": "Noto Sans",
	"as.desktop.button": "Noto Sans",
	"as.desktop.code": "JetBrains Mono",
	"as.mobile.headingXl": "Noto Sans",
	"as.mobile.headingL": "Noto Sans",
	"as.mobile.headingM": "Noto Sans",
	"as.mobile.headingS": "Noto Sans",
	"as.mobile.headingXs": "Noto Sans",
	"as.mobile.headingXxs": "Noto Sans",
	"as.mobile.overline": "Noto Sans",
	"as.mobile.bodyL": "Noto Sans",
	"as.mobile.bodyLBold": "Noto Sans",
	"as.mobile.bodyLLink": "Noto Sans",
	"as.mobile.bodyM": "Noto Sans",
	"as.mobile.bodyMBold": "Noto Sans",
	"as.mobile.bodyMLink": "Noto Sans",
	"as.mobile.bodyS": "Noto Sans",
	"as.mobile.bodySBold": "Noto Sans",
	"as.mobile.bodySLink": "Noto Sans",
	"as.mobile.bodyXs": "Noto Sans",
	"as.mobile.bodyXsBold": "Noto Sans",
	"as.mobile.bodyXsLink": "Noto Sans",
	"as.mobile.bodyXxs": "Noto Sans",
	"as.mobile.bodyXxsBold": "Noto Sans",
	"as.mobile.bodyXxsLink": "Noto Sans",
	"as.mobile.listTitle": "Noto Sans",
	"as.mobile.button": "Noto Sans",
	"as.mobile.code": "JetBrains Mono",
	"bn.desktop.headingXl": "Noto Sans Bengali",
	"bn.desktop.headingL": "Noto Sans Bengali",
	"bn.desktop.headingM": "Noto Sans Bengali",
	"bn.desktop.headingS": "Noto Sans Bengali",
	"bn.desktop.headingXs": "Noto Sans Bengali",
	"bn.desktop.headingXxs": "Noto Sans Bengali",
	"bn.desktop.overline": "Noto Sans Bengali",
	"bn.desktop.bodyL": "Noto Sans Bengali",
	"bn.desktop.bodyLBold": "Noto Sans Bengali",
	"bn.desktop.bodyLLink": "Noto Sans Bengali",
	"bn.desktop.bodyM": "Noto Sans Bengali",
	"bn.desktop.bodyMBold": "Noto Sans Bengali",
	"bn.desktop.bodyMLink": "Noto Sans Bengali",
	"bn.desktop.bodyS": "Noto Sans Bengali",
	"bn.desktop.bodySBold": "Noto Sans Bengali",
	"bn.desktop.bodySLink": "Noto Sans Bengali",
	"bn.desktop.bodyXs": "Noto Sans Bengali",
	"bn.desktop.bodyXsBold": "Noto Sans Bengali",
	"bn.desktop.bodyXsLink": "Noto Sans Bengali",
	"bn.desktop.bodyXxs": "Noto Sans Bengali",
	"bn.desktop.bodyXxsBold": "Noto Sans Bengali",
	"bn.desktop.bodyXxsLink": "Noto Sans Bengali",
	"bn.desktop.listTitle": "Noto Sans Bengali",
	"bn.desktop.button": "Noto Sans Bengali",
	"bn.desktop.code": "JetBrains Mono",
	"bn.mobile.headingXl": "Noto Sans Bengali",
	"bn.mobile.headingL": "Noto Sans Bengali",
	"bn.mobile.headingM": "Noto Sans Bengali",
	"bn.mobile.headingS": "Noto Sans Bengali",
	"bn.mobile.headingXs": "Noto Sans Bengali",
	"bn.mobile.headingXxs": "Noto Sans Bengali",
	"bn.mobile.overline": "Noto Sans Bengali",
	"bn.mobile.bodyL": "Noto Sans Bengali",
	"bn.mobile.bodyLBold": "Noto Sans Bengali",
	"bn.mobile.bodyLLink": "Noto Sans Bengali",
	"bn.mobile.bodyM": "Noto Sans Bengali",
	"bn.mobile.bodyMBold": "Noto Sans Bengali",
	"bn.mobile.bodyMLink": "Noto Sans Bengali",
	"bn.mobile.bodyS": "Noto Sans Bengali",
	"bn.mobile.bodySBold": "Noto Sans Bengali",
	"bn.mobile.bodySLink": "Noto Sans Bengali",
	"bn.mobile.bodyXs": "Noto Sans Bengali",
	"bn.mobile.bodyXsBold": "Noto Sans Bengali",
	"bn.mobile.bodyXsLink": "Noto Sans Bengali",
	"bn.mobile.bodyXxs": "Noto Sans Bengali",
	"bn.mobile.bodyXxsBold": "Noto Sans Bengali",
	"bn.mobile.bodyXxsLink": "Noto Sans Bengali",
	"bn.mobile.listTitle": "Noto Sans Bengali",
	"bn.mobile.button": "Noto Sans Bengali",
	"bn.mobile.code": "JetBrains Mono",
	"en.desktop.headingXl": "JioType Black",
	"en.desktop.headingL": "JioType Black",
	"en.desktop.headingM": "JioType Black",
	"en.desktop.headingS": "JioType Black",
	"en.desktop.headingXs": "JioType Black",
	"en.desktop.headingXxs": "JioType Black",
	"en.desktop.overline": "JioType Bold",
	"en.desktop.bodyL": "JioType Medium",
	"en.desktop.bodyLBold": "JioType Bold",
	"en.desktop.bodyLLink": "JioType Bold",
	"en.desktop.bodyM": "JioType Medium",
	"en.desktop.bodyMBold": "JioType Bold",
	"en.desktop.bodyMLink": "JioType Bold",
	"en.desktop.bodyS": "JioType Medium",
	"en.desktop.bodySBold": "JioType Bold",
	"en.desktop.bodySLink": "JioType Bold",
	"en.desktop.bodyXs": "JioType Medium",
	"en.desktop.bodyXsBold": "JioType Bold",
	"en.desktop.bodyXsLink": "JioType Bold",
	"en.desktop.bodyXxs": "JioType Medium",
	"en.desktop.bodyXxsBold": "JioType Bold",
	"en.desktop.bodyXxsLink": "JioType Bold",
	"en.desktop.listTitle": "JioType Medium",
	"en.desktop.button": "JioType Bold",
	"en.desktop.code": "JetBrains Mono",
	"en.mobile.headingXl": "JioType Black",
	"en.mobile.headingL": "JioType Black",
	"en.mobile.headingM": "JioType Black",
	"en.mobile.headingS": "JioType Black",
	"en.mobile.headingXs": "JioType Black",
	"en.mobile.headingXxs": "JioType Black",
	"en.mobile.overline": "JioType Bold",
	"en.mobile.bodyL": "JioType Medium",
	"en.mobile.bodyLBold": "JioType Bold",
	"en.mobile.bodyLLink": "JioType Bold",
	"en.mobile.bodyM": "JioType Medium",
	"en.mobile.bodyMBold": "JioType Bold",
	"en.mobile.bodyMLink": "JioType Bold",
	"en.mobile.bodyS": "JioType Medium",
	"en.mobile.bodySBold": "JioType Bold",
	"en.mobile.bodySLink": "JioType Bold",
	"en.mobile.bodyXs": "JioType Medium",
	"en.mobile.bodyXsBold": "JioType Bold",
	"en.mobile.bodyXsLink": "JioType Bold",
	"en.mobile.bodyXxs": "JioType Medium",
	"en.mobile.bodyXxsBold": "JioType Bold",
	"en.mobile.bodyXxsLink": "JioType Bold",
	"en.mobile.listTitle": "JioType Medium",
	"en.mobile.button": "JioType Bold",
	"en.mobile.code": "JetBrains Mono",
	"gu.desktop.headingXl": "Noto Sans Gujarati",
	"gu.desktop.headingL": "Noto Sans Gujarati",
	"gu.desktop.headingM": "Noto Sans Gujarati",
	"gu.desktop.headingS": "Noto Sans Gujarati",
	"gu.desktop.headingXs": "Noto Sans Gujarati",
	"gu.desktop.headingXxs": "Noto Sans Gujarati",
	"gu.desktop.overline": "Noto Sans Gujarati",
	"gu.desktop.bodyL": "Noto Sans Gujarati",
	"gu.desktop.bodyLBold": "Noto Sans Gujarati",
	"gu.desktop.bodyLLink": "Noto Sans Gujarati",
	"gu.desktop.bodyM": "Noto Sans Gujarati",
	"gu.desktop.bodyMBold": "Noto Sans Gujarati",
	"gu.desktop.bodyMLink": "Noto Sans Gujarati",
	"gu.desktop.bodyS": "Noto Sans Gujarati",
	"gu.desktop.bodySBold": "Noto Sans Gujarati",
	"gu.desktop.bodySLink": "Noto Sans Gujarati",
	"gu.desktop.bodyXs": "Noto Sans Gujarati",
	"gu.desktop.bodyXsBold": "Noto Sans Gujarati",
	"gu.desktop.bodyXsLink": "Noto Sans Gujarati",
	"gu.desktop.bodyXxs": "Noto Sans Gujarati",
	"gu.desktop.bodyXxsBold": "Noto Sans Gujarati",
	"gu.desktop.bodyXxsLink": "Noto Sans Gujarati",
	"gu.desktop.listTitle": "Noto Sans Gujarati",
	"gu.desktop.button": "Noto Sans Gujarati",
	"gu.desktop.code": "JetBrains Mono",
	"gu.mobile.headingXl": "Noto Sans Gujarati",
	"gu.mobile.headingL": "Noto Sans Gujarati",
	"gu.mobile.headingM": "Noto Sans Gujarati",
	"gu.mobile.headingS": "Noto Sans Gujarati",
	"gu.mobile.headingXs": "Noto Sans Gujarati",
	"gu.mobile.headingXxs": "Noto Sans Gujarati",
	"gu.mobile.overline": "Noto Sans Gujarati",
	"gu.mobile.bodyL": "Noto Sans Gujarati",
	"gu.mobile.bodyLBold": "Noto Sans Gujarati",
	"gu.mobile.bodyLLink": "Noto Sans Gujarati",
	"gu.mobile.bodyM": "Noto Sans Gujarati",
	"gu.mobile.bodyMBold": "Noto Sans Gujarati",
	"gu.mobile.bodyMLink": "Noto Sans Gujarati",
	"gu.mobile.bodyS": "Noto Sans Gujarati",
	"gu.mobile.bodySBold": "Noto Sans Gujarati",
	"gu.mobile.bodySLink": "Noto Sans Gujarati",
	"gu.mobile.bodyXs": "Noto Sans Gujarati",
	"gu.mobile.bodyXsBold": "Noto Sans Gujarati",
	"gu.mobile.bodyXsLink": "Noto Sans Gujarati",
	"gu.mobile.bodyXxs": "Noto Sans Gujarati",
	"gu.mobile.bodyXxsBold": "Noto Sans Gujarati",
	"gu.mobile.bodyXxsLink": "Noto Sans Gujarati",
	"gu.mobile.listTitle": "Noto Sans Gujarati",
	"gu.mobile.button": "Noto Sans Gujarati",
	"gu.mobile.code": "JetBrains Mono",
	"hi.desktop.headingXl": "Noto Sans",
	"hi.desktop.headingL": "Noto Sans",
	"hi.desktop.headingM": "Noto Sans",
	"hi.desktop.headingS": "Noto Sans",
	"hi.desktop.headingXs": "Noto Sans",
	"hi.desktop.headingXxs": "Noto Sans",
	"hi.desktop.overline": "Noto Sans Bengali",
	"hi.desktop.bodyL": "Noto Sans",
	"hi.desktop.bodyLBold": "Noto Sans",
	"hi.desktop.bodyLLink": "Noto Sans",
	"hi.desktop.bodyM": "Noto Sans",
	"hi.desktop.bodyMBold": "Noto Sans",
	"hi.desktop.bodyMLink": "Noto Sans",
	"hi.desktop.bodyS": "Noto Sans",
	"hi.desktop.bodySBold": "Noto Sans",
	"hi.desktop.bodySLink": "Noto Sans",
	"hi.desktop.bodyXs": "Noto Sans",
	"hi.desktop.bodyXsBold": "Noto Sans",
	"hi.desktop.bodyXsLink": "Noto Sans",
	"hi.desktop.bodyXxs": "Noto Sans",
	"hi.desktop.bodyXxsBold": "Noto Sans",
	"hi.desktop.bodyXxsLink": "Noto Sans",
	"hi.desktop.listTitle": "Noto Sans",
	"hi.desktop.button": "Noto Sans",
	"hi.desktop.code": "JetBrains Mono",
	"hi.mobile.headingXl": "Noto Sans",
	"hi.mobile.headingL": "Noto Sans",
	"hi.mobile.headingM": "Noto Sans",
	"hi.mobile.headingS": "Noto Sans",
	"hi.mobile.headingXs": "Noto Sans",
	"hi.mobile.headingXxs": "Noto Sans",
	"hi.mobile.overline": "Noto Sans",
	"hi.mobile.bodyL": "Noto Sans",
	"hi.mobile.bodyLBold": "Noto Sans",
	"hi.mobile.bodyLLink": "Noto Sans",
	"hi.mobile.bodyM": "Noto Sans",
	"hi.mobile.bodyMBold": "Noto Sans",
	"hi.mobile.bodyMLink": "Noto Sans",
	"hi.mobile.bodyS": "Noto Sans",
	"hi.mobile.bodySBold": "Noto Sans",
	"hi.mobile.bodySLink": "Noto Sans",
	"hi.mobile.bodyXs": "Noto Sans",
	"hi.mobile.bodyXsBold": "Noto Sans",
	"hi.mobile.bodyXsLink": "Noto Sans",
	"hi.mobile.bodyXxs": "Noto Sans",
	"hi.mobile.bodyXxsBold": "Noto Sans",
	"hi.mobile.bodyXxsLink": "Noto Sans",
	"hi.mobile.listTitle": "Noto Sans",
	"hi.mobile.button": "Noto Sans",
	"hi.mobile.code": "JetBrains Mono",
	"kn.desktop.headingXl": "Noto Sans Kannada",
	"kn.desktop.headingL": "Noto Sans Kannada",
	"kn.desktop.headingM": "Noto Sans Kannada",
	"kn.desktop.headingS": "Noto Sans Kannada",
	"kn.desktop.headingXs": "Noto Sans Kannada",
	"kn.desktop.headingXxs": "Noto Sans Kannada",
	"kn.desktop.overline": "Noto Sans Kannada",
	"kn.desktop.bodyL": "Noto Sans Kannada",
	"kn.desktop.bodyLBold": "Noto Sans Kannada",
	"kn.desktop.bodyLLink": "Noto Sans Kannada",
	"kn.desktop.bodyM": "Noto Sans Kannada",
	"kn.desktop.bodyMBold": "Noto Sans Kannada",
	"kn.desktop.bodyMLink": "Noto Sans Kannada",
	"kn.desktop.bodyS": "Noto Sans Kannada",
	"kn.desktop.bodySBold": "Noto Sans Kannada",
	"kn.desktop.bodySLink": "Noto Sans Kannada",
	"kn.desktop.bodyXs": "Noto Sans Kannada",
	"kn.desktop.bodyXsBold": "Noto Sans Kannada",
	"kn.desktop.bodyXsLink": "Noto Sans Kannada",
	"kn.desktop.bodyXxs": "Noto Sans Kannada",
	"kn.desktop.bodyXxsBold": "Noto Sans Kannada",
	"kn.desktop.bodyXxsLink": "Noto Sans Kannada",
	"kn.desktop.listTitle": "Noto Sans Kannada",
	"kn.desktop.button": "Noto Sans Kannada",
	"kn.desktop.code": "JetBrains Mono",
	"kn.mobile.headingXl": "Noto Sans Kannada",
	"kn.mobile.headingL": "Noto Sans Kannada",
	"kn.mobile.headingM": "Noto Sans Kannada",
	"kn.mobile.headingS": "Noto Sans Kannada",
	"kn.mobile.headingXs": "Noto Sans Kannada",
	"kn.mobile.headingXxs": "Noto Sans Kannada",
	"kn.mobile.overline": "Noto Sans Kannada",
	"kn.mobile.bodyL": "Noto Sans Kannada",
	"kn.mobile.bodyLBold": "Noto Sans Kannada",
	"kn.mobile.bodyLLink": "Noto Sans Kannada",
	"kn.mobile.bodyM": "Noto Sans Kannada",
	"kn.mobile.bodyMBold": "Noto Sans Kannada",
	"kn.mobile.bodyMLink": "Noto Sans Kannada",
	"kn.mobile.bodyS": "Noto Sans Kannada",
	"kn.mobile.bodySBold": "Noto Sans Kannada",
	"kn.mobile.bodySLink": "Noto Sans Kannada",
	"kn.mobile.bodyXs": "Noto Sans Kannada",
	"kn.mobile.bodyXsBold": "Noto Sans Kannada",
	"kn.mobile.bodyXsLink": "Noto Sans Kannada",
	"kn.mobile.bodyXxs": "Noto Sans Kannada",
	"kn.mobile.bodyXxsBold": "Noto Sans Kannada",
	"kn.mobile.bodyXxsLink": "Noto Sans Kannada",
	"kn.mobile.listTitle": "Noto Sans Kannada",
	"kn.mobile.button": "Noto Sans Kannada",
	"kn.mobile.code": "JetBrains Mono",
	"ml.desktop.headingXl": "Noto Sans Malayalam",
	"ml.desktop.headingL": "Noto Sans Malayalam",
	"ml.desktop.headingM": "Noto Sans Malayalam",
	"ml.desktop.headingS": "Noto Sans Malayalam",
	"ml.desktop.headingXs": "Noto Sans Malayalam",
	"ml.desktop.headingXxs": "Noto Sans Malayalam",
	"ml.desktop.overline": "Noto Sans Malayalam",
	"ml.desktop.bodyL": "Noto Sans Malayalam",
	"ml.desktop.bodyLBold": "Noto Sans Malayalam",
	"ml.desktop.bodyLLink": "Noto Sans Malayalam",
	"ml.desktop.bodyM": "Noto Sans Malayalam",
	"ml.desktop.bodyMBold": "Noto Sans Malayalam",
	"ml.desktop.bodyMLink": "Noto Sans Malayalam",
	"ml.desktop.bodyS": "Noto Sans Malayalam",
	"ml.desktop.bodySBold": "Noto Sans Malayalam",
	"ml.desktop.bodySLink": "Noto Sans Malayalam",
	"ml.desktop.bodyXs": "Noto Sans Malayalam",
	"ml.desktop.bodyXsBold": "Noto Sans Malayalam",
	"ml.desktop.bodyXsLink": "Noto Sans Malayalam",
	"ml.desktop.bodyXxs": "Noto Sans Malayalam",
	"ml.desktop.bodyXxsBold": "Noto Sans Malayalam",
	"ml.desktop.bodyXxsLink": "Noto Sans Malayalam",
	"ml.desktop.listTitle": "Noto Sans Malayalam",
	"ml.desktop.button": "Noto Sans Malayalam",
	"ml.desktop.code": "JetBrains Mono",
	"ml.mobile.headingXl": "Noto Sans Malayalam",
	"ml.mobile.headingL": "Noto Sans Malayalam",
	"ml.mobile.headingM": "Noto Sans Malayalam",
	"ml.mobile.headingS": "Noto Sans Malayalam",
	"ml.mobile.headingXs": "Noto Sans Malayalam",
	"ml.mobile.headingXxs": "Noto Sans Malayalam",
	"ml.mobile.overline": "Noto Sans Malayalam",
	"ml.mobile.bodyL": "Noto Sans Malayalam",
	"ml.mobile.bodyLBold": "Noto Sans Malayalam",
	"ml.mobile.bodyLLink": "Noto Sans Malayalam",
	"ml.mobile.bodyM": "Noto Sans Malayalam",
	"ml.mobile.bodyMBold": "Noto Sans Malayalam",
	"ml.mobile.bodyMLink": "Noto Sans Malayalam",
	"ml.mobile.bodyS": "Noto Sans Malayalam",
	"ml.mobile.bodySBold": "Noto Sans Malayalam",
	"ml.mobile.bodySLink": "Noto Sans Malayalam",
	"ml.mobile.bodyXs": "Noto Sans Malayalam",
	"ml.mobile.bodyXsBold": "Noto Sans Malayalam",
	"ml.mobile.bodyXsLink": "Noto Sans Malayalam",
	"ml.mobile.bodyXxs": "Noto Sans Malayalam",
	"ml.mobile.bodyXxsBold": "Noto Sans Malayalam",
	"ml.mobile.bodyXxsLink": "Noto Sans Malayalam",
	"ml.mobile.listTitle": "Noto Sans Malayalam",
	"ml.mobile.button": "Noto Sans Malayalam",
	"ml.mobile.code": "JetBrains Mono",
	"mr.desktop.headingXl": "Noto Sans",
	"mr.desktop.headingL": "Noto Sans",
	"mr.desktop.headingM": "Noto Sans",
	"mr.desktop.headingS": "Noto Sans",
	"mr.desktop.headingXs": "Noto Sans",
	"mr.desktop.headingXxs": "Noto Sans",
	"mr.desktop.overline": "Noto Sans",
	"mr.desktop.bodyL": "Noto Sans",
	"mr.desktop.bodyLBold": "Noto Sans",
	"mr.desktop.bodyLLink": "Noto Sans",
	"mr.desktop.bodyM": "Noto Sans",
	"mr.desktop.bodyMBold": "Noto Sans",
	"mr.desktop.bodyMLink": "Noto Sans",
	"mr.desktop.bodyS": "Noto Sans",
	"mr.desktop.bodySBold": "Noto Sans",
	"mr.desktop.bodySLink": "Noto Sans",
	"mr.desktop.bodyXs": "Noto Sans",
	"mr.desktop.bodyXsBold": "Noto Sans",
	"mr.desktop.bodyXsLink": "Noto Sans",
	"mr.desktop.bodyXxs": "Noto Sans",
	"mr.desktop.bodyXxsBold": "Noto Sans",
	"mr.desktop.bodyXxsLink": "Noto Sans",
	"mr.desktop.listTitle": "Noto Sans",
	"mr.desktop.button": "Noto Sans",
	"mr.desktop.code": "JetBrains Mono",
	"mr.mobile.headingXl": "Noto Sans",
	"mr.mobile.headingL": "Noto Sans",
	"mr.mobile.headingM": "Noto Sans",
	"mr.mobile.headingS": "Noto Sans",
	"mr.mobile.headingXs": "Noto Sans",
	"mr.mobile.headingXxs": "Noto Sans",
	"mr.mobile.overline": "Noto Sans Oriya",
	"mr.mobile.bodyL": "Noto Sans",
	"mr.mobile.bodyLBold": "Noto Sans",
	"mr.mobile.bodyLLink": "Noto Sans",
	"mr.mobile.bodyM": "Noto Sans",
	"mr.mobile.bodyMBold": "Noto Sans",
	"mr.mobile.bodyMLink": "Noto Sans",
	"mr.mobile.bodyS": "Noto Sans",
	"mr.mobile.bodySBold": "Noto Sans",
	"mr.mobile.bodySLink": "Noto Sans",
	"mr.mobile.bodyXs": "Noto Sans",
	"mr.mobile.bodyXsBold": "Noto Sans",
	"mr.mobile.bodyXsLink": "Noto Sans",
	"mr.mobile.bodyXxs": "Noto Sans",
	"mr.mobile.bodyXxsBold": "Noto Sans",
	"mr.mobile.bodyXxsLink": "Noto Sans",
	"mr.mobile.listTitle": "Noto Sans",
	"mr.mobile.button": "Noto Sans",
	"mr.mobile.code": "JetBrains Mono",
	"or.desktop.headingXl": "Noto Sans Oriya",
	"or.desktop.headingL": "Noto Sans Oriya",
	"or.desktop.headingM": "Noto Sans Oriya",
	"or.desktop.headingS": "Noto Sans Oriya",
	"or.desktop.headingXs": "Noto Sans Oriya",
	"or.desktop.headingXxs": "Noto Sans Oriya",
	"or.desktop.overline": "Noto Sans Oriya",
	"or.desktop.bodyL": "Noto Sans Oriya",
	"or.desktop.bodyLBold": "Noto Sans Oriya",
	"or.desktop.bodyLLink": "Noto Sans Oriya",
	"or.desktop.bodyM": "Noto Sans Oriya",
	"or.desktop.bodyMBold": "Noto Sans Oriya",
	"or.desktop.bodyMLink": "Noto Sans Oriya",
	"or.desktop.bodyS": "Noto Sans Oriya",
	"or.desktop.bodySBold": "Noto Sans Oriya",
	"or.desktop.bodySLink": "Noto Sans Oriya",
	"or.desktop.bodyXs": "Noto Sans Oriya",
	"or.desktop.bodyXsBold": "Noto Sans Oriya",
	"or.desktop.bodyXsLink": "Noto Sans Oriya",
	"or.desktop.bodyXxs": "Noto Sans Oriya",
	"or.desktop.bodyXxsBold": "Noto Sans Oriya",
	"or.desktop.bodyXxsLink": "Noto Sans Oriya",
	"or.desktop.listTitle": "Noto Sans Oriya",
	"or.desktop.button": "Noto Sans Oriya",
	"or.desktop.code": "JetBrains Mono",
	"or.mobile.headingXl": "Noto Sans Oriya",
	"or.mobile.headingL": "Noto Sans Oriya",
	"or.mobile.headingM": "Noto Sans Oriya",
	"or.mobile.headingS": "Noto Sans Oriya",
	"or.mobile.headingXs": "Noto Sans Oriya",
	"or.mobile.headingXxs": "Noto Sans Oriya",
	"or.mobile.overline": "Noto Sans Oriya",
	"or.mobile.bodyL": "Noto Sans Oriya",
	"or.mobile.bodyLBold": "Noto Sans Oriya",
	"or.mobile.bodyLLink": "Noto Sans Oriya",
	"or.mobile.bodyM": "Noto Sans Oriya",
	"or.mobile.bodyMBold": "Noto Sans Oriya",
	"or.mobile.bodyMLink": "Noto Sans Oriya",
	"or.mobile.bodyS": "Noto Sans Oriya",
	"or.mobile.bodySBold": "Noto Sans Oriya",
	"or.mobile.bodySLink": "Noto Sans Oriya",
	"or.mobile.bodyXs": "Noto Sans Oriya",
	"or.mobile.bodyXsBold": "Noto Sans Oriya",
	"or.mobile.bodyXsLink": "Noto Sans Oriya",
	"or.mobile.bodyXxs": "Noto Sans Oriya",
	"or.mobile.bodyXxsBold": "Noto Sans Oriya",
	"or.mobile.bodyXxsLink": "Noto Sans Oriya",
	"or.mobile.listTitle": "Noto Sans Oriya",
	"or.mobile.button": "Noto Sans Oriya",
	"or.mobile.code": "JetBrains Mono",
	"pa.desktop.headingXl": "Noto Sans Gurmukhi",
	"pa.desktop.headingL": "Noto Sans Gurmukhi",
	"pa.desktop.headingM": "Noto Sans Gurmukhi",
	"pa.desktop.headingS": "Noto Sans Gurmukhi",
	"pa.desktop.headingXs": "Noto Sans Gurmukhi",
	"pa.desktop.headingXxs": "Noto Sans Gurmukhi",
	"pa.desktop.overline": "Noto Sans Gurmukhi",
	"pa.desktop.bodyL": "Noto Sans Gurmukhi",
	"pa.desktop.bodyLBold": "Noto Sans Gurmukhi",
	"pa.desktop.bodyLLink": "Noto Sans Gurmukhi",
	"pa.desktop.bodyM": "Noto Sans Gurmukhi",
	"pa.desktop.bodyMBold": "Noto Sans Gurmukhi",
	"pa.desktop.bodyMLink": "Noto Sans Gurmukhi",
	"pa.desktop.bodyS": "Noto Sans Gurmukhi",
	"pa.desktop.bodySBold": "Noto Sans Gurmukhi",
	"pa.desktop.bodySLink": "Noto Sans Gurmukhi",
	"pa.desktop.bodyXs": "Noto Sans Gurmukhi",
	"pa.desktop.bodyXsBold": "Noto Sans Gurmukhi",
	"pa.desktop.bodyXsLink": "Noto Sans Gurmukhi",
	"pa.desktop.bodyXxs": "Noto Sans Gurmukhi",
	"pa.desktop.bodyXxsBold": "Noto Sans Gurmukhi",
	"pa.desktop.bodyXxsLink": "Noto Sans Gurmukhi",
	"pa.desktop.listTitle": "Noto Sans Gurmukhi",
	"pa.desktop.button": "Noto Sans Gurmukhi",
	"pa.desktop.code": "JetBrains Mono",
	"pa.mobile.headingXl": "Noto Sans Gurmukhi",
	"pa.mobile.headingL": "Noto Sans Gurmukhi",
	"pa.mobile.headingM": "Noto Sans Gurmukhi",
	"pa.mobile.headingS": "Noto Sans Gurmukhi",
	"pa.mobile.headingXs": "Noto Sans Gurmukhi",
	"pa.mobile.headingXxs": "Noto Sans Gurmukhi",
	"pa.mobile.overline": "Noto Sans Gurmukhi",
	"pa.mobile.bodyL": "Noto Sans Gurmukhi",
	"pa.mobile.bodyLBold": "Noto Sans Gurmukhi",
	"pa.mobile.bodyLLink": "Noto Sans Gurmukhi",
	"pa.mobile.bodyM": "Noto Sans Gurmukhi",
	"pa.mobile.bodyMBold": "Noto Sans Gurmukhi",
	"pa.mobile.bodyMLink": "Noto Sans Gurmukhi",
	"pa.mobile.bodyS": "Noto Sans Gurmukhi",
	"pa.mobile.bodySBold": "Noto Sans Gurmukhi",
	"pa.mobile.bodySLink": "Noto Sans Gurmukhi",
	"pa.mobile.bodyXs": "Noto Sans Gurmukhi",
	"pa.mobile.bodyXsBold": "Noto Sans Gurmukhi",
	"pa.mobile.bodyXsLink": "Noto Sans Gurmukhi",
	"pa.mobile.bodyXxs": "Noto Sans Gurmukhi",
	"pa.mobile.bodyXxsBold": "Noto Sans Gurmukhi",
	"pa.mobile.bodyXxsLink": "Noto Sans Gurmukhi",
	"pa.mobile.listTitle": "Noto Sans Gurmukhi",
	"pa.mobile.button": "Noto Sans Gurmukhi",
	"pa.mobile.code": "JetBrains Mono",
	"ta.desktop.headingXl": "Noto Sans Tamil",
	"ta.desktop.headingL": "Noto Sans Tamil",
	"ta.desktop.headingM": "Noto Sans Tamil",
	"ta.desktop.headingS": "Noto Sans Tamil",
	"ta.desktop.headingXs": "Noto Sans Tamil",
	"ta.desktop.headingXxs": "Noto Sans Tamil",
	"ta.desktop.overline": "Noto Sans Tamil",
	"ta.desktop.bodyL": "Noto Sans Tamil",
	"ta.desktop.bodyLBold": "Noto Sans Tamil",
	"ta.desktop.bodyLLink": "Noto Sans Tamil",
	"ta.desktop.bodyM": "Noto Sans Tamil",
	"ta.desktop.bodyMBold": "Noto Sans Tamil",
	"ta.desktop.bodyMLink": "Noto Sans Tamil",
	"ta.desktop.bodyS": "Noto Sans Tamil",
	"ta.desktop.bodySBold": "Noto Sans Tamil",
	"ta.desktop.bodySLink": "Noto Sans Tamil",
	"ta.desktop.bodyXs": "Noto Sans Tamil",
	"ta.desktop.bodyXsBold": "Noto Sans Tamil",
	"ta.desktop.bodyXsLink": "Noto Sans Tamil",
	"ta.desktop.bodyXxs": "Noto Sans Tamil",
	"ta.desktop.bodyXxsBold": "Noto Sans Tamil",
	"ta.desktop.bodyXxsLink": "Noto Sans Tamil",
	"ta.desktop.listTitle": "Noto Sans Tamil",
	"ta.desktop.button": "Noto Sans Tamil",
	"ta.desktop.code": "JetBrains Mono",
	"ta.mobile.headingXl": "Noto Sans Tamil",
	"ta.mobile.headingL": "Noto Sans Tamil",
	"ta.mobile.headingM": "Noto Sans Tamil",
	"ta.mobile.headingS": "Noto Sans Tamil",
	"ta.mobile.headingXs": "Noto Sans Tamil",
	"ta.mobile.headingXxs": "Noto Sans Tamil",
	"ta.mobile.overline": "Noto Sans Tamil",
	"ta.mobile.bodyL": "Noto Sans Tamil",
	"ta.mobile.bodyLBold": "Noto Sans Tamil",
	"ta.mobile.bodyLLink": "Noto Sans Tamil",
	"ta.mobile.bodyM": "Noto Sans Tamil",
	"ta.mobile.bodyMBold": "Noto Sans Tamil",
	"ta.mobile.bodyMLink": "Noto Sans Tamil",
	"ta.mobile.bodyS": "Noto Sans Tamil",
	"ta.mobile.bodySBold": "Noto Sans Tamil",
	"ta.mobile.bodySLink": "Noto Sans Tamil",
	"ta.mobile.bodyXs": "Noto Sans Tamil",
	"ta.mobile.bodyXsBold": "Noto Sans Tamil",
	"ta.mobile.bodyXsLink": "Noto Sans Tamil",
	"ta.mobile.bodyXxs": "Noto Sans Tamil",
	"ta.mobile.bodyXxsBold": "Noto Sans Tamil",
	"ta.mobile.bodyXxsLink": "Noto Sans Tamil",
	"ta.mobile.listTitle": "Noto Sans Tamil",
	"ta.mobile.button": "Noto Sans Tamil",
	"ta.mobile.code": "JetBrains Mono",
	"te.desktop.headingXl": "Noto Sans Telugu",
	"te.desktop.headingL": "Noto Sans Telugu",
	"te.desktop.headingM": "Noto Sans Telugu",
	"te.desktop.headingS": "Noto Sans Telugu",
	"te.desktop.headingXs": "Noto Sans Telugu",
	"te.desktop.headingXxs": "Noto Sans Telugu",
	"te.desktop.overline": "Noto Sans Telugu",
	"te.desktop.bodyL": "Noto Sans Telugu",
	"te.desktop.bodyLBold": "Noto Sans Telugu",
	"te.desktop.bodyLLink": "Noto Sans Telugu",
	"te.desktop.bodyM": "Noto Sans Telugu",
	"te.desktop.bodyMBold": "Noto Sans Telugu",
	"te.desktop.bodyMLink": "Noto Sans Telugu",
	"te.desktop.bodyS": "Noto Sans Telugu",
	"te.desktop.bodySBold": "Noto Sans Telugu",
	"te.desktop.bodySLink": "Noto Sans Telugu",
	"te.desktop.bodyXs": "Noto Sans Telugu",
	"te.desktop.bodyXsBold": "Noto Sans Telugu",
	"te.desktop.bodyXsLink": "Noto Sans Telugu",
	"te.desktop.bodyXxs": "Noto Sans Telugu",
	"te.desktop.bodyXxsBold": "Noto Sans Telugu",
	"te.desktop.bodyXxsLink": "Noto Sans Telugu",
	"te.desktop.listTitle": "Noto Sans Telugu",
	"te.desktop.button": "Noto Sans Telugu",
	"te.desktop.code": "JetBrains Mono",
	"te.mobile.headingXl": "Noto Sans Telugu",
	"te.mobile.headingL": "Noto Sans Telugu",
	"te.mobile.headingM": "Noto Sans Telugu",
	"te.mobile.headingS": "Noto Sans Telugu",
	"te.mobile.headingXs": "Noto Sans Telugu",
	"te.mobile.headingXxs": "Noto Sans Telugu",
	"te.mobile.overline": "Noto Sans Telugu",
	"te.mobile.bodyL": "Noto Sans Telugu",
	"te.mobile.bodyLBold": "Noto Sans Telugu",
	"te.mobile.bodyLLink": "Noto Sans Telugu",
	"te.mobile.bodyM": "Noto Sans Telugu",
	"te.mobile.bodyMBold": "Noto Sans Telugu",
	"te.mobile.bodyMLink": "Noto Sans Telugu",
	"te.mobile.bodyS": "Noto Sans Telugu",
	"te.mobile.bodySBold": "Noto Sans Telugu",
	"te.mobile.bodySLink": "Noto Sans Telugu",
	"te.mobile.bodyXs": "Noto Sans Telugu",
	"te.mobile.bodyXsBold": "Noto Sans Telugu",
	"te.mobile.bodyXsLink": "Noto Sans Telugu",
	"te.mobile.bodyXxs": "Noto Sans Telugu",
	"te.mobile.bodyXxsBold": "Noto Sans Telugu",
	"te.mobile.bodyXxsLink": "Noto Sans Telugu",
	"te.mobile.listTitle": "Noto Sans Telugu",
	"te.mobile.button": "Noto Sans Telugu",
	"te.mobile.code": "JetBrains Mono",
	headingXl: headingXl$4,
	headingL: headingL$4,
	headingM: headingM$4,
	headingS: headingS$4,
	headingXs: headingXs$4,
	headingXxs: headingXxs$4,
	overline: overline$5,
	bodyL: bodyL$4,
	bodyLBold: bodyLBold$4,
	bodyLLink: bodyLLink$4,
	bodyM: bodyM$4,
	bodyMBold: bodyMBold$4,
	bodyMLink: bodyMLink$4,
	bodyS: bodyS$4,
	bodySBold: bodySBold$4,
	bodySLink: bodySLink$4,
	bodyXs: bodyXs$4,
	bodyXsBold: bodyXsBold$4,
	bodyXsLink: bodyXsLink$4,
	bodyXxs: bodyXxs$4,
	bodyXxsBold: bodyXxsBold$4,
	bodyXxsLink: bodyXxsLink$4,
	listTitle: listTitle$4,
	button: button$4,
	code: code$4
};

const headingXl$3 = "{$lang.$platform.headingXl}";
const headingL$3 = "{$lang.$platform.headingL}";
const headingM$3 = "{$lang.$platform.headingM}";
const headingS$3 = "{$lang.$platform.headingS}";
const headingXs$3 = "{$lang.$platform.headingXs}";
const headingXxs$3 = "{$lang.$platform.headingXxs}";
const overline$4 = "{$lang.$platform.overline}";
const bodyL$3 = "{$lang.$platform.bodyL}";
const bodyLBold$3 = "{$lang.$platform.bodyLBold}";
const bodyLLink$3 = "{$lang.$platform.bodyLLink}";
const bodyM$3 = "{$lang.$platform.bodyM}";
const bodyMBold$3 = "{$lang.$platform.bodyMBold}";
const bodyMLink$3 = "{$lang.$platform.bodyMLink}";
const bodyS$3 = "{$lang.$platform.bodyS}";
const bodySBold$3 = "{$lang.$platform.bodySBold}";
const bodySLink$3 = "{$lang.$platform.bodySLink}";
const bodyXs$3 = "{$lang.$platform.bodyXs}";
const bodyXsBold$3 = "{$lang.$platform.bodyXsBold}";
const bodyXsLink$3 = "{$lang.$platform.bodyXsLink}";
const bodyXxs$3 = "{$lang.$platform.bodyXxs}";
const bodyXxsBold$3 = "{$lang.$platform.bodyXxsBold}";
const bodyXxsLink$3 = "{$lang.$platform.bodyXxsLink}";
const listTitle$3 = "{$lang.$platform.listTitle}";
const button$3 = "{$lang.$platform.button}";
const code$3 = "{$lang.$platform.code}";
const fontSizes = {
	"as.desktop.headingXl": 88,
	"as.desktop.headingL": 64,
	"as.desktop.headingM": 40,
	"as.desktop.headingS": 32,
	"as.desktop.headingXs": 24,
	"as.desktop.headingXxs": 16,
	"as.desktop.overline": 12,
	"as.desktop.bodyL": 24,
	"as.desktop.bodyLBold": 24,
	"as.desktop.bodyLLink": 24,
	"as.desktop.bodyM": 18,
	"as.desktop.bodyMBold": 18,
	"as.desktop.bodyMLink": 18,
	"as.desktop.bodyS": 16,
	"as.desktop.bodySBold": 16,
	"as.desktop.bodySLink": 16,
	"as.desktop.bodyXs": 14,
	"as.desktop.bodyXsBold": 14,
	"as.desktop.bodyXsLink": 14,
	"as.desktop.bodyXxs": 12,
	"as.desktop.bodyXxsBold": 12,
	"as.desktop.bodyXxsLink": 12,
	"as.desktop.listTitle": 16,
	"as.desktop.button": 16,
	"as.desktop.code": 12,
	"as.mobile.headingXl": 64,
	"as.mobile.headingL": 48,
	"as.mobile.headingM": 40,
	"as.mobile.headingS": 32,
	"as.mobile.headingXs": 24,
	"as.mobile.headingXxs": 16,
	"as.mobile.overline": 12,
	"as.mobile.bodyL": 24,
	"as.mobile.bodyLBold": 24,
	"as.mobile.bodyLLink": 24,
	"as.mobile.bodyM": 18,
	"as.mobile.bodyMBold": 18,
	"as.mobile.bodyMLink": 18,
	"as.mobile.bodyS": 16,
	"as.mobile.bodySBold": 16,
	"as.mobile.bodySLink": 16,
	"as.mobile.bodyXs": 14,
	"as.mobile.bodyXsBold": 14,
	"as.mobile.bodyXsLink": 14,
	"as.mobile.bodyXxs": 12,
	"as.mobile.bodyXxsBold": 12,
	"as.mobile.bodyXxsLink": 12,
	"as.mobile.listTitle": 16,
	"as.mobile.button": 16,
	"as.mobile.code": 12,
	"bn.desktop.headingXl": 88,
	"bn.desktop.headingL": 64,
	"bn.desktop.headingM": 40,
	"bn.desktop.headingS": 32,
	"bn.desktop.headingXs": 24,
	"bn.desktop.headingXxs": 16,
	"bn.desktop.overline": 12,
	"bn.desktop.bodyL": 24,
	"bn.desktop.bodyLBold": 24,
	"bn.desktop.bodyLLink": 24,
	"bn.desktop.bodyM": 18,
	"bn.desktop.bodyMBold": 18,
	"bn.desktop.bodyMLink": 18,
	"bn.desktop.bodyS": 16,
	"bn.desktop.bodySBold": 16,
	"bn.desktop.bodySLink": 16,
	"bn.desktop.bodyXs": 14,
	"bn.desktop.bodyXsBold": 14,
	"bn.desktop.bodyXsLink": 14,
	"bn.desktop.bodyXxs": 12,
	"bn.desktop.bodyXxsBold": 12,
	"bn.desktop.bodyXxsLink": 12,
	"bn.desktop.listTitle": 16,
	"bn.desktop.button": 16,
	"bn.desktop.code": 12,
	"bn.mobile.headingXl": 64,
	"bn.mobile.headingL": 48,
	"bn.mobile.headingM": 40,
	"bn.mobile.headingS": 32,
	"bn.mobile.headingXs": 24,
	"bn.mobile.headingXxs": 16,
	"bn.mobile.overline": 12,
	"bn.mobile.bodyL": 24,
	"bn.mobile.bodyLBold": 24,
	"bn.mobile.bodyLLink": 24,
	"bn.mobile.bodyM": 18,
	"bn.mobile.bodyMBold": 18,
	"bn.mobile.bodyMLink": 18,
	"bn.mobile.bodyS": 16,
	"bn.mobile.bodySBold": 16,
	"bn.mobile.bodySLink": 16,
	"bn.mobile.bodyXs": 14,
	"bn.mobile.bodyXsBold": 14,
	"bn.mobile.bodyXsLink": 14,
	"bn.mobile.bodyXxs": 12,
	"bn.mobile.bodyXxsBold": 12,
	"bn.mobile.bodyXxsLink": 12,
	"bn.mobile.listTitle": 16,
	"bn.mobile.button": 16,
	"bn.mobile.code": 12,
	"en.desktop.headingXl": 88,
	"en.desktop.headingL": 64,
	"en.desktop.headingM": 40,
	"en.desktop.headingS": 32,
	"en.desktop.headingXs": 24,
	"en.desktop.headingXxs": 16,
	"en.desktop.overline": 12,
	"en.desktop.bodyL": 24,
	"en.desktop.bodyLBold": 24,
	"en.desktop.bodyLLink": 24,
	"en.desktop.bodyM": 18,
	"en.desktop.bodyMBold": 18,
	"en.desktop.bodyMLink": 18,
	"en.desktop.bodyS": 16,
	"en.desktop.bodySBold": 16,
	"en.desktop.bodySLink": 16,
	"en.desktop.bodyXs": 14,
	"en.desktop.bodyXsBold": 14,
	"en.desktop.bodyXsLink": 14,
	"en.desktop.bodyXxs": 12,
	"en.desktop.bodyXxsBold": 12,
	"en.desktop.bodyXxsLink": 12,
	"en.desktop.listTitle": 16,
	"en.desktop.button": 16,
	"en.desktop.code": 12,
	"en.mobile.headingXl": 64,
	"en.mobile.headingL": 48,
	"en.mobile.headingM": 40,
	"en.mobile.headingS": 32,
	"en.mobile.headingXs": 24,
	"en.mobile.headingXxs": 16,
	"en.mobile.overline": 12,
	"en.mobile.bodyL": 24,
	"en.mobile.bodyLBold": 24,
	"en.mobile.bodyLLink": 24,
	"en.mobile.bodyM": 18,
	"en.mobile.bodyMBold": 18,
	"en.mobile.bodyMLink": 18,
	"en.mobile.bodyS": 16,
	"en.mobile.bodySBold": 16,
	"en.mobile.bodySLink": 16,
	"en.mobile.bodyXs": 14,
	"en.mobile.bodyXsBold": 14,
	"en.mobile.bodyXsLink": 14,
	"en.mobile.bodyXxs": 12,
	"en.mobile.bodyXxsBold": 12,
	"en.mobile.bodyXxsLink": 12,
	"en.mobile.listTitle": 16,
	"en.mobile.button": 16,
	"en.mobile.code": 12,
	"gu.desktop.headingXl": 88,
	"gu.desktop.headingL": 64,
	"gu.desktop.headingM": 40,
	"gu.desktop.headingS": 32,
	"gu.desktop.headingXs": 24,
	"gu.desktop.headingXxs": 16,
	"gu.desktop.overline": 12,
	"gu.desktop.bodyL": 24,
	"gu.desktop.bodyLBold": 24,
	"gu.desktop.bodyLLink": 24,
	"gu.desktop.bodyM": 18,
	"gu.desktop.bodyMBold": 18,
	"gu.desktop.bodyMLink": 18,
	"gu.desktop.bodyS": 16,
	"gu.desktop.bodySBold": 16,
	"gu.desktop.bodySLink": 16,
	"gu.desktop.bodyXs": 14,
	"gu.desktop.bodyXsBold": 14,
	"gu.desktop.bodyXsLink": 14,
	"gu.desktop.bodyXxs": 12,
	"gu.desktop.bodyXxsBold": 12,
	"gu.desktop.bodyXxsLink": 12,
	"gu.desktop.listTitle": 16,
	"gu.desktop.button": 16,
	"gu.desktop.code": 12,
	"gu.mobile.headingXl": 64,
	"gu.mobile.headingL": 48,
	"gu.mobile.headingM": 40,
	"gu.mobile.headingS": 32,
	"gu.mobile.headingXs": 24,
	"gu.mobile.headingXxs": 16,
	"gu.mobile.overline": 12,
	"gu.mobile.bodyL": 24,
	"gu.mobile.bodyLBold": 24,
	"gu.mobile.bodyLLink": 24,
	"gu.mobile.bodyM": 18,
	"gu.mobile.bodyMBold": 18,
	"gu.mobile.bodyMLink": 18,
	"gu.mobile.bodyS": 16,
	"gu.mobile.bodySBold": 16,
	"gu.mobile.bodySLink": 16,
	"gu.mobile.bodyXs": 14,
	"gu.mobile.bodyXsBold": 14,
	"gu.mobile.bodyXsLink": 14,
	"gu.mobile.bodyXxs": 12,
	"gu.mobile.bodyXxsBold": 12,
	"gu.mobile.bodyXxsLink": 12,
	"gu.mobile.listTitle": 16,
	"gu.mobile.button": 16,
	"gu.mobile.code": 12,
	"hi.desktop.headingXl": 88,
	"hi.desktop.headingL": 64,
	"hi.desktop.headingM": 40,
	"hi.desktop.headingS": 32,
	"hi.desktop.headingXs": 24,
	"hi.desktop.headingXxs": 16,
	"hi.desktop.overline": 12,
	"hi.desktop.bodyL": 24,
	"hi.desktop.bodyLBold": 24,
	"hi.desktop.bodyLLink": 24,
	"hi.desktop.bodyM": 18,
	"hi.desktop.bodyMBold": 18,
	"hi.desktop.bodyMLink": 18,
	"hi.desktop.bodyS": 16,
	"hi.desktop.bodySBold": 16,
	"hi.desktop.bodySLink": 16,
	"hi.desktop.bodyXs": 14,
	"hi.desktop.bodyXsBold": 14,
	"hi.desktop.bodyXsLink": 14,
	"hi.desktop.bodyXxs": 12,
	"hi.desktop.bodyXxsBold": 12,
	"hi.desktop.bodyXxsLink": 12,
	"hi.desktop.listTitle": 16,
	"hi.desktop.button": 16,
	"hi.desktop.code": 12,
	"hi.mobile.headingXl": 64,
	"hi.mobile.headingL": 48,
	"hi.mobile.headingM": 40,
	"hi.mobile.headingS": 32,
	"hi.mobile.headingXs": 24,
	"hi.mobile.headingXxs": 16,
	"hi.mobile.overline": 12,
	"hi.mobile.bodyL": 24,
	"hi.mobile.bodyLBold": 24,
	"hi.mobile.bodyLLink": 24,
	"hi.mobile.bodyM": 18,
	"hi.mobile.bodyMBold": 18,
	"hi.mobile.bodyMLink": 18,
	"hi.mobile.bodyS": 16,
	"hi.mobile.bodySBold": 16,
	"hi.mobile.bodySLink": 16,
	"hi.mobile.bodyXs": 14,
	"hi.mobile.bodyXsBold": 14,
	"hi.mobile.bodyXsLink": 14,
	"hi.mobile.bodyXxs": 12,
	"hi.mobile.bodyXxsBold": 12,
	"hi.mobile.bodyXxsLink": 12,
	"hi.mobile.listTitle": 16,
	"hi.mobile.button": 16,
	"hi.mobile.code": 12,
	"kn.desktop.headingXl": 88,
	"kn.desktop.headingL": 64,
	"kn.desktop.headingM": 40,
	"kn.desktop.headingS": 32,
	"kn.desktop.headingXs": 24,
	"kn.desktop.headingXxs": 16,
	"kn.desktop.overline": 12,
	"kn.desktop.bodyL": 24,
	"kn.desktop.bodyLBold": 24,
	"kn.desktop.bodyLLink": 24,
	"kn.desktop.bodyM": 18,
	"kn.desktop.bodyMBold": 18,
	"kn.desktop.bodyMLink": 18,
	"kn.desktop.bodyS": 16,
	"kn.desktop.bodySBold": 16,
	"kn.desktop.bodySLink": 16,
	"kn.desktop.bodyXs": 14,
	"kn.desktop.bodyXsBold": 14,
	"kn.desktop.bodyXsLink": 14,
	"kn.desktop.bodyXxs": 12,
	"kn.desktop.bodyXxsBold": 12,
	"kn.desktop.bodyXxsLink": 12,
	"kn.desktop.listTitle": 16,
	"kn.desktop.button": 16,
	"kn.desktop.code": 12,
	"kn.mobile.headingXl": 64,
	"kn.mobile.headingL": 48,
	"kn.mobile.headingM": 40,
	"kn.mobile.headingS": 32,
	"kn.mobile.headingXs": 24,
	"kn.mobile.headingXxs": 16,
	"kn.mobile.overline": 12,
	"kn.mobile.bodyL": 24,
	"kn.mobile.bodyLBold": 24,
	"kn.mobile.bodyLLink": 24,
	"kn.mobile.bodyM": 18,
	"kn.mobile.bodyMBold": 18,
	"kn.mobile.bodyMLink": 18,
	"kn.mobile.bodyS": 16,
	"kn.mobile.bodySBold": 16,
	"kn.mobile.bodySLink": 16,
	"kn.mobile.bodyXs": 14,
	"kn.mobile.bodyXsBold": 14,
	"kn.mobile.bodyXsLink": 14,
	"kn.mobile.bodyXxs": 12,
	"kn.mobile.bodyXxsBold": 12,
	"kn.mobile.bodyXxsLink": 12,
	"kn.mobile.listTitle": 16,
	"kn.mobile.button": 16,
	"kn.mobile.code": 12,
	"ml.desktop.headingXl": 88,
	"ml.desktop.headingL": 64,
	"ml.desktop.headingM": 40,
	"ml.desktop.headingS": 32,
	"ml.desktop.headingXs": 24,
	"ml.desktop.headingXxs": 16,
	"ml.desktop.overline": 12,
	"ml.desktop.bodyL": 24,
	"ml.desktop.bodyLBold": 24,
	"ml.desktop.bodyLLink": 24,
	"ml.desktop.bodyM": 18,
	"ml.desktop.bodyMBold": 18,
	"ml.desktop.bodyMLink": 18,
	"ml.desktop.bodyS": 16,
	"ml.desktop.bodySBold": 16,
	"ml.desktop.bodySLink": 16,
	"ml.desktop.bodyXs": 14,
	"ml.desktop.bodyXsBold": 14,
	"ml.desktop.bodyXsLink": 14,
	"ml.desktop.bodyXxs": 12,
	"ml.desktop.bodyXxsBold": 12,
	"ml.desktop.bodyXxsLink": 12,
	"ml.desktop.listTitle": 16,
	"ml.desktop.button": 16,
	"ml.desktop.code": 12,
	"ml.mobile.headingXl": 64,
	"ml.mobile.headingL": 48,
	"ml.mobile.headingM": 40,
	"ml.mobile.headingS": 32,
	"ml.mobile.headingXs": 24,
	"ml.mobile.headingXxs": 16,
	"ml.mobile.overline": 12,
	"ml.mobile.bodyL": 24,
	"ml.mobile.bodyLBold": 24,
	"ml.mobile.bodyLLink": 24,
	"ml.mobile.bodyM": 18,
	"ml.mobile.bodyMBold": 18,
	"ml.mobile.bodyMLink": 18,
	"ml.mobile.bodyS": 16,
	"ml.mobile.bodySBold": 16,
	"ml.mobile.bodySLink": 16,
	"ml.mobile.bodyXs": 14,
	"ml.mobile.bodyXsBold": 14,
	"ml.mobile.bodyXsLink": 14,
	"ml.mobile.bodyXxs": 12,
	"ml.mobile.bodyXxsBold": 12,
	"ml.mobile.bodyXxsLink": 12,
	"ml.mobile.listTitle": 16,
	"ml.mobile.button": 16,
	"ml.mobile.code": 12,
	"mr.desktop.headingXl": 88,
	"mr.desktop.headingL": 64,
	"mr.desktop.headingM": 40,
	"mr.desktop.headingS": 32,
	"mr.desktop.headingXs": 24,
	"mr.desktop.headingXxs": 16,
	"mr.desktop.overline": 12,
	"mr.desktop.bodyL": 24,
	"mr.desktop.bodyLBold": 24,
	"mr.desktop.bodyLLink": 24,
	"mr.desktop.bodyM": 18,
	"mr.desktop.bodyMBold": 18,
	"mr.desktop.bodyMLink": 18,
	"mr.desktop.bodyS": 16,
	"mr.desktop.bodySBold": 16,
	"mr.desktop.bodySLink": 16,
	"mr.desktop.bodyXs": 14,
	"mr.desktop.bodyXsBold": 14,
	"mr.desktop.bodyXsLink": 14,
	"mr.desktop.bodyXxs": 12,
	"mr.desktop.bodyXxsBold": 12,
	"mr.desktop.bodyXxsLink": 12,
	"mr.desktop.listTitle": 16,
	"mr.desktop.button": 16,
	"mr.desktop.code": 12,
	"mr.mobile.headingXl": 64,
	"mr.mobile.headingL": 48,
	"mr.mobile.headingM": 40,
	"mr.mobile.headingS": 32,
	"mr.mobile.headingXs": 24,
	"mr.mobile.headingXxs": 16,
	"mr.mobile.overline": 12,
	"mr.mobile.bodyL": 24,
	"mr.mobile.bodyLBold": 24,
	"mr.mobile.bodyLLink": 24,
	"mr.mobile.bodyM": 18,
	"mr.mobile.bodyMBold": 18,
	"mr.mobile.bodyMLink": 18,
	"mr.mobile.bodyS": 16,
	"mr.mobile.bodySBold": 16,
	"mr.mobile.bodySLink": 16,
	"mr.mobile.bodyXs": 14,
	"mr.mobile.bodyXsBold": 14,
	"mr.mobile.bodyXsLink": 14,
	"mr.mobile.bodyXxs": 12,
	"mr.mobile.bodyXxsBold": 12,
	"mr.mobile.bodyXxsLink": 12,
	"mr.mobile.listTitle": 16,
	"mr.mobile.button": 16,
	"mr.mobile.code": 12,
	"or.desktop.headingXl": 88,
	"or.desktop.headingL": 64,
	"or.desktop.headingM": 40,
	"or.desktop.headingS": 32,
	"or.desktop.headingXs": 24,
	"or.desktop.headingXxs": 16,
	"or.desktop.overline": 12,
	"or.desktop.bodyL": 24,
	"or.desktop.bodyLBold": 24,
	"or.desktop.bodyLLink": 24,
	"or.desktop.bodyM": 18,
	"or.desktop.bodyMBold": 18,
	"or.desktop.bodyMLink": 18,
	"or.desktop.bodyS": 16,
	"or.desktop.bodySBold": 16,
	"or.desktop.bodySLink": 16,
	"or.desktop.bodyXs": 14,
	"or.desktop.bodyXsBold": 14,
	"or.desktop.bodyXsLink": 14,
	"or.desktop.bodyXxs": 12,
	"or.desktop.bodyXxsBold": 12,
	"or.desktop.bodyXxsLink": 12,
	"or.desktop.listTitle": 16,
	"or.desktop.button": 16,
	"or.desktop.code": 12,
	"or.mobile.headingXl": 64,
	"or.mobile.headingL": 48,
	"or.mobile.headingM": 40,
	"or.mobile.headingS": 32,
	"or.mobile.headingXs": 24,
	"or.mobile.headingXxs": 16,
	"or.mobile.overline": 12,
	"or.mobile.bodyL": 24,
	"or.mobile.bodyLBold": 24,
	"or.mobile.bodyLLink": 24,
	"or.mobile.bodyM": 18,
	"or.mobile.bodyMBold": 18,
	"or.mobile.bodyMLink": 18,
	"or.mobile.bodyS": 16,
	"or.mobile.bodySBold": 16,
	"or.mobile.bodySLink": 16,
	"or.mobile.bodyXs": 14,
	"or.mobile.bodyXsBold": 14,
	"or.mobile.bodyXsLink": 14,
	"or.mobile.bodyXxs": 12,
	"or.mobile.bodyXxsBold": 12,
	"or.mobile.bodyXxsLink": 12,
	"or.mobile.listTitle": 16,
	"or.mobile.button": 16,
	"or.mobile.code": 12,
	"pa.desktop.headingXl": 88,
	"pa.desktop.headingL": 64,
	"pa.desktop.headingM": 40,
	"pa.desktop.headingS": 32,
	"pa.desktop.headingXs": 24,
	"pa.desktop.headingXxs": 16,
	"pa.desktop.overline": 12,
	"pa.desktop.bodyL": 24,
	"pa.desktop.bodyLBold": 24,
	"pa.desktop.bodyLLink": 24,
	"pa.desktop.bodyM": 18,
	"pa.desktop.bodyMBold": 18,
	"pa.desktop.bodyMLink": 18,
	"pa.desktop.bodyS": 16,
	"pa.desktop.bodySBold": 16,
	"pa.desktop.bodySLink": 16,
	"pa.desktop.bodyXs": 14,
	"pa.desktop.bodyXsBold": 14,
	"pa.desktop.bodyXsLink": 14,
	"pa.desktop.bodyXxs": 12,
	"pa.desktop.bodyXxsBold": 12,
	"pa.desktop.bodyXxsLink": 12,
	"pa.desktop.listTitle": 16,
	"pa.desktop.button": 16,
	"pa.desktop.code": 12,
	"pa.mobile.headingXl": 64,
	"pa.mobile.headingL": 48,
	"pa.mobile.headingM": 40,
	"pa.mobile.headingS": 32,
	"pa.mobile.headingXs": 24,
	"pa.mobile.headingXxs": 16,
	"pa.mobile.overline": 12,
	"pa.mobile.bodyL": 24,
	"pa.mobile.bodyLBold": 24,
	"pa.mobile.bodyLLink": 24,
	"pa.mobile.bodyM": 18,
	"pa.mobile.bodyMBold": 18,
	"pa.mobile.bodyMLink": 18,
	"pa.mobile.bodyS": 16,
	"pa.mobile.bodySBold": 16,
	"pa.mobile.bodySLink": 16,
	"pa.mobile.bodyXs": 14,
	"pa.mobile.bodyXsBold": 14,
	"pa.mobile.bodyXsLink": 14,
	"pa.mobile.bodyXxs": 12,
	"pa.mobile.bodyXxsBold": 12,
	"pa.mobile.bodyXxsLink": 12,
	"pa.mobile.listTitle": 16,
	"pa.mobile.button": 16,
	"pa.mobile.code": 12,
	"ta.desktop.headingXl": 88,
	"ta.desktop.headingL": 64,
	"ta.desktop.headingM": 40,
	"ta.desktop.headingS": 32,
	"ta.desktop.headingXs": 24,
	"ta.desktop.headingXxs": 16,
	"ta.desktop.overline": 12,
	"ta.desktop.bodyL": 24,
	"ta.desktop.bodyLBold": 24,
	"ta.desktop.bodyLLink": 24,
	"ta.desktop.bodyM": 18,
	"ta.desktop.bodyMBold": 18,
	"ta.desktop.bodyMLink": 18,
	"ta.desktop.bodyS": 16,
	"ta.desktop.bodySBold": 16,
	"ta.desktop.bodySLink": 16,
	"ta.desktop.bodyXs": 14,
	"ta.desktop.bodyXsBold": 14,
	"ta.desktop.bodyXsLink": 14,
	"ta.desktop.bodyXxs": 12,
	"ta.desktop.bodyXxsBold": 12,
	"ta.desktop.bodyXxsLink": 12,
	"ta.desktop.listTitle": 16,
	"ta.desktop.button": 16,
	"ta.desktop.code": 12,
	"ta.mobile.headingXl": 64,
	"ta.mobile.headingL": 48,
	"ta.mobile.headingM": 40,
	"ta.mobile.headingS": 32,
	"ta.mobile.headingXs": 24,
	"ta.mobile.headingXxs": 16,
	"ta.mobile.overline": 12,
	"ta.mobile.bodyL": 24,
	"ta.mobile.bodyLBold": 24,
	"ta.mobile.bodyLLink": 24,
	"ta.mobile.bodyM": 18,
	"ta.mobile.bodyMBold": 18,
	"ta.mobile.bodyMLink": 18,
	"ta.mobile.bodyS": 16,
	"ta.mobile.bodySBold": 16,
	"ta.mobile.bodySLink": 16,
	"ta.mobile.bodyXs": 14,
	"ta.mobile.bodyXsBold": 14,
	"ta.mobile.bodyXsLink": 14,
	"ta.mobile.bodyXxs": 12,
	"ta.mobile.bodyXxsBold": 12,
	"ta.mobile.bodyXxsLink": 12,
	"ta.mobile.listTitle": 16,
	"ta.mobile.button": 16,
	"ta.mobile.code": 12,
	"te.desktop.headingXl": 88,
	"te.desktop.headingL": 64,
	"te.desktop.headingM": 40,
	"te.desktop.headingS": 32,
	"te.desktop.headingXs": 24,
	"te.desktop.headingXxs": 16,
	"te.desktop.overline": 12,
	"te.desktop.bodyL": 24,
	"te.desktop.bodyLBold": 24,
	"te.desktop.bodyLLink": 24,
	"te.desktop.bodyM": 18,
	"te.desktop.bodyMBold": 18,
	"te.desktop.bodyMLink": 18,
	"te.desktop.bodyS": 16,
	"te.desktop.bodySBold": 16,
	"te.desktop.bodySLink": 16,
	"te.desktop.bodyXs": 14,
	"te.desktop.bodyXsBold": 14,
	"te.desktop.bodyXsLink": 14,
	"te.desktop.bodyXxs": 12,
	"te.desktop.bodyXxsBold": 12,
	"te.desktop.bodyXxsLink": 12,
	"te.desktop.listTitle": 16,
	"te.desktop.button": 16,
	"te.desktop.code": 12,
	"te.mobile.headingXl": 64,
	"te.mobile.headingL": 48,
	"te.mobile.headingM": 40,
	"te.mobile.headingS": 32,
	"te.mobile.headingXs": 24,
	"te.mobile.headingXxs": 16,
	"te.mobile.overline": 12,
	"te.mobile.bodyL": 24,
	"te.mobile.bodyLBold": 24,
	"te.mobile.bodyLLink": 24,
	"te.mobile.bodyM": 18,
	"te.mobile.bodyMBold": 18,
	"te.mobile.bodyMLink": 18,
	"te.mobile.bodyS": 16,
	"te.mobile.bodySBold": 16,
	"te.mobile.bodySLink": 16,
	"te.mobile.bodyXs": 14,
	"te.mobile.bodyXsBold": 14,
	"te.mobile.bodyXsLink": 14,
	"te.mobile.bodyXxs": 12,
	"te.mobile.bodyXxsBold": 12,
	"te.mobile.bodyXxsLink": 12,
	"te.mobile.listTitle": 16,
	"te.mobile.button": 16,
	"te.mobile.code": 12,
	headingXl: headingXl$3,
	headingL: headingL$3,
	headingM: headingM$3,
	headingS: headingS$3,
	headingXs: headingXs$3,
	headingXxs: headingXxs$3,
	overline: overline$4,
	bodyL: bodyL$3,
	bodyLBold: bodyLBold$3,
	bodyLLink: bodyLLink$3,
	bodyM: bodyM$3,
	bodyMBold: bodyMBold$3,
	bodyMLink: bodyMLink$3,
	bodyS: bodyS$3,
	bodySBold: bodySBold$3,
	bodySLink: bodySLink$3,
	bodyXs: bodyXs$3,
	bodyXsBold: bodyXsBold$3,
	bodyXsLink: bodyXsLink$3,
	bodyXxs: bodyXxs$3,
	bodyXxsBold: bodyXxsBold$3,
	bodyXxsLink: bodyXxsLink$3,
	listTitle: listTitle$3,
	button: button$3,
	code: code$3
};

const headingXl$2 = "{$lang.$platform.headingXl}";
const headingL$2 = "{$lang.$platform.headingL}";
const headingM$2 = "{$lang.$platform.headingM}";
const headingS$2 = "{$lang.$platform.headingS}";
const headingXs$2 = "{$lang.$platform.headingXs}";
const headingXxs$2 = "{$lang.$platform.headingXxs}";
const overline$3 = "{$lang.$platform.overline}";
const bodyL$2 = "{$lang.$platform.bodyL}";
const bodyLBold$2 = "{$lang.$platform.bodyLBold}";
const bodyLLink$2 = "{$lang.$platform.bodyLLink}";
const bodyM$2 = "{$lang.$platform.bodyM}";
const bodyMBold$2 = "{$lang.$platform.bodyMBold}";
const bodyMLink$2 = "{$lang.$platform.bodyMLink}";
const bodyS$2 = "{$lang.$platform.bodyS}";
const bodySBold$2 = "{$lang.$platform.bodySBold}";
const bodySLink$2 = "{$lang.$platform.bodySLink}";
const bodyXs$2 = "{$lang.$platform.bodyXs}";
const bodyXsBold$2 = "{$lang.$platform.bodyXsBold}";
const bodyXsLink$2 = "{$lang.$platform.bodyXsLink}";
const bodyXxs$2 = "{$lang.$platform.bodyXxs}";
const bodyXxsBold$2 = "{$lang.$platform.bodyXxsBold}";
const bodyXxsLink$2 = "{$lang.$platform.bodyXxsLink}";
const listTitle$2 = "{$lang.$platform.listTitle}";
const button$2 = "{$lang.$platform.button}";
const code$2 = "{$lang.$platform.code}";
const fontWeights = {
	"400": "400",
	"500": "500",
	"700": "700",
	"800": "800",
	"900": "900",
	"avatar.font.weight": "700",
	"badge.font.weight": "700",
	"button.font.weight": "700",
	"as.desktop.headingXl": 700,
	"as.desktop.headingL": 700,
	"as.desktop.headingM": 700,
	"as.desktop.headingS": 700,
	"as.desktop.headingXs": 700,
	"as.desktop.headingXxs": 700,
	"as.desktop.overline": 700,
	"as.desktop.bodyL": 400,
	"as.desktop.bodyLBold": 700,
	"as.desktop.bodyLLink": 700,
	"as.desktop.bodyM": 400,
	"as.desktop.bodyMBold": 700,
	"as.desktop.bodyMLink": 700,
	"as.desktop.bodyS": 400,
	"as.desktop.bodySBold": 700,
	"as.desktop.bodySLink": 700,
	"as.desktop.bodyXs": 400,
	"as.desktop.bodyXsBold": 700,
	"as.desktop.bodyXsLink": 700,
	"as.desktop.bodyXxs": 400,
	"as.desktop.bodyXxsBold": 700,
	"as.desktop.bodyXxsLink": 700,
	"as.desktop.listTitle": 400,
	"as.desktop.button": 700,
	"as.desktop.code": 500,
	"as.mobile.headingXl": 700,
	"as.mobile.headingL": 700,
	"as.mobile.headingM": 700,
	"as.mobile.headingS": 700,
	"as.mobile.headingXs": 700,
	"as.mobile.headingXxs": 700,
	"as.mobile.overline": 700,
	"as.mobile.bodyL": 400,
	"as.mobile.bodyLBold": 700,
	"as.mobile.bodyLLink": 700,
	"as.mobile.bodyM": 400,
	"as.mobile.bodyMBold": 700,
	"as.mobile.bodyMLink": 700,
	"as.mobile.bodyS": 400,
	"as.mobile.bodySBold": 700,
	"as.mobile.bodySLink": 700,
	"as.mobile.bodyXs": 400,
	"as.mobile.bodyXsBold": 700,
	"as.mobile.bodyXsLink": 700,
	"as.mobile.bodyXxs": 400,
	"as.mobile.bodyXxsBold": 700,
	"as.mobile.bodyXxsLink": 700,
	"as.mobile.listTitle": 400,
	"as.mobile.button": 700,
	"as.mobile.code": 500,
	"bn.desktop.headingXl": 700,
	"bn.desktop.headingL": 700,
	"bn.desktop.headingM": 700,
	"bn.desktop.headingS": 700,
	"bn.desktop.headingXs": 700,
	"bn.desktop.headingXxs": 700,
	"bn.desktop.overline": 700,
	"bn.desktop.bodyL": 400,
	"bn.desktop.bodyLBold": 700,
	"bn.desktop.bodyLLink": 700,
	"bn.desktop.bodyM": 400,
	"bn.desktop.bodyMBold": 700,
	"bn.desktop.bodyMLink": 700,
	"bn.desktop.bodyS": 400,
	"bn.desktop.bodySBold": 700,
	"bn.desktop.bodySLink": 700,
	"bn.desktop.bodyXs": 400,
	"bn.desktop.bodyXsBold": 700,
	"bn.desktop.bodyXsLink": 700,
	"bn.desktop.bodyXxs": 400,
	"bn.desktop.bodyXxsBold": 700,
	"bn.desktop.bodyXxsLink": 700,
	"bn.desktop.listTitle": 400,
	"bn.desktop.button": 700,
	"bn.desktop.code": 500,
	"bn.mobile.headingXl": 700,
	"bn.mobile.headingL": 700,
	"bn.mobile.headingM": 700,
	"bn.mobile.headingS": 700,
	"bn.mobile.headingXs": 700,
	"bn.mobile.headingXxs": 700,
	"bn.mobile.overline": 700,
	"bn.mobile.bodyL": 400,
	"bn.mobile.bodyLBold": 700,
	"bn.mobile.bodyLLink": 700,
	"bn.mobile.bodyM": 400,
	"bn.mobile.bodyMBold": 700,
	"bn.mobile.bodyMLink": 700,
	"bn.mobile.bodyS": 400,
	"bn.mobile.bodySBold": 700,
	"bn.mobile.bodySLink": 700,
	"bn.mobile.bodyXs": 400,
	"bn.mobile.bodyXsBold": 700,
	"bn.mobile.bodyXsLink": 700,
	"bn.mobile.bodyXxs": 400,
	"bn.mobile.bodyXxsBold": 700,
	"bn.mobile.bodyXxsLink": 700,
	"bn.mobile.listTitle": 400,
	"bn.mobile.button": 700,
	"bn.mobile.code": 500,
	"en.desktop.headingXl": 900,
	"en.desktop.headingL": 900,
	"en.desktop.headingM": 900,
	"en.desktop.headingS": 900,
	"en.desktop.headingXs": 900,
	"en.desktop.headingXxs": 900,
	"en.desktop.overline": 700,
	"en.desktop.bodyL": 500,
	"en.desktop.bodyLBold": 700,
	"en.desktop.bodyLLink": 700,
	"en.desktop.bodyM": 500,
	"en.desktop.bodyMBold": 700,
	"en.desktop.bodyMLink": 700,
	"en.desktop.bodyS": 500,
	"en.desktop.bodySBold": 700,
	"en.desktop.bodySLink": 700,
	"en.desktop.bodyXs": 500,
	"en.desktop.bodyXsBold": 700,
	"en.desktop.bodyXsLink": 700,
	"en.desktop.bodyXxs": 500,
	"en.desktop.bodyXxsBold": 700,
	"en.desktop.bodyXxsLink": 700,
	"en.desktop.listTitle": 500,
	"en.desktop.button": 700,
	"en.desktop.code": 500,
	"en.mobile.headingXl": 900,
	"en.mobile.headingL": 900,
	"en.mobile.headingM": 900,
	"en.mobile.headingS": 900,
	"en.mobile.headingXs": 900,
	"en.mobile.headingXxs": 900,
	"en.mobile.overline": 700,
	"en.mobile.bodyL": 500,
	"en.mobile.bodyLBold": 700,
	"en.mobile.bodyLLink": 700,
	"en.mobile.bodyM": 500,
	"en.mobile.bodyMBold": 700,
	"en.mobile.bodyMLink": 700,
	"en.mobile.bodyS": 500,
	"en.mobile.bodySBold": 700,
	"en.mobile.bodySLink": 700,
	"en.mobile.bodyXs": 500,
	"en.mobile.bodyXsBold": 700,
	"en.mobile.bodyXsLink": 700,
	"en.mobile.bodyXxs": 500,
	"en.mobile.bodyXxsBold": 700,
	"en.mobile.bodyXxsLink": 700,
	"en.mobile.listTitle": 500,
	"en.mobile.button": 700,
	"en.mobile.code": 500,
	"gu.desktop.headingXl": 700,
	"gu.desktop.headingL": 700,
	"gu.desktop.headingM": 700,
	"gu.desktop.headingS": 700,
	"gu.desktop.headingXs": 700,
	"gu.desktop.headingXxs": 700,
	"gu.desktop.overline": 700,
	"gu.desktop.bodyL": 400,
	"gu.desktop.bodyLBold": 700,
	"gu.desktop.bodyLLink": 700,
	"gu.desktop.bodyM": 400,
	"gu.desktop.bodyMBold": 700,
	"gu.desktop.bodyMLink": 700,
	"gu.desktop.bodyS": 400,
	"gu.desktop.bodySBold": 700,
	"gu.desktop.bodySLink": 700,
	"gu.desktop.bodyXs": 400,
	"gu.desktop.bodyXsBold": 700,
	"gu.desktop.bodyXsLink": 700,
	"gu.desktop.bodyXxs": 400,
	"gu.desktop.bodyXxsBold": 700,
	"gu.desktop.bodyXxsLink": 700,
	"gu.desktop.listTitle": 400,
	"gu.desktop.button": 700,
	"gu.desktop.code": 500,
	"gu.mobile.headingXl": 700,
	"gu.mobile.headingL": 700,
	"gu.mobile.headingM": 700,
	"gu.mobile.headingS": 700,
	"gu.mobile.headingXs": 700,
	"gu.mobile.headingXxs": 700,
	"gu.mobile.overline": 700,
	"gu.mobile.bodyL": 400,
	"gu.mobile.bodyLBold": 700,
	"gu.mobile.bodyLLink": 700,
	"gu.mobile.bodyM": 400,
	"gu.mobile.bodyMBold": 700,
	"gu.mobile.bodyMLink": 700,
	"gu.mobile.bodyS": 400,
	"gu.mobile.bodySBold": 700,
	"gu.mobile.bodySLink": 700,
	"gu.mobile.bodyXs": 400,
	"gu.mobile.bodyXsBold": 700,
	"gu.mobile.bodyXsLink": 700,
	"gu.mobile.bodyXxs": 400,
	"gu.mobile.bodyXxsBold": 700,
	"gu.mobile.bodyXxsLink": 700,
	"gu.mobile.listTitle": 400,
	"gu.mobile.button": 700,
	"gu.mobile.code": 500,
	"hi.desktop.headingXl": 700,
	"hi.desktop.headingL": 700,
	"hi.desktop.headingM": 700,
	"hi.desktop.headingS": 700,
	"hi.desktop.headingXs": 700,
	"hi.desktop.headingXxs": 700,
	"hi.desktop.overline": 700,
	"hi.desktop.bodyL": 400,
	"hi.desktop.bodyLBold": 700,
	"hi.desktop.bodyLLink": 700,
	"hi.desktop.bodyM": 400,
	"hi.desktop.bodyMBold": 700,
	"hi.desktop.bodyMLink": 700,
	"hi.desktop.bodyS": 400,
	"hi.desktop.bodySBold": 700,
	"hi.desktop.bodySLink": 700,
	"hi.desktop.bodyXs": 400,
	"hi.desktop.bodyXsBold": 700,
	"hi.desktop.bodyXsLink": 700,
	"hi.desktop.bodyXxs": 400,
	"hi.desktop.bodyXxsBold": 700,
	"hi.desktop.bodyXxsLink": 700,
	"hi.desktop.listTitle": 400,
	"hi.desktop.button": 700,
	"hi.desktop.code": 500,
	"hi.mobile.headingXl": 700,
	"hi.mobile.headingL": 700,
	"hi.mobile.headingM": 700,
	"hi.mobile.headingS": 700,
	"hi.mobile.headingXs": 700,
	"hi.mobile.headingXxs": 700,
	"hi.mobile.overline": 700,
	"hi.mobile.bodyL": 400,
	"hi.mobile.bodyLBold": 700,
	"hi.mobile.bodyLLink": 700,
	"hi.mobile.bodyM": 400,
	"hi.mobile.bodyMBold": 700,
	"hi.mobile.bodyMLink": 700,
	"hi.mobile.bodyS": 400,
	"hi.mobile.bodySBold": 700,
	"hi.mobile.bodySLink": 700,
	"hi.mobile.bodyXs": 400,
	"hi.mobile.bodyXsBold": 700,
	"hi.mobile.bodyXsLink": 700,
	"hi.mobile.bodyXxs": 400,
	"hi.mobile.bodyXxsBold": 700,
	"hi.mobile.bodyXxsLink": 700,
	"hi.mobile.listTitle": 400,
	"hi.mobile.button": 700,
	"hi.mobile.code": 500,
	"kn.desktop.headingXl": 700,
	"kn.desktop.headingL": 700,
	"kn.desktop.headingM": 700,
	"kn.desktop.headingS": 700,
	"kn.desktop.headingXs": 700,
	"kn.desktop.headingXxs": 700,
	"kn.desktop.overline": 700,
	"kn.desktop.bodyL": 400,
	"kn.desktop.bodyLBold": 700,
	"kn.desktop.bodyLLink": 700,
	"kn.desktop.bodyM": 400,
	"kn.desktop.bodyMBold": 700,
	"kn.desktop.bodyMLink": 700,
	"kn.desktop.bodyS": 400,
	"kn.desktop.bodySBold": 700,
	"kn.desktop.bodySLink": 700,
	"kn.desktop.bodyXs": 400,
	"kn.desktop.bodyXsBold": 700,
	"kn.desktop.bodyXsLink": 700,
	"kn.desktop.bodyXxs": 400,
	"kn.desktop.bodyXxsBold": 700,
	"kn.desktop.bodyXxsLink": 700,
	"kn.desktop.listTitle": 400,
	"kn.desktop.button": 700,
	"kn.desktop.code": 500,
	"kn.mobile.headingXl": 700,
	"kn.mobile.headingL": 700,
	"kn.mobile.headingM": 700,
	"kn.mobile.headingS": 700,
	"kn.mobile.headingXs": 700,
	"kn.mobile.headingXxs": 700,
	"kn.mobile.overline": 700,
	"kn.mobile.bodyL": 400,
	"kn.mobile.bodyLBold": 700,
	"kn.mobile.bodyLLink": 700,
	"kn.mobile.bodyM": 400,
	"kn.mobile.bodyMBold": 700,
	"kn.mobile.bodyMLink": 700,
	"kn.mobile.bodyS": 400,
	"kn.mobile.bodySBold": 700,
	"kn.mobile.bodySLink": 700,
	"kn.mobile.bodyXs": 400,
	"kn.mobile.bodyXsBold": 700,
	"kn.mobile.bodyXsLink": 700,
	"kn.mobile.bodyXxs": 400,
	"kn.mobile.bodyXxsBold": 700,
	"kn.mobile.bodyXxsLink": 700,
	"kn.mobile.listTitle": 400,
	"kn.mobile.button": 700,
	"kn.mobile.code": 500,
	"ml.desktop.headingXl": 700,
	"ml.desktop.headingL": 700,
	"ml.desktop.headingM": 700,
	"ml.desktop.headingS": 700,
	"ml.desktop.headingXs": 700,
	"ml.desktop.headingXxs": 700,
	"ml.desktop.overline": 700,
	"ml.desktop.bodyL": 400,
	"ml.desktop.bodyLBold": 700,
	"ml.desktop.bodyLLink": 700,
	"ml.desktop.bodyM": 400,
	"ml.desktop.bodyMBold": 700,
	"ml.desktop.bodyMLink": 700,
	"ml.desktop.bodyS": 400,
	"ml.desktop.bodySBold": 700,
	"ml.desktop.bodySLink": 700,
	"ml.desktop.bodyXs": 400,
	"ml.desktop.bodyXsBold": 700,
	"ml.desktop.bodyXsLink": 700,
	"ml.desktop.bodyXxs": 400,
	"ml.desktop.bodyXxsBold": 700,
	"ml.desktop.bodyXxsLink": 700,
	"ml.desktop.listTitle": 400,
	"ml.desktop.button": 700,
	"ml.desktop.code": 500,
	"ml.mobile.headingXl": 700,
	"ml.mobile.headingL": 700,
	"ml.mobile.headingM": 700,
	"ml.mobile.headingS": 700,
	"ml.mobile.headingXs": 700,
	"ml.mobile.headingXxs": 700,
	"ml.mobile.overline": 700,
	"ml.mobile.bodyL": 400,
	"ml.mobile.bodyLBold": 700,
	"ml.mobile.bodyLLink": 700,
	"ml.mobile.bodyM": 400,
	"ml.mobile.bodyMBold": 700,
	"ml.mobile.bodyMLink": 700,
	"ml.mobile.bodyS": 400,
	"ml.mobile.bodySBold": 700,
	"ml.mobile.bodySLink": 700,
	"ml.mobile.bodyXs": 400,
	"ml.mobile.bodyXsBold": 700,
	"ml.mobile.bodyXsLink": 700,
	"ml.mobile.bodyXxs": 400,
	"ml.mobile.bodyXxsBold": 700,
	"ml.mobile.bodyXxsLink": 700,
	"ml.mobile.listTitle": 400,
	"ml.mobile.button": 700,
	"ml.mobile.code": 500,
	"mr.desktop.headingXl": 700,
	"mr.desktop.headingL": 700,
	"mr.desktop.headingM": 700,
	"mr.desktop.headingS": 700,
	"mr.desktop.headingXs": 700,
	"mr.desktop.headingXxs": 700,
	"mr.desktop.overline": 700,
	"mr.desktop.bodyL": 400,
	"mr.desktop.bodyLBold": 700,
	"mr.desktop.bodyLLink": 700,
	"mr.desktop.bodyM": 400,
	"mr.desktop.bodyMBold": 700,
	"mr.desktop.bodyMLink": 700,
	"mr.desktop.bodyS": 400,
	"mr.desktop.bodySBold": 700,
	"mr.desktop.bodySLink": 700,
	"mr.desktop.bodyXs": 400,
	"mr.desktop.bodyXsBold": 700,
	"mr.desktop.bodyXsLink": 700,
	"mr.desktop.bodyXxs": 400,
	"mr.desktop.bodyXxsBold": 700,
	"mr.desktop.bodyXxsLink": 700,
	"mr.desktop.listTitle": 400,
	"mr.desktop.button": 700,
	"mr.desktop.code": 500,
	"mr.mobile.headingXl": 700,
	"mr.mobile.headingL": 700,
	"mr.mobile.headingM": 700,
	"mr.mobile.headingS": 700,
	"mr.mobile.headingXs": 700,
	"mr.mobile.headingXxs": 700,
	"mr.mobile.overline": 700,
	"mr.mobile.bodyL": 400,
	"mr.mobile.bodyLBold": 700,
	"mr.mobile.bodyLLink": 700,
	"mr.mobile.bodyM": 400,
	"mr.mobile.bodyMBold": 700,
	"mr.mobile.bodyMLink": 700,
	"mr.mobile.bodyS": 400,
	"mr.mobile.bodySBold": 700,
	"mr.mobile.bodySLink": 700,
	"mr.mobile.bodyXs": 400,
	"mr.mobile.bodyXsBold": 700,
	"mr.mobile.bodyXsLink": 700,
	"mr.mobile.bodyXxs": 400,
	"mr.mobile.bodyXxsBold": 700,
	"mr.mobile.bodyXxsLink": 700,
	"mr.mobile.listTitle": 400,
	"mr.mobile.button": 700,
	"mr.mobile.code": 500,
	"or.desktop.headingXl": 700,
	"or.desktop.headingL": 700,
	"or.desktop.headingM": 700,
	"or.desktop.headingS": 700,
	"or.desktop.headingXs": 700,
	"or.desktop.headingXxs": 700,
	"or.desktop.overline": 700,
	"or.desktop.bodyL": 400,
	"or.desktop.bodyLBold": 700,
	"or.desktop.bodyLLink": 700,
	"or.desktop.bodyM": 400,
	"or.desktop.bodyMBold": 700,
	"or.desktop.bodyMLink": 700,
	"or.desktop.bodyS": 400,
	"or.desktop.bodySBold": 700,
	"or.desktop.bodySLink": 700,
	"or.desktop.bodyXs": 400,
	"or.desktop.bodyXsBold": 700,
	"or.desktop.bodyXsLink": 700,
	"or.desktop.bodyXxs": 400,
	"or.desktop.bodyXxsBold": 700,
	"or.desktop.bodyXxsLink": 700,
	"or.desktop.listTitle": 400,
	"or.desktop.button": 700,
	"or.desktop.code": 500,
	"or.mobile.headingXl": 700,
	"or.mobile.headingL": 700,
	"or.mobile.headingM": 700,
	"or.mobile.headingS": 700,
	"or.mobile.headingXs": 700,
	"or.mobile.headingXxs": 700,
	"or.mobile.overline": 700,
	"or.mobile.bodyL": 400,
	"or.mobile.bodyLBold": 700,
	"or.mobile.bodyLLink": 700,
	"or.mobile.bodyM": 400,
	"or.mobile.bodyMBold": 700,
	"or.mobile.bodyMLink": 700,
	"or.mobile.bodyS": 400,
	"or.mobile.bodySBold": 700,
	"or.mobile.bodySLink": 700,
	"or.mobile.bodyXs": 400,
	"or.mobile.bodyXsBold": 700,
	"or.mobile.bodyXsLink": 700,
	"or.mobile.bodyXxs": 400,
	"or.mobile.bodyXxsBold": 700,
	"or.mobile.bodyXxsLink": 700,
	"or.mobile.listTitle": 400,
	"or.mobile.button": 700,
	"or.mobile.code": 500,
	"pa.desktop.headingXl": 700,
	"pa.desktop.headingL": 700,
	"pa.desktop.headingM": 700,
	"pa.desktop.headingS": 700,
	"pa.desktop.headingXs": 700,
	"pa.desktop.headingXxs": 700,
	"pa.desktop.overline": 700,
	"pa.desktop.bodyL": 400,
	"pa.desktop.bodyLBold": 700,
	"pa.desktop.bodyLLink": 700,
	"pa.desktop.bodyM": 400,
	"pa.desktop.bodyMBold": 700,
	"pa.desktop.bodyMLink": 700,
	"pa.desktop.bodyS": 400,
	"pa.desktop.bodySBold": 700,
	"pa.desktop.bodySLink": 700,
	"pa.desktop.bodyXs": 400,
	"pa.desktop.bodyXsBold": 700,
	"pa.desktop.bodyXsLink": 700,
	"pa.desktop.bodyXxs": 400,
	"pa.desktop.bodyXxsBold": 700,
	"pa.desktop.bodyXxsLink": 700,
	"pa.desktop.listTitle": 400,
	"pa.desktop.button": 700,
	"pa.desktop.code": 500,
	"pa.mobile.headingXl": 700,
	"pa.mobile.headingL": 700,
	"pa.mobile.headingM": 700,
	"pa.mobile.headingS": 700,
	"pa.mobile.headingXs": 700,
	"pa.mobile.headingXxs": 700,
	"pa.mobile.overline": 700,
	"pa.mobile.bodyL": 400,
	"pa.mobile.bodyLBold": 700,
	"pa.mobile.bodyLLink": 700,
	"pa.mobile.bodyM": 400,
	"pa.mobile.bodyMBold": 700,
	"pa.mobile.bodyMLink": 700,
	"pa.mobile.bodyS": 400,
	"pa.mobile.bodySBold": 700,
	"pa.mobile.bodySLink": 700,
	"pa.mobile.bodyXs": 400,
	"pa.mobile.bodyXsBold": 700,
	"pa.mobile.bodyXsLink": 700,
	"pa.mobile.bodyXxs": 400,
	"pa.mobile.bodyXxsBold": 700,
	"pa.mobile.bodyXxsLink": 700,
	"pa.mobile.listTitle": 400,
	"pa.mobile.button": 700,
	"pa.mobile.code": 500,
	"ta.desktop.headingXl": 700,
	"ta.desktop.headingL": 700,
	"ta.desktop.headingM": 700,
	"ta.desktop.headingS": 700,
	"ta.desktop.headingXs": 700,
	"ta.desktop.headingXxs": 700,
	"ta.desktop.overline": 700,
	"ta.desktop.bodyL": 400,
	"ta.desktop.bodyLBold": 700,
	"ta.desktop.bodyLLink": 700,
	"ta.desktop.bodyM": 400,
	"ta.desktop.bodyMBold": 700,
	"ta.desktop.bodyMLink": 700,
	"ta.desktop.bodyS": 400,
	"ta.desktop.bodySBold": 700,
	"ta.desktop.bodySLink": 700,
	"ta.desktop.bodyXs": 400,
	"ta.desktop.bodyXsBold": 700,
	"ta.desktop.bodyXsLink": 700,
	"ta.desktop.bodyXxs": 400,
	"ta.desktop.bodyXxsBold": 700,
	"ta.desktop.bodyXxsLink": 700,
	"ta.desktop.listTitle": 400,
	"ta.desktop.button": 700,
	"ta.desktop.code": 500,
	"ta.mobile.headingXl": 700,
	"ta.mobile.headingL": 700,
	"ta.mobile.headingM": 700,
	"ta.mobile.headingS": 700,
	"ta.mobile.headingXs": 700,
	"ta.mobile.headingXxs": 700,
	"ta.mobile.overline": 700,
	"ta.mobile.bodyL": 400,
	"ta.mobile.bodyLBold": 700,
	"ta.mobile.bodyLLink": 700,
	"ta.mobile.bodyM": 400,
	"ta.mobile.bodyMBold": 700,
	"ta.mobile.bodyMLink": 700,
	"ta.mobile.bodyS": 400,
	"ta.mobile.bodySBold": 700,
	"ta.mobile.bodySLink": 700,
	"ta.mobile.bodyXs": 400,
	"ta.mobile.bodyXsBold": 700,
	"ta.mobile.bodyXsLink": 700,
	"ta.mobile.bodyXxs": 400,
	"ta.mobile.bodyXxsBold": 700,
	"ta.mobile.bodyXxsLink": 700,
	"ta.mobile.listTitle": 400,
	"ta.mobile.button": 700,
	"ta.mobile.code": 500,
	"te.desktop.headingXl": 700,
	"te.desktop.headingL": 700,
	"te.desktop.headingM": 700,
	"te.desktop.headingS": 700,
	"te.desktop.headingXs": 700,
	"te.desktop.headingXxs": 700,
	"te.desktop.overline": 700,
	"te.desktop.bodyL": 400,
	"te.desktop.bodyLBold": 700,
	"te.desktop.bodyLLink": 700,
	"te.desktop.bodyM": 400,
	"te.desktop.bodyMBold": 700,
	"te.desktop.bodyMLink": 700,
	"te.desktop.bodyS": 400,
	"te.desktop.bodySBold": 700,
	"te.desktop.bodySLink": 700,
	"te.desktop.bodyXs": 400,
	"te.desktop.bodyXsBold": 700,
	"te.desktop.bodyXsLink": 700,
	"te.desktop.bodyXxs": 400,
	"te.desktop.bodyXxsBold": 700,
	"te.desktop.bodyXxsLink": 700,
	"te.desktop.listTitle": 400,
	"te.desktop.button": 700,
	"te.desktop.code": 500,
	"te.mobile.headingXl": 700,
	"te.mobile.headingL": 700,
	"te.mobile.headingM": 700,
	"te.mobile.headingS": 700,
	"te.mobile.headingXs": 700,
	"te.mobile.headingXxs": 700,
	"te.mobile.overline": 700,
	"te.mobile.bodyL": 400,
	"te.mobile.bodyLBold": 700,
	"te.mobile.bodyLLink": 700,
	"te.mobile.bodyM": 400,
	"te.mobile.bodyMBold": 700,
	"te.mobile.bodyMLink": 700,
	"te.mobile.bodyS": 400,
	"te.mobile.bodySBold": 700,
	"te.mobile.bodySLink": 700,
	"te.mobile.bodyXs": 400,
	"te.mobile.bodyXsBold": 700,
	"te.mobile.bodyXsLink": 700,
	"te.mobile.bodyXxs": 400,
	"te.mobile.bodyXxsBold": 700,
	"te.mobile.bodyXxsLink": 700,
	"te.mobile.listTitle": 400,
	"te.mobile.button": 700,
	"te.mobile.code": 500,
	headingXl: headingXl$2,
	headingL: headingL$2,
	headingM: headingM$2,
	headingS: headingS$2,
	headingXs: headingXs$2,
	headingXxs: headingXxs$2,
	overline: overline$3,
	bodyL: bodyL$2,
	bodyLBold: bodyLBold$2,
	bodyLLink: bodyLLink$2,
	bodyM: bodyM$2,
	bodyMBold: bodyMBold$2,
	bodyMLink: bodyMLink$2,
	bodyS: bodyS$2,
	bodySBold: bodySBold$2,
	bodySLink: bodySLink$2,
	bodyXs: bodyXs$2,
	bodyXsBold: bodyXsBold$2,
	bodyXsLink: bodyXsLink$2,
	bodyXxs: bodyXxs$2,
	bodyXxsBold: bodyXxsBold$2,
	bodyXxsLink: bodyXxsLink$2,
	listTitle: listTitle$2,
	button: button$2,
	code: code$2
};

const JSON_MAP$1 = { "JDSActionButton": { "a_0": "{global.transparent}", "a_1": "{opacity.enabled}", "a_2": "{flexDirection.stack}", "a_3": "{alignItems.center}", "a_4": "{justifyContent.center}", "a_5": "{pill}", "a_6": "{primary50}", "a_7": "{flexDirection.row}", "a_8": "{alignItems.center}", "a_9": "{justifyContent.center}", "a_10": "{pill}", "a_11": "{xs}", "a_12": "{base}", "a_13": "{xs}", "a_14": "{base}", "a_15": "{xs}", "a_16": "{primary30}", "a_17": "{primary60}", "a_18": "{border_focus}", "a_19": "{primary60}", "a_20": "{primary50}", "a_21": "{global.transparent}", "a_22": "{primaryGrey40}", "a_23": "{border_focus}", "a_24": "{border_none}", "a_25": "{opacity.enabled}", "a_26": "{m}", "a_27": "{m}", "a_28": "{primaryInverse}", "a_29": "{primary70}", "a_30": "{primaryInverse}", "a_31": "{m}", "a_32": "{primaryInverse}", "a_33": "{primary70}", "a_34": "{primaryInverse}", "a_35": "{xxs}", "a_36": "{s}", "a_37": "{xxs}", "a_38": "{s}", "a_39": "{xxs}", "a_40": "{base}", "a_41": "{base}", "a_42": "{m}", "a_43": "{s}", "a_44": "{m}", "a_45": "{s}", "a_46": "{m}", "a_47": "{xs}", "a_48": "{m}", "a_49": "{m}", "a_50": "{m}", "a_51": "{base}", "a_52": "{l}", "a_53": "{base}", "a_54": "{l}", "a_55": "{xs}", "a_56": "{l}", "a_57": "{l}", "a_58": "{xxl}", "a_59": "{opacity.disabled}", "a_60": "{opacity.invisible}", "a_61": "{opacity.invisible}", "a_62": "{opacity.invisible}", "a_63": "{opacity.disabled}", "a_64": "{opacity.enabled}", "a_65": "{global.transparent}", "a_66": "{border_thin}", "a_67": "{primaryGrey60}", "a_68": "{primary20}", "a_69": "{primary30}", "a_70": "{border_focus}", "a_71": "{primary60}", "a_72": "{primary60}", "a_73": "{primary60}", "a_74": "{primary70}", "a_75": "{primary60}", "a_76": "{primary60}", "a_77": "{primary70}", "a_78": "{global.transparent}", "a_79": "{global.transparent}", "a_80": "{global.transparent}", "a_81": "{border_focus}", "a_82": "{custom_1}", "a_83": "{primary60}", "a_84": "{primary60}", "a_85": "{primary50}", "a_86": "{primary70}", "a_87": "{primary60}", "a_88": "{primary50}", "a_89": "{primary70}", "a_90": "{feedbackSuccess50}", "a_91": "{feedbackSuccess20}", "a_92": "{feedbackSuccess80}", "a_93": "{primary60}", "a_94": "{global.white}", "a_95": "{feedbackSuccess80}", "a_96": "{primaryBackground}", "a_97": "{global.white}", "a_98": "{feedbackSuccess80}", "a_99": "{primaryBackground}", "a_100": "{global.transparent}", "a_101": "{border_thin}", "a_102": "{primaryGrey60}", "a_103": "{feedbackSuccess20}", "a_104": "{feedbackSuccess80}", "a_105": "{primary60}", "a_106": "{feedbackSuccess80}", "a_107": "{feedbackSuccess80}", "a_108": "{primaryBackground}", "a_109": "{feedbackSuccess80}", "a_110": "{feedbackSuccess80}", "a_111": "{primaryBackground}", "a_112": "{global.transparent}", "a_113": "{custom_1}", "a_114": "{global.transparent}", "a_115": "{global.transparent}", "a_116": "{primary60}", "a_117": "{feedbackSuccess80}", "a_118": "{feedbackSuccess50}", "a_119": "{primaryGrey100}", "a_120": "{feedbackSuccess80}", "a_121": "{feedbackSuccess50}", "a_122": "{primaryGrey100}", "a_123": "{feedbackError50}", "a_124": "{feedbackError20}", "a_125": "{feedbackError80}", "a_126": "{primary60}", "a_127": "{global.white}", "a_128": "{feedbackError80}", "a_129": "{primaryBackground}", "a_130": "{global.white}", "a_131": "{feedbackError80}", "a_132": "{primaryBackground}", "a_133": "{global.transparent}", "a_134": "{border_thin}", "a_135": "{primaryGrey60}", "a_136": "{feedbackError20}", "a_137": "{feedbackError80}", "a_138": "{primary60}", "a_139": "{feedbackError80}", "a_140": "{feedbackError80}", "a_141": "{primaryBackground}", "a_142": "{feedbackError80}", "a_143": "{feedbackError80}", "a_144": "{primaryBackground}", "a_145": "{global.transparent}", "a_146": "{pill}", "a_147": "{global.transparent}", "a_148": "{global.transparent}", "a_149": "{primary60}", "a_150": "{feedbackError80}", "a_151": "{feedbackError50}", "a_152": "{primaryGrey100}", "a_153": "{feedbackError80}", "a_154": "{feedbackError50}", "a_155": "{primaryGrey100}", "a_156": "{primaryBackground}", "a_157": "{primary20}", "a_158": "{primary30}", "a_159": "{primary50}", "a_160": "{primaryGrey100}", "a_161": "{primaryGrey100}", "a_162": "{primaryGrey100}", "a_163": "{primaryGrey100}", "a_164": "{primaryGrey100}", "a_165": "{primaryGrey100}", "a_166": "{global.transparent}", "a_167": "{border_thin}", "a_168": "{primaryGrey60}", "a_169": "{primary20}", "a_170": "{primary30}", "a_171": "{border_focus}", "a_172": "{primary50}", "a_173": "{primaryBackground}", "a_174": "{primaryGrey100}", "a_175": "{primaryGrey100}", "a_176": "{primaryBackground}", "a_177": "{primaryGrey100}", "a_178": "{primaryGrey100}", "a_179": "{global.transparent}", "a_180": "{pill}", "a_181": "{global.transparent}", "a_182": "{global.transparent}", "a_183": "{border_focus}", "a_184": "{primary50}", "a_185": "{primaryBackground}", "a_186": "{primary20}", "a_187": "{primary30}", "a_188": "{primaryBackground}", "a_189": "{primary20}", "a_190": "{primary30}", "a_191": "{base}", "a_192": "{base}", "a_193": "{m}", "a_194": "{m}", "a_195": "{l}", "a_196": "{l}", "a_197": "{size.max}", "a_198": "{size.max}" }, "JDSAvatar": { "a_0": "{xl}", "a_1": "{xl}", "a_2": "{flexDirection.row}", "a_3": "{justifyContent.center}", "a_4": "{alignItems.center}", "a_5": "{primary20}", "a_6": "{pill}", "a_7": "{border_none}", "a_8": "{primary80}", "a_9": "{m}", "a_10": "{m}", "a_11": "{l}", "a_12": "{l}", "a_13": "{xxl}", "a_14": "{xxl}", "a_15": "{custom_1}", "a_16": "{custom_1}", "a_17": "{opacity.enabled}", "a_18": "{opacity.disabled}", "a_19": "{sparkle20}", "a_20": "{border_focus}", "a_21": "{sparkle40}", "a_22": "{border_focus}", "a_23": "{sparkle40}", "a_24": "{opacity.disabled}", "a_25": "{border_focus}", "a_26": "{opacity.disabled}" }, "JDSAvatarV2Default": { "a_0": "{xl}", "a_1": "{xl}", "a_2": "{flexDirection.row}", "a_3": "{justifyContent.center}", "a_4": "{alignItems.center}", "a_5": "{primary20}", "a_6": "{pill}", "a_7": "{border_none}", "a_8": "{primary60}", "a_9": "{opacity.enabled}", "a_10": "{primary30}", "a_11": "{border_focus}", "a_12": "{custom_3}", "a_13": "{primary60}", "a_14": "{primary50}", "a_15": "{primary70}", "a_16": "{m}", "a_17": "{m}", "a_18": "{l}", "a_19": "{l}", "a_20": "{xxl}", "a_21": "{xxl}", "a_22": "{custom_11}", "a_23": "{custom_11}", "a_24": "{custom_1}", "a_25": "{custom_1}", "a_26": "{base}", "a_27": "{m}", "a_28": "{l}", "a_29": "{xl}", "a_30": "{xxl}", "a_31": "{opacity.disabled}", "a_32": "{sparkle20}", "a_33": "{opacity.disabled}", "a_34": "{primaryBackground}", "a_35": "{opacity.disabled}", "a_36": "{primaryGrey80}" }, "JDSAccordionList": { "a_0": "{flexDirection.column}", "a_1": "{size.max}", "a_2": "{flexDirection.column}", "a_3": "{size.max}" }, "JDSMobileBottomSheet": { "m_0": "{flexDirection.stack}", "m_1": "{justifyContent.center}", "m_2": "{alignItems.end}", "m_3": "{size.max}", "m_4": "{custom_color_3}", "m_5": "{flexDirection.column}", "m_6": "{justifyContent.start}", "m_7": "{primaryBackground}", "m_8": "{alignItems.start}", "m_9": "{xl}", "m_10": "{xl}", "m_11": "{size.max}", "m_12": "{flexDirection.row}", "m_13": "{justifyContent.end}", "m_14": "{alignItems.center}", "m_15": "{size.max}", "m_16": "{xxs}", "m_17": "{xxs}", "m_18": "{xs}", "m_19": "{s}", "m_20": "{s}", "m_21": "{base}", "m_22": "{flexDirection.column}", "m_23": "{justifyContent.start}", "m_24": "{alignItems.start}", "m_25": "{m}", "m_26": "{m}", "m_27": "{size.max}", "m_28": "{xs}", "m_29": "{m}", "m_30": "{flexDirection.column}", "m_31": "{base}", "m_32": "{size.max}", "m_33": "{m}", "m_34": "{m}", "m_35": "{custom_color_5}" }, "JDSMobileBottomSheetInternal": { "m_0": "{flexDirection.stack}", "m_1": "{justifyContent.center}", "m_2": "{alignItems.end}", "m_3": "{size.max}", "m_4": "{custom_color_3}", "m_5": "{flexDirection.column}", "m_6": "{justifyContent.start}", "m_7": "{primaryBackground}", "m_8": "{alignItems.start}", "m_9": "{xl}", "m_10": "{xl}", "m_11": "{size.max}", "m_12": "{flexDirection.row}", "m_13": "{justifyContent.end}", "m_14": "{alignItems.center}", "m_15": "{size.max}", "m_16": "{xxs}", "m_17": "{xxs}", "m_18": "{xs}", "m_19": "{s}", "m_20": "{s}", "m_21": "{base}", "m_22": "{flexDirection.column}", "m_23": "{justifyContent.start}", "m_24": "{alignItems.start}", "m_25": "{m}", "m_26": "{m}", "m_27": "{size.max}", "m_28": "{xs}", "m_29": "{m}", "m_30": "{flexDirection.column}", "m_31": "{base}", "m_32": "{size.max}", "m_33": "{m}", "m_34": "{m}", "m_35": "{custom_color_5}" }, "JDSBadge": { "b_0": "{flexDirection.row}", "b_1": "{justifyContent.center}", "b_2": "{alignItems.center}", "b_3": "{xxs}", "b_4": "{xs}", "b_5": "{xs}", "b_6": "{xxs}", "b_7": "{xxs}", "b_8": "{sparkle60}", "b_9": "{medium}", "b_10": "{base}", "b_11": "{sparkleGrey20}", "b_12": "{justifyContent.start}", "b_13": "{alignItems.start}", "b_14": "{bodySBold}", "b_15": "{bodySBold}", "b_16": "{bodySBold}", "b_17": "{bodySBold}", "b_18": "{bodySBold}", "b_19": "{sparkleGrey20}", "b_20": "{text-case.uppercase}", "b_21": "{pill}", "b_22": "{custom_color_2}", "b_23": "{xxs}", "b_24": "{xxs}", "b_25": "{s}", "b_26": "{xxs}", "b_27": "{xs}", "b_28": "{bodyMBold}", "b_29": "{bodyMBold}", "b_30": "{bodyMBold}", "b_31": "{bodyMBold}", "b_32": "{bodyMBold}", "b_33": "{global.white}", "b_34": "{m}", "b_35": "{custom_color_1}", "b_36": "{small}", "b_37": "{s}", "b_38": "{bodyXxsBold}", "b_39": "{bodyXxsBold}", "b_40": "{bodyXxsBold}", "b_41": "{bodyXxsBold}", "b_42": "{bodyXxsBold}", "b_43": "{s}", "b_44": "{s}", "b_45": "{xs}", "b_46": "{m}", "b_47": "{bodyLBold}", "b_48": "{bodyLBold}", "b_49": "{bodyLBold}", "b_50": "{bodyLBold}", "b_51": "{bodyLBold}" }, "JDSBadgeV2Brand": { "b_0": "{flexDirection.row}", "b_1": "{justifyContent.center}", "b_2": "{alignItems.center}", "b_3": "{primary50}", "b_4": "{xxs}", "b_5": "{pill}", "b_6": "{xs}", "b_7": "{s}", "b_8": "{xxs}", "b_9": "{xxs}", "b_10": "{pill}", "b_11": "{custom_18}", "b_12": "{medium}", "b_13": "{medium}", "b_14": "{medium}", "b_15": "{medium}", "b_16": "{small}", "b_17": "{xxs}", "b_18": "{xxs}", "b_19": "{custom_5}", "b_20": "{custom_5}", "b_21": "{s}", "b_22": "{xxs}", "b_23": "{xs}", "b_24": "{custom_4}", "b_25": "{custom_4}", "b_26": "{s}", "b_27": "{xxs}", "b_28": "{xs}", "b_29": "{custom_4}", "b_30": "{custom_4}", "b_31": "{base}", "b_32": "{xxs}", "b_33": "{xs}", "b_34": "{xxs}", "b_35": "{xxs}", "b_36": "{custom_18}", "b_37": "{xs}", "b_38": "{custom_3}", "b_39": "{primary60}", "b_40": "{custom_5}", "b_41": "{custom_5}", "b_42": "{custom_5}", "b_43": "{base}", "b_44": "{custom_5}", "b_45": "{custom_18}", "b_46": "{custom_5}", "b_47": "{m}", "b_48": "{custom_5}", "b_49": "{custom_3}", "b_50": "{custom_5}", "b_51": "{l}", "b_52": "{custom_5}", "b_53": "{xl}", "b_54": "{small}", "b_55": "{custom_5}", "b_56": "{base}", "b_57": "{small}", "b_58": "{small}", "b_59": "{custom_5}", "b_60": "{custom_18}", "b_61": "{small}", "b_62": "{small}", "b_63": "{custom_5}", "b_64": "{m}", "b_65": "{small}", "b_66": "{small}", "b_67": "{custom_5}", "b_68": "{custom_3}", "b_69": "{small}", "b_70": "{l}", "b_71": "{xl}", "b_72": "{medium}", "b_73": "{small}", "b_74": "{small}", "b_75": "{xxs}", "b_76": "{small}", "b_77": "{xxs}", "b_78": "{xs}", "b_79": "{base}", "b_80": "{xs}", "b_81": "{small}", "b_82": "{xs}" }, "JDSBadgeV2Information": { "b_0": "{small}", "b_1": "{alignItems.center}", "b_2": "{flexDirection.row}", "b_3": "{justifyContent.center}", "b_4": "{alignItems.center}", "b_5": "{sparkle60}", "b_6": "{xxs}", "b_7": "{small}", "b_8": "{xxs}", "b_9": "{xs}", "b_10": "{custom_4}", "b_11": "{custom_4}", "b_12": "{flexDirection.row}", "b_13": "{justifyContent.center}", "b_14": "{alignItems.center}", "b_15": "{base}", "b_16": "{primaryBackground}", "b_17": "{base}", "b_18": "{flexDirection.row}", "b_19": "{justifyContent.center}", "b_20": "{alignItems.center}", "b_21": "{base}", "b_22": "{secondary60}", "b_23": "{secondary60}", "b_24": "{primaryBackground}", "b_25": "{xxs}", "b_26": "{custom_5}", "b_27": "{custom_5}", "b_28": "{s}", "b_29": "{s}", "b_30": "{s}", "b_31": "{xxs}", "b_32": "{custom_5}", "b_33": "{custom_5}", "b_34": "{s}", "b_35": "{s}", "b_36": "{s}", "b_37": "{xxs}", "b_38": "{custom_5}", "b_39": "{custom_5}", "b_40": "{s}", "b_41": "{s}", "b_42": "{s}", "b_43": "{xs}", "b_44": "{xxs}", "b_45": "{xxs}", "b_46": "{medium}", "b_47": "{medium}", "b_48": "{xs}", "b_49": "{xxs}", "b_50": "{xxs}", "b_51": "{custom_18}", "b_52": "{custom_18}", "b_53": "{custom_18}", "b_54": "{medium}", "b_55": "{medium}", "b_56": "{xs}", "b_57": "{s}", "b_58": "{xxs}", "b_59": "{xxs}", "b_60": "{custom_3}", "b_61": "{custom_3}", "b_62": "{custom_3}", "b_63": "{feedbackSuccess50}", "b_64": "{feedbackSuccess50}", "b_65": "{feedbackWarning50}", "b_66": "{feedbackWarning50}", "b_67": "{feedbackError50}", "b_68": "{feedbackError50}", "b_69": "{primaryGrey80}", "b_70": "{global.transparent}", "b_71": "{custom_16}", "b_72": "{primaryBackground}", "b_73": "{custom_5}", "b_74": "{xs}", "b_75": "{xs}", "b_76": "{custom_5}", "b_77": "{s}", "b_78": "{s}", "b_79": "{custom_5}", "b_80": "{base}", "b_81": "{base}", "b_82": "{custom_5}", "b_83": "{custom_5}", "b_84": "{custom_5}", "b_85": "{custom_5}", "b_86": "{custom_5}", "b_87": "{custom_18}", "b_88": "{custom_18}", "b_89": "{m}", "b_90": "{m}", "b_91": "{custom_3}", "b_92": "{custom_3}", "b_93": "{l}", "b_94": "{l}", "b_95": "{xl}", "b_96": "{xl}", "b_97": "{pill}", "b_98": "{pill}", "b_99": "{custom_5}", "b_100": "{s}", "b_101": "{pill}", "b_102": "{xs}", "b_103": "{pill}", "b_104": "{pill}", "b_105": "{custom_5}", "b_106": "{s}", "b_107": "{pill}", "b_108": "{xs}", "b_109": "{pill}", "b_110": "{custom_5}", "b_111": "{base}", "b_112": "{pill}", "b_113": "{custom_19}", "b_114": "{pill}", "b_115": "{custom_5}", "b_116": "{custom_18}", "b_117": "{pill}", "b_118": "{s}", "b_119": "{pill}", "b_120": "{custom_5}", "b_121": "{m}", "b_122": "{pill}", "b_123": "{base}", "b_124": "{pill}", "b_125": "{custom_5}", "b_126": "{custom_3}", "b_127": "{pill}", "b_128": "{base}", "b_129": "{pill}", "b_130": "{custom_5}", "b_131": "{l}", "b_132": "{pill}", "b_133": "{custom_18}", "b_134": "{pill}", "b_135": "{custom_5}", "b_136": "{xl}", "b_137": "{pill}", "b_138": "{m}", "b_139": "{small}", "b_140": "{small}", "b_141": "{custom_5}", "b_142": "{s}", "b_143": "{small}", "b_144": "{xs}", "b_145": "{small}", "b_146": "{custom_5}", "b_147": "{s}", "b_148": "{small}", "b_149": "{xs}", "b_150": "{small}", "b_151": "{custom_5}", "b_152": "{base}", "b_153": "{small}", "b_154": "{custom_19}", "b_155": "{small}", "b_156": "{custom_5}", "b_157": "{custom_18}", "b_158": "{small}", "b_159": "{s}", "b_160": "{small}", "b_161": "{custom_5}", "b_162": "{m}", "b_163": "{small}", "b_164": "{base}", "b_165": "{small}", "b_166": "{custom_5}", "b_167": "{custom_3}", "b_168": "{small}", "b_169": "{base}", "b_170": "{medium}", "b_171": "{custom_5}", "b_172": "{l}", "b_173": "{medium}", "b_174": "{custom_18}", "b_175": "{custom_1}", "b_176": "{custom_5}", "b_177": "{xl}", "b_178": "{custom_1}", "b_179": "{m}", "b_180": "{base}", "b_181": "{base}", "b_182": "{base}", "b_183": "{custom_18}", "b_184": "{xs}", "b_185": "{m}", "b_186": "{xs}", "b_187": "{custom_3}", "b_188": "{l}", "b_189": "{xl}", "b_190": "{s}", "b_191": "{base}", "b_192": "{base}", "b_193": "{base}", "b_194": "{custom_18}", "b_195": "{m}", "b_196": "{custom_3}", "b_197": "{l}", "b_198": "{xl}", "b_199": "{base}", "b_200": "{base}", "b_201": "{base}", "b_202": "{custom_18}", "b_203": "{m}", "b_204": "{custom_3}", "b_205": "{l}", "b_206": "{xl}", "b_207": "{sparkle20}", "b_208": "{sparkle20}", "b_209": "{sparkle60}", "b_210": "{feedbackSuccess20}", "b_211": "{feedbackSuccess20}", "b_212": "{feedbackSuccess50}", "b_213": "{feedbackWarning20}", "b_214": "{feedbackWarning20}", "b_215": "{feedbackWarning50}", "b_216": "{feedbackError20}", "b_217": "{feedbackError20}", "b_218": "{feedbackError50}", "b_219": "{primaryGrey20}", "b_220": "{primaryGrey20}", "b_221": "{primaryGrey80}", "b_222": "{global.transparent}", "b_223": "{global.transparent}", "b_224": "{sparkle60}", "b_225": "{global.transparent}", "b_226": "{global.transparent}", "b_227": "{feedbackSuccess50}", "b_228": "{global.transparent}", "b_229": "{global.transparent}", "b_230": "{feedbackWarning50}", "b_231": "{global.transparent}", "b_232": "{global.transparent}", "b_233": "{feedbackError50}", "b_234": "{global.transparent}", "b_235": "{global.transparent}", "b_236": "{primaryGrey80}", "b_237": "{global.transparent}", "b_238": "{global.transparent}", "b_239": "{sparkle60}", "b_240": "{global.transparent}", "b_241": "{global.transparent}", "b_242": "{feedbackSuccess50}", "b_243": "{global.transparent}", "b_244": "{global.transparent}", "b_245": "{feedbackWarning50}", "b_246": "{global.transparent}", "b_247": "{global.transparent}", "b_248": "{feedbackError50}", "b_249": "{global.transparent}", "b_250": "{global.transparent}", "b_251": "{primaryGrey80}", "b_252": "{custom_4}", "b_253": "{custom_4}", "b_254": "{custom_4}", "b_255": "{custom_16}", "b_256": "{custom_16}", "b_257": "{custom_16}", "b_258": "{xxs}", "b_259": "{custom_4}", "b_260": "{custom_4}", "b_261": "{global.transparent}", "b_262": "{global.transparent}", "b_263": "{secondary60}", "b_264": "{global.transparent}", "b_265": "{global.tansparent}", "b_266": "{secondary60}", "b_267": "{secondary20}", "b_268": "{secondary20}", "b_269": "{secondary60}", "b_270": "{global.transparent}", "b_271": "{custom_5}" }, "JDSBadgeV2Notification": { "b_0": "{flexDirection.row}", "b_1": "{justifyContent.center}", "b_2": "{alignItems.center}", "b_3": "{xs}", "b_4": "{xs}", "b_5": "{feedbackError50}", "b_6": "{pill}", "b_7": "{custom_5}", "b_8": "{primaryBackground}", "b_9": "{custom_4}", "b_10": "{s}", "b_11": "{s}", "b_12": "{base}", "b_13": "{base}", "b_14": "{custom_4}", "b_15": "{custom_18}", "b_16": "{custom_18}", "b_17": "{custom_4}", "b_18": "{m}", "b_19": "{m}", "b_20": "{custom_16}", "b_21": "{custom_3}", "b_22": "{custom_3}", "b_23": "{custom_16}", "b_24": "{l}", "b_25": "{l}", "b_26": "{custom_16}", "b_27": "{xl}", "b_28": "{xl}", "b_29": "{xxs}", "b_30": "{custom_1}", "b_31": "{base}", "b_32": "{base}", "b_33": "{base}", "b_34": "{base}", "b_35": "{base}", "b_36": "{base}", "b_37": "{custom_18}", "b_38": "{custom_18}", "b_39": "{m}", "b_40": "{m}", "b_41": "{custom_3}", "b_42": "{custom_3}", "b_43": "{l}", "b_44": "{l}", "b_45": "{xl}", "b_46": "{xl}", "b_47": "{base}", "b_48": "{small}", "b_49": "{xxs}", "b_50": "{xxs}", "b_51": "{base}", "b_52": "{small}", "b_53": "{xxs}", "b_54": "{xxs}", "b_55": "{base}", "b_56": "{small}", "b_57": "{xxs}", "b_58": "{xxs}", "b_59": "{custom_18}", "b_60": "{small}", "b_61": "{custom_18}", "b_62": "{custom_18}", "b_63": "{m}", "b_64": "{small}", "b_65": "{custom_18}", "b_66": "{custom_18}", "b_67": "{custom_3}", "b_68": "{small}", "b_69": "{custom_18}", "b_70": "{custom_18}", "b_71": "{l}", "b_72": "{medium}", "b_73": "{xs}", "b_74": "{xs}", "b_75": "{xl}", "b_76": "{medium}", "b_77": "{xs}", "b_78": "{xs}", "b_79": "{custom_4}" }, "JDSBadgeV2Status": { "b_0": "{flexDirection.row}", "b_1": "{justifyContent.center}", "b_2": "{alignItems.center}", "b_3": "{xs}", "b_4": "{flexDirection.row}", "b_5": "{justifyContent.center}", "b_6": "{alignItems.center}", "b_7": "{m}", "b_8": "{pill}", "b_9": "{feedbackSuccess50}", "b_10": "{global.white}", "b_11": "{base}", "b_12": "{s}", "b_13": "{s}", "b_14": "{small}", "b_15": "{xs}", "b_16": "{xs}", "b_17": "{small}", "b_18": "{xs}", "b_19": "{xs}", "b_20": "{s}", "b_21": "{small}", "b_22": "{xs}", "b_23": "{xs}", "b_24": "{base}", "b_25": "{s}", "b_26": "{l}", "b_27": "{m}", "b_28": "{xl}", "b_29": "{custom_3}", "b_30": "{feedbackError50}", "b_31": "{feedbackWarning50}", "b_32": "{primaryGrey60}", "b_33": "{primaryBackground}", "b_34": "{primaryBackground}", "b_35": "{xs}", "b_36": "{base}", "b_37": "{m}", "b_38": "{l}", "b_39": "{xs}", "b_40": "{base}", "b_41": "{m}", "b_42": "{l}", "b_43": "{m}", "b_44": "{base}", "b_45": "{m}", "b_46": "{base}", "b_47": "{medium}", "b_48": "{medium}", "b_49": "{xs}", "b_50": "{medium}", "b_51": "{base}", "b_52": "{medium}", "b_53": "{m}", "b_54": "{l}", "b_55": "{medium}", "b_56": "{base}", "b_57": "{s}", "b_58": "{medium}", "b_59": "{m}", "b_60": "{base}", "b_61": "{feedbackSuccess50}", "b_62": "{feedbackError50}", "b_63": "{feedbackWarning50}", "b_64": "{primaryGrey60}", "b_65": "{feedbackSuccess50}", "b_66": "{global.white}", "b_67": "{feedbackError50}", "b_68": "{global.white}", "b_69": "{feedbackWarning50}", "b_70": "{global.white}", "b_71": "{primaryGrey60}", "b_72": "{global.white}", "b_73": "{feedbackSuccess50}", "b_74": "{global.white}", "b_75": "{feedbackSuccess50}", "b_76": "{feedbackError50}", "b_77": "{global.white}", "b_78": "{feedbackError50}", "b_79": "{feedbackWarning50}", "b_80": "{global.white}", "b_81": "{feedbackWarning50}", "b_82": "{primaryGrey60}", "b_83": "{global.white}", "b_84": "{primaryGrey60}", "b_85": "{border_normal}", "b_86": "{border_normal}", "b_87": "{border_thick}", "b_88": "{border_thick}", "b_89": "{border_thick}", "b_90": "{border_normal}", "b_91": "{border_normal}", "b_92": "{border_thick}", "b_93": "{border_thick}", "b_94": "{border_thick}", "b_95": "{border_normal}", "b_96": "{border_normal}", "b_97": "{border_thick}", "b_98": "{border_thick}", "b_99": "{border_thick}" }, "JDSDesktopBottomSheet": { "d_0": "{flexDirection.row}", "d_1": "{justifyContent.end}", "d_2": "{alignItems.end}", "d_3": "{custom_color_3}", "d_4": "{size.max}", "d_5": "{flexDirection.column}", "d_6": "{justifyContent.start}", "d_7": "{primaryBackground}", "d_8": "{alignItems.start}", "d_9": "{xl}", "d_10": "{xl}", "d_11": "{flexDirection.row}", "d_12": "{justifyContent.end}", "d_13": "{alignItems.center}", "d_14": "{size.max}", "d_15": "{xxs}", "d_16": "{xxs}", "d_17": "{xs}", "d_18": "{s}", "d_19": "{s}", "d_20": "{flexDirection.column}", "d_21": "{justifyContent.start}", "d_22": "{alignItems.start}", "d_23": "{m}", "d_24": "{m}", "d_25": "{size.max}", "d_26": "{xs}", "d_27": "{m}", "d_28": "{flexDirection.column}", "d_29": "{base}", "d_30": "{size.max}", "d_31": "{m}", "d_32": "{m}", "d_33": "{base}", "d_34": "{custom_color_5}" }, "JDSDesktopBottomSheetInternal": { "d_0": "{flexDirection.row}", "d_1": "{justifyContent.end}", "d_2": "{alignItems.end}", "d_3": "{custom_color_3}", "d_4": "{size.max}", "d_5": "{flexDirection.column}", "d_6": "{justifyContent.start}", "d_7": "{primaryBackground}", "d_8": "{alignItems.start}", "d_9": "{xl}", "d_10": "{xl}", "d_11": "{flexDirection.row}", "d_12": "{justifyContent.end}", "d_13": "{alignItems.center}", "d_14": "{size.max}", "d_15": "{xxs}", "d_16": "{xxs}", "d_17": "{xs}", "d_18": "{s}", "d_19": "{s}", "d_20": "{flexDirection.column}", "d_21": "{justifyContent.start}", "d_22": "{alignItems.start}", "d_23": "{m}", "d_24": "{m}", "d_25": "{size.max}", "d_26": "{xs}", "d_27": "{m}", "d_28": "{flexDirection.column}", "d_29": "{base}", "d_30": "{size.max}", "d_31": "{m}", "d_32": "{m}", "d_33": "{base}", "d_34": "{custom_color_5}" }, "JDSBreadcrumbs": { "b_0": "{flexDirection.row}", "b_1": "{justifyContent.start}", "b_2": "{alignItems.start}", "b_3": "{m}", "b_4": "{flexDirection.row}", "b_5": "{justifyContent.start}", "b_6": "{alignItems.start}" }, "JDSCarousel": { "c_0": "{flexDirection.column}", "c_1": "{justifyContent.center}", "c_2": "{alignItems.center}", "c_3": "{base}", "c_4": "{size.max}", "c_5": "{size.max}", "c_6": "{flexDirection.row}", "c_7": "{justifyContent.spaceBetween}", "c_8": "{alignItems.center}", "c_9": "{base}", "c_10": "{size.max}", "c_11": "{size.max}", "c_12": "{flexDirection.row}", "c_13": "{justifyContent.start}", "c_14": "{alignItems.center}", "c_15": "{base}", "c_16": "{xs}", "c_17": "{xs}", "c_18": "{flexDirection.column}", "c_19": "{justifyContent.center}", "c_20": "{alignItems.start}", "c_21": "{flexDirection.stack}", "c_22": "{justifyContent.center}", "c_23": "{alignItems.center}", "c_24": "{flexDirection.row}", "c_25": "{justifyContent.start}", "c_26": "{alignItems.start}", "c_27": "{size.max}", "c_28": "{flexDirection.row}", "c_29": "{justifyContent.end}", "c_30": "{alignItems.start}", "c_31": "{s}", "c_32": "{xs}", "c_33": "{xs}", "c_34": "{xs}" }, "JDSCarouselPagination": { "c_0": "{flexDirection.row}", "c_1": "{justifyContent.center}", "c_2": "{alignItems.center}", "c_3": "{s}", "c_4": "{xs}", "c_5": "{size.max}", "c_6": "{xs}", "c_7": "{xs}" }, "JDSButton": { "b_0": "{opacity.enabled}", "b_1": "{primary50}", "b_2": "{flexDirection.row}", "b_3": "{alignItems.center}", "b_4": "{justifyContent.center}", "b_5": "{pill}", "b_6": "0", "b_7": "", "b_8": "{xs}", "b_9": 0, "b_10": "{primary60}", "b_11": "{primary60}", "b_12": "{border_focus}", "b_13": "{primary80}", "b_14": "{flexDirection.row}", "b_15": "{alignItems.center}", "b_16": "{justifyContent.start}", "b_17": "{xs}", "b_18": "{primaryInverse}", "b_19": "{global.transparent}", "b_20": "{border_focus}", "b_21": "{opacity.enabled}", "b_22": "{base}", "b_23": "{m}", "b_24": "{primaryInverse}", "b_25": "{m}", "b_26": "{primaryInverse}", "b_27": "{size.max}", "b_28": "{justifyContent.spaceBetween}", "b_29": "{opacity.disabled}", "b_30": "{primary30}", "b_31": "{primary30}", "b_32": "{feedbackError20}", "b_33": "{feedbackError50}", "b_34": "{feedbackError80}", "b_35": "{feedbackError50}", "b_36": "{feedbackError80}", "b_37": "{feedbackError80}", "b_38": "{global.white}", "b_39": "{feedbackError20}", "b_40": "{global.white}", "b_41": "{feedbackError80}", "b_42": "{feedbackError20}", "b_43": "{feedbackSuccess20}", "b_44": "{feedbackSuccess50}", "b_45": "{feedbackSuccess80}", "b_46": "{feedbackSuccess50}", "b_47": "{feedbackSuccess80}", "b_48": "{feedbackSuccess80}", "b_49": "{global.white}", "b_50": "{feedbackSuccess20}", "b_51": "{feedbackSuccess80}", "b_52": "{global.white}", "b_53": "{feedbackSuccess20}", "b_54": "{global.transparent}", "b_55": "{border_thin}", "b_56": "{primaryGrey40}", "b_57": "{primary60}", "b_58": "{global.transparent}", "b_59": "{primary20}", "b_60": "{primary60}", "b_61": "{primary80}", "b_62": "{primary60}", "b_63": "{primary60}", "b_64": "{primary60}", "b_65": "{global.transparent}", "b_66": "{border_thin}", "b_67": "{primaryGrey40}", "b_68": "{feedbackError20}", "b_69": "{feedbackError80}", "b_70": "{feedbackError50}", "b_71": "{border_focus}", "b_72": "{feedbackError80}", "b_73": "{feedbackError80}", "b_74": "{feedbackError80}", "b_75": "{global.transparent}", "b_76": "{border_thin}", "b_77": "{primaryGrey40}", "b_78": "{feedbackSuccess20}", "b_79": "{feedbackSuccess80}", "b_80": "{feedbackSuccess50}", "b_81": "{border_focus}", "b_82": "{feedbackSuccess80}", "b_83": "{feedbackSuccess80}", "b_84": "{feedbackSuccess80}", "b_85": "{global.transparent}", "b_86": "{primary20}", "b_87": "{primary30}", "b_88": "{primary80}", "b_89": "{primary20}", "b_90": "{primary60}", "b_91": "{primary60}", "b_92": "{primary60}", "b_93": "{global.transparent}", "b_94": "{feedbackError20}", "b_95": "{feedbackError80}", "b_96": "{feedbackError50}", "b_97": "{border_focus}", "b_98": "{feedbackError20}", "b_99": "{feedbackError80}", "b_100": "{feedbackError80}", "b_101": "{feedbackError80}", "b_102": "{global.transparent}", "b_103": "{feedbackSuccess20}", "b_104": "{feedbackSuccess50}", "b_105": "{border_focus}", "b_106": "{feedbackSuccess80}", "b_107": "{feedbackSuccess80}", "b_108": "{feedbackSuccess80}", "b_109": "{xxs}", "b_110": "{base}", "b_111": "{xxs}", "b_112": "{base}", "b_113": "{base}", "b_114": "{base}", "b_115": "{base}", "b_116": "{s}", "b_117": "{base}", "b_118": "{s}", "b_119": "{base}", "b_120": "{m}", "b_121": "{m}", "b_122": "{m}", "b_123": "{base}", "b_124": "{m}", "b_125": "{base}", "b_126": "{m}", "b_127": "{m}", "b_128": "{m}", "b_129": "{m}", "b_130": "{l}", "b_131": "{l}", "b_132": "{base}", "b_133": "{base}", "b_134": "{base}", "b_135": "{xxl}", "b_136": "{xxl}", "b_137": "{m}", "b_138": "{m}", "b_139": "{m}", "b_140": "{m}", "b_141": "{m}", "b_142": "{m}", "b_143": "{justifyContent.center}", "b_144": "{justifyContent.center}", "b_145": "{justifyContent.center}", "b_146": "{justifyContent.center}", "b_147": "{justifyContent.center}" }, "JDSCarouselPaginationItem": { "c_0": "{s}", "c_1": "{s}", "c_2": "{primary60}", "c_3": "{opacity.disabled}", "c_4": "{pill}", "c_5": "{primary40}", "c_6": "{opacity.enabled}", "c_7": "{primary60}", "c_8": "{opacity.enabled}", "c_9": "{xs}", "c_10": "{opacity.enabled}", "c_11": "{primary70}", "c_12": "{primary70}", "c_13": "{s}", "c_14": "{xs}", "c_15": "{xs}", "c_16": "{custom_15}", "c_17": "{custom_15}", "c_18": "{xs}", "c_19": "{custom_15}", "c_20": "{custom_15}", "c_21": "{xxs}", "c_22": "{xxs}", "c_23": "{m}", "c_24": "{m}", "c_25": "{m}", "c_26": "{l}", "c_27": "{l}", "c_28": "{l}" }, "JDSCarouselSlide": { "c_0": "{size.max}", "c_1": "{small}", "c_2": "{size.max}" }, "JDSCheckbox": { "c_0": "{flexDirection.column}", "c_1": "{justifyContent.start}", "c_2": "{alignItems.start}", "c_3": "{xs}", "c_4": "{flexDirection.row}", "c_5": "{justifyContent.start}", "c_6": "{alignItems.center}", "c_7": "{xs}", "c_8": "{m}", "c_9": "{m}", "c_10": "{flexDirection.row}", "c_11": "{justifyContent.center}", "c_12": "{alignItems.center}", "c_13": "{global.transparent}", "c_14": "{small}", "c_15": "{primaryGrey80}", "c_16": "{primary40}", "c_17": "{primary60}", "c_18": "{primary60}", "c_19": "{base}", "c_20": "{textAlign.start}", "c_21": "{base}", "c_22": "{base}", "c_23": "{xxs}", "c_24": "{s}", "c_25": "ic_confirm", "c_26": "{primary50}", "c_27": "{primary40}", "c_28": "{primary60}", "c_29": "{primaryInverse}", "c_30": "ic_minus", "c_31": "{primary50}", "c_32": "{primary40}", "c_33": "{primary50}", "c_34": "{primaryInverse}", "c_35": "{opacity.disabled}", "c_36": "{opacity.enabled}" }, "JDSContentBlock": { "c_0": "{flexDirection.column}", "c_1": "{alignItems.start}", "c_2": "{justifyContent.start}", "c_3": "{size.max}", "c_4": "{flexDirection.column}", "c_5": "{alignItems.start}", "c_6": "{justifyContent.start}", "c_7": "{size.max}", "c_8": "{xs}", "c_9": "{xxs}", "c_10": "{m}", "c_11": "{m}", "c_12": "{flexDirection.row}", "c_13": "{size.max}", "c_14": "{xs}", "c_15": "{s}", "c_16": "{s}", "c_17": "{s}", "c_18": "{s}", "c_19": "{base}", "c_20": "{base}", "c_21": "{l}", "c_22": "{s}", "c_23": "{base}", "c_24": "{base}", "c_25": "{l}", "c_26": "{s}", "c_27": "{flexDirection.column}", "c_28": "{size.max}", "c_29": "{size.max}", "c_30": "{base}", "c_31": "{m}", "c_32": "{m}", "c_33": "{flexDirection.row}", "c_34": "{justifyContent.spaceBetween}", "c_35": "{alignItems.center}", "c_36": "{flexDirection.row}", "c_37": "{justifyContent.end}", "c_38": "{alignItems.center}" }, "JDSDatepickerButton": { "d_0": "{xxl}", "d_1": "{custom_9}", "d_2": "{pill}", "d_3": "{global.transparent}", "d_4": "{border_thin}", "d_5": "{primaryGrey40}", "d_6": "{flexDirection.row}", "d_7": "{justifyContent.center}", "d_8": "{alignItems.center}", "d_9": "{xs}", "d_10": "{base}", "d_11": "{base}", "d_12": "{primary60}", "d_13": "{primaryGrey100}", "d_14": "{border_focus}", "d_15": "{primary60}", "d_16": "{primary20}", "d_17": "{primary20}", "d_18": "{primary60}", "d_19": "{border_none}", "d_20": "{opacity.disabled}", "d_21": "{border_none}" }, "JDSContentCard": { "c_0": "{size.max}", "c_1": "{xl}", "c_2": "{flexDirection.column}", "c_3": "{justifyContent.start}", "c_4": "{alignItems.start}", "c_5": "{primaryBackground}", "c_6": "{justifyContent.start}", "c_7": "{alignItems.start}", "c_8": "{size.max}", "c_9": "{base}", "c_10": "{base}", "c_11": "{base}", "c_12": "{justifyContent.start}", "c_13": "{alignItems.start}", "c_14": "{size.max}", "c_15": "{base}", "c_16": "{base}", "c_17": "{base}", "c_18": "{flexDirection.column}", "c_19": "{size.max}", "c_20": "{justifyContent.start}", "c_21": "{alignItems.start}", "c_22": "{base}", "c_23": "{base}", "c_24": "{base}", "c_25": "{base}", "c_26": "{base}", "c_27": "{base}", "c_28": "{base}", "c_29": "{base}", "c_30": "{base}", "c_31": "{base}", "c_32": "{flexDirection.row}", "c_33": "{custom_10}", "c_34": "{size.max}", "c_35": "{base}", "c_36": "{base}", "c_37": "{flexDirection.row}", "c_38": "{size.max}" }, "JDSDatepickerCalendarButton": { "d_0": "{flexDirection.row}", "d_1": "{justifyContent.center}", "d_2": "{alignItems.center}", "d_3": "{xxl}", "d_4": "{xxl}", "d_5": "{flexDirection.row}", "d_6": "{justifyContent.center}", "d_7": "{alignItems.center}", "d_8": "{xxl}", "d_9": "{xxl}", "d_10": "{pill}", "d_11": "{primaryGrey100}", "d_12": "{global.transparent}", "d_13": "{primary20}", "d_14": "{primary40}", "d_15": "{primary20}", "d_16": "{border_focus}", "d_17": "{primary50}", "d_18": "{primary20}", "d_19": "{opacity.disabled}" }, "JDSDatepickerCalendar": { "d_0": "{flexDirection.column}", "d_1": "{justifyContent.start}", "d_2": "{alignItems.center}", "d_3": "{s}", "d_4": "{flexDirection.column}" }, "JDSDatepickerCalendarRow": { "d_0": "{flexDirection.row}", "d_1": "{justifyContent.start}", "d_2": "{alignItems.center}", "d_3": "{size.max}" }, "JDSAccordion": { "a_0": "{flexDirection.column}", "a_1": "{size.max}", "a_2": "{flexDirection.row}", "a_3": "{alignItems.center}", "a_4": "{justifyContent.start}", "a_5": "{size.max}", "a_6": "{xxs}", "a_7": "{s}", "a_8": "{flexDirection.column}", "a_9": "{justifyContent.start}", "a_10": "{alignItems.start}", "a_11": "{xxs}", "a_12": "0", "a_13": "{size.max}", "a_14": "{size.max}", "a_15": "{opacity.enabled}", "a_16": "{base}", "a_17": "{opacity.disabled}", "a_18": "ic_minus", "a_19": "ic_add", "a_20": "ic_chevron_up", "a_21": "ic_chevron_down" }, "JDSDatepickerCalendarHeader": { "d_0": "{flexDirection.row}", "d_1": "{justifyContent.center}", "d_2": "{alignItems.center}", "d_3": "{size.max}" }, "JDSDatepickerDesktop": { "d_0": "{flexDirection.column}", "d_1": "{justifyContent.start}", "d_2": "{alignItems.center}", "d_3": "{opacity.invisible}", "d_4": "{primaryBackground}", "d_5": "{flexDirection.column}", "d_6": "{justifyContent.start}", "d_7": "{alignItems.center}", "d_8": "{xl}", "d_9": "{flexDirection.row}", "d_10": "{justifyContent.end}", "d_11": "{alignItems.center}", "d_12": "{xs}", "d_13": "{s}", "d_14": "{xs}", "d_15": "{s}", "d_16": "{custom_6}", "d_17": "{m}", "d_18": "{m}", "d_19": "{flexDirection.column}", "d_20": "{justifyContent.start}", "d_21": "{alignItems.center}", "d_22": "{m}", "d_23": "{flexDirection.column}", "d_24": "{justifyContent.start}", "d_25": "{alignItems.center}", "d_26": "{size.max}", "d_27": "{size.max}", "d_28": "{m}", "d_29": "{m}", "d_30": "{m}", "d_31": "{opacity.enabled}", "d_32": "{justifyContent.spaceBetween}", "d_33": "{justifyContent.spaceBetween}" }, "JDSDatepickerDesktopInternal": { "d_0": "{flexDirection.column}", "d_1": "{justifyContent.start}", "d_2": "{alignItems.center}", "d_3": "{opacity.invisible}", "d_4": "{primaryBackground}", "d_5": "{flexDirection.column}", "d_6": "{justifyContent.start}", "d_7": "{alignItems.center}", "d_8": "{xl}", "d_9": "{flexDirection.row}", "d_10": "{justifyContent.end}", "d_11": "{alignItems.center}", "d_12": "{xs}", "d_13": "{s}", "d_14": "{xs}", "d_15": "{s}", "d_16": "{custom_6}", "d_17": "{m}", "d_18": "{m}", "d_19": "{flexDirection.column}", "d_20": "{justifyContent.start}", "d_21": "{alignItems.center}", "d_22": "{m}", "d_23": "{flexDirection.column}", "d_24": "{justifyContent.start}", "d_25": "{alignItems.center}", "d_26": "{size.max}", "d_27": "{size.max}", "d_28": "{m}", "d_29": "{m}", "d_30": "{m}", "d_31": "{opacity.enabled}", "d_32": "{justifyContent.spaceBetween}", "d_33": "{justifyContent.spaceBetween}" }, "JDSDatepickerHeader": { "d_0": "{size.max}", "d_1": "{xxl}", "d_2": "{flexDirection.row}", "d_3": "{justifyContent.spaceBetween}", "d_4": "{alignItems.center}", "d_5": "{xxl}", "d_6": "{flexDirection.row}", "d_7": "{justifyContent.center}", "d_8": "{alignItems.center}", "d_9": "{s}" }, "JDSDatepickerYearView": { "d_0": "{flexDirection.column}", "d_1": "{size.max}", "d_2": "{alignItems.center}" }, "JDSDatepickerMonthView": { "d_0": "{flexDirection.column}", "d_1": "{custom_8}", "d_2": "{size.max}", "d_3": "{alignItems.center}" }, "JDSDatepickerMobile": { "d_0": "{primaryBackground}", "d_1": "{flexDirection.column}", "d_2": "{justifyContent.start}", "d_3": "{alignItems.center}", "d_4": "{size.max}", "d_5": "{flexDirection.row}", "d_6": "{justifyContent.end}", "d_7": "{alignItems.center}", "d_8": "{xs}", "d_9": "{xs}", "d_10": "{s}", "d_11": "{s}", "d_12": "{size.max}", "d_13": "{flexDirection.column}", "d_14": "{justifyContent.start}", "d_15": "{alignItems.center}", "d_16": "{m}", "d_17": "{s}", "d_18": "{s}", "d_19": "{s}", "d_20": "{s}", "d_21": "{m}", "d_22": "{s}", "d_23": "{s}", "d_24": "{s}", "d_25": "{s}", "d_26": "{m}", "d_27": "{flexDirection.column}", "d_28": "{s}", "d_29": "{justifyContent.start}", "d_30": "{alignItems.center}", "d_31": "{size.max}", "d_32": "{m}", "d_33": "{m}", "d_34": "{flexDirection.column}", "d_35": "{justifyContent.start}", "d_36": "{alignItems.center}", "d_37": "{s}", "d_38": "{size.max}", "d_39": "{justifyContent.spaceBetween}", "d_40": "{justifyContent.spaceBetween}" }, "JDSDatepickerMobileInteral": { "d_0": "{primaryBackground}", "d_1": "{flexDirection.column}", "d_2": "{justifyContent.start}", "d_3": "{alignItems.center}", "d_4": "{size.max}", "d_5": "{flexDirection.row}", "d_6": "{justifyContent.end}", "d_7": "{alignItems.center}", "d_8": "{xs}", "d_9": "{xs}", "d_10": "{s}", "d_11": "{s}", "d_12": "{size.max}", "d_13": "{flexDirection.column}", "d_14": "{justifyContent.start}", "d_15": "{alignItems.center}", "d_16": "{m}", "d_17": "{s}", "d_18": "{s}", "d_19": "{s}", "d_20": "{s}", "d_21": "{m}", "d_22": "{s}", "d_23": "{s}", "d_24": "{s}", "d_25": "{s}", "d_26": "{m}", "d_27": "{flexDirection.column}", "d_28": "{s}", "d_29": "{justifyContent.start}", "d_30": "{alignItems.center}", "d_31": "{size.max}", "d_32": "{m}", "d_33": "{m}", "d_34": "{flexDirection.column}", "d_35": "{justifyContent.start}", "d_36": "{alignItems.center}", "d_37": "{s}", "d_38": "{size.max}", "d_39": "{justifyContent.spaceBetween}", "d_40": "{justifyContent.spaceBetween}" }, "JDSDivider": { "d_0": "{global.transparent}", "d_1": "{flexDirection.row}", "d_2": "{justifyContent.center}", "d_3": "{alignItems.center}", "d_4": "{xs}", "d_5": "{s}", "d_6": "{s}", "d_7": "{s}", "d_8": "{s}", "d_9": "{custom_5}", "d_10": "{custom_5}", "d_11": "{flexDirection.row}", "d_12": "{primaryGrey40}", "d_13": "{pill}", "d_14": "{custom_5}", "d_15": "{custom_5}", "d_16": "{flexDirection.row}", "d_17": "{primaryGrey40}", "d_18": "{pill}", "d_19": "{sparkle50}", "d_20": "{sparkle50}", "d_21": "{size.max}", "d_22": "{size.max}", "d_23": "{flexDirection.column}", "d_24": "{flexDirection.column}", "d_25": "{flexDirection.column}", "d_26": "{base}", "d_27": "{base}", "d_28": "{base}", "d_29": "{base}", "d_30": "{base}", "d_31": "{base}", "d_32": "{base}", "d_33": "{base}", "d_34": "{base}", "d_35": "{base}", "d_36": "{base}", "d_37": "{base}", "d_38": "{m}", "d_39": "{m}", "d_40": "{m}", "d_41": "{m}", "d_42": "{m}", "d_43": "{m}", "d_44": "{m}", "d_45": "{m}", "d_46": "{m}", "d_47": "{m}", "d_48": "{m}", "d_49": "{m}", "d_50": "{xs}", "d_51": "{xs}", "d_52": "{xs}", "d_53": "{xs}", "d_54": "{xs}", "d_55": "{xs}", "d_56": "{xs}", "d_57": "{xs}", "d_58": "{xs}", "d_59": "{xs}", "d_60": "{xs}", "d_61": "{xs}", "d_62": "{xxs}", "d_63": "{xxs}", "d_64": "{xxs}", "d_65": "{xxs}", "d_66": "{xxs}", "d_67": "{xxs}", "d_68": "{xxs}", "d_69": "{xxs}", "d_70": "{xxs}", "d_71": "{xxs}", "d_72": "{xxs}", "d_73": "{xxs}", "d_74": "{xxl}", "d_75": "{xxl}", "d_76": "{xxl}", "d_77": "{xxl}", "d_78": "{xxl}", "d_79": "{xxl}", "d_80": "{xxl}", "d_81": "{xxl}", "d_82": "{xxl}", "d_83": "{xxl}", "d_84": "{xxl}", "d_85": "{xxl}", "d_86": "{xl}", "d_87": "{xl}", "d_88": "{xl}", "d_89": "{xl}", "d_90": "{xl}", "d_91": "{xl}", "d_92": "{xl}", "d_93": "{xl}", "d_94": "{xl}", "d_95": "{xl}", "d_96": "{xl}", "d_97": "{xl}", "d_98": "{l}", "d_99": "{l}", "d_100": "{l}", "d_101": "{l}", "d_102": "{l}", "d_103": "{l}", "d_104": "{l}", "d_105": "{l}", "d_106": "{l}", "d_107": "{l}", "d_108": "{l}", "d_109": "{l}", "d_110": "{huge}", "d_111": "{huge}", "d_112": "{huge}", "d_113": "{huge}", "d_114": "{huge}", "d_115": "{huge}", "d_116": "{huge}", "d_117": "{huge}", "d_118": "{huge}", "d_119": "{huge}", "d_120": "{huge}", "d_121": "{huge}", "d_122": "{massive}", "d_123": "{massive}", "d_124": "{massive}", "d_125": "{massive}", "d_126": "{massive}", "d_127": "{massive}", "d_128": "{massive}", "d_129": "{massive}", "d_130": "{massive}", "d_131": "{massive}", "d_132": "{massive}", "d_133": "{massive}" }, "JDSDatepickerViewButton": { "d_0": "{size.max}", "d_1": "{flexDirection.row}", "d_2": "{justifyContent.center}", "d_3": "{alignItems.center}", "d_4": "{xxl}", "d_5": "{custom_7}", "d_6": "{flexDirection.row}", "d_7": "{justifyContent.center}", "d_8": "{alignItems.center}" }, "JDSFAB": { "f_0": "{flexDirection.stack}", "f_1": "{justifyContent.end}", "f_2": "{alignItems.end}", "f_3": "{size.max}", "f_4": "{base}", "f_5": "{base}", "f_6": "{secondary50}", "f_7": "{flexDirection.row}", "f_8": "{justifyContent.center}", "f_9": "{alignItems.center}", "f_10": "{xs}", "f_11": "{pill}", "f_12": "{base}", "f_13": "{m}", "f_14": "{m}", "f_15": "{base}", "f_16": "{primary80}", "f_17": "{border_none}", "f_18": "{secondary60}", "f_19": "{secondary60}", "f_20": "{secondary60}", "f_21": "{border_focus}", "f_22": "{m}", "f_23": "{secondaryInverse}", "f_24": "{pill}", "f_25": "{secondary30}", "f_26": "{base}", "f_27": "{base}" }, "JDSFABInternal": { "f_0": "{flexDirection.stack}", "f_1": "{justifyContent.end}", "f_2": "{alignItems.end}", "f_3": "{size.max}", "f_4": "{base}", "f_5": "{base}", "f_6": "{secondary50}", "f_7": "{flexDirection.row}", "f_8": "{justifyContent.center}", "f_9": "{alignItems.center}", "f_10": "{xs}", "f_11": "{pill}", "f_12": "{base}", "f_13": "{m}", "f_14": "{m}", "f_15": "{base}", "f_16": "{primary80}", "f_17": "{border_none}", "f_18": "{secondary60}", "f_19": "{secondary60}", "f_20": "{secondary60}", "f_21": "{border_focus}", "f_22": "{m}", "f_23": "{secondaryInverse}", "f_24": "{pill}", "f_25": "{secondary30}", "f_26": "{base}", "f_27": "{base}" }, "JDSDropdown": { "d_0": "{flexDirection.column}", "d_1": "{xxs}", "d_2": "{size.max}", "d_3": "{justifyContent.start}", "d_4": "{alignItems.start}", "d_5": "{flexDirection.stack}", "d_6": "{size.max}", "d_7": "{alignItems.end}", "d_8": "{justifyContent.start}", "d_9": "{xxs}", "d_10": "{flexDirection.row}", "d_11": "{xs}", "d_12": "{flexDirection.row}", "d_13": "{justifyContent.end}", "d_14": "{size.max}", "d_15": "{alignItems.center}", "d_16": "{flexDirection.column}", "d_17": "{size.max}", "d_18": "{alignItems.center}", "d_19": "{size.max}", "d_20": "{primaryGrey100}", "d_21": "{primary50}", "d_22": "{primary50}", "d_23": "{primary50}", "d_24": "{m}", "d_25": "{primaryGrey80}", "d_26": "{opacity.disabled}", "d_27": "{opacity.enabled}", "d_28": "{feedbackSuccess50}", "d_29": "{feedbackSuccess50}", "d_30": "{feedbackSuccess50}", "d_31": "{feedbackSuccess50}", "d_32": "{feedbackError50}", "d_33": "{feedbackError50}", "d_34": "{feedbackError50}", "d_35": "{feedbackError50}", "d_36": "{feedbackWarning50}", "d_37": "{feedbackWarning50}", "d_38": "{feedbackWarning50}", "d_39": "{feedbackWarning50}", "d_40": "{alignItems.start}", "d_41": "{alignItems.start}", "d_42": "{alignItems.end}", "d_43": "{l}", "d_44": "{alignItems.end}", "d_45": "{primary60}" }, "JDSDropdownMenu": { "d_0": "{global.transparent}", "d_1": "{primaryGrey20}", "d_2": "{flexDirection.column}", "d_3": "{flexDirection.column}", "d_4": "{large}", "d_5": "{xs}", "d_6": "{xs}", "d_7": "{base}", "d_8": "{base}", "d_9": "{base}", "d_10": "{custom_color_5}", "d_11": "{size.max}", "d_12": "{size.max}", "d_13": "{size.max}", "d_14": "{size.max}", "d_15": "{size.max}", "d_16": "{opacity.invisible}", "d_17": "{opacity.enabled}" }, "JDSDropdownMenuInternal": { "d_0": "{global.transparent}", "d_1": "{primaryGrey20}", "d_2": "{flexDirection.column}", "d_3": "{flexDirection.column}", "d_4": "{large}", "d_5": "{xs}", "d_6": "{xs}", "d_7": "{base}", "d_8": "{base}", "d_9": "{base}", "d_10": "{custom_color_5}", "d_11": "{size.max}", "d_12": "{size.max}", "d_13": "{size.max}", "d_14": "{size.max}", "d_15": "{size.max}", "d_16": "{opacity.invisible}", "d_17": "{opacity.enabled}" }, "JDSDropdownMenuItem": { "d_0": "{size.max}", "d_1": "{flexDirection.row}", "d_2": "{flexDirection.column}", "d_3": "{s}", "d_4": "{primaryGrey20}", "d_5": "{primaryBackground}", "d_6": "{primary50}", "d_7": "{primaryGrey100}", "d_8": "{xs}", "d_9": "{base}", "d_10": "{xs}", "d_11": "{base}", "d_12": "{primary50}", "d_13": "{primary50}", "d_14": "{justifyContent.start}", "d_15": "{alignItems.start}", "d_16": "{alignItems.center}", "d_17": "{alignItems.start}", "d_18": "{primary60}", "d_19": "{m}", "d_20": "{primaryInverse}", "d_21": "{primaryInverse}", "d_22": "{opacity.disabled}", "d_23": "{small}", "d_24": "{size.max}" }, "JDSDropdownMenuItemMobile": { "d_0": "{size.max}", "d_1": "{flexDirection.row}", "d_2": "{flexDirection.column}", "d_3": "{s}", "d_4": "{primaryGrey20}", "d_5": "{primaryBackground}", "d_6": "{primary50}", "d_7": "{primaryGrey100}", "d_8": "{xs}", "d_9": "{base}", "d_10": "{xs}", "d_11": "{base}", "d_12": "{primary50}", "d_13": "{primary50}", "d_14": "{justifyContent.start}", "d_15": "{alignItems.start}", "d_16": "{alignItems.center}", "d_17": "{alignItems.start}", "d_18": "{primary60}", "d_19": "{m}", "d_20": "{primaryInverse}", "d_21": "{primaryInverse}", "d_22": "{opacity.disabled}", "d_23": "{small}", "d_24": "{size.max}" }, "JDSDropdownMenuGroup": { "d_0": "{size.max}", "d_1": "{flexDirection.column}", "d_2": "{flexDirection.column}", "d_3": "{xs}", "d_4": "{base}", "d_5": "{base}", "d_6": "{size.max}", "d_7": "{primaryGrey20}", "d_8": "{size.max}" }, "JDSDropdownMenuSubMenu": { "d_0": "{global.transparent}", "d_1": "{primaryGrey20}", "d_2": "{flexDirection.column}", "d_3": "{large}", "d_4": "{xs}", "d_5": "{xs}", "d_6": "{custom_color_5}", "d_7": "{size.max}", "d_8": "{size.max}", "d_9": "{opacity.invisible}", "d_10": "{opacity.enabled}" }, "JDSFeedbackBlock": { "f_0": "{flexDirection.row}", "f_1": "{justifyContent.center}", "f_2": "{alignItems.center}", "f_3": "{xs}", "f_4": "{alignItems.start}", "f_5": "{flexDirection.row}", "f_6": "{justifyContent.center}", "f_7": "{alignItems.center}", "f_8": "{m}", "f_9": "{m}", "f_10": "{custom_18}", "f_11": "{base}" }, "JDSBottomFooterLinkItem": { "b_0": "{base}" }, "JDSFooterIconLinks": { "f_0": "{base}", "f_1": "{flexDirection.column}", "f_2": "{alignItems.start}", "f_3": "{flexDirection.row}", "f_4": "{base}" }, "JDSFooter": { "f_0": "{flexDirection.column}", "f_1": "{alignItems.center}", "f_2": "{size.max}", "f_3": "{primaryGrey20}", "f_4": "{flexDirection.row}", "f_5": "{justifyContent.spaceBetween}", "f_6": "{alignItems.start}", "f_7": "{base}", "f_8": "{size.max}", "f_9": "{xl}", "f_10": "{xl}", "f_11": "{huge}", "f_12": "{huge}", "f_13": "{xs}", "f_14": "{flexDirection.column}", "f_15": "{l}", "f_16": "{flexDirection.column}", "f_17": "{alignItems.start}", "f_18": "{size.max}", "f_19": "{size.max}", "f_20": "{size.max}", "f_21": "{m}", "f_22": "{flexDirection.column}", "f_23": "{justifyContent.start}", "f_24": "{m}", "f_25": "{xl}", "f_26": "{m}", "f_27": "{m}", "f_28": "{custom_17}" }, "JDSBottomFooter": { "b_0": "{flexDirection.row}", "b_1": "{justifyContent.spaceBetween}", "b_2": "{alignItems.center}", "b_3": "{base}", "b_4": "{huge}", "b_5": "{base}", "b_6": "{huge}", "b_7": "{global.transparent}", "b_8": "{base}", "b_9": "{flexDirection.row}", "b_10": "{alignItems.center}", "b_11": "{alignItems.center}", "b_12": "{size.max}", "b_13": "{flexDirection.column}", "b_14": "{justifyContent.start}", "b_15": "{alignItems.start}", "b_16": "{m}", "b_17": "{m}", "b_18": "{m}", "b_19": "{base}", "b_20": "{flexDirection.column}", "b_21": "{alignItems.start}", "b_22": "{base}" }, "JDSFooterLinksGrid": { "f_0": "{flexDirection.row}", "f_1": "{size.max}", "f_2": "{base}" }, "JDSFooterLinks": { "f_0": "{flexDirection.column}", "f_1": "{alignItems.start}", "f_2": "{size.max}", "f_3": "{size.max}", "f_4": "{xs}", "f_5": "{xs}", "f_6": "{flexDirection.column}", "f_7": "{justifyContent.start}", "f_8": "{alignItems.start}", "f_9": "{global.transparent}", "f_10": "{primaryGrey40}", "f_11": "{xs}", "f_12": "{xs}", "f_13": "{s}", "f_14": "{size.max}", "f_15": "{flexDirection.column}" }, "JDSIcon": { "icon_0": "{global.transparent}", "icon_1": "{pill}", "icon_2": "{m}", "icon_3": "{justifyContent.center}", "icon_4": "{alignItems.center}", "icon_5": "{m}", "icon_6": "{custom_color_1}", "icon_7": "{primary50}", "icon_8": "{primary30}", "icon_9": "{primary60}", "icon_10": "{primary70}", "icon_11": "{primaryBackground}", "icon_12": "{secondary50}", "icon_13": "{sparkle50}", "icon_14": "{primaryGrey60}", "icon_15": "{primaryGrey80}", "icon_16": "{primaryGrey100}", "icon_17": "{feedbackSuccess50}", "icon_18": "{feedbackError50}", "icon_19": "{feedbackWarning50}", "icon_20": "{global.white}", "icon_21": "{base}", "icon_22": "{base}", "icon_23": "{l}", "icon_24": "{l}", "icon_25": "{xl}", "icon_26": "{xl}", "icon_27": "{xxl}", "icon_28": "{xxl}", "icon_29": "{size.max}", "icon_30": "{size.max}", "icon_31": "{primary20}", "icon_32": "{primary20}", "icon_33": "{primary20}", "icon_34": "{primary20}", "icon_35": "{primary20}", "icon_36": "{secondary20}", "icon_37": "{sparkle20}", "icon_38": "{primaryGrey20}", "icon_39": "{primaryGrey20}", "icon_40": "{primaryGrey20}", "icon_41": "{primary20}", "icon_42": "{feedbackSuccess20}", "icon_43": "{feedbackError20}", "icon_44": "{feedbackWarning20}", "icon_45": "{primary50}", "icon_46": "{primaryInverse}", "icon_47": "{primary30}", "icon_48": "{primary30}", "icon_49": "{primary60}", "icon_50": "{primaryInverse}", "icon_51": "{primary70}", "icon_52": "{primaryInverse}", "icon_53": "{primaryBackground}", "icon_54": "{primaryInverse}", "icon_55": "{secondary50}", "icon_56": "{secondaryInverse}", "icon_57": "{sparkle50}", "icon_58": "{sparkleInverse}", "icon_59": "{primaryGrey60}", "icon_60": "{primaryInverse}", "icon_61": "{primaryGrey80}", "icon_62": "{primaryInverse}", "icon_63": "{primaryGrey100}", "icon_64": "{primaryInverse}", "icon_65": "{global.white}", "icon_66": "{global.white}", "icon_67": "{feedbackSuccess50}", "icon_68": "{primaryInverse}", "icon_69": "{feedbackError50}", "icon_70": "{primaryInverse}", "icon_71": "{feedbackWarning50}", "icon_72": "{primaryInverse}", "icon_73": "{m}", "icon_74": "{base}", "icon_75": "{base}", "icon_76": "{global.transparent}", "icon_77": "{base}", "icon_78": "{l}", "icon_79": "{m}", "icon_80": "{xl}", "icon_81": "{custom_3}", "icon_82": "{xxl}", "icon_83": "{l}", "icon_84": "{global.transparent}", "icon_85": "{primary50}", "icon_86": "{global.transparent}", "icon_87": "{primary30}", "icon_88": "{global.transparent}", "icon_89": "{primary60}", "icon_90": "{global.transparent}", "icon_91": "{primary70}", "icon_92": "{global.transparent}", "icon_93": "{primaryBackground}", "icon_94": "{global.transparent}", "icon_95": "{secondary50}", "icon_96": "{global.transparent}", "icon_97": "{sparkle50}", "icon_98": "{global.transparent}", "icon_99": "{primaryGrey60}", "icon_100": "{global.transparent}", "icon_101": "{primaryGrey80}", "icon_102": "{global.transparent}", "icon_103": "{primaryGrey100}", "icon_104": "{global.transparent}", "icon_105": "{global.white}", "icon_106": "{global.transparent}", "icon_107": "{feedbackSuccess50}", "icon_108": "{global.transparent}", "icon_109": "{feedbackError50}", "icon_110": "{global.transparent}", "icon_111": "{feedbackWarning50}", "icon_112": "{m}", "icon_113": "{base}", "icon_114": "{base}", "icon_115": "{base}", "icon_116": "{l}", "icon_117": "{m}", "icon_118": "{xl}", "icon_119": "{custom_3}", "icon_120": "{xxl}", "icon_121": "{l}", "icon_122": "{m}", "icon_123": "{m}", "icon_124": "{m}", "icon_125": "{m}", "icon_126": "{m}", "icon_127": "{m}", "icon_128": "{m}", "icon_129": "{m}", "icon_130": "{m}", "icon_131": "{m}", "icon_132": "{m}", "icon_133": "{m}", "icon_134": "{l}", "icon_135": "{l}", "icon_136": "{l}", "icon_137": "{l}", "icon_138": "{l}", "icon_139": "{l}", "icon_140": "{l}", "icon_141": "{l}", "icon_142": "{l}", "icon_143": "{l}", "icon_144": "{l}", "icon_145": "{l}", "icon_146": "{xl}", "icon_147": "{xl}", "icon_148": "{xl}", "icon_149": "{xl}", "icon_150": "{xl}", "icon_151": "{xl}", "icon_152": "{xl}", "icon_153": "{xl}", "icon_154": "{xl}", "icon_155": "{xl}", "icon_156": "{xl}", "icon_157": "{xl}", "icon_158": "{xxl}", "icon_159": "{xxl}", "icon_160": "{xxl}", "icon_161": "{xxl}", "icon_162": "{xxl}", "icon_163": "{xxl}", "icon_164": "{xxl}", "icon_165": "{xxl}", "icon_166": "{xxl}", "icon_167": "{xxl}", "icon_168": "{xxl}", "icon_169": "{xxl}" }, "JDSFooterMarketLinks": { "f_0": "{base}", "f_1": "{flexDirection.column}", "f_2": "{alignItems.start}", "f_3": "{flexDirection.row}", "f_4": "{alignItems.center}", "f_5": "{base}" }, "JDSImage": { "i_0": "{global.transparent}", "i_1": "{flexDirection.stack}", "i_2": "{justifyContent.center}", "i_3": "{alignItems.center}", "i_4": "{size.min}", "i_5": "{size.min}", "i_6": "{xl}", "i_7": "{aspect_ratio.1.1}", "i_8": "{xl}", "i_9": "{size.max}", "i_10": "{size.max}", "i_11": "{l}", "i_12": "{primaryGrey80}", "i_13": "{size.max}", "i_14": "{aspect_ratio.1.1}", "i_15": "{size.max}", "i_16": "{size.max}", "i_17": "{primaryGrey20}", "i_18": "{opacity.invisible}", "i_19": "{primaryGrey20}", "i_20": "{opacity.invisible}", "i_21": "{primaryGrey20}", "i_22": "{opacity.invisible}", "i_23": "{aspect_ratio.4.3}", "i_24": "{aspect_ratio.4.3}", "i_25": "{aspect_ratio.4.3}", "i_26": "{aspect_ratio.4.3}", "i_27": "{aspect_ratio.5.4}", "i_28": "{aspect_ratio.5.4}", "i_29": "{aspect_ratio.5.4}", "i_30": "{aspect_ratio.5.4}", "i_31": "{aspect_ratio.16.9}", "i_32": "{aspect_ratio.16.9}", "i_33": "{aspect_ratio.16.9}", "i_34": "{aspect_ratio.16.9}", "i_35": "{aspect_ratio.4.5}", "i_36": "{aspect_ratio.4.5}", "i_37": "{aspect_ratio.4.5}", "i_38": "{aspect_ratio.4.5}", "i_39": "{aspect_ratio.3.4}", "i_40": "{aspect_ratio.3.4}", "i_41": "{aspect_ratio.3.4}", "i_42": "{aspect_ratio.3.4}", "i_43": "{aspect_ratio.9.16}", "i_44": "{aspect_ratio.9.16}", "i_45": "{aspect_ratio.9.16}", "i_46": "{aspect_ratio.9.16}", "i_47": "{aspect_ratio.2_75.1}", "i_48": "{aspect_ratio.2_75.1}", "i_49": "{aspect_ratio.2_75.1}", "i_50": "{aspect_ratio.2_75.1}" }, "JDSInput": { "i_0": "{textAlign.start}", "i_1": "{primaryGrey60}", "i_2": "{bodyS}", "i_3": "{bodyS}", "i_4": "{bodyS}", "i_5": "{bodyS}", "i_6": "{bodyS}", "i_7": "{primaryGrey100}", "i_8": "{bodyS}", "i_9": "{bodyS}", "i_10": "{bodyS}", "i_11": "{bodyS}", "i_12": "{bodyS}", "i_13": "{primaryGrey100}", "i_14": "{size.max}", "i_15": "{opacity.disabled}", "i_16": "{textAlign.center}", "i_17": "{textAlign.end}", "i_18": "{textAlign.justify}", "i_19": "{bodyL}", "i_20": "{bodyL}", "i_21": "{bodyL}", "i_22": "{bodyL}", "i_23": "{bodyL}", "i_24": "{bodyL}", "i_25": "{bodyL}", "i_26": "{bodyL}" }, "JDSInputCodeItem": { "i_0": "{flexDirection.column}", "i_1": "{justifyContent.center}", "i_2": "{alignItems.center}", "i_3": "{xs}", "i_4": "{size.max}", "i_5": "{size.max}", "i_6": "{flexDirection.column}", "i_7": "{justifyContent.center}", "i_8": "{alignItems.center}", "i_9": "{size.max}", "i_10": "{custom_1}", "i_11": "{custom_1}", "i_12": "{size.max}", "i_13": "{custom_4}", "i_14": "{primaryGrey100}", "i_15": "{custom_2}", "i_16": "{primary50}", "i_17": "{primary50}", "i_18": "{primary50}", "i_19": "{feedbackSuccess50}", "i_20": "{feedbackError50}", "i_21": "{feedbackWarning50}", "i_22": "{primary60}" }, "JDSInputDate": { "i_0": "{flexDirection.column}", "i_1": "{alignItems.start}", "i_2": "{xs}", "i_3": "{size.max}", "i_4": "{flexDirection.row}", "i_5": "{size.max}", "i_6": "{alignItems.center}", "i_7": "{flexDirection.column}", "i_8": "{size.max}", "i_9": "{alignItems.start}", "i_10": "{size.max}", "i_11": "{s}", "i_12": "{alignItems.stretch}", "i_13": "{flexDirection.column}", "i_14": "{xs}", "i_15": "{alignItems.start}", "i_16": "{textAlign.start}", "i_17": "{size.max}", "i_18": "{size.max}", "i_19": "{primaryGrey80}", "i_20": "{primaryGrey60}", "i_21": "{flexDirection.column}", "i_22": "{xs}", "i_23": "{alignItems.start}", "i_24": "{textAlign.start}", "i_25": "{size.max}", "i_26": "{size.max}", "i_27": "{primaryGrey80}", "i_28": "{primaryGrey60}", "i_29": "{flexDirection.column}", "i_30": "{xs}", "i_31": "{alignItems.start}", "i_32": "{textAlign.start}", "i_33": "{size.max}", "i_34": "{size.max}", "i_35": "{primaryGrey80}", "i_36": "{justifyContent.center}", "i_37": "{alignItems.center}", "i_38": "{opacity.disabled}", "i_39": "{feedbackError50}", "i_40": "{feedbackError50}", "i_41": "{feedbackError50}", "i_42": "{feedbackError50}", "i_43": "{feedbackError50}", "i_44": "{feedbackError50}" }, "JDSLink": { "l_0": "{global.transparent}", "l_1": "{flexDirection.row}", "l_2": "{justifyContent.center}", "l_3": "{alignItems.center}", "l_4": "{small}", "l_5": "{border_normal}", "l_6": "{primary60}", "l_7": "{primary30}", "l_8": "{text-decoration.underline}", "l_9": "{text-decoration.underline}", "l_10": "{text-decoration.underline}", "l_11": "{text-decoration.none}", "l_12": "{text-decoration.underline}" }, "JDSFileUploader": { "f_0": "{flexDirection.column}", "f_1": "{justifyContent.start}", "f_2": "{alignItems.start}", "f_3": "{size.max}", "f_4": "{xs}", "f_5": "{opacity.enabled}" }, "JDSFileUploaderControl": { "f_0": "{flexDirection.column}", "f_1": "{justifyContent.start}", "f_2": "{alignItems.start}", "f_3": "{xxs}", "f_4": "{size.max}", "f_5": "{opacity.enabled}", "f_6": "{flexDirection.row}", "f_7": "{justifyContent.start}", "f_8": "{alignItems.center}", "f_9": "{xxs}" }, "JDSFileUploaderItem": { "f_0": "{flexDirection.column}", "f_1": "{justifyContent.start}", "f_2": "{alignItems.start}", "f_3": "{size.max}", "f_4": "{opacity.enabled}", "f_5": "{primaryGrey20}", "f_6": "{flexDirection.row}", "f_7": "{justifyContent.spaceBetween}", "f_8": "{alignItems.center}", "f_9": "{xs}", "f_10": "{s}", "f_11": "{size.max}", "f_12": "{flexDirection.row}", "f_13": "{justifyContent.start}", "f_14": "{alignItems.center}", "f_15": "{xs}", "f_16": "{alignItems.center}" }, "JDSFileUploaderList": { "f_0": "{flexDirection.column}", "f_1": "{justifyContent.start}", "f_2": "{alignItems.start}", "f_3": "{size.max}", "f_4": "{opacity.enabled}", "f_5": "{primaryGrey20}", "f_6": "{large}" }, "JDSFileUploaderPanel": { "f_0": "{flexDirection.column}", "f_1": "{justifyContent.start}", "f_2": "{alignItems.start}", "f_3": "{size.max}", "f_4": "{opacity.enabled}", "f_5": "{primaryGrey20}", "f_6": "{large}", "f_7": "{xs}", "f_8": "{xs}", "f_9": "{xs}", "f_10": "{xs}", "f_11": "{s}", "f_12": "{s}", "f_13": "{size.max}" }, "JDSMenuBlock": { "m_0": "{global.transparent}", "m_1": "{flexDirection.stack}", "m_2": "{size.max}", "m_3": "{intrinsicSize.max}", "m_4": "{primaryBackground}", "m_5": "{flexDirection.column}", "m_6": "{medium}", "m_7": "{size.max}" }, "JDSMenuBlockInternal": { "m_0": "{global.transparent}", "m_1": "{flexDirection.stack}", "m_2": "{size.max}", "m_3": "{intrinsicSize.max}", "m_4": "{primaryBackground}", "m_5": "{flexDirection.column}", "m_6": "{medium}", "m_7": "{size.max}" }, "JDSListBlock": { "l_0": "{flexDirection.column}", "l_1": "{size.max}", "l_2": "{justifyContent.start}", "l_3": "{alignItems.start}", "l_4": "{xs}", "l_5": "{xs}", "l_6": "{xs}", "l_7": "{flexDirection.row}", "l_8": "{size.max}", "l_9": "{base}", "l_10": "{justifyContent.start}", "l_11": "{alignItems.center}", "l_12": "{flexDirection.column}", "l_13": "{xxs}", "l_14": "{justifyContent.start}", "l_15": "{alignItems.start}", "l_16": "{flexDirection.row}", "l_17": "{size.max}", "l_18": "{justifyContent.spaceBetween}", "l_19": "{alignItems.center}", "l_20": "{s}", "l_21": "{flexDirection.row}", "l_22": "{justifyContent.start}", "l_23": "{alignItems.center}", "l_24": "{s}", "l_25": "{flexDirection.row}", "l_26": "{size.max}", "l_27": "{justifyContent.spaceBetween}", "l_28": "{alignItems.center}", "l_29": "{s}", "l_30": "{flexDirection.row}", "l_31": "{justifyContent.start}", "l_32": "{alignItems.center}", "l_33": "{s}", "l_34": "{flexDirection.row}", "l_35": "{size.max}", "l_36": "{justifyContent.spaceBetween}", "l_37": "{alignItems.center}", "l_38": "{s}", "l_39": "{flexDirection.row}", "l_40": "{justifyContent.start}", "l_41": "{alignItems.center}", "l_42": "{s}", "l_43": "{s}", "l_44": "{xxs}", "l_45": "{alignItems.start}" }, "JDSInputField": { "i_0": "{flexDirection.column}", "i_1": "{xxs}", "i_2": "{size.max}", "i_3": "{justifyContent.start}", "i_4": "{alignItems.start}", "i_5": "{flexDirection.stack}", "i_6": "{size.max}", "i_7": "{alignItems.end}", "i_8": "{justifyContent.start}", "i_9": "{xxs}", "i_10": "{flexDirection.row}", "i_11": "{justifyContent.start}", "i_12": "{size.max}", "i_13": "{xs}", "i_14": "{alignItems.center}", "i_15": "{m}", "i_16": "{primaryGrey80}", "i_17": "{textAlign.start}", "i_18": "{m}", "i_19": "{primaryGrey80}", "i_20": "{primary60}", "i_21": "{flexDirection.column}", "i_22": "{size.max}", "i_23": "{alignItems.center}", "i_24": "{size.max}", "i_25": "{primaryGrey80}", "i_26": "{primary50}", "i_27": "{primary60}", "i_28": "{primary60}", "i_29": "{opacity.disabled}", "i_30": "{opacity.enabled}", "i_31": "{feedbackSuccess50}", "i_32": "{feedbackSuccess50}", "i_33": "{feedbackSuccess50}", "i_34": "{feedbackSuccess50}", "i_35": "{feedbackError50}", "i_36": "{feedbackError50}", "i_37": "{feedbackError50}", "i_38": "{feedbackError50}", "i_39": "{feedbackWarning50}", "i_40": "{feedbackWarning50}", "i_41": "{feedbackWarning50}", "i_42": "{feedbackWarning50}", "i_43": "{alignItems.start}", "i_44": "{alignItems.start}", "i_45": "{alignItems.end}", "i_46": "{l}", "i_47": "{alignItems.end}", "i_48": "{primary60}" }, "JDSInputFieldV2": { "i_0": "{s}", "i_1": "{flexDirection.column}", "i_2": "{size.max}", "i_3": "{justifyContent.start}", "i_4": "{alignItems.start}", "i_5": "{opacity.enabled}", "i_6": "{flexDirection.row}", "i_7": "{justifyContent.start}", "i_8": "{alignItems.center}", "i_9": "{xxs}", "i_10": "{xs}", "i_11": "{xs}", "i_12": "{xxs}", "i_13": "{flexDirection.row}", "i_14": "{justifyContent.start}", "i_15": "{alignItems.center}", "i_16": "{size.max}", "i_17": "{xl}", "i_18": "{xs}", "i_19": "{xs}", "i_20": "{xs}", "i_21": "{xs}", "i_22": "{xs}", "i_23": "{border_thin}", "i_24": "{primaryGrey60}", "i_25": "{medium}", "i_26": "{primary50}", "i_27": "{primary60}", "i_28": "{primary60}", "i_29": "{textAlign.start}", "i_30": "{flexDirection.column}", "i_31": "{justifyContent.start}", "i_32": "{alignItems.start}", "i_33": "{xxs}", "i_34": "{xxs}", "i_35": "{xs}", "i_36": "{xs}", "i_37": "{xxs}", "i_38": "{flexDirection.row}", "i_39": "{justifyContent.start}", "i_40": "{alignItems.center}", "i_41": "{xs}", "i_42": "{xs}", "i_43": "{opacity.disabled}", "i_44": "{feedbackSuccess50}", "i_45": "{feedbackSuccess50}", "i_46": "{feedbackSuccess50}", "i_47": "{feedbackSuccess50}", "i_48": "{feedbackError50}", "i_49": "{feedbackError50}", "i_50": "{feedbackError50}", "i_51": "{feedbackError50}", "i_52": "{feedbackWarning50}", "i_53": "{feedbackWarning50}", "i_54": "{feedbackWarning50}", "i_55": "{feedbackWarning50}", "i_56": "{l}", "i_57": "{xxs}", "i_58": "{xxs}", "i_59": "{xxl}", "i_60": "{s}", "i_61": "{s}", "i_62": "{s}", "i_63": "{xs}", "i_64": "{xs}" }, "JDSModalDesktop": { "m_0": "{flexDirection.stack}", "m_1": "{justifyContent.center}", "m_2": "{alignItems.center}", "m_3": "{size.max}", "m_4": "{size.max}", "m_5": "{global.black}", "m_6": "{custom_2}", "m_7": "{flexDirection.column}", "m_8": "{justifyContent.start}", "m_9": "{alignItems.start}", "m_10": "{xxl}", "m_11": "{primaryBackground}", "m_12": "{size.max}", "m_13": "{flexDirection.row}", "m_14": "{justifyContent.end}", "m_15": "{alignItems.center}", "m_16": "{size.max}", "m_17": "{s}", "m_18": "{s}", "m_19": "{s}", "m_20": "{s}", "m_21": "{flexDirection.column}", "m_22": "{justifyContent.start}", "m_23": "{alignItems.start}", "m_24": "{l}", "m_25": "{l}", "m_26": "{l}", "m_27": "{size.max}", "m_28": "auto", "m_29": "auto", "m_30": "{flexDirection.row}", "m_31": "{justifyContent.start}", "m_32": "{alignItems.center}", "m_33": "{size.max}", "m_34": "{base}", "m_35": "{size.max}", "m_36": "auto", "m_37": "{size.max}", "m_38": "{justifyContent.end}", "m_39": "{alignItems.start}", "m_40": "{flexDirection.row}", "m_41": "{s}", "m_42": "{base}", "m_43": "{flexDirection.column}", "m_44": "{justifyContent.start}", "m_45": "{alignItems.start}", "m_46": "{xxl}", "m_47": "{primaryBackground}", "m_48": "{l}", "m_49": "{l}", "m_50": "{l}", "m_51": "{l}", "m_52": "{custom_27}", "m_53": "{size.max}", "m_54": "{justifyContent.end}", "m_55": "{justifyContent.center}", "m_56": "{m}", "m_57": "{m}", "m_58": "{m}", "m_59": "{l}", "m_60": "{l}" }, "JDSModalDesktopInternal": { "m_0": "{flexDirection.stack}", "m_1": "{justifyContent.center}", "m_2": "{alignItems.center}", "m_3": "{size.max}", "m_4": "{size.max}", "m_5": "{global.black}", "m_6": "{custom_2}", "m_7": "{flexDirection.column}", "m_8": "{justifyContent.start}", "m_9": "{alignItems.start}", "m_10": "{xxl}", "m_11": "{primaryBackground}", "m_12": "{size.max}", "m_13": "{flexDirection.row}", "m_14": "{justifyContent.end}", "m_15": "{alignItems.center}", "m_16": "{size.max}", "m_17": "{s}", "m_18": "{s}", "m_19": "{s}", "m_20": "{s}", "m_21": "{flexDirection.column}", "m_22": "{justifyContent.start}", "m_23": "{alignItems.start}", "m_24": "{l}", "m_25": "{l}", "m_26": "{l}", "m_27": "{size.max}", "m_28": "auto", "m_29": "auto", "m_30": "{flexDirection.row}", "m_31": "{justifyContent.start}", "m_32": "{alignItems.center}", "m_33": "{size.max}", "m_34": "{base}", "m_35": "{size.max}", "m_36": "auto", "m_37": "{size.max}", "m_38": "{justifyContent.end}", "m_39": "{alignItems.start}", "m_40": "{flexDirection.row}", "m_41": "{s}", "m_42": "{base}", "m_43": "{flexDirection.column}", "m_44": "{justifyContent.start}", "m_45": "{alignItems.start}", "m_46": "{xxl}", "m_47": "{primaryBackground}", "m_48": "{l}", "m_49": "{l}", "m_50": "{l}", "m_51": "{l}", "m_52": "{custom_27}", "m_53": "{size.max}", "m_54": "{justifyContent.end}", "m_55": "{justifyContent.center}", "m_56": "{m}", "m_57": "{m}", "m_58": "{m}", "m_59": "{l}", "m_60": "{l}" }, "JDSMenuBlockItem": { "m_0": "{opacity.enabled}", "m_1": "{global.transparent}", "m_2": "{size.max}", "m_3": "{global.transparent}", "m_4": "{size.max}", "m_5": "{xs}", "m_6": "{base}", "m_7": "{xs}", "m_8": "{base}", "m_9": "{flexDirection.row}", "m_10": "{alignItems.center}", "m_11": "{justifyContent.spaceBetween}", "m_12": "{global.transparent}", "m_13": "{primaryGrey20}", "m_14": "{primary60}", "m_15": "{small}", "m_16": "{size.max}", "m_17": "{xs}", "m_18": "{base}", "m_19": "{xs}", "m_20": "{base}", "m_21": "{size.max}", "m_22": "{alignItems.center}", "m_23": "{justifyContent.start}", "m_24": "{xs}", "m_25": "{flexDirection.row}", "m_26": "{alignItems.center}", "m_27": "{primaryGrey20}", "m_28": "{opacity.disabled}", "m_29": "{xxl}" }, "JDSModalMobile": { "m_0": "{flexDirection.stack}", "m_1": "{justifyContent.center}", "m_2": "{alignItems.center}", "m_3": "{size.max}", "m_4": "{size.max}", "m_5": "{global.black}", "m_6": "{custom_2}", "m_7": "{flexDirection.column}", "m_8": "{justifyContent.start}", "m_9": "{alignItems.start}", "m_10": "{xl}", "m_11": "{size.max}", "m_12": "{size.max}", "m_13": "{primaryBackground}", "m_14": "{flexDirection.row}", "m_15": "{justifyContent.center}", "m_16": "{alignItems.center}", "m_17": "{xl}", "m_18": "{size.max}", "m_19": "{size.max}", "m_20": "{m}", "m_21": "{m}", "m_22": "{m}", "m_23": "{m}", "m_24": "{flexDirection.row}", "m_25": "{justifyContent.end}", "m_26": "{alignItems.center}", "m_27": "{size.max}", "m_28": "{s}", "m_29": "{s}", "m_30": "{s}", "m_31": "{s}", "m_32": "{flexDirection.column}", "m_33": "{justifyContent.start}", "m_34": "{alignItems.start}", "m_35": "{size.max}", "m_36": "{l}", "m_37": "{l}", "m_38": "{l}", "m_39": "auto", "m_40": "{flexDirection.row}", "m_41": "{justifyContent.start}", "m_42": "{alignItems.center}", "m_43": "{size.max}", "m_44": "{base}", "m_45": "{size.max}", "m_46": "auto", "m_47": "{size.max}", "m_48": "{justifyContent.start}", "m_49": "{alignItems.start}", "m_50": "{flexDirection.column}", "m_51": "{s}", "m_52": "{base}", "m_53": "{flexDirection.column}", "m_54": "{justifyContent.start}", "m_55": "{alignItems.start}", "m_56": "{xl}", "m_57": "{primaryBackground}", "m_58": "{l}", "m_59": "{l}", "m_60": "{l}", "m_61": "{l}", "m_62": "{size.max}", "m_63": "{justifyContent.end}", "m_64": "{justifyContent.center}", "m_65": "{m}", "m_66": "{m}", "m_67": "{m}", "m_68": "{l}", "m_69": "{l}" }, "JDSModalMobileInternal": { "m_0": "{flexDirection.stack}", "m_1": "{justifyContent.center}", "m_2": "{alignItems.center}", "m_3": "{size.max}", "m_4": "{size.max}", "m_5": "{global.black}", "m_6": "{custom_2}", "m_7": "{flexDirection.column}", "m_8": "{justifyContent.start}", "m_9": "{alignItems.start}", "m_10": "{xl}", "m_11": "{size.max}", "m_12": "{size.max}", "m_13": "{primaryBackground}", "m_14": "{flexDirection.row}", "m_15": "{justifyContent.center}", "m_16": "{alignItems.center}", "m_17": "{xl}", "m_18": "{size.max}", "m_19": "{size.max}", "m_20": "{m}", "m_21": "{m}", "m_22": "{m}", "m_23": "{m}", "m_24": "{flexDirection.row}", "m_25": "{justifyContent.end}", "m_26": "{alignItems.center}", "m_27": "{size.max}", "m_28": "{s}", "m_29": "{s}", "m_30": "{s}", "m_31": "{s}", "m_32": "{flexDirection.column}", "m_33": "{justifyContent.start}", "m_34": "{alignItems.start}", "m_35": "{size.max}", "m_36": "{l}", "m_37": "{l}", "m_38": "{l}", "m_39": "auto", "m_40": "{flexDirection.row}", "m_41": "{justifyContent.start}", "m_42": "{alignItems.center}", "m_43": "{size.max}", "m_44": "{base}", "m_45": "{size.max}", "m_46": "auto", "m_47": "{size.max}", "m_48": "{justifyContent.start}", "m_49": "{alignItems.start}", "m_50": "{flexDirection.column}", "m_51": "{s}", "m_52": "{base}", "m_53": "{flexDirection.column}", "m_54": "{justifyContent.start}", "m_55": "{alignItems.start}", "m_56": "{xl}", "m_57": "{primaryBackground}", "m_58": "{l}", "m_59": "{l}", "m_60": "{l}", "m_61": "{l}", "m_62": "{size.max}", "m_63": "{justifyContent.end}", "m_64": "{justifyContent.center}", "m_65": "{m}", "m_66": "{m}", "m_67": "{m}", "m_68": "{l}", "m_69": "{l}" }, "JDSHeaderDesktop": { "h_0": "{size.max}", "h_1": "{flexDirection.column}", "h_2": "{flexDirection.row}", "h_3": "{justifyContent.start}", "h_4": "{alignItems.center}", "h_5": "{xs}", "h_6": "{size.max}", "h_7": "{primary50}", "h_8": "{flexDirection.row}", "h_9": "{justifyContent.end}", "h_10": "{alignItems.center}", "h_11": "{xxl}", "h_12": "{s}", "h_13": "{xxl}", "h_14": "{s}", "h_15": "{base}", "h_16": "{custom_16}", "h_17": "{flexDirection.row}", "h_18": "{justifyContent.start}", "h_19": "{alignItems.center}", "h_20": "{base}", "h_21": "{flexDirection.row}", "h_22": "{justifyContent.center}", "h_23": "{alignItems.center}", "h_24": "{xs}", "h_25": "{flexDirection.row}", "h_26": "{justifyContent.center}", "h_27": "{alignItems.center}", "h_28": "{xs}", "h_29": "{flexDirection.row}", "h_30": "{justifyContent.start}", "h_31": "{alignItems.center}", "h_32": "{l}", "h_33": "{huge}", "h_34": "{flexDirection.row}", "h_35": "{justifyContent.end}", "h_36": "{alignItems.center}", "h_37": "{s}", "h_38": "{flexDirection.row}", "h_39": "{justifyContent.end}", "h_40": "{alignItems.center}", "h_41": "{s}", "h_42": "{size.max}", "h_43": "{flexDirection.row}", "h_44": "{justifyContent.center}", "h_45": "{alignItems.center}", "h_46": "{s}", "h_47": "{size.max}", "h_48": "{huge}", "h_49": "{s}", "h_50": "{s}", "h_51": "{s}", "h_52": "{xs}", "h_53": "{xs}", "h_54": "{xs}", "h_55": "{size.max}", "h_56": "{justifyContent.spaceBetween}", "h_57": "{size.max}", "h_58": "{intrinsicSize.max}", "h_59": "{justifyContent.spaceBetween}" }, "JDSBottomNavigation": { "b_0": "{size.max}", "b_1": "{flexDirection.row}", "b_2": "{justifyContent.center}", "b_3": "{alignItems.center}", "b_4": "{primaryBackground}", "b_5": "{m}", "b_6": "{base}", "b_7": "{m}", "b_8": "{base}", "b_9": "{m}", "b_10": "{primaryGrey40}" }, "JDSBottomNavigationItem": { "b_0": "{size.max}", "b_1": "{flexDirection.column}", "b_2": "{justifyContent.center}", "b_3": "{alignItems.center}", "b_4": "{xxs}", "b_5": "{opacity.disabled}", "b_6": "{opacity.enabled}" }, "JDSMegaMenu": { "m_0": "{flexDirection.row}", "m_1": "{size.max}", "m_2": "{flexDirection.row}", "m_3": "{justifyContent.start}", "m_4": "{alignItems.start}", "m_5": "{primaryBackground}", "m_6": "{m}", "m_7": "{m}", "m_8": "{xxl}", "m_9": "{xxl}", "m_10": "{base}" }, "JDSMegaMenuInternal": { "m_0": "{flexDirection.row}", "m_1": "{size.max}", "m_2": "{flexDirection.row}", "m_3": "{justifyContent.start}", "m_4": "{alignItems.start}", "m_5": "{primaryBackground}", "m_6": "{m}", "m_7": "{m}", "m_8": "{xxl}", "m_9": "{xxl}", "m_10": "{base}" }, "JDSHeaderMobile": { "h_0": "{size.max}", "h_1": "{flexDirection.column}", "h_2": "{size.max}", "h_3": "{size.max}", "h_4": "{primary50}", "h_5": "{flexDirection.row}", "h_6": "{justifyContent.spaceBetween}", "h_7": "{alignItems.center}", "h_8": "{s}", "h_9": "{xs}", "h_10": "{s}", "h_11": "{xs}", "h_12": "{base}", "h_13": "{huge}", "h_14": "{flexDirection.row}", "h_15": "{justifyContent.start}", "h_16": "{alignItems.center}", "h_17": "{base}", "h_18": "{flexDirection.row}", "h_19": "{justifyContent.start}", "h_20": "{alignItems.center}", "h_21": "{xs}", "h_22": "{flexDirection.row}", "h_23": "{justifyContent.center}", "h_24": "{alignItems.center}", "h_25": "{xs}", "h_26": "{flexDirection.row}", "h_27": "{justifyContent.start}", "h_28": "{alignItems.center}", "h_29": "{l}", "h_30": "{huge}", "h_31": "{flexDirection.row}", "h_32": "{justifyContent.end}", "h_33": "{alignItems.center}", "h_34": "{s}", "h_35": "{flexDirection.row}", "h_36": "{justifyContent.end}", "h_37": "{alignItems.center}", "h_38": "{s}", "h_39": "{flexDirection.row}", "h_40": "{justifyContent.center}", "h_41": "{alignItems.center}", "h_42": "{s}", "h_43": "{s}", "h_44": "{s}", "h_45": "{xxs}", "h_46": "{xs}", "h_47": "{xs}", "h_48": "{xs}", "h_49": "{intrinsicSize.max}" }, "JDSMegaMenuItem": { "m_0": "{flexDirection.row}", "m_1": "{justifyContent.start}", "m_2": "{alignItems.start}", "m_3": "{xs}", "m_4": "{xs}" }, "JDSTextarea": { "t_0": "{flexDirection.column}", "t_1": "{justifyContent.start}", "t_2": "{alignItems.start}", "t_3": "{xxs}", "t_4": "{size.max}", "t_5": "{flexDirection.stack}", "t_6": "{size.max}", "t_7": "{xxs}", "t_8": "{justifyContent.start}", "t_9": "{alignItems.end}", "t_10": "{flexDirection.row}", "t_11": "{justifyContent.start}", "t_12": "{size.max}", "t_13": "{alignItems.center}", "t_14": "{textAlign.start}", "t_15": "{primaryGrey60}", "t_16": "{bodyS}", "t_17": "{bodyS}", "t_18": "{bodyS}", "t_19": "{bodyS}", "t_20": "{bodyS}", "t_21": "{primaryGrey100}", "t_22": "{bodyS}", "t_23": "{bodyS}", "t_24": "{bodyS}", "t_25": "{bodyS}", "t_26": "{bodyS}", "t_27": "{primaryGrey100}", "t_28": "{primaryGrey100}", "t_29": "{size.max}", "t_30": "{primary50}", "t_31": "{primary60}", "t_32": "{primary60}", "t_33": "{flexDirection.column}", "t_34": "{size.max}", "t_35": "{alignItems.center}", "t_36": "{size.max}", "t_37": "{primaryGrey100}", "t_38": "{primary50}", "t_39": "{primary60}", "t_40": "{primary60}", "t_41": "{opacity.disabled}", "t_42": "{opacity.enabled}", "t_43": "{feedbackSuccess50}", "t_44": "{feedbackSuccess50}", "t_45": "{feedbackSuccess50}", "t_46": "{feedbackSuccess50}", "t_47": "{feedbackSuccess50}", "t_48": "{feedbackSuccess50}", "t_49": "{feedbackSuccess50}", "t_50": "{feedbackSuccess50}", "t_51": "{feedbackError50}", "t_52": "{feedbackError50}", "t_53": "{feedbackError50}", "t_54": "{feedbackError50}", "t_55": "{feedbackError50}", "t_56": "{feedbackError50}", "t_57": "{feedbackError50}", "t_58": "{feedbackError50}", "t_59": "{feedbackWarning50}", "t_60": "{feedbackWarning50}", "t_61": "{feedbackWarning50}", "t_62": "{feedbackWarning50}", "t_63": "{feedbackWarning50}", "t_64": "{feedbackWarning50}", "t_65": "{feedbackWarning50}", "t_66": "{feedbackWarning50}", "t_67": "{alignItems.start}", "t_68": "{primary60}", "t_69": "{primary60}" }, "JDSSidePanelItem": { "s_0": "{xl}", "s_1": "{xs}", "s_2": "{flexDirection.row}", "s_3": "{justifyContent.spaceBetween}", "s_4": "{alignItems.center}", "s_5": "{size.max}", "s_6": "{flexDirection.row}", "s_7": "{justifyContent.start}", "s_8": "{alignItems.center}", "s_9": "{base}", "s_10": "{s}", "s_11": "{s}" }, "JDSMegaMenuBlock": { "m_0": "{flexDirection.column}", "m_1": "{justifyContent.start}", "m_2": "{alignItems.start}", "m_3": "{base}", "m_4": "{flexDirection.column}", "m_5": "{justifyContent.start}", "m_6": "{alignItems.start}", "m_7": "{xs}" }, "JDSNotificationButton": { "n_0": "{xxs}", "n_1": "{base}", "n_2": "{xxs}", "n_3": "{base}", "n_4": "{global.transparent}", "n_5": "{primaryGrey60}", "n_6": "{primary20}", "n_7": "{primary30}", "n_8": "{primary50}", "n_9": "{opacity.disabled}", "n_10": "{primary30}", "n_11": "{primary40}", "n_12": "{primary30}", "n_13": "{primary20}", "n_14": "{base}", "n_15": "{xs}", "n_16": "{xs}", "n_17": "{xs}", "n_18": "{xs}" }, "JDSNotificationBanner": { "n_0": "{custom_11}", "n_1": "{size.max}", "n_2": "{flexDirection.column}", "n_3": "{justifyContent.center}", "n_4": "{alignItems.center}", "n_5": "{base}", "n_6": "{base}", "n_7": "{base}", "n_8": "{base}", "n_9": "{base}", "n_10": "{large}", "n_11": "{primaryGrey20}", "n_12": "{flexDirection.row}", "n_13": "{justifyContent.start}", "n_14": "{alignItems.start}", "n_15": "{size.max}", "n_16": "{s}", "n_17": "{justifyContent.start}", "n_18": "{alignItems.start}", "n_19": "{flexDirection.column}", "n_20": "{xxs}", "n_21": "{flexDirection.row}", "n_22": "{xs}", "n_23": "{size.max}", "n_24": "{flexDirection.row}", "n_25": "{justifyContent.end}", "n_26": "{alignItems.center}", "n_27": "{alignItems.center}", "n_28": "{custom_3}", "n_29": "{custom_3}", "n_30": "{m}", "n_31": "{m}", "n_32": "{l}", "n_33": "{l}" }, "JDSNudgeContainer": { "n_0": "{flexDirection.stack}", "n_1": "{size.max}", "n_2": "{base}", "n_3": "{base}", "n_4": "{base}", "n_5": "{base}", "n_6": "{flexDirection.column}", "n_7": "{justifyContent.start}", "n_8": "{alignItems.end}", "n_9": "{size.max}", "n_10": "{xs}" }, "JDSToastContainer": { "t_0": "{flexDirection.stack}", "t_1": "{size.max}", "t_2": "{base}", "t_3": "{base}", "t_4": "{base}", "t_5": "{base}", "t_6": "{flexDirection.column}", "t_7": "{justifyContent.end}", "t_8": "{alignItems.start}", "t_9": "{size.max}", "t_10": "{xs}" }, "JDSToast": { "t_0": "{size.max}", "t_1": "{size.max}", "t_2": "{xl}", "t_3": "{primaryGrey80}", "t_4": "{flexDirection.column}", "t_5": "{base}", "t_6": "{base}", "t_7": "{base}", "t_8": "{base}", "t_9": "{base}", "t_10": "{s}", "t_11": "{size.max}", "t_12": "{flexDirection.row}", "t_13": "{justifyContent.start}", "t_14": "{alignItems.center}", "t_15": "{flexDirection.column}", "t_16": "{justifyContent.start}", "t_17": "{alignItems.start}", "t_18": "{xxs}", "t_19": "{size.max}", "t_20": "{s}", "t_21": "{flexDirection.row}", "t_22": "{justifyContent.end}", "t_23": "{custom_13}", "t_24": "{custom_14}" }, "JDSNudge": { "n_0": "{size.max}", "n_1": "{size.max}", "n_2": "{xl}", "n_3": "{primaryGrey80}", "n_4": "{flexDirection.column}", "n_5": "{base}", "n_6": "{base}", "n_7": "{base}", "n_8": "{base}", "n_9": "{base}", "n_10": "{s}", "n_11": "{size.max}", "n_12": "{flexDirection.row}", "n_13": "{justifyContent.start}", "n_14": "{alignItems.center}", "n_15": "{flexDirection.column}", "n_16": "{justifyContent.start}", "n_17": "{alignItems.start}", "n_18": "{s}", "n_19": "{size.max}", "n_20": "{s}", "n_21": "{flexDirection.row}", "n_22": "{justifyContent.end}", "n_23": "{custom_13}", "n_24": "{custom_14}" }, "JDSPagination": { "p_0": "{global.transparent}", "p_1": "{flexDirection.row}", "p_2": "{alignItems.center}", "p_3": "{alignItems.center}", "p_4": "{custom_25}", "p_5": "{custom_25}", "p_6": "{size.max}", "p_7": "{xxl}", "p_8": "{flexDirection.row}", "p_9": "{flexDirection.row}", "p_10": "{xxs}", "p_11": "{base}", "p_12": "{base}" }, "JDSPromoCard": { "p_0": "{global.white}", "p_1": "{flexDirection.column}", "p_2": "{size.max}", "p_3": "{justifyContent.start}", "p_4": "{alignItems.start}", "p_5": "{xl}", "p_6": "{flexDirection.column}", "p_7": "{alignItems.start}", "p_8": "{justifyContent.start}", "p_9": "{size.max}", "p_10": "{xl}", "p_11": "{primaryBackground}", "p_12": "{flexDirection.row}", "p_13": "{alignItems.stretch}", "p_14": "{justifyContent.start}", "p_15": "{size.max}", "p_16": "{xl}", "p_17": "{intrinsicSize.max}", "p_18": "{primaryBackground}", "p_19": "{flexDirection.row}", "p_20": "{alignItems.start}", "p_21": "{justifyContent.start}", "p_22": "{size.max}", "p_23": "{primaryBackground}", "p_24": "{xl}", "p_25": "{xl}", "p_26": "{m}", "p_27": "{m}", "p_28": "{m}", "p_29": "{flexDirection.row}", "p_30": "{alignItems.start}", "p_31": "{justifyContent.start}", "p_32": "{size.max}", "p_33": "{primaryBackground}", "p_34": "{m}", "p_35": "{m}", "p_36": "{m}", "p_37": "{m}", "p_38": "{size.max}", "p_39": "{flexDirection.stack}", "p_40": "{alignItems.end}", "p_41": "{size.max}", "p_42": "{flexDirection.stack}", "p_43": "{alignItems.center}", "p_44": "{justifyContent.start}", "p_45": "{size.max}", "p_46": "{primaryBackground}", "p_47": "{size.max}", "p_48": "{xl}", "p_49": "{primaryBackground}", "p_50": "{size.max}", "p_51": "{xl}", "p_52": "{primaryBackground}", "p_53": "{size.max}", "p_54": "{justifyContent.spaceBetween}", "p_55": "{alignItems.center}", "p_56": "{flexDirection.row}", "p_57": "{base}", "p_58": "{m}", "p_59": "{m}", "p_60": "{base}", "p_61": "{base}", "p_62": "{l}", "p_63": "{l}", "p_64": "{l}", "p_65": "{l}", "p_66": "{l}", "p_67": "{l}", "p_68": "{l}", "p_69": "{l}" }, "JDSSidePanel": { "s_0": "{size.max}", "s_1": "{size.max}", "s_2": "{flexDirection.row}", "s_3": "{justifyContent.start}", "s_4": "{alignItems.center}", "s_5": "{size.max}", "s_6": "{flexDirection.column}", "s_7": "{primaryBackground}", "s_8": "{size.max}", "s_9": "{size.max}", "s_10": "{flexDirection.column}", "s_11": "{justifyContent.start}", "s_12": "{alignItems.center}", "s_13": "{m}", "s_14": "{m}", "s_15": "{m}", "s_16": "{primary50}", "s_17": "{s}", "s_18": "{s}", "s_19": "{m}", "s_20": "{m}", "s_21": "{size.max}", "s_22": "{justifyContent.spaceBetween}", "s_23": "{alignItems.center}", "s_24": "{flexDirection.row}", "s_25": "{s}", "s_26": "{alignItems.center}", "s_27": "{justifyContent.end}", "s_28": "{size.max}", "s_29": "{size.max}", "s_30": 376 }, "JDSSidePanelInternal": { "s_0": "{size.max}", "s_1": "{size.max}", "s_2": "{flexDirection.row}", "s_3": "{justifyContent.start}", "s_4": "{alignItems.center}", "s_5": "{size.max}", "s_6": "{flexDirection.column}", "s_7": "{primaryBackground}", "s_8": "{size.max}", "s_9": "{size.max}", "s_10": "{flexDirection.column}", "s_11": "{justifyContent.start}", "s_12": "{alignItems.center}", "s_13": "{m}", "s_14": "{m}", "s_15": "{m}", "s_16": "{primary50}", "s_17": "{s}", "s_18": "{s}", "s_19": "{m}", "s_20": "{m}", "s_21": "{size.max}", "s_22": "{justifyContent.spaceBetween}", "s_23": "{alignItems.center}", "s_24": "{flexDirection.row}", "s_25": "{s}", "s_26": "{alignItems.center}", "s_27": "{justifyContent.end}", "s_28": "{size.max}", "s_29": "{size.max}", "s_30": 376 }, "JDSProgressBar": { "p_0": "{flexDirection.column}", "p_1": "{justifyContent.center}", "p_2": "{alignItems.start}", "p_3": "{base}", "p_4": "{size.max}", "p_5": "{global.transparent}", "p_6": "{global.transparent}", "p_7": "{flexDirection.row}", "p_8": "{justifyContent.spaceBetween}", "p_9": "{alignItems.center}", "p_10": "{size.max}", "p_11": "{m}", "p_12": "{primaryGrey40}", "p_13": "{xs}", "p_14": "{size.max}", "p_15": "{flexDirection.row}", "p_16": "{justifyContent.start}", "p_17": "{alignItems.start}", "p_18": "{pill}", "p_19": "{primary50}", "p_20": "{xs}", "p_21": "{pill}", "p_22": "{xs}", "p_23": "{flexDirection.stack}", "p_24": "{primaryGrey40}", "p_25": "{xs}", "p_26": "{size.max}", "p_27": "{pill}", "p_28": "{size.max}", "p_29": "{size.max}", "p_30": "{massive}", "p_31": "{primary50}", "p_32": "{pill}", "p_33": "{feedbackSuccess50}", "p_34": "{feedbackSuccess50}", "p_35": "{feedbackError50}", "p_36": "{feedbackError50}", "p_37": "{feedbackWarning50}", "p_38": "{feedbackWarning50}", "p_39": "{justifyContent.center}" }, "JDSSearchBox": { "s_0": "{primaryGrey20}", "s_1": "{flexDirection.row}", "s_2": "{justifyContent.start}", "s_3": "{alignItems.center}", "s_4": "{s}", "s_5": "{s}", "s_6": "{size.max}", "s_7": "{xl}", "s_8": "{pill}", "s_9": "{s}", "s_10": "{opacity.enabled}", "s_11": "{primary60}", "s_12": "{border_focus}", "s_13": "{primaryGrey40}", "s_14": "{textAlign.start}", "s_15": "{primaryGrey100}", "s_16": "{bodyS}", "s_17": "{bodyS}", "s_18": "{bodyS}", "s_19": "{bodyS}", "s_20": "{bodyS}", "s_21": "{primaryGrey100}", "s_22": "{bodyS}", "s_23": "{bodyS}", "s_24": "{bodyS}", "s_25": "{bodyS}", "s_26": "{bodyS}", "s_27": "{primary60}", "s_28": "{primary60}", "s_29": "{primary60}", "s_30": "{primary60}", "s_31": "{flexDirection.row}", "s_32": "{justifyContent.center}", "s_33": "{alignItems.center}", "s_34": "{m}", "s_35": "{primaryGrey100}", "s_36": "{primary60}", "s_37": "{primary60}", "s_38": "{primaryGrey80}", "s_39": "{flexDirection.row}", "s_40": "{justifyContent.center}", "s_41": "{alignItems.center}", "s_42": "{m}", "s_43": "{primary60}", "s_44": "{primary60}", "s_45": "{primary60}", "s_46": "{primaryGrey100}", "s_47": "{primary60}", "s_48": "{primary80}", "s_49": "{primary70}", "s_50": "{primaryBackground}", "s_51": "{primary30}", "s_52": "{primary30}", "s_53": "{primaryBackground}", "s_54": "{primary30}", "s_55": "{primary30}", "s_56": "{primaryBackground}", "s_57": "{primary40}", "s_58": "{primary30}", "s_59": "{primary30}", "s_60": "{primaryBackground}", "s_61": "{primaryGrey60}", "s_62": "{primary50}", "s_63": "{primary80}", "s_64": "{primary60}", "s_65": "{border_thin}", "s_66": "{border_focus}", "s_67": "{primaryGrey100}", "s_68": "{primary60}", "s_69": "{primaryGrey100}", "s_70": "{primaryGrey100}", "s_71": "{primary60}", "s_72": "{primary60}", "s_73": "{primaryGrey100}", "s_74": "{primary60}", "s_75": "{primary60}", "s_76": "{opacity.disabled}", "s_77": "{primaryGrey80}", "s_78": "{primary30}", "s_79": "{primaryGrey60}", "s_80": "{primaryGrey80}", "s_81": "{primary60}" }, "JDSPaginationButton": { "p_0": "{xxl}", "p_1": "{justifyContent.center}", "p_2": "{alignItems.center}", "p_3": "{global.transparent}", "p_4": "{flexDirection.row}", "p_5": "{justifyContent.center}", "p_6": "{alignItems.center}", "p_7": "{pill}", "p_8": "{l}", "p_9": "{l}", "p_10": "{opacity.enabled}", "p_11": "{xs}", "p_12": "{primary80}", "p_13": "{primary20}", "p_14": "{primary30}", "p_15": "{border_focus}", "p_16": "{primary70}", "p_17": "{global.transparent}" }, "JDSSearchResultItem": { "s_0": "{flexDirection.row}", "s_1": "{base}", "s_2": "{xs}", "s_3": "{xs}", "s_4": "{alignItems.center}", "s_5": "{size.max}", "s_6": "{primaryGrey20}", "s_7": "{primaryGrey20}", "s_8": "{primaryGrey20}", "s_9": "{l}", "s_10": "{primaryGrey80}", "s_11": "{flexDirection.row}", "s_12": "{justifyContent.start}", "s_13": "{alignItems.center}" }, "JDSSearchResultText": {}, "JDSRadioButton": { "r_0": "{flexDirection.column}", "r_1": "{justifyContent.start}", "r_2": "{alignItems.start}", "r_3": "{xs}", "r_4": "{flexDirection.row}", "r_5": "{justifyContent.start}", "r_6": "{alignItems.center}", "r_7": "{xs}", "r_8": "{m}", "r_9": "{m}", "r_10": "{flexDirection.row}", "r_11": "{justifyContent.center}", "r_12": "{alignItems.center}", "r_13": "{global.transparent}", "r_14": "{pill}", "r_15": "{primaryGrey80}", "r_16": "{border_thin}", "r_17": "{border_none}", "r_18": "{primary40}", "r_19": "{primary60}", "r_20": "{primary60}", "r_21": "{s}", "r_22": "{s}", "r_23": "{pill}", "r_24": "{textAlign.start}", "r_25": "{base}", "r_26": "{base}", "r_27": "{xxs}", "r_28": "{xs}", "r_29": "{xs}", "r_30": "{primary50}", "r_31": "{primary40}", "r_32": "{primary60}", "r_33": "{primary50}", "r_34": "{primaryInverse}", "r_35": "{opacity.disabled}", "r_36": "{opacity.enabled}", "r_37": "{global.white}", "r_38": "{global.white}", "r_39": "{global.white}" }, "JDSSelector": { "s_0": "{flexDirection.stack}", "s_1": "{opacity.enabled}", "s_2": "{alignItems.center}", "s_3": "{justifyContent.center}", "s_4": "{pill}", "s_5": "{xxs}", "s_6": "{xxs}", "s_7": "{xxs}", "s_8": "{xxs}", "s_9": "{xxs}", "s_10": "{xxs}", "s_11": "{xxs}", "s_12": "{xxs}", "s_13": "{primaryGrey20}", "s_14": "{pill}", "s_15": "{xxs}", "s_16": "{flexDirection.row}", "s_17": "{size.max}", "s_18": "{intrinsicSize.max}", "s_19": "{justifyContent.start}", "s_20": "{alignItems.center}", "s_21": "{primary50}", "s_22": "{pill}", "s_23": "{size.max}", "s_24": "{size.max}", "s_25": "{primary50}" }, "JDSSelectorItem": { "s_0": "{opacity.enabled}", "s_1": "{global.transparent}", "s_2": "{flexDirection.row}", "s_3": "{alignItems.center}", "s_4": "{justifyContent.center}", "s_5": "{pill}", "s_6": "{xs}", "s_7": "{xs}", "s_8": "{base}", "s_9": "{xs}", "s_10": "{base}", "s_11": "{primary20}", "s_12": "{xxs}", "s_13": "{primary60}", "s_14": "{primary20}", "s_15": "{primary30}", "s_16": "{m}", "s_17": "{primary60}", "s_18": "{primary50}", "s_19": "{primary60}", "s_20": "{primary60}", "s_21": "{primary50}", "s_22": "{primaryInverse}", "s_23": "{primary30}", "s_24": "{flexDirection.column}", "s_25": "{size.max}", "s_26": "{opacity.disabled}", "s_27": "{xxs}" }, "JDSSearchResults": { "s_0": "{global.transparent}", "s_1": "{flexDirection.stack}", "s_2": "{justifyContent.center}", "s_3": "{size.max}", "s_4": "{global.transparent}", "s_5": "{primaryBackground}", "s_6": "{flexDirection.column}", "s_7": "{alignItems.center}", "s_8": "{base}", "s_9": "{base}", "s_10": "{base}", "s_11": "{base}", "s_12": "{base}", "s_13": "{size.max}", "s_14": "{size.max}", "s_15": "{flexDirection.column}", "s_16": "{alignItems.center}", "s_17": "{flexDirection.row}", "s_18": "{justifyContent.spaceBetween}", "s_19": "{alignItems.start}", "s_20": "{size.max}", "s_21": "{flexDirection.column}", "s_22": "{alignItems.start}", "s_23": "{base}", "s_24": "{size.max}", "s_25": "{xl}" }, "JDSSearchResultsInternal": { "s_0": "{global.transparent}", "s_1": "{flexDirection.stack}", "s_2": "{justifyContent.center}", "s_3": "{size.max}", "s_4": "{global.transparent}", "s_5": "{primaryBackground}", "s_6": "{flexDirection.column}", "s_7": "{alignItems.center}", "s_8": "{base}", "s_9": "{base}", "s_10": "{base}", "s_11": "{base}", "s_12": "{base}", "s_13": "{size.max}", "s_14": "{size.max}", "s_15": "{flexDirection.column}", "s_16": "{alignItems.center}", "s_17": "{flexDirection.row}", "s_18": "{justifyContent.spaceBetween}", "s_19": "{alignItems.start}", "s_20": "{size.max}", "s_21": "{flexDirection.column}", "s_22": "{alignItems.start}", "s_23": "{base}", "s_24": "{size.max}", "s_25": "{xl}" }, "JDSSkeleton": { "s_0": "{primaryGrey20}", "s_1": "{primaryGrey20}", "s_2": "{primaryGrey40}", "s_3": "{pill}", "s_4": "{xxl}", "s_5": "{pill}", "s_6": "{pill}", "s_7": "{base}", "s_8": "{xl}", "s_9": "{xxl}", "s_10": "{size.max}", "s_11": "{size.max}" }, "JDSServiceCard": { "s_0": "{flexDirection.stack}", "s_1": "{flexDirection.stack}", "s_2": "{size.max}", "s_3": "{size.max}", "s_4": "{justifyContent.start}", "s_5": "{justifyContent.start}", "s_6": "{alignItems.start}", "s_7": "{xl}", "s_8": "{size.max}", "s_9": "{size.max}", "s_10": "{xl}", "s_11": "{aspect_ratio.16.9}", "s_12": "{flexDirection.column}", "s_13": "{size.max}", "s_14": "{justifyContent.start}", "s_15": "{alignItems.start}", "s_16": "{flexDirection.row}", "s_17": "{justifyContent.start}", "s_18": "{alignItems.start}", "s_19": "{size.max}", "s_20": "{size.max}", "s_21": "{base}", "s_22": "{base}", "s_23": "{custom_color_4}", "s_24": "{size.max}", "s_25": "{base}", "s_26": "{base}", "s_27": "{base}", "s_28": "{base}", "s_29": "{size.max}", "s_30": "{aspect_ratio.1.1}", "s_31": "{aspect_ratio.4.3}", "s_32": "{aspect_ratio.4.5}" }, "JDSNotificationIconButton": { "n_0": "{l}", "n_1": "{l}", "n_2": "{justifyContent.center}", "n_3": "{alignItems.center}", "n_4": "{global.transparent}", "n_5": "{global.transparent}", "n_6": "{primary30}", "n_7": "{primary40}", "n_8": "{primary30}", "n_9": "{primary50}", "n_10": "{base}", "n_11": "{primary20}", "n_12": "{opacity.disabled}" }, "JDSSpinner": { "s_0": "{global.transparent}", "s_1": "{base}", "s_2": "{justifyContent.center}", "s_3": "{alignItems.center}", "s_4": "{flexDirection.row}", "s_5": "{xxl}", "s_6": "{flexDirection.stack}", "s_7": "{justifyContent.center}", "s_8": "{alignItems.center}", "s_9": "{size.max}", "s_10": "{primaryGrey40}", "s_11": "{m}", "s_12": "{xs}", "s_13": 0, "s_14": 360, "s_15": "{primary50}", "s_16": "{m}", "s_17": "{xs}", "s_18": 0, "s_19": 120, "s_20": "1000", "s_21": "{primary50}", "s_22": "{m}", "s_23": "{xs}", "s_24": 0, "s_25": 360, "s_26": "300", "s_27": "1300", "s_28": "{secondary50}", "s_29": "{m}", "s_30": "{xs}", "s_31": 0, "s_32": 360, "s_33": "150", "s_34": "1300", "s_35": "{sparkle50}", "s_36": "{m}", "s_37": "{xs}", "s_38": 0, "s_39": 360, "s_40": "1300", "s_41": "{flexDirection.column}", "s_42": "{s}", "s_43": "{m}", "s_44": "{xxs}", "s_45": "{s}", "s_46": "{xxs}", "s_47": "{s}", "s_48": "{xxs}", "s_49": "{s}", "s_50": "{xxs}", "s_51": "{s}", "s_52": "{xxs}", "s_53": "{s}", "s_54": "{primaryGrey80}", "s_55": "{flexDirection.row}" }, "JDSSelectorButton": { "s_0": "{primary50}", "s_1": "{flexDirection.row}", "s_2": "{justifyContent.center}", "s_3": "{alignItems.center}", "s_4": "{pill}", "s_5": "{xs}", "s_6": "{xs}", "s_7": "{base}", "s_8": "{base}", "s_9": "{border_none}", "s_10": "{xs}", "s_11": "{opacity.enabled}", "s_12": "{primary30}", "s_13": "{primary60}", "s_14": "{border_focus}", "s_15": "{primary60}", "s_16": "{m}", "s_17": "{primaryInverse}", "s_18": "{primary70}", "s_19": "{m}", "s_20": "{primaryInverse}", "s_21": "{primary70}", "s_22": "{opacity.disabled}", "s_23": "{primary60}", "s_24": "{primary50}", "s_25": "{primary70}", "s_26": "{primary70}", "s_27": "{global.transparent}", "s_28": "{border_thin}", "s_29": "{primaryGrey60}", "s_30": "{primary20}", "s_31": "{primary60}", "s_32": "{primary20}", "s_33": "{border_focus}", "s_34": "{primary60}", "s_35": "{primary60}", "s_36": "{primary60}", "s_37": "{primary20}", "s_38": "{border_thin}", "s_39": "{primaryGrey60}", "s_40": "{primary60}", "s_41": "{primary30}", "s_42": "{border_focus}", "s_43": "{primary60}", "s_44": "{primary60}", "s_45": "{primary70}", "s_46": "{primary60}", "s_47": "{primary70}", "s_48": "{primary20}", "s_49": "{primary20}", "s_50": "{primary60}", "s_51": "{border_thin}", "s_52": "{primary30}", "s_53": "{border_focus}", "s_54": "{primary60}", "s_55": "{primary60}", "s_56": "{primary70}", "s_57": "{primary60}", "s_58": "{primary60}", "s_59": "{primary70}", "s_60": "{primary60}", "s_61": "{global.transparent}", "s_62": "{border_thin}", "s_63": "{primary60}", "s_64": "{primary20}", "s_65": "{primary20}", "s_66": "{primary60}", "s_67": "{primary60}", "s_68": "{primary60}", "s_69": "{primary60}", "s_70": "{primary60}", "s_71": "{primary60}", "s_72": "{global.transparent}", "s_73": "{border_focus}", "s_74": "{primary60}", "s_75": "{global.transparent}", "s_76": "{global.transparent}", "s_77": "{primary70}", "s_78": "{primary60}", "s_79": "{primary80}", "s_80": "{primary70}", "s_81": "{primary60}", "s_82": "{primary80}", "s_83": "{global.transparent}", "s_84": "{global.transparent}", "s_85": "{global.transparent}", "s_86": "{primary60}", "s_87": "{primary50}", "s_88": "{primary70}", "s_89": "{primary60}", "s_90": "{primary50}", "s_91": "{primary70}", "s_92": "{primaryGrey80}", "s_93": "{primary30}", "s_94": "{primary50}", "s_95": "{border_focus}", "s_96": "{primary60}", "s_97": "{primaryBackground}", "s_98": "{primary70}", "s_99": "{primaryInverse}", "s_100": "{primaryBackground}", "s_101": "{primary70}", "s_102": "{primaryInverse}", "s_103": "{global.transparent}", "s_104": "{border_thin}", "s_105": "{primaryGrey60}", "s_106": "{primary20}", "s_107": "{primary60}", "s_108": "{primary20}", "s_109": "{border_focus}", "s_110": "{primary60}", "s_111": "{primaryGrey80}", "s_112": "{primaryGrey80}", "s_113": "{primary20}", "s_114": "{primaryGrey60}", "s_115": "{primary60}", "s_116": "{primary30}", "s_117": "{border_focus}", "s_118": "{primary60}", "s_119": "{primary60}", "s_120": "{primary70}", "s_121": "{primary60}", "s_122": "{primary70}", "s_123": "{primary20}", "s_124": "{primary60}", "s_125": "{border_thin}", "s_126": "{primary30}", "s_127": "{border_focus}", "s_128": "{primary60}", "s_129": "{primary60}", "s_130": "{primary70}", "s_131": "{primary60}", "s_132": "{primary70}", "s_133": "{global.transparent}", "s_134": "{primary60}", "s_135": "{border_thin}", "s_136": "{primary20}", "s_137": "{primary20}", "s_138": "{border_focus}", "s_139": "{primary60}", "s_140": "{primaryGrey80}", "s_141": "{primary60}", "s_142": "{primary60}", "s_143": "{primaryGrey80}", "s_144": "{primary60}", "s_145": "{primary60}", "s_146": "{global.transparent}", "s_147": "{global.transparent}", "s_148": "{border_focus}", "s_149": "{primary60}", "s_150": "{primary60}", "s_151": "{primary50}", "s_152": "{primary80}", "s_153": "{primary60}", "s_154": "{primary50}", "s_155": "{primary80}", "s_156": "{global.transparent}", "s_157": "{global.transparent}", "s_158": "{border_focus}", "s_159": "{primary60}", "s_160": "{primaryGrey80}", "s_161": "{primary50}", "s_162": "{primary60}", "s_163": "{primaryGrey80}", "s_164": "{primary50}", "s_165": "{primary60}", "s_166": "{primaryBackground}", "s_167": "{primary30}", "s_168": "{primary50}", "s_169": "{border_focus}", "s_170": "{primary50}", "s_171": "{primaryGrey100}", "s_172": "{primaryGrey100}", "s_173": "{primaryGrey100}", "s_174": "{primaryInverse}", "s_175": "{primaryGrey100}", "s_176": "{primaryGrey100}", "s_177": "{primaryGrey100}", "s_178": "{primaryInverse}", "s_179": "{primary50}", "s_180": "{primary30}", "s_181": "{primary60}", "s_182": "{primary50}", "s_183": "{border_focus}", "s_184": "{primary40}", "s_185": "{primaryInverse}", "s_186": "{primaryGrey100}", "s_187": "{primaryInverse}", "s_188": "{primaryGrey100}", "s_189": "{global.transparent}", "s_190": "{border_thin}", "s_191": "{primaryGrey60}", "s_192": "{primary30}", "s_193": "{primary50}", "s_194": "{primary30}", "s_195": "{border_focus}", "s_196": "{primary50}", "s_197": "{primaryBackground}", "s_198": "{primaryGrey100}", "s_199": "{primaryGrey100}", "s_200": "{primaryBackground}", "s_201": "{primaryGrey100}", "s_202": "{primaryGrey100}", "s_203": "{primary30}", "s_204": "{primaryGrey60}", "s_205": "{primary50}", "s_206": "{primary50}", "s_207": "{border_focus}", "s_208": "{primary50}", "s_209": "{primaryGrey100}", "s_210": "{primaryInverse}", "s_211": "{primaryGrey100}", "s_212": "{primaryInverse}", "s_213": "{global.transparent}", "s_214": "{primary30}", "s_215": "{primary50}", "s_216": "{primary30}", "s_217": "{border_focus}", "s_218": "{primary50}", "s_219": "{primaryBackground}", "s_220": "{primaryGrey100}", "s_221": "{primaryGrey100}", "s_222": "{primaryBackground}", "s_223": "{primaryGrey100}", "s_224": "{primaryGrey100}", "s_225": "{primary30}", "s_226": "{primary50}", "s_227": "{border_focus}", "s_228": "{primary50}", "s_229": "{primary50}", "s_230": "{primaryGrey100}", "s_231": "{primaryInverse}", "s_232": "{primaryGrey100}", "s_233": "{primaryInverse}", "s_234": "{global.transparent}", "s_235": "{border_focus}", "s_236": "{primary50}", "s_237": "{global.transparent}", "s_238": "{global.transparent}", "s_239": "{primaryBackground}", "s_240": "{primary20}", "s_241": "{primary30}", "s_242": "{primaryBackground}", "s_243": "{primary20}", "s_244": "{primary30}", "s_245": "{global.transparent}", "s_246": "{border_focus}", "s_247": "{primary50}", "s_248": "{global.transparent}", "s_249": "{global.transparent}", "s_250": "{primary30}", "s_251": "{primary20}", "s_252": "{primary30}", "s_253": "{primary30}", "s_254": "{primary30}", "s_255": "{primary20}", "s_256": "{primary30}", "s_257": "{primary30}", "s_258": "{xxs}", "s_259": "{xxs}", "s_260": "{xs}", "s_261": "{xs}", "s_262": "{s}", "s_263": "{s}", "s_264": "{base}", "s_265": "{base}", "s_266": "{xxs}", "s_267": "{xxs}", "s_268": "{base}", "s_269": "{base}", "s_270": "{s}", "s_271": "{m}", "s_272": "{s}", "s_273": "{m}", "s_274": "{m}", "s_275": "{m}", "s_276": "{base}", "s_277": "{l}", "s_278": "{base}", "s_279": "{l}", "s_280": "{l}", "s_281": "{l}", "s_282": "{l}", "s_283": "{l}", "s_284": "{base}", "s_285": "{xl}", "s_286": "{xl}", "s_287": "{xxl}", "s_288": "{xxl}", "s_289": "{m}", "s_290": "{huge}", "s_291": "{huge}", "s_292": "{l}", "s_293": "{size.max}", "s_294": "{justifyContent.spaceBetween}", "s_295": "{primary60}", "s_296": "{primary60}" }, "JDSSlider": { "s_0": "{flexDirection.column}", "s_1": "{justifyContent.start}", "s_2": "{alignItems.start}", "s_3": "{size.max}", "s_4": "{xs}", "s_5": "{flexDirection.row}", "s_6": "{justifyContent.start}", "s_7": "{alignItems.center}", "s_8": "{size.max}", "s_9": "{xs}", "s_10": "{justifyContent.start}", "s_11": "{alignItems.center}", "s_12": "{alignItems.center}", "s_13": "{xs}", "s_14": "{xs}", "s_15": "{border_thin}", "s_16": "{primaryGrey80}", "s_17": "{medium}", "s_18": "{size.max}", "s_19": "{xxs}", "s_20": "{primaryGrey40}", "s_21": "{primary50}", "s_22": "{primary50}", "s_23": "{primary80}", "s_24": "{small}", "s_25": "{primary60}", "s_26": "{primary60}", "s_27": "{primary60}", "s_28": "{border_focus}", "s_29": "{flexDirection.row}", "s_30": "{justifyContent.spaceBetween}", "s_31": "{alignItems.center}", "s_32": "{size.max}", "s_33": "{feedbackSuccess50}", "s_34": "{feedbackError50}", "s_35": "{feedbackWarning50}", "s_36": "{opacity.disabled}", "s_37": "{primary50}", "s_38": "{primary50}", "s_39": "{primary50}" }, "JDSStepperDot": { "s_0": "{global.transparent}", "s_1": "{border_thin}", "s_2": "{sparkleGrey60}", "s_3": "{l}", "s_4": "{l}", "s_5": "{justifyContent.center}", "s_6": "{alignItems.center}", "s_7": "{pill}", "s_8": "{sparkleGrey60}", "s_9": "{base}", "s_10": "{sparkle60}", "s_11": "{base}", "s_12": "{sparkleGrey60}", "s_13": "{xs}", "s_14": "{xs}", "s_15": "{pill}", "s_16": "{sparkle50}", "s_17": "{sparkle50}", "s_18": "{sparkleInverse}", "s_19": "{sparkleInverse}", "s_20": "{sparkle20}", "s_21": "{sparkle50}", "s_22": "{l}", "s_23": "{l}", "s_24": "{sparkle60}", "s_25": "{sparkle60}", "s_26": "{opacity.disabled}" }, "JDSHorizontalStepItem": { "h_0": "{flexDirection.column}", "h_1": "{alignItems.center}", "h_2": "{justifyContent.start}", "h_3": "{size.max}", "h_4": "{xs}", "h_5": "{flexDirection.row}", "h_6": "{size.max}", "h_7": "{alignItems.center}", "h_8": "{xs}", "h_9": "{xs}", "h_10": "{xs}", "h_11": "{opacity.enabled}", "h_12": "{opacity.enabled}", "h_13": "{opacity.invisible}", "h_14": "{opacity.invisible}" }, "JDSVerticalStepItem": { "v_0": "{flexDirection.column}", "v_1": "{justifyContent.start}", "v_2": "{alignItems.start}", "v_3": "{xs}", "v_4": "{size.max}", "v_5": "{opacity.enabled}", "v_6": "{flexDirection.row}", "v_7": "{justifyContent.start}", "v_8": "{alignItems.center}", "v_9": "{intrinsicSize.max}", "v_10": "{flexDirection.row}", "v_11": "{justifyContent.start}", "v_12": "{alignItems.stretch}", "v_13": "{l}", "v_14": "{custom_23}", "v_15": "{flexDirection.row}", "v_16": "{justifyContent.start}", "v_17": "{alignItems.center}", "v_18": "{base}", "v_19": "0", "v_20": "0", "v_21": "{custom_24}", "v_22": "{xs}", "v_23": "{m}", "v_24": "{opacity.invisible}" }, "JDSTableCell": { "t_0": "{flexDirection.row}", "t_1": "{justifyContent.start}", "t_2": "{alignItems.center}", "t_3": "{global.transparent}", "t_4": "{base}", "t_5": "{base}", "t_6": "{base}", "t_7": "{base}", "t_8": "{primaryGrey40}", "t_9": "{xs}", "t_10": "{xs}", "t_11": "{xs}", "t_12": "{xs}", "t_13": "{primary50}", "t_14": "{primary60}", "t_15": "{primaryGrey20}" }, "JDSTableBody": { "t_0": "{size.max}", "t_1": "{flexDirection.row}", "t_2": "{size.max}" }, "JDSTableRow": { "t_0": "{flexDirection.column}", "t_1": "{size.max}", "t_2": "{size.max}" }, "JDSTabBar": { "t_0": "{flexDirection.stack}", "t_1": "{size.max}", "t_2": "{size.max}", "t_3": "{justifyContent.start}", "t_4": "{alignItems.end}", "t_5": "{size.max}", "t_6": "{opacity.enabled}", "t_7": "{global.transparent}", "t_8": "{alignItems.center}", "t_9": "{justifyContent.start}", "t_10": "{xxs}", "t_11": "{flexDirection.row}", "t_12": "{flexDirection.row}", "t_13": "{justifyContent.start}", "t_14": "{alignItems.center}", "t_15": "{size.max}", "t_16": "{pill}", "t_17": "{primary50}", "t_18": "{xxs}", "t_19": "{size.max}", "t_20": "{justifyContent.center}", "t_21": "{primary60}", "t_22": "{xxl}", "t_23": "{xxl}", "t_24": "{custom_dark_primary_60}", "t_25": "{m}", "t_26": "{m}" }, "JDSVerticalStepper": { "v_0": "{flexDirection.column}", "v_1": "{justifyContent.start}", "v_2": "{alignItems.start}", "v_3": "{size.max}", "v_4": "{xs}" }, "JDSTabItem": { "t_0": "{global.transparent}", "t_1": "{flexDirection.column}", "t_2": "{alignItems.center}", "t_3": "{justifyContent.center}", "t_4": "{xxl}", "t_5": "{intrinsicSize.max}", "t_6": "{intrinsicSize.max}", "t_7": "{flexDirection.row}", "t_8": "{alignItems.center}", "t_9": "{justifyContent.center}", "t_10": "{xs}", "t_11": "{s}", "t_12": "{s}", "t_13": "{xs}", "t_14": "{xs}", "t_15": "{border_normal}", "t_16": "{primary80}", "t_17": "{large}", "t_18": "{m}", "t_19": "{primaryGrey80}", "t_20": "{primaryGrey100}", "t_21": "{primary60}", "t_22": "{primaryGrey80}", "t_23": "{bodyS}", "t_24": "{bodyS}", "t_25": "{bodyS}", "t_26": "{bodyS}", "t_27": "{bodyS}", "t_28": "{primary60}", "t_29": "{global.transparent}", "t_30": "{xxs}", "t_31": "{size.max}", "t_32": "{pill}", "t_33": "{opacity.enabled}", "t_34": "{opacity.disabled}", "t_35": "{primaryGrey100}", "t_36": "{primary60}", "t_37": "{custom_dark_primary_40}", "t_38": "{custom_dark_primary_60}", "t_39": "{custom_dark_primary_grey_100}", "t_40": "{custom_dark_primary_grey_80}", "t_41": "{custom_dark_primary_grey_100}", "t_42": "{custom_dark_primary_grey_100}", "t_43": "{custom_dark_primary_grey_80}", "t_44": "{custom_dark_primary_grey_100}", "t_45": "{primaryGrey100}", "t_46": "{primaryGrey100}" }, "JDSTabsDesktop": { "t_0": "{flexDirection.column}", "t_1": "{size.max}", "t_2": "{size.max}", "t_3": "{flexDirection.row}", "t_4": "{size.max}", "t_5": "{alignItems.center}", "t_6": "{size.max}", "t_7": "{base}", "t_8": "{primary60}" }, "JDSTag": { "t_0": "{flexDirection.row}", "t_1": "{justifyContent.start}", "t_2": "{alignItems.center}", "t_3": "{xxs}", "t_4": "{s}", "t_5": "{s}", "t_6": "{xxs}", "t_7": "{xxs}", "t_8": "{global.transparent}", "t_9": "{pill}", "t_10": "{border_thin}", "t_11": "{primaryGrey80}", "t_12": "{primaryGrey80}", "t_13": "{sparkle20}", "t_14": "{sparkle80}", "t_15": "{border_focus}", "t_16": "{base}", "t_17": "{primaryGrey100}", "t_18": "{sparkle80}", "t_19": "{sparkle80}", "t_20": "{sparkle80}", "t_21": "{border_none}", "t_22": "{primaryGrey80}", "t_23": "{sparkle20}", "t_24": "{sparkle30}", "t_25": "{global.transparent}", "t_26": "{primaryGrey40}", "t_27": "{sparkle30}", "t_28": "{sparkle80}", "t_29": "{opacity.disabled}", "t_30": "{opacity.enabled}", "t_31": "{custom_4}", "t_32": "{xs}", "t_33": "{xs}", "t_34": "{custom_4}" }, "JDSHorizontalStepper": { "h_0": "{stepper_horizontal}", "h_1": "{flexDirection.column}", "h_2": "{size.max}", "h_3": "{flexDirection.row}", "h_4": "{justifyContent.center}", "h_5": "{alignItems.center}", "h_6": "{size.max}", "h_7": "{l}", "h_8": "{l}", "h_9": "{size.max}", "h_10": "{flexDirection.row}", "h_11": "{justifyContent.start}", "h_12": "{alignItems.center}" }, "JDSTable": { "t_0": "{flexDirection.column}", "t_1": "{size.max}", "t_2": "{medium}", "t_3": "{border_thin}", "t_4": "{primaryGrey40}", "t_5": "{size.max}" }, "JDSToggle": { "t_0": "{flexDirection.column}", "t_1": "{flexDirection.column}", "t_2": "{justifyContent.start}", "t_3": "{alignItems.start}", "t_4": "{xs}", "t_5": "{flexDirection.row}", "t_6": "{justifyContent.start}", "t_7": "{alignItems.center}", "t_8": "{xs}", "t_9": "{custom_2}", "t_10": "{m}", "t_11": "{flexDirection.row}", "t_12": "{justifyContent.start}", "t_13": "{alignItems.center}", "t_14": "{xxs}", "t_15": "{xxs}", "t_16": "{global.transparent}", "t_17": "{pill}", "t_18": "{border_thin}", "t_19": "{primaryGrey80}", "t_20": "{primary40}", "t_21": "{primary60}", "t_22": "{xxs}", "t_23": "{primary60}", "t_24": "{border_none}", "t_25": "{base}", "t_26": "{base}", "t_27": "{primaryGrey80}", "t_28": "{pill}", "t_29": "{textAlign.start}", "t_30": "{custom_3}", "t_31": "{base}", "t_32": "{xxs}", "t_33": "{xs}", "t_34": "{xs}", "t_35": "{justifyContent.end}", "t_36": "{primary50}", "t_37": "{border_none}", "t_38": "{primary40}", "t_39": "{primary60}", "t_40": "{primaryInverse}", "t_41": "{opacity.disabled}", "t_42": "{opacity.enabled}" }, "JDSText": { "text_0": "{primary60}", "text_1": "{bodyS}", "text_2": "{primaryGrey100}", "text_3": "{bodyS}", "text_4": "{bodyS}", "text_5": "{bodyS}", "text_6": "{bodyS}", "text_7": "{text-decoration.none}", "text_8": "{text-decoration.underline}", "text_9": "{text-decoration.line-through}", "text_10": "{text-decoration.overline}", "text_11": "{primary80}", "text_12": "{primary70}", "text_13": "{primary60}", "text_14": "{primary50}", "text_15": "{primary40}", "text_16": "{primary30}", "text_17": "{primary20}", "text_18": "{primaryInverse}", "text_19": "{primaryBackground}", "text_20": "{primaryGrey100}", "text_21": "{primaryGrey80}", "text_22": "{primaryGrey60}", "text_23": "{primaryGrey40}", "text_24": "{primaryGrey20}", "text_25": "{secondary80}", "text_26": "{secondary70}", "text_27": "{secondary60}", "text_28": "{secondary50}", "text_29": "{secondary40}", "text_30": "{secondary30}", "text_31": "{secondary20}", "text_32": "{secondaryInverse}", "text_33": "{secondaryBackground}", "text_34": "{secondaryGrey100}", "text_35": "{secondaryGrey80}", "text_36": "{secondaryGrey60}", "text_37": "{secondaryGrey40}", "text_38": "{secondaryGrey20}", "text_39": "{sparkle80}", "text_40": "{sparkle70}", "text_41": "{sparkle60}", "text_42": "{sparkle50}", "text_43": "{sparkle40}", "text_44": "{sparkle30}", "text_45": "{sparkle20}", "text_46": "{sparkleInverse}", "text_47": "{sparkleBackground}", "text_48": "{sparkleGrey100}", "text_49": "{sparkleGrey80}", "text_50": "{sparkleGrey60}", "text_51": "{sparkleGrey40}", "text_52": "{sparkleGrey20}", "text_53": "{feedbackError80}", "text_54": "{feedbackError50}", "text_55": "{feedbackError20}", "text_56": "{feedbackWarning80}", "text_57": "{feedbackWarning50}", "text_58": "{feedbackWarning20}", "text_59": "{feedbackSuccess80}", "text_60": "{feedbackSuccess50}", "text_61": "{feedbackSuccess20}", "text_62": "{global.white}", "text_63": "{global.black}", "text_64": "{global.transparent}", "text_65": "{headingXl}", "text_66": "{headingXl}", "text_67": "{headingXl}", "text_68": "{headingXl}", "text_69": "{headingXl}", "text_70": "{headingL}", "text_71": "{headingL}", "text_72": "{headingL}", "text_73": "{headingL}", "text_74": "{headingL}", "text_75": "{headingM}", "text_76": "{headingM}", "text_77": "{headingM}", "text_78": "{headingM}", "text_79": "{headingM}", "text_80": "{headingS}", "text_81": "{headingS}", "text_82": "{headingS}", "text_83": "{headingS}", "text_84": "{headingS}", "text_85": "{headingXs}", "text_86": "{headingXs}", "text_87": "{headingXs}", "text_88": "{headingXs}", "text_89": "{headingXs}", "text_90": "{headingXxs}", "text_91": "{headingXxs}", "text_92": "{headingXxs}", "text_93": "{headingXxs}", "text_94": "{headingXxs}", "text_95": "{overline}", "text_96": "{overline}", "text_97": "{overline}", "text_98": "{overline}", "text_99": "{overline}", "text_100": "{overline}", "text_101": "{bodyL}", "text_102": "{bodyL}", "text_103": "{bodyL}", "text_104": "{bodyL}", "text_105": "{bodyL}", "text_106": "{bodyLBold}", "text_107": "{bodyLBold}", "text_108": "{bodyLBold}", "text_109": "{bodyLBold}", "text_110": "{bodyLBold}", "text_111": "{bodyLLink}", "text_112": "{bodyLLink}", "text_113": "{bodyLLink}", "text_114": "{bodyLLink}", "text_115": "{bodyLLink}", "text_116": "{bodyM}", "text_117": "{bodyM}", "text_118": "{bodyM}", "text_119": "{bodyM}", "text_120": "{bodyM}", "text_121": "{bodyMBold}", "text_122": "{bodyMBold}", "text_123": "{bodyMBold}", "text_124": "{bodyMBold}", "text_125": "{bodyMBold}", "text_126": "{bodyMLink}", "text_127": "{bodyMLink}", "text_128": "{bodyMLink}", "text_129": "{bodyMLink}", "text_130": "{bodyMLink}", "text_131": "{bodyS}", "text_132": "{bodyS}", "text_133": "{bodyS}", "text_134": "{bodyS}", "text_135": "{bodyS}", "text_136": "{bodySBold}", "text_137": "{bodySBold}", "text_138": "{bodySBold}", "text_139": "{bodySBold}", "text_140": "{bodySBold}", "text_141": "{bodySLink}", "text_142": "{bodySLink}", "text_143": "{bodySLink}", "text_144": "{bodySLink}", "text_145": "{bodySLink}", "text_146": "{bodyXs}", "text_147": "{bodyXs}", "text_148": "{bodyXs}", "text_149": "{bodyXs}", "text_150": "{bodyXs}", "text_151": "{bodyXsBold}", "text_152": "{bodyXsBold}", "text_153": "{bodyXsBold}", "text_154": "{bodyXsBold}", "text_155": "{bodyXsBold}", "text_156": "{bodyXsLink}", "text_157": "{bodyXsLink}", "text_158": "{bodyXsLink}", "text_159": "{bodyXsLink}", "text_160": "{bodyXsLink}", "text_161": "{bodyXs}", "text_162": "{bodyXs}", "text_163": "{bodyS}", "text_164": "{bodyXs}", "text_165": "{bodyXs}", "text_166": "{bodyXxs}", "text_167": "{bodyXxs}", "text_168": "{bodyXxs}", "text_169": "{bodyXxs}", "text_170": "{bodyXxs}", "text_171": "{bodyXxsBold}", "text_172": "{bodyXxsBold}", "text_173": "{bodyXxsBold}", "text_174": "{bodyXxsBold}", "text_175": "{bodyXxsBold}", "text_176": "{bodyXxsLink}", "text_177": "{bodyXxsLink}", "text_178": "{bodyXxsLink}", "text_179": "{bodyXxsLink}", "text_180": "{bodyXxsLink}", "text_181": "{listTitle}", "text_182": "{listTitle}", "text_183": "{listTitle}", "text_184": "{listTitle}", "text_185": "{listTitle}", "text_186": "{button}", "text_187": "{button}", "text_188": "{button}", "text_189": "{button}", "text_190": "{button}", "text_191": "{code}", "text_192": "{code}", "text_193": "{code}", "text_194": "{code}", "text_195": "{code}", "text_196": "{bodyS}", "text_197": "{bodyS}", "text_198": "{bodyS}", "text_199": "{bodyS}", "text_200": "{bodyS}" }, "JDSTooltip": { "t_0": "{flexDirection.row}", "t_1": "{justifyContent.start}", "t_2": "{alignItems.start}", "t_3": "{flexDirection.row}", "t_4": "{justifyContent.start}", "t_5": "{alignItems.center}", "t_6": "hidden", "t_7": "{medium}", "t_8": "{border_thin}", "t_9": "{primaryGrey100}", "t_10": "{primaryGrey100}", "t_11": "{primaryGrey100}", "t_12": "{base}", "t_13": "{base}", "t_14": "{xs}", "t_15": "{xs}", "t_16": "{alignItems.start}", "t_17": "{xs}", "t_18": "{alignItems.end}", "t_19": "{xs}", "t_20": "{alignItems.start}", "t_21": "{xs}", "t_22": "{alignItems.end}", "t_23": "{xs}", "t_24": "{flexDirection.column}", "t_25": "{alignItems.center}", "t_26": "{flexDirection.column}", "t_27": "{alignItems.start}", "t_28": "{xs}", "t_29": "{flexDirection.column}", "t_30": "{alignItems.end}", "t_31": "{xs}", "t_32": "{flexDirection.column}", "t_33": "{alignItems.center}", "t_34": "{flexDirection.column}", "t_35": "{alignItems.start}", "t_36": "{xs}", "t_37": "{flexDirection.column}", "t_38": "{alignItems.end}", "t_39": "{xs}", "t_40": "{xl}", "t_41": "{alignItems.center}" }, "JDSTooltipInternal": { "t_0": "{flexDirection.row}", "t_1": "{justifyContent.start}", "t_2": "{alignItems.start}", "t_3": "{flexDirection.row}", "t_4": "{justifyContent.start}", "t_5": "{alignItems.center}", "t_6": "hidden", "t_7": "{medium}", "t_8": "{border_thin}", "t_9": "{primaryGrey100}", "t_10": "{primaryGrey100}", "t_11": "{primaryGrey100}", "t_12": "{base}", "t_13": "{base}", "t_14": "{xs}", "t_15": "{xs}", "t_16": "{alignItems.start}", "t_17": "{xs}", "t_18": "{alignItems.end}", "t_19": "{xs}", "t_20": "{alignItems.start}", "t_21": "{xs}", "t_22": "{alignItems.end}", "t_23": "{xs}", "t_24": "{flexDirection.column}", "t_25": "{alignItems.center}", "t_26": "{flexDirection.column}", "t_27": "{alignItems.start}", "t_28": "{xs}", "t_29": "{flexDirection.column}", "t_30": "{alignItems.end}", "t_31": "{xs}", "t_32": "{flexDirection.column}", "t_33": "{alignItems.center}", "t_34": "{flexDirection.column}", "t_35": "{alignItems.start}", "t_36": "{xs}", "t_37": "{flexDirection.column}", "t_38": "{alignItems.end}", "t_39": "{xs}", "t_40": "{xl}", "t_41": "{alignItems.center}" }, "JDSInputCode": { "i_0": "{flexDirection.column}", "i_1": "{justifyContent.start}", "i_2": "{alignItems.start}", "i_3": "{size.max}", "i_4": "{xs}", "i_5": "{flexDirection.row}", "i_6": "{justifyContent.center}", "i_7": "{alignItems.center}", "i_8": "{size.max}", "i_9": "{xs}", "i_10": "{opacity.disabled}", "i_11": "{opacity.enabled}" }, "JDSRatingBar": { "r_0": "{flexDirection.column}", "r_1": "{alignItems.start}", "r_2": "{justifyContent.start}", "r_3": "{xxs}", "r_4": "{flexDirection.row}", "a_5": "{alignItems.center}", "r_6": "{justifyContent.start}", "r_7": "{xs}", "r_8": "{flexDirection.row}", "r_9": "{xxs}", "r_10": "{xs}", "r_11": "{alignItems.center}", "r_12": "{alignItems.center}", "r_13": "{opacity.disabled}", "r_14": "{xxs}", "r_15": "{xxs}", "r_16": "{xs}", "r_17": "{xs}", "r_18": "{xs}", "r_19": "{xs}", "r_20": "{xxs}", "r_21": "{xxs}", "r_22": "{xs}", "r_23": "{xs}", "r_24": "{xs}", "r_25": "{xs}", "r_26": "{alignItems.center}" }, "JDSRatingBarItem": { "r_0": "{flexDirection.stack}", "r_1": "{border_focus}", "r_2": "{primary60}", "r_3": "{m}", "r_4": "{m}", "r_5": "{xl}", "r_6": "{xl}", "r_7": "{opacity.disabled}", "r_8": "{primaryGrey60}", "r_9": "{primaryGrey60}", "r_10": "{primaryGrey60}", "r_11": "{primaryGrey60}", "r_12": "{primaryGrey80}", "r_13": "{primaryGrey80}", "r_14": "{primaryGrey80}", "r_15": "{primaryGrey80}", "r_16": "{border_focus}", "r_17": "{border_focus}", "r_18": "{primary60}", "r_19": "{primary60}", "r_20": "{primaryGrey60}", "r_21": "{primaryGrey60}", "r_22": "{primary50}", "r_23": "{primary50}", "r_24": "{primary70}", "r_25": "{primary70}", "r_26": "{primary60}", "r_27": "{primary60}", "r_28": "{border_focus}", "r_29": "{border_focus}", "r_30": "{primary60}", "r_31": "{primary60}", "r_32": "{primary50}", "r_33": "{primary50}", "r_34": "{primary70}", "r_35": "{primary70}", "r_36": "{primary70}", "r_37": "{primary70}", "r_38": "{primaryGrey80}", "r_39": "{primaryGrey60}" } };

function getComponentTokens(componentName) {
  return JSON_MAP$1[componentName];
}

const layout = {
	"flexDirection.row": "row",
	"flexDirection.column": "column",
	"flexDirection.stack": "stack",
	"alignItems.start": "flex-start",
	"alignItems.center": "center",
	"alignItems.end": "flex-end",
	"alignItems.spaceBetween": "space-between",
	"alignItems.spaceAround": "space-around",
	"alignItems.spaceEvenly": "space-evenly",
	"alignItems.stretch": "stretch",
	"justifyContent.start": "flex-start",
	"justifyContent.center": "center",
	"justifyContent.end": "flex-end",
	"justifyContent.spaceBetween": "space-between",
	"justifyContent.spaceAround": "space-around",
	"justifyContent.spaceEvenly": "space-evenly",
	"textAlign.start": "start",
	"textAlign.center": "center",
	"textAlign.end": "end",
	"textAlign.justify": "justify",
	"aspect_ratio.1.1": "1",
	"aspect_ratio.3.4": "0.75",
	"aspect_ratio.4.3": "1.33",
	"aspect_ratio.4.5": "0.8",
	"aspect_ratio.5.4": "1.25",
	"aspect_ratio.9.16": "0.56",
	"aspect_ratio.16.9": "1.77",
	"aspect_ratio.2_75.1": "2.75",
	"size.max": "max",
	"size.min": "min",
	"size.negativeMax": "negativeMax",
	"intrinsicSize.min": "intrinsicSize.min",
	"intrinsicSize.max": "intrinsicSize.max",
	"zIndex-1": 1
};

const headingXl$1 = "{$lang.$platform.headingXl}";
const headingL$1 = "{$lang.$platform.headingL}";
const headingM$1 = "{$lang.$platform.headingM}";
const headingS$1 = "{$lang.$platform.headingS}";
const headingXs$1 = "{$lang.$platform.headingXs}";
const headingXxs$1 = "{$lang.$platform.headingXxs}";
const overline$2 = "{$lang.$platform.overline}";
const bodyL$1 = "{$lang.$platform.bodyL}";
const bodyLBold$1 = "{$lang.$platform.bodyLBold}";
const bodyLLink$1 = "{$lang.$platform.bodyLLink}";
const bodyM$1 = "{$lang.$platform.bodyM}";
const bodyMBold$1 = "{$lang.$platform.bodyMBold}";
const bodyMLink$1 = "{$lang.$platform.bodyMLink}";
const bodyS$1 = "{$lang.$platform.bodyS}";
const bodySBold$1 = "{$lang.$platform.bodySBold}";
const bodySLink$1 = "{$lang.$platform.bodySLink}";
const bodyXs$1 = "{$lang.$platform.bodyXs}";
const bodyXsBold$1 = "{$lang.$platform.bodyXsBold}";
const bodyXsLink$1 = "{$lang.$platform.bodyXsLink}";
const bodyXxs$1 = "{$lang.$platform.bodyXxs}";
const bodyXxsBold$1 = "{$lang.$platform.bodyXxsBold}";
const bodyXxsLink$1 = "{$lang.$platform.bodyXxsLink}";
const listTitle$1 = "{$lang.$platform.listTitle}";
const button$1 = "{$lang.$platform.button}";
const code$1 = "{$lang.$platform.code}";
const letterSpacing = {
	"letter-spacing.0": "0",
	"as.desktop.headingXl": -2.6399999999999997,
	"as.desktop.headingL": -1.92,
	"as.desktop.headingM": -1.2,
	"as.desktop.headingS": -0.96,
	"as.desktop.headingXs": -0.72,
	"as.desktop.headingXxs": -0.48,
	"as.desktop.overline": -0.06,
	"as.desktop.bodyL": -0.12,
	"as.desktop.bodyLBold": -0.12,
	"as.desktop.bodyLLink": -0.12,
	"as.desktop.bodyM": -0.09,
	"as.desktop.bodyMBold": -0.09,
	"as.desktop.bodyMLink": -0.09,
	"as.desktop.bodyS": -0.08,
	"as.desktop.bodySBold": -0.08,
	"as.desktop.bodySLink": -0.08,
	"as.desktop.bodyXs": -0.07,
	"as.desktop.bodyXsBold": -0.07,
	"as.desktop.bodyXsLink": -0.07,
	"as.desktop.bodyXxs": -0.06,
	"as.desktop.bodyXxsBold": -0.06,
	"as.desktop.bodyXxsLink": -0.06,
	"as.desktop.listTitle": -0.08,
	"as.desktop.button": -0.08,
	"as.desktop.code": 0,
	"as.mobile.headingXl": -1.92,
	"as.mobile.headingL": -1.44,
	"as.mobile.headingM": -1.2,
	"as.mobile.headingS": -0.96,
	"as.mobile.headingXs": -0.72,
	"as.mobile.headingXxs": -0.48,
	"as.mobile.overline": -0.06,
	"as.mobile.bodyL": -0.12,
	"as.mobile.bodyLBold": -0.12,
	"as.mobile.bodyLLink": -0.12,
	"as.mobile.bodyM": -0.09,
	"as.mobile.bodyMBold": -0.09,
	"as.mobile.bodyMLink": -0.09,
	"as.mobile.bodyS": 0.08,
	"as.mobile.bodySBold": -0.08,
	"as.mobile.bodySLink": -0.08,
	"as.mobile.bodyXs": -0.07,
	"as.mobile.bodyXsBold": -0.07,
	"as.mobile.bodyXsLink": -0.07,
	"as.mobile.bodyXxs": -0.06,
	"as.mobile.bodyXxsBold": -0.06,
	"as.mobile.bodyXxsLink": -0.06,
	"as.mobile.listTitle": -0.08,
	"as.mobile.button": -0.08,
	"as.mobile.code": 0,
	"bn.desktop.headingXl": -2.6399999999999997,
	"bn.desktop.headingL": -1.92,
	"bn.desktop.headingM": -1.2,
	"bn.desktop.headingS": -0.96,
	"bn.desktop.headingXs": -0.72,
	"bn.desktop.headingXxs": -0.48,
	"bn.desktop.overline": -0.06,
	"bn.desktop.bodyL": -0.12,
	"bn.desktop.bodyLBold": -0.12,
	"bn.desktop.bodyLLink": -0.12,
	"bn.desktop.bodyM": -0.09,
	"bn.desktop.bodyMBold": -0.09,
	"bn.desktop.bodyMLink": -0.09,
	"bn.desktop.bodyS": -0.08,
	"bn.desktop.bodySBold": -0.08,
	"bn.desktop.bodySLink": -0.08,
	"bn.desktop.bodyXs": -0.07,
	"bn.desktop.bodyXsBold": -0.07,
	"bn.desktop.bodyXsLink": -0.07,
	"bn.desktop.bodyXxs": -0.06,
	"bn.desktop.bodyXxsBold": -0.06,
	"bn.desktop.bodyXxsLink": -0.06,
	"bn.desktop.listTitle": -0.08,
	"bn.desktop.button": -0.08,
	"bn.desktop.code": 0,
	"bn.mobile.headingXl": -1.92,
	"bn.mobile.headingL": -1.44,
	"bn.mobile.headingM": -1.2,
	"bn.mobile.headingS": -0.96,
	"bn.mobile.headingXs": -0.72,
	"bn.mobile.headingXxs": -0.48,
	"bn.mobile.overline": -0.06,
	"bn.mobile.bodyL": -0.12,
	"bn.mobile.bodyLBold": -0.12,
	"bn.mobile.bodyLLink": -0.12,
	"bn.mobile.bodyM": -0.09,
	"bn.mobile.bodyMBold": -0.09,
	"bn.mobile.bodyMLink": -0.09,
	"bn.mobile.bodyS": 0.08,
	"bn.mobile.bodySBold": -0.08,
	"bn.mobile.bodySLink": -0.08,
	"bn.mobile.bodyXs": -0.07,
	"bn.mobile.bodyXsBold": -0.07,
	"bn.mobile.bodyXsLink": -0.07,
	"bn.mobile.bodyXxs": -0.06,
	"bn.mobile.bodyXxsBold": -0.06,
	"bn.mobile.bodyXxsLink": -0.06,
	"bn.mobile.listTitle": -0.08,
	"bn.mobile.button": -0.08,
	"bn.mobile.code": 0,
	"en.desktop.headingXl": -2.6399999999999997,
	"en.desktop.headingL": -1.92,
	"en.desktop.headingM": -1.2,
	"en.desktop.headingS": -0.96,
	"en.desktop.headingXs": -0.72,
	"en.desktop.headingXxs": -0.48,
	"en.desktop.overline": 0.06,
	"en.desktop.bodyL": -0.12,
	"en.desktop.bodyLBold": -0.12,
	"en.desktop.bodyLLink": -0.12,
	"en.desktop.bodyM": -0.09,
	"en.desktop.bodyMBold": -0.09,
	"en.desktop.bodyMLink": -0.09,
	"en.desktop.bodyS": -0.08,
	"en.desktop.bodySBold": -0.08,
	"en.desktop.bodySLink": -0.08,
	"en.desktop.bodyXs": -0.07,
	"en.desktop.bodyXsBold": -0.07,
	"en.desktop.bodyXsLink": -0.07,
	"en.desktop.bodyXxs": -0.06,
	"en.desktop.bodyXxsBold": -0.06,
	"en.desktop.bodyXxsLink": -0.06,
	"en.desktop.listTitle": -0.08,
	"en.desktop.button": -0.08,
	"en.desktop.code": 0,
	"en.mobile.headingXl": -1.92,
	"en.mobile.headingL": -1.44,
	"en.mobile.headingM": -1.2,
	"en.mobile.headingS": -0.96,
	"en.mobile.headingXs": -0.72,
	"en.mobile.headingXxs": -0.48,
	"en.mobile.overline": 0.06,
	"en.mobile.bodyL": -0.12,
	"en.mobile.bodyLBold": -0.12,
	"en.mobile.bodyLLink": -0.12,
	"en.mobile.bodyM": -0.09,
	"en.mobile.bodyMBold": -0.09,
	"en.mobile.bodyMLink": -0.09,
	"en.mobile.bodyS": -0.08,
	"en.mobile.bodySBold": -0.08,
	"en.mobile.bodySLink": -0.08,
	"en.mobile.bodyXs": -0.07,
	"en.mobile.bodyXsBold": -0.07,
	"en.mobile.bodyXsLink": -0.07,
	"en.mobile.bodyXxs": -0.06,
	"en.mobile.bodyXxsBold": -0.06,
	"en.mobile.bodyXxsLink": -0.06,
	"en.mobile.listTitle": -0.08,
	"en.mobile.button": -0.08,
	"en.mobile.code": 0,
	"gu.desktop.headingXl": -2.6399999999999997,
	"gu.desktop.headingL": -1.92,
	"gu.desktop.headingM": -1.2,
	"gu.desktop.headingS": -0.96,
	"gu.desktop.headingXs": -0.72,
	"gu.desktop.headingXxs": -0.48,
	"gu.desktop.overline": -0.06,
	"gu.desktop.bodyL": -0.12,
	"gu.desktop.bodyLBold": -0.12,
	"gu.desktop.bodyLLink": -0.12,
	"gu.desktop.bodyM": -0.09,
	"gu.desktop.bodyMBold": -0.09,
	"gu.desktop.bodyMLink": -0.09,
	"gu.desktop.bodyS": -0.08,
	"gu.desktop.bodySBold": -0.08,
	"gu.desktop.bodySLink": -0.08,
	"gu.desktop.bodyXs": -0.07,
	"gu.desktop.bodyXsBold": -0.07,
	"gu.desktop.bodyXsLink": -0.07,
	"gu.desktop.bodyXxs": -0.06,
	"gu.desktop.bodyXxsBold": -0.06,
	"gu.desktop.bodyXxsLink": -0.06,
	"gu.desktop.listTitle": -0.08,
	"gu.desktop.button": -0.08,
	"gu.desktop.code": 0,
	"gu.mobile.headingXl": -1.92,
	"gu.mobile.headingL": -1.44,
	"gu.mobile.headingM": -1.2,
	"gu.mobile.headingS": -0.96,
	"gu.mobile.headingXs": -0.72,
	"gu.mobile.headingXxs": -0.48,
	"gu.mobile.overline": -0.06,
	"gu.mobile.bodyL": -0.12,
	"gu.mobile.bodyLBold": -0.12,
	"gu.mobile.bodyLLink": -0.12,
	"gu.mobile.bodyM": -0.09,
	"gu.mobile.bodyMBold": -0.09,
	"gu.mobile.bodyMLink": -0.09,
	"gu.mobile.bodyS": 0.08,
	"gu.mobile.bodySBold": -0.08,
	"gu.mobile.bodySLink": -0.08,
	"gu.mobile.bodyXs": -0.07,
	"gu.mobile.bodyXsBold": -0.07,
	"gu.mobile.bodyXsLink": -0.07,
	"gu.mobile.bodyXxs": -0.06,
	"gu.mobile.bodyXxsBold": -0.06,
	"gu.mobile.bodyXxsLink": -0.06,
	"gu.mobile.listTitle": -0.08,
	"gu.mobile.button": -0.08,
	"gu.mobile.code": 0,
	"hi.desktop.headingXl": -2.6399999999999997,
	"hi.desktop.headingL": -1.92,
	"hi.desktop.headingM": -1.2,
	"hi.desktop.headingS": -0.96,
	"hi.desktop.headingXs": -0.72,
	"hi.desktop.headingXxs": -0.48,
	"hi.desktop.overline": -0.06,
	"hi.desktop.bodyL": -0.12,
	"hi.desktop.bodyLBold": -0.12,
	"hi.desktop.bodyLLink": -0.12,
	"hi.desktop.bodyM": -0.09,
	"hi.desktop.bodyMBold": -0.09,
	"hi.desktop.bodyMLink": -0.09,
	"hi.desktop.bodyS": -0.08,
	"hi.desktop.bodySBold": -0.08,
	"hi.desktop.bodySLink": -0.08,
	"hi.desktop.bodyXs": -0.07,
	"hi.desktop.bodyXsBold": -0.07,
	"hi.desktop.bodyXsLink": -0.07,
	"hi.desktop.bodyXxs": -0.06,
	"hi.desktop.bodyXxsBold": -0.06,
	"hi.desktop.bodyXxsLink": -0.06,
	"hi.desktop.listTitle": -0.08,
	"hi.desktop.button": -0.08,
	"hi.desktop.code": 0,
	"hi.mobile.headingXl": -1.92,
	"hi.mobile.headingL": -1.44,
	"hi.mobile.headingM": -1.2,
	"hi.mobile.headingS": -0.96,
	"hi.mobile.headingXs": -0.72,
	"hi.mobile.headingXxs": -0.48,
	"hi.mobile.overline": -0.06,
	"hi.mobile.bodyL": -0.12,
	"hi.mobile.bodyLBold": -0.12,
	"hi.mobile.bodyLLink": -0.12,
	"hi.mobile.bodyM": -0.09,
	"hi.mobile.bodyMBold": -0.09,
	"hi.mobile.bodyMLink": -0.09,
	"hi.mobile.bodyS": 0.08,
	"hi.mobile.bodySBold": -0.08,
	"hi.mobile.bodySLink": -0.08,
	"hi.mobile.bodyXs": -0.07,
	"hi.mobile.bodyXsBold": -0.07,
	"hi.mobile.bodyXsLink": -0.07,
	"hi.mobile.bodyXxs": -0.06,
	"hi.mobile.bodyXxsBold": -0.06,
	"hi.mobile.bodyXxsLink": -0.06,
	"hi.mobile.listTitle": -0.08,
	"hi.mobile.button": -0.08,
	"hi.mobile.code": 0,
	"kn.desktop.headingXl": -2.6399999999999997,
	"kn.desktop.headingL": -1.92,
	"kn.desktop.headingM": -1.2,
	"kn.desktop.headingS": -0.96,
	"kn.desktop.headingXs": -0.72,
	"kn.desktop.headingXxs": -0.48,
	"kn.desktop.overline": -0.06,
	"kn.desktop.bodyL": -0.12,
	"kn.desktop.bodyLBold": -0.12,
	"kn.desktop.bodyLLink": -0.12,
	"kn.desktop.bodyM": -0.09,
	"kn.desktop.bodyMBold": -0.09,
	"kn.desktop.bodyMLink": -0.09,
	"kn.desktop.bodyS": -0.08,
	"kn.desktop.bodySBold": -0.08,
	"kn.desktop.bodySLink": -0.08,
	"kn.desktop.bodyXs": -0.07,
	"kn.desktop.bodyXsBold": -0.07,
	"kn.desktop.bodyXsLink": -0.07,
	"kn.desktop.bodyXxs": -0.06,
	"kn.desktop.bodyXxsBold": -0.06,
	"kn.desktop.bodyXxsLink": -0.06,
	"kn.desktop.listTitle": -0.08,
	"kn.desktop.button": -0.08,
	"kn.desktop.code": 0,
	"kn.mobile.headingXl": -1.92,
	"kn.mobile.headingL": -1.44,
	"kn.mobile.headingM": -1.2,
	"kn.mobile.headingS": -0.96,
	"kn.mobile.headingXs": -0.72,
	"kn.mobile.headingXxs": -0.48,
	"kn.mobile.overline": -0.06,
	"kn.mobile.bodyL": -0.12,
	"kn.mobile.bodyLBold": -0.12,
	"kn.mobile.bodyLLink": -0.12,
	"kn.mobile.bodyM": -0.09,
	"kn.mobile.bodyMBold": -0.09,
	"kn.mobile.bodyMLink": -0.09,
	"kn.mobile.bodyS": 0.08,
	"kn.mobile.bodySBold": -0.08,
	"kn.mobile.bodySLink": -0.08,
	"kn.mobile.bodyXs": -0.07,
	"kn.mobile.bodyXsBold": -0.07,
	"kn.mobile.bodyXsLink": -0.07,
	"kn.mobile.bodyXxs": -0.06,
	"kn.mobile.bodyXxsBold": -0.06,
	"kn.mobile.bodyXxsLink": -0.06,
	"kn.mobile.listTitle": -0.08,
	"kn.mobile.button": -0.08,
	"kn.mobile.code": 0,
	"ml.desktop.headingXl": -2.6399999999999997,
	"ml.desktop.headingL": -1.92,
	"ml.desktop.headingM": -1.2,
	"ml.desktop.headingS": -0.96,
	"ml.desktop.headingXs": -0.72,
	"ml.desktop.headingXxs": -0.48,
	"ml.desktop.overline": -0.06,
	"ml.desktop.bodyL": -0.12,
	"ml.desktop.bodyLBold": -0.12,
	"ml.desktop.bodyLLink": -0.12,
	"ml.desktop.bodyM": -0.09,
	"ml.desktop.bodyMBold": -0.09,
	"ml.desktop.bodyMLink": -0.09,
	"ml.desktop.bodyS": -0.08,
	"ml.desktop.bodySBold": -0.08,
	"ml.desktop.bodySLink": -0.08,
	"ml.desktop.bodyXs": -0.07,
	"ml.desktop.bodyXsBold": -0.07,
	"ml.desktop.bodyXsLink": -0.07,
	"ml.desktop.bodyXxs": -0.06,
	"ml.desktop.bodyXxsBold": -0.06,
	"ml.desktop.bodyXxsLink": -0.06,
	"ml.desktop.listTitle": -0.08,
	"ml.desktop.button": -0.08,
	"ml.desktop.code": 0,
	"ml.mobile.headingXl": -1.92,
	"ml.mobile.headingL": -1.44,
	"ml.mobile.headingM": -1.2,
	"ml.mobile.headingS": -0.96,
	"ml.mobile.headingXs": -0.72,
	"ml.mobile.headingXxs": -0.48,
	"ml.mobile.overline": -0.06,
	"ml.mobile.bodyL": -0.12,
	"ml.mobile.bodyLBold": -0.12,
	"ml.mobile.bodyLLink": -0.12,
	"ml.mobile.bodyM": -0.09,
	"ml.mobile.bodyMBold": -0.09,
	"ml.mobile.bodyMLink": -0.09,
	"ml.mobile.bodyS": 0.08,
	"ml.mobile.bodySBold": -0.08,
	"ml.mobile.bodySLink": -0.08,
	"ml.mobile.bodyXs": -0.07,
	"ml.mobile.bodyXsBold": -0.07,
	"ml.mobile.bodyXsLink": -0.07,
	"ml.mobile.bodyXxs": -0.06,
	"ml.mobile.bodyXxsBold": -0.06,
	"ml.mobile.bodyXxsLink": -0.06,
	"ml.mobile.listTitle": -0.08,
	"ml.mobile.button": -0.08,
	"ml.mobile.code": 0,
	"mr.desktop.headingXl": -2.6399999999999997,
	"mr.desktop.headingL": -1.92,
	"mr.desktop.headingM": -1.2,
	"mr.desktop.headingS": -0.96,
	"mr.desktop.headingXs": -0.72,
	"mr.desktop.headingXxs": -0.48,
	"mr.desktop.overline": -0.06,
	"mr.desktop.bodyL": -0.12,
	"mr.desktop.bodyLBold": -0.12,
	"mr.desktop.bodyLLink": -0.12,
	"mr.desktop.bodyM": -0.09,
	"mr.desktop.bodyMBold": -0.09,
	"mr.desktop.bodyMLink": -0.09,
	"mr.desktop.bodyS": -0.08,
	"mr.desktop.bodySBold": -0.08,
	"mr.desktop.bodySLink": -0.08,
	"mr.desktop.bodyXs": -0.07,
	"mr.desktop.bodyXsBold": -0.07,
	"mr.desktop.bodyXsLink": -0.07,
	"mr.desktop.bodyXxs": -0.06,
	"mr.desktop.bodyXxsBold": -0.06,
	"mr.desktop.bodyXxsLink": -0.06,
	"mr.desktop.listTitle": -0.08,
	"mr.desktop.button": -0.08,
	"mr.desktop.code": 0,
	"mr.mobile.headingXl": -1.92,
	"mr.mobile.headingL": -1.44,
	"mr.mobile.headingM": -1.2,
	"mr.mobile.headingS": -0.96,
	"mr.mobile.headingXs": -0.72,
	"mr.mobile.headingXxs": -0.48,
	"mr.mobile.overline": -0.06,
	"mr.mobile.bodyL": -0.12,
	"mr.mobile.bodyLBold": -0.12,
	"mr.mobile.bodyLLink": -0.12,
	"mr.mobile.bodyM": -0.09,
	"mr.mobile.bodyMBold": -0.09,
	"mr.mobile.bodyMLink": -0.09,
	"mr.mobile.bodyS": 0.08,
	"mr.mobile.bodySBold": -0.08,
	"mr.mobile.bodySLink": -0.08,
	"mr.mobile.bodyXs": -0.07,
	"mr.mobile.bodyXsBold": -0.07,
	"mr.mobile.bodyXsLink": -0.07,
	"mr.mobile.bodyXxs": -0.06,
	"mr.mobile.bodyXxsBold": -0.06,
	"mr.mobile.bodyXxsLink": -0.06,
	"mr.mobile.listTitle": -0.08,
	"mr.mobile.button": -0.08,
	"mr.mobile.code": 0,
	"or.desktop.headingXl": -2.6399999999999997,
	"or.desktop.headingL": -1.92,
	"or.desktop.headingM": -1.2,
	"or.desktop.headingS": -0.96,
	"or.desktop.headingXs": -0.72,
	"or.desktop.headingXxs": -0.48,
	"or.desktop.overline": -0.06,
	"or.desktop.bodyL": -0.12,
	"or.desktop.bodyLBold": -0.12,
	"or.desktop.bodyLLink": -0.12,
	"or.desktop.bodyM": -0.09,
	"or.desktop.bodyMBold": -0.09,
	"or.desktop.bodyMLink": -0.09,
	"or.desktop.bodyS": -0.08,
	"or.desktop.bodySBold": -0.08,
	"or.desktop.bodySLink": -0.08,
	"or.desktop.bodyXs": -0.07,
	"or.desktop.bodyXsBold": -0.07,
	"or.desktop.bodyXsLink": -0.07,
	"or.desktop.bodyXxs": -0.06,
	"or.desktop.bodyXxsBold": -0.06,
	"or.desktop.bodyXxsLink": -0.06,
	"or.desktop.listTitle": -0.08,
	"or.desktop.button": -0.08,
	"or.desktop.code": 0,
	"or.mobile.headingXl": -1.92,
	"or.mobile.headingL": -1.44,
	"or.mobile.headingM": -1.2,
	"or.mobile.headingS": -0.96,
	"or.mobile.headingXs": -0.72,
	"or.mobile.headingXxs": -0.48,
	"or.mobile.overline": -0.06,
	"or.mobile.bodyL": -0.12,
	"or.mobile.bodyLBold": -0.12,
	"or.mobile.bodyLLink": -0.12,
	"or.mobile.bodyM": -0.09,
	"or.mobile.bodyMBold": -0.09,
	"or.mobile.bodyMLink": -0.09,
	"or.mobile.bodyS": 0.08,
	"or.mobile.bodySBold": -0.08,
	"or.mobile.bodySLink": -0.08,
	"or.mobile.bodyXs": -0.07,
	"or.mobile.bodyXsBold": -0.07,
	"or.mobile.bodyXsLink": -0.07,
	"or.mobile.bodyXxs": -0.06,
	"or.mobile.bodyXxsBold": -0.06,
	"or.mobile.bodyXxsLink": -0.06,
	"or.mobile.listTitle": -0.08,
	"or.mobile.button": -0.08,
	"or.mobile.code": 0,
	"pa.desktop.headingXl": -2.6399999999999997,
	"pa.desktop.headingL": -1.92,
	"pa.desktop.headingM": -1.2,
	"pa.desktop.headingS": -0.96,
	"pa.desktop.headingXs": -0.72,
	"pa.desktop.headingXxs": -0.48,
	"pa.desktop.overline": -0.06,
	"pa.desktop.bodyL": -0.12,
	"pa.desktop.bodyLBold": -0.12,
	"pa.desktop.bodyLLink": -0.12,
	"pa.desktop.bodyM": -0.09,
	"pa.desktop.bodyMBold": -0.09,
	"pa.desktop.bodyMLink": -0.09,
	"pa.desktop.bodyS": -0.08,
	"pa.desktop.bodySBold": -0.08,
	"pa.desktop.bodySLink": -0.08,
	"pa.desktop.bodyXs": -0.07,
	"pa.desktop.bodyXsBold": -0.07,
	"pa.desktop.bodyXsLink": -0.07,
	"pa.desktop.bodyXxs": -0.06,
	"pa.desktop.bodyXxsBold": -0.06,
	"pa.desktop.bodyXxsLink": -0.06,
	"pa.desktop.listTitle": -0.08,
	"pa.desktop.button": -0.08,
	"pa.desktop.code": 0,
	"pa.mobile.headingXl": -1.92,
	"pa.mobile.headingL": -1.44,
	"pa.mobile.headingM": -1.2,
	"pa.mobile.headingS": -0.96,
	"pa.mobile.headingXs": -0.72,
	"pa.mobile.headingXxs": -0.48,
	"pa.mobile.overline": -0.06,
	"pa.mobile.bodyL": -0.12,
	"pa.mobile.bodyLBold": -0.12,
	"pa.mobile.bodyLLink": -0.12,
	"pa.mobile.bodyM": -0.09,
	"pa.mobile.bodyMBold": -0.09,
	"pa.mobile.bodyMLink": -0.09,
	"pa.mobile.bodyS": 0.08,
	"pa.mobile.bodySBold": -0.08,
	"pa.mobile.bodySLink": -0.08,
	"pa.mobile.bodyXs": -0.07,
	"pa.mobile.bodyXsBold": -0.07,
	"pa.mobile.bodyXsLink": -0.07,
	"pa.mobile.bodyXxs": -0.06,
	"pa.mobile.bodyXxsBold": -0.06,
	"pa.mobile.bodyXxsLink": -0.06,
	"pa.mobile.listTitle": -0.08,
	"pa.mobile.button": -0.08,
	"pa.mobile.code": 0,
	"ta.desktop.headingXl": -2.6399999999999997,
	"ta.desktop.headingL": -1.92,
	"ta.desktop.headingM": -1.2,
	"ta.desktop.headingS": -0.96,
	"ta.desktop.headingXs": -0.72,
	"ta.desktop.headingXxs": -0.48,
	"ta.desktop.overline": -0.06,
	"ta.desktop.bodyL": -0.12,
	"ta.desktop.bodyLBold": -0.12,
	"ta.desktop.bodyLLink": -0.12,
	"ta.desktop.bodyM": -0.09,
	"ta.desktop.bodyMBold": -0.09,
	"ta.desktop.bodyMLink": -0.09,
	"ta.desktop.bodyS": -0.08,
	"ta.desktop.bodySBold": -0.08,
	"ta.desktop.bodySLink": -0.08,
	"ta.desktop.bodyXs": -0.07,
	"ta.desktop.bodyXsBold": -0.07,
	"ta.desktop.bodyXsLink": -0.07,
	"ta.desktop.bodyXxs": -0.06,
	"ta.desktop.bodyXxsBold": -0.06,
	"ta.desktop.bodyXxsLink": -0.06,
	"ta.desktop.listTitle": -0.08,
	"ta.desktop.button": -0.08,
	"ta.desktop.code": 0,
	"ta.mobile.headingXl": -1.92,
	"ta.mobile.headingL": -1.44,
	"ta.mobile.headingM": -1.2,
	"ta.mobile.headingS": -0.96,
	"ta.mobile.headingXs": -0.72,
	"ta.mobile.headingXxs": -0.48,
	"ta.mobile.overline": -0.06,
	"ta.mobile.bodyL": -0.12,
	"ta.mobile.bodyLBold": -0.12,
	"ta.mobile.bodyLLink": -0.12,
	"ta.mobile.bodyM": -0.09,
	"ta.mobile.bodyMBold": -0.09,
	"ta.mobile.bodyMLink": -0.09,
	"ta.mobile.bodyS": 0.08,
	"ta.mobile.bodySBold": -0.08,
	"ta.mobile.bodySLink": -0.08,
	"ta.mobile.bodyXs": -0.07,
	"ta.mobile.bodyXsBold": -0.07,
	"ta.mobile.bodyXsLink": -0.07,
	"ta.mobile.bodyXxs": -0.06,
	"ta.mobile.bodyXxsBold": -0.06,
	"ta.mobile.bodyXxsLink": -0.06,
	"ta.mobile.listTitle": -0.08,
	"ta.mobile.button": -0.08,
	"ta.mobile.code": 0,
	"te.desktop.headingXl": -2.6399999999999997,
	"te.desktop.headingL": -1.92,
	"te.desktop.headingM": -1.2,
	"te.desktop.headingS": -0.96,
	"te.desktop.headingXs": -0.72,
	"te.desktop.headingXxs": -0.48,
	"te.desktop.overline": -0.06,
	"te.desktop.bodyL": -0.12,
	"te.desktop.bodyLBold": -0.12,
	"te.desktop.bodyLLink": -0.12,
	"te.desktop.bodyM": -0.09,
	"te.desktop.bodyMBold": -0.09,
	"te.desktop.bodyMLink": -0.09,
	"te.desktop.bodyS": -0.08,
	"te.desktop.bodySBold": -0.08,
	"te.desktop.bodySLink": -0.08,
	"te.desktop.bodyXs": -0.07,
	"te.desktop.bodyXsBold": -0.07,
	"te.desktop.bodyXsLink": -0.07,
	"te.desktop.bodyXxs": -0.06,
	"te.desktop.bodyXxsBold": -0.06,
	"te.desktop.bodyXxsLink": -0.06,
	"te.desktop.listTitle": -0.08,
	"te.desktop.button": -0.08,
	"te.desktop.code": 0,
	"te.mobile.headingXl": -1.92,
	"te.mobile.headingL": -1.44,
	"te.mobile.headingM": -1.2,
	"te.mobile.headingS": -0.96,
	"te.mobile.headingXs": -0.72,
	"te.mobile.headingXxs": -0.48,
	"te.mobile.overline": -0.06,
	"te.mobile.bodyL": -0.12,
	"te.mobile.bodyLBold": -0.12,
	"te.mobile.bodyLLink": -0.12,
	"te.mobile.bodyM": -0.09,
	"te.mobile.bodyMBold": -0.09,
	"te.mobile.bodyMLink": -0.09,
	"te.mobile.bodyS": 0.08,
	"te.mobile.bodySBold": -0.08,
	"te.mobile.bodySLink": -0.08,
	"te.mobile.bodyXs": -0.07,
	"te.mobile.bodyXsBold": -0.07,
	"te.mobile.bodyXsLink": -0.07,
	"te.mobile.bodyXxs": -0.06,
	"te.mobile.bodyXxsBold": -0.06,
	"te.mobile.bodyXxsLink": -0.06,
	"te.mobile.listTitle": -0.08,
	"te.mobile.button": -0.08,
	"te.mobile.code": 0,
	headingXl: headingXl$1,
	headingL: headingL$1,
	headingM: headingM$1,
	headingS: headingS$1,
	headingXs: headingXs$1,
	headingXxs: headingXxs$1,
	overline: overline$2,
	bodyL: bodyL$1,
	bodyLBold: bodyLBold$1,
	bodyLLink: bodyLLink$1,
	bodyM: bodyM$1,
	bodyMBold: bodyMBold$1,
	bodyMLink: bodyMLink$1,
	bodyS: bodyS$1,
	bodySBold: bodySBold$1,
	bodySLink: bodySLink$1,
	bodyXs: bodyXs$1,
	bodyXsBold: bodyXsBold$1,
	bodyXsLink: bodyXsLink$1,
	bodyXxs: bodyXxs$1,
	bodyXxsBold: bodyXxsBold$1,
	bodyXxsLink: bodyXxsLink$1,
	listTitle: listTitle$1,
	button: button$1,
	code: code$1
};

const headingXl = "{$lang.$platform.headingXl}";
const headingL = "{$lang.$platform.headingL}";
const headingM = "{$lang.$platform.headingM}";
const headingS = "{$lang.$platform.headingS}";
const headingXs = "{$lang.$platform.headingXs}";
const headingXxs = "{$lang.$platform.headingXxs}";
const overline$1 = "{$lang.$platform.overline}";
const bodyL = "{$lang.$platform.bodyL}";
const bodyLBold = "{$lang.$platform.bodyLBold}";
const bodyLLink = "{$lang.$platform.bodyLLink}";
const bodyM = "{$lang.$platform.bodyM}";
const bodyMBold = "{$lang.$platform.bodyMBold}";
const bodyMLink = "{$lang.$platform.bodyMLink}";
const bodyS = "{$lang.$platform.bodyS}";
const bodySBold = "{$lang.$platform.bodySBold}";
const bodySLink = "{$lang.$platform.bodySLink}";
const bodyXs = "{$lang.$platform.bodyXs}";
const bodyXsBold = "{$lang.$platform.bodyXsBold}";
const bodyXsLink = "{$lang.$platform.bodyXsLink}";
const bodyXxs = "{$lang.$platform.bodyXxs}";
const bodyXxsBold = "{$lang.$platform.bodyXxsBold}";
const bodyXxsLink = "{$lang.$platform.bodyXxsLink}";
const listTitle = "{$lang.$platform.listTitle}";
const button = "{$lang.$platform.button}";
const code = "{$lang.$platform.code}";
const lineHeights = {
	"as.desktop.headingXl": 92,
	"as.desktop.headingL": 68,
	"as.desktop.headingM": 44,
	"as.desktop.headingS": 36,
	"as.desktop.headingXs": 32,
	"as.desktop.headingXxs": 24,
	"as.desktop.overline": 16,
	"as.desktop.bodyL": 28,
	"as.desktop.bodyLBold": 28,
	"as.desktop.bodyLLink": 28,
	"as.desktop.bodyM": 24,
	"as.desktop.bodyMBold": 24,
	"as.desktop.bodyMLink": 24,
	"as.desktop.bodyS": 24,
	"as.desktop.bodySBold": 24,
	"as.desktop.bodySLink": 24,
	"as.desktop.bodyXs": 16,
	"as.desktop.bodyXsBold": 16,
	"as.desktop.bodyXsLink": 16,
	"as.desktop.bodyXxs": 16,
	"as.desktop.bodyXxsBold": 20,
	"as.desktop.bodyXxsLink": 16,
	"as.desktop.listTitle": 20,
	"as.desktop.button": 24,
	"as.desktop.code": 16,
	"as.mobile.headingXl": 68,
	"as.mobile.headingL": 52,
	"as.mobile.headingM": 44,
	"as.mobile.headingS": 36,
	"as.mobile.headingXs": 32,
	"as.mobile.headingXxs": 24,
	"as.mobile.overline": 16,
	"as.mobile.bodyL": 32,
	"as.mobile.bodyLBold": 32,
	"as.mobile.bodyLLink": 32,
	"as.mobile.bodyM": 24,
	"as.mobile.bodyMBold": 24,
	"as.mobile.bodyMLink": 24,
	"as.mobile.bodyS": 24,
	"as.mobile.bodySBold": 24,
	"as.mobile.bodySLink": 24,
	"as.mobile.bodyXs": 16,
	"as.mobile.bodyXsBold": 16,
	"as.mobile.bodyXsLink": 16,
	"as.mobile.bodyXxs": 16,
	"as.mobile.bodyXxsBold": 16,
	"as.mobile.bodyXxsLink": 16,
	"as.mobile.listTitle": 20,
	"as.mobile.button": 24,
	"as.mobile.code": 16,
	"bn.desktop.headingXl": 92,
	"bn.desktop.headingL": 68,
	"bn.desktop.headingM": 44,
	"bn.desktop.headingS": 36,
	"bn.desktop.headingXs": 32,
	"bn.desktop.headingXxs": 24,
	"bn.desktop.overline": 16,
	"bn.desktop.bodyL": 28,
	"bn.desktop.bodyLBold": 28,
	"bn.desktop.bodyLLink": 28,
	"bn.desktop.bodyM": 24,
	"bn.desktop.bodyMBold": 24,
	"bn.desktop.bodyMLink": 24,
	"bn.desktop.bodyS": 24,
	"bn.desktop.bodySBold": 24,
	"bn.desktop.bodySLink": 24,
	"bn.desktop.bodyXs": 16,
	"bn.desktop.bodyXsBold": 16,
	"bn.desktop.bodyXsLink": 16,
	"bn.desktop.bodyXxs": 16,
	"bn.desktop.bodyXxsBold": 16,
	"bn.desktop.bodyXxsLink": 16,
	"bn.desktop.listTitle": 20,
	"bn.desktop.button": 24,
	"bn.desktop.code": 16,
	"bn.mobile.headingXl": 68,
	"bn.mobile.headingL": 52,
	"bn.mobile.headingM": 44,
	"bn.mobile.headingS": 36,
	"bn.mobile.headingXs": 32,
	"bn.mobile.headingXxs": 24,
	"bn.mobile.overline": 16,
	"bn.mobile.bodyL": 32,
	"bn.mobile.bodyLBold": 32,
	"bn.mobile.bodyLLink": 32,
	"bn.mobile.bodyM": 24,
	"bn.mobile.bodyMBold": 24,
	"bn.mobile.bodyMLink": 24,
	"bn.mobile.bodyS": 24,
	"bn.mobile.bodySBold": 24,
	"bn.mobile.bodySLink": 24,
	"bn.mobile.bodyXs": 16,
	"bn.mobile.bodyXsBold": 16,
	"bn.mobile.bodyXsLink": 16,
	"bn.mobile.bodyXxs": 16,
	"bn.mobile.bodyXxsBold": 16,
	"bn.mobile.bodyXxsLink": 16,
	"bn.mobile.listTitle": 20,
	"bn.mobile.button": 24,
	"bn.mobile.code": 16,
	"en.desktop.headingXl": 88,
	"en.desktop.headingL": 64,
	"en.desktop.headingM": 40,
	"en.desktop.headingS": 32,
	"en.desktop.headingXs": 28,
	"en.desktop.headingXxs": 20,
	"en.desktop.overline": 16,
	"en.desktop.bodyL": 32,
	"en.desktop.bodyLBold": 32,
	"en.desktop.bodyLLink": 32,
	"en.desktop.bodyM": 24,
	"en.desktop.bodyMBold": 24,
	"en.desktop.bodyMLink": 24,
	"en.desktop.bodyS": 24,
	"en.desktop.bodySBold": 24,
	"en.desktop.bodySLink": 24,
	"en.desktop.bodyXs": 20,
	"en.desktop.bodyXsBold": 20,
	"en.desktop.bodyXsLink": 20,
	"en.desktop.bodyXxs": 16,
	"en.desktop.bodyXxsBold": 16,
	"en.desktop.bodyXxsLink": 16,
	"en.desktop.listTitle": 20,
	"en.desktop.button": 24,
	"en.desktop.code": 16,
	"en.mobile.headingXl": 64,
	"en.mobile.headingL": 48,
	"en.mobile.headingM": 40,
	"en.mobile.headingS": 32,
	"en.mobile.headingXs": 28,
	"en.mobile.headingXxs": 20,
	"en.mobile.overline": 16,
	"en.mobile.bodyL": 32,
	"en.mobile.bodyLBold": 32,
	"en.mobile.bodyLLink": 32,
	"en.mobile.bodyM": 24,
	"en.mobile.bodyMBold": 24,
	"en.mobile.bodyMLink": 24,
	"en.mobile.bodyS": 24,
	"en.mobile.bodySBold": 24,
	"en.mobile.bodySLink": 24,
	"en.mobile.bodyXs": 20,
	"en.mobile.bodyXsBold": 20,
	"en.mobile.bodyXsLink": 20,
	"en.mobile.bodyXxs": 16,
	"en.mobile.bodyXxsBold": 16,
	"en.mobile.bodyXxsLink": 16,
	"en.mobile.listTitle": 20,
	"en.mobile.button": 24,
	"en.mobile.code": 16,
	"gu.desktop.headingXl": 112,
	"gu.desktop.headingL": 88,
	"gu.desktop.headingM": 64,
	"gu.desktop.headingS": 44,
	"gu.desktop.headingXs": 32,
	"gu.desktop.headingXxs": 24,
	"gu.desktop.overline": 16,
	"gu.desktop.bodyL": 28,
	"gu.desktop.bodyLBold": 28,
	"gu.desktop.bodyLLink": 28,
	"gu.desktop.bodyM": 24,
	"gu.desktop.bodyMBold": 24,
	"gu.desktop.bodyMLink": 24,
	"gu.desktop.bodyS": 24,
	"gu.desktop.bodySBold": 24,
	"gu.desktop.bodySLink": 24,
	"gu.desktop.bodyXs": 20,
	"gu.desktop.bodyXsBold": 16,
	"gu.desktop.bodyXsLink": 16,
	"gu.desktop.bodyXxs": 16,
	"gu.desktop.bodyXxsBold": 16,
	"gu.desktop.bodyXxsLink": 16,
	"gu.desktop.listTitle": 20,
	"gu.desktop.button": 24,
	"gu.desktop.code": 16,
	"gu.mobile.headingXl": 68,
	"gu.mobile.headingL": 52,
	"gu.mobile.headingM": 44,
	"gu.mobile.headingS": 36,
	"gu.mobile.headingXs": 32,
	"gu.mobile.headingXxs": 24,
	"gu.mobile.overline": 16,
	"gu.mobile.bodyL": 32,
	"gu.mobile.bodyLBold": 32,
	"gu.mobile.bodyLLink": 32,
	"gu.mobile.bodyM": 24,
	"gu.mobile.bodyMBold": 24,
	"gu.mobile.bodyMLink": 24,
	"gu.mobile.bodyS": 24,
	"gu.mobile.bodySBold": 24,
	"gu.mobile.bodySLink": 24,
	"gu.mobile.bodyXs": 16,
	"gu.mobile.bodyXsBold": 16,
	"gu.mobile.bodyXsLink": 16,
	"gu.mobile.bodyXxs": 16,
	"gu.mobile.bodyXxsBold": 16,
	"gu.mobile.bodyXxsLink": 16,
	"gu.mobile.listTitle": 20,
	"gu.mobile.button": 24,
	"gu.mobile.code": 16,
	"hi.desktop.headingXl": 92,
	"hi.desktop.headingL": 68,
	"hi.desktop.headingM": 44,
	"hi.desktop.headingS": 36,
	"hi.desktop.headingXs": 32,
	"hi.desktop.headingXxs": 24,
	"hi.desktop.overline": 16,
	"hi.desktop.bodyL": 28,
	"hi.desktop.bodyLBold": 28,
	"hi.desktop.bodyLLink": 28,
	"hi.desktop.bodyM": 24,
	"hi.desktop.bodyMBold": 24,
	"hi.desktop.bodyMLink": 24,
	"hi.desktop.bodyS": 24,
	"hi.desktop.bodySBold": 24,
	"hi.desktop.bodySLink": 24,
	"hi.desktop.bodyXs": 16,
	"hi.desktop.bodyXsBold": 16,
	"hi.desktop.bodyXsLink": 16,
	"hi.desktop.bodyXxs": 16,
	"hi.desktop.bodyXxsBold": 20,
	"hi.desktop.bodyXxsLink": 16,
	"hi.desktop.listTitle": 20,
	"hi.desktop.button": 24,
	"hi.desktop.code": 16,
	"hi.mobile.headingXl": 68,
	"hi.mobile.headingL": 52,
	"hi.mobile.headingM": 44,
	"hi.mobile.headingS": 36,
	"hi.mobile.headingXs": 32,
	"hi.mobile.headingXxs": 24,
	"hi.mobile.overline": 16,
	"hi.mobile.bodyL": 32,
	"hi.mobile.bodyLBold": 32,
	"hi.mobile.bodyLLink": 32,
	"hi.mobile.bodyM": 24,
	"hi.mobile.bodyMBold": 24,
	"hi.mobile.bodyMLink": 24,
	"hi.mobile.bodyS": 24,
	"hi.mobile.bodySBold": 24,
	"hi.mobile.bodySLink": 24,
	"hi.mobile.bodyXs": 16,
	"hi.mobile.bodyXsBold": 16,
	"hi.mobile.bodyXsLink": 16,
	"hi.mobile.bodyXxs": 16,
	"hi.mobile.bodyXxsBold": 16,
	"hi.mobile.bodyXxsLink": 16,
	"hi.mobile.listTitle": 20,
	"hi.mobile.button": 24,
	"hi.mobile.code": 16,
	"kn.desktop.headingXl": 112,
	"kn.desktop.headingL": 88,
	"kn.desktop.headingM": 64,
	"kn.desktop.headingS": 44,
	"kn.desktop.headingXs": 32,
	"kn.desktop.headingXxs": 24,
	"kn.desktop.overline": 16,
	"kn.desktop.bodyL": 28,
	"kn.desktop.bodyLBold": 28,
	"kn.desktop.bodyLLink": 28,
	"kn.desktop.bodyM": 24,
	"kn.desktop.bodyMBold": 24,
	"kn.desktop.bodyMLink": 24,
	"kn.desktop.bodyS": 24,
	"kn.desktop.bodySBold": 24,
	"kn.desktop.bodySLink": 24,
	"kn.desktop.bodyXs": 20,
	"kn.desktop.bodyXsBold": 16,
	"kn.desktop.bodyXsLink": 16,
	"kn.desktop.bodyXxs": 16,
	"kn.desktop.bodyXxsBold": 16,
	"kn.desktop.bodyXxsLink": 16,
	"kn.desktop.listTitle": 20,
	"kn.desktop.button": 24,
	"kn.desktop.code": 16,
	"kn.mobile.headingXl": 68,
	"kn.mobile.headingL": 52,
	"kn.mobile.headingM": 44,
	"kn.mobile.headingS": 36,
	"kn.mobile.headingXs": 32,
	"kn.mobile.headingXxs": 24,
	"kn.mobile.overline": 16,
	"kn.mobile.bodyL": 32,
	"kn.mobile.bodyLBold": 32,
	"kn.mobile.bodyLLink": 32,
	"kn.mobile.bodyM": 24,
	"kn.mobile.bodyMBold": 24,
	"kn.mobile.bodyMLink": 24,
	"kn.mobile.bodyS": 24,
	"kn.mobile.bodySBold": 24,
	"kn.mobile.bodySLink": 24,
	"kn.mobile.bodyXs": 16,
	"kn.mobile.bodyXsBold": 16,
	"kn.mobile.bodyXsLink": 16,
	"kn.mobile.bodyXxs": 16,
	"kn.mobile.bodyXxsBold": 16,
	"kn.mobile.bodyXxsLink": 16,
	"kn.mobile.listTitle": 20,
	"kn.mobile.button": 24,
	"kn.mobile.code": 16,
	"ml.desktop.headingXl": 92,
	"ml.desktop.headingL": 68,
	"ml.desktop.headingM": 44,
	"ml.desktop.headingS": 36,
	"ml.desktop.headingXs": 32,
	"ml.desktop.headingXxs": 24,
	"ml.desktop.overline": 16,
	"ml.desktop.bodyL": 28,
	"ml.desktop.bodyLBold": 28,
	"ml.desktop.bodyLLink": 28,
	"ml.desktop.bodyM": 24,
	"ml.desktop.bodyMBold": 24,
	"ml.desktop.bodyMLink": 24,
	"ml.desktop.bodyS": 24,
	"ml.desktop.bodySBold": 24,
	"ml.desktop.bodySLink": 24,
	"ml.desktop.bodyXs": 20,
	"ml.desktop.bodyXsBold": 16,
	"ml.desktop.bodyXsLink": 16,
	"ml.desktop.bodyXxs": 16,
	"ml.desktop.bodyXxsBold": 16,
	"ml.desktop.bodyXxsLink": 16,
	"ml.desktop.listTitle": 20,
	"ml.desktop.button": 24,
	"ml.desktop.code": 16,
	"ml.mobile.headingXl": 68,
	"ml.mobile.headingL": 52,
	"ml.mobile.headingM": 44,
	"ml.mobile.headingS": 36,
	"ml.mobile.headingXs": 32,
	"ml.mobile.headingXxs": 24,
	"ml.mobile.overline": 16,
	"ml.mobile.bodyL": 32,
	"ml.mobile.bodyLBold": 32,
	"ml.mobile.bodyLLink": 32,
	"ml.mobile.bodyM": 24,
	"ml.mobile.bodyMBold": 24,
	"ml.mobile.bodyMLink": 24,
	"ml.mobile.bodyS": 24,
	"ml.mobile.bodySBold": 24,
	"ml.mobile.bodySLink": 24,
	"ml.mobile.bodyXs": 16,
	"ml.mobile.bodyXsBold": 16,
	"ml.mobile.bodyXsLink": 16,
	"ml.mobile.bodyXxs": 16,
	"ml.mobile.bodyXxsBold": 16,
	"ml.mobile.bodyXxsLink": 16,
	"ml.mobile.listTitle": 20,
	"ml.mobile.button": 24,
	"ml.mobile.code": 16,
	"mr.desktop.headingXl": 92,
	"mr.desktop.headingL": 68,
	"mr.desktop.headingM": 44,
	"mr.desktop.headingS": 36,
	"mr.desktop.headingXs": 32,
	"mr.desktop.headingXxs": 24,
	"mr.desktop.overline": 16,
	"mr.desktop.bodyL": 28,
	"mr.desktop.bodyLBold": 28,
	"mr.desktop.bodyLLink": 28,
	"mr.desktop.bodyM": 24,
	"mr.desktop.bodyMBold": 24,
	"mr.desktop.bodyMLink": 24,
	"mr.desktop.bodyS": 24,
	"mr.desktop.bodySBold": 24,
	"mr.desktop.bodySLink": 24,
	"mr.desktop.bodyXs": 16,
	"mr.desktop.bodyXsBold": 16,
	"mr.desktop.bodyXsLink": 16,
	"mr.desktop.bodyXxs": 16,
	"mr.desktop.bodyXxsBold": 16,
	"mr.desktop.bodyXxsLink": 16,
	"mr.desktop.listTitle": 20,
	"mr.desktop.button": 24,
	"mr.desktop.code": 16,
	"mr.mobile.headingXl": 68,
	"mr.mobile.headingL": 52,
	"mr.mobile.headingM": 44,
	"mr.mobile.headingS": 36,
	"mr.mobile.headingXs": 32,
	"mr.mobile.headingXxs": 24,
	"mr.mobile.overline": 16,
	"mr.mobile.bodyL": 32,
	"mr.mobile.bodyLBold": 32,
	"mr.mobile.bodyLLink": 32,
	"mr.mobile.bodyM": 24,
	"mr.mobile.bodyMBold": 24,
	"mr.mobile.bodyMLink": 24,
	"mr.mobile.bodyS": 24,
	"mr.mobile.bodySBold": 24,
	"mr.mobile.bodySLink": 24,
	"mr.mobile.bodyXs": 16,
	"mr.mobile.bodyXsBold": 16,
	"mr.mobile.bodyXsLink": 16,
	"mr.mobile.bodyXxs": 16,
	"mr.mobile.bodyXxsBold": 16,
	"mr.mobile.bodyXxsLink": 16,
	"mr.mobile.listTitle": 20,
	"mr.mobile.button": 24,
	"mr.mobile.code": 16,
	"or.desktop.headingXl": 92,
	"or.desktop.headingL": 68,
	"or.desktop.headingM": 44,
	"or.desktop.headingS": 36,
	"or.desktop.headingXs": 32,
	"or.desktop.headingXxs": 24,
	"or.desktop.overline": 16,
	"or.desktop.bodyL": 28,
	"or.desktop.bodyLBold": 28,
	"or.desktop.bodyLLink": 28,
	"or.desktop.bodyM": 24,
	"or.desktop.bodyMBold": 24,
	"or.desktop.bodyMLink": 24,
	"or.desktop.bodyS": 24,
	"or.desktop.bodySBold": 24,
	"or.desktop.bodySLink": 24,
	"or.desktop.bodyXs": 16,
	"or.desktop.bodyXsBold": 16,
	"or.desktop.bodyXsLink": 16,
	"or.desktop.bodyXxs": 16,
	"or.desktop.bodyXxsBold": 16,
	"or.desktop.bodyXxsLink": 16,
	"or.desktop.listTitle": 20,
	"or.desktop.button": 24,
	"or.desktop.code": 16,
	"or.mobile.headingXl": 68,
	"or.mobile.headingL": 52,
	"or.mobile.headingM": 44,
	"or.mobile.headingS": 36,
	"or.mobile.headingXs": 32,
	"or.mobile.headingXxs": 24,
	"or.mobile.overline": 16,
	"or.mobile.bodyL": 32,
	"or.mobile.bodyLBold": 32,
	"or.mobile.bodyLLink": 32,
	"or.mobile.bodyM": 24,
	"or.mobile.bodyMBold": 24,
	"or.mobile.bodyMLink": 24,
	"or.mobile.bodyS": 24,
	"or.mobile.bodySBold": 24,
	"or.mobile.bodySLink": 24,
	"or.mobile.bodyXs": 16,
	"or.mobile.bodyXsBold": 16,
	"or.mobile.bodyXsLink": 16,
	"or.mobile.bodyXxs": 16,
	"or.mobile.bodyXxsBold": 16,
	"or.mobile.bodyXxsLink": 16,
	"or.mobile.listTitle": 20,
	"or.mobile.button": 24,
	"or.mobile.code": 16,
	"pa.desktop.headingXl": 92,
	"pa.desktop.headingL": 68,
	"pa.desktop.headingM": 44,
	"pa.desktop.headingS": 36,
	"pa.desktop.headingXs": 32,
	"pa.desktop.headingXxs": 24,
	"pa.desktop.overline": 16,
	"pa.desktop.bodyL": 28,
	"pa.desktop.bodyLBold": 28,
	"pa.desktop.bodyLLink": 28,
	"pa.desktop.bodyM": 24,
	"pa.desktop.bodyMBold": 24,
	"pa.desktop.bodyMLink": 24,
	"pa.desktop.bodyS": 24,
	"pa.desktop.bodySBold": 24,
	"pa.desktop.bodySLink": 24,
	"pa.desktop.bodyXs": 20,
	"pa.desktop.bodyXsBold": 16,
	"pa.desktop.bodyXsLink": 16,
	"pa.desktop.bodyXxs": 16,
	"pa.desktop.bodyXxsBold": 16,
	"pa.desktop.bodyXxsLink": 16,
	"pa.desktop.listTitle": 20,
	"pa.desktop.button": 24,
	"pa.desktop.code": 16,
	"pa.mobile.headingXl": 68,
	"pa.mobile.headingL": 52,
	"pa.mobile.headingM": 44,
	"pa.mobile.headingS": 36,
	"pa.mobile.headingXs": 32,
	"pa.mobile.headingXxs": 24,
	"pa.mobile.overline": 16,
	"pa.mobile.bodyL": 32,
	"pa.mobile.bodyLBold": 32,
	"pa.mobile.bodyLLink": 32,
	"pa.mobile.bodyM": 24,
	"pa.mobile.bodyMBold": 24,
	"pa.mobile.bodyMLink": 24,
	"pa.mobile.bodyS": 24,
	"pa.mobile.bodySBold": 24,
	"pa.mobile.bodySLink": 24,
	"pa.mobile.bodyXs": 16,
	"pa.mobile.bodyXsBold": 16,
	"pa.mobile.bodyXsLink": 16,
	"pa.mobile.bodyXxs": 16,
	"pa.mobile.bodyXxsBold": 16,
	"pa.mobile.bodyXxsLink": 16,
	"pa.mobile.listTitle": 20,
	"pa.mobile.button": 24,
	"pa.mobile.code": 16,
	"ta.desktop.headingXl": 112,
	"ta.desktop.headingL": 88,
	"ta.desktop.headingM": 64,
	"ta.desktop.headingS": 44,
	"ta.desktop.headingXs": 32,
	"ta.desktop.headingXxs": 24,
	"ta.desktop.overline": 16,
	"ta.desktop.bodyL": 28,
	"ta.desktop.bodyLBold": 28,
	"ta.desktop.bodyLLink": 28,
	"ta.desktop.bodyM": 24,
	"ta.desktop.bodyMBold": 24,
	"ta.desktop.bodyMLink": 24,
	"ta.desktop.bodyS": 24,
	"ta.desktop.bodySBold": 24,
	"ta.desktop.bodySLink": 24,
	"ta.desktop.bodyXs": 16,
	"ta.desktop.bodyXsBold": 16,
	"ta.desktop.bodyXsLink": 16,
	"ta.desktop.bodyXxs": 16,
	"ta.desktop.bodyXxsBold": 16,
	"ta.desktop.bodyXxsLink": 16,
	"ta.desktop.listTitle": 20,
	"ta.desktop.button": 24,
	"ta.desktop.code": 16,
	"ta.mobile.headingXl": 68,
	"ta.mobile.headingL": 52,
	"ta.mobile.headingM": 44,
	"ta.mobile.headingS": 36,
	"ta.mobile.headingXs": 32,
	"ta.mobile.headingXxs": 24,
	"ta.mobile.overline": 16,
	"ta.mobile.bodyL": 32,
	"ta.mobile.bodyLBold": 32,
	"ta.mobile.bodyLLink": 32,
	"ta.mobile.bodyM": 24,
	"ta.mobile.bodyMBold": 24,
	"ta.mobile.bodyMLink": 24,
	"ta.mobile.bodyS": 24,
	"ta.mobile.bodySBold": 24,
	"ta.mobile.bodySLink": 24,
	"ta.mobile.bodyXs": 20,
	"ta.mobile.bodyXsBold": 16,
	"ta.mobile.bodyXsLink": 16,
	"ta.mobile.bodyXxs": 16,
	"ta.mobile.bodyXxsBold": 16,
	"ta.mobile.bodyXxsLink": 16,
	"ta.mobile.listTitle": 20,
	"ta.mobile.button": 24,
	"ta.mobile.code": 16,
	"te.desktop.headingXl": 92,
	"te.desktop.headingL": 68,
	"te.desktop.headingM": 44,
	"te.desktop.headingS": 36,
	"te.desktop.headingXs": 32,
	"te.desktop.headingXxs": 24,
	"te.desktop.overline": 16,
	"te.desktop.bodyL": 28,
	"te.desktop.bodyLBold": 28,
	"te.desktop.bodyLLink": 28,
	"te.desktop.bodyM": 24,
	"te.desktop.bodyMBold": 24,
	"te.desktop.bodyMLink": 24,
	"te.desktop.bodyS": 24,
	"te.desktop.bodySBold": 24,
	"te.desktop.bodySLink": 24,
	"te.desktop.bodyXs": 16,
	"te.desktop.bodyXsBold": 16,
	"te.desktop.bodyXsLink": 16,
	"te.desktop.bodyXxs": 16,
	"te.desktop.bodyXxsBold": 16,
	"te.desktop.bodyXxsLink": 16,
	"te.desktop.listTitle": 20,
	"te.desktop.button": 24,
	"te.desktop.code": 16,
	"te.mobile.headingXl": 68,
	"te.mobile.headingL": 52,
	"te.mobile.headingM": 44,
	"te.mobile.headingS": 36,
	"te.mobile.headingXs": 32,
	"te.mobile.headingXxs": 24,
	"te.mobile.overline": 16,
	"te.mobile.bodyL": 32,
	"te.mobile.bodyLBold": 32,
	"te.mobile.bodyLLink": 32,
	"te.mobile.bodyM": 24,
	"te.mobile.bodyMBold": 24,
	"te.mobile.bodyMLink": 24,
	"te.mobile.bodyS": 24,
	"te.mobile.bodySBold": 24,
	"te.mobile.bodySLink": 24,
	"te.mobile.bodyXs": 16,
	"te.mobile.bodyXsBold": 16,
	"te.mobile.bodyXsLink": 16,
	"te.mobile.bodyXxs": 16,
	"te.mobile.bodyXxsBold": 16,
	"te.mobile.bodyXxsLink": 16,
	"te.mobile.listTitle": 20,
	"te.mobile.button": 24,
	"te.mobile.code": 16,
	headingXl: headingXl,
	headingL: headingL,
	headingM: headingM,
	headingS: headingS,
	headingXs: headingXs,
	headingXxs: headingXxs,
	overline: overline$1,
	bodyL: bodyL,
	bodyLBold: bodyLBold,
	bodyLLink: bodyLLink,
	bodyM: bodyM,
	bodyMBold: bodyMBold,
	bodyMLink: bodyMLink,
	bodyS: bodyS,
	bodySBold: bodySBold,
	bodySLink: bodySLink,
	bodyXs: bodyXs,
	bodyXsBold: bodyXsBold,
	bodyXsLink: bodyXsLink,
	bodyXxs: bodyXxs,
	bodyXxsBold: bodyXxsBold,
	bodyXxsLink: bodyXxsLink,
	listTitle: listTitle,
	button: button,
	code: code
};

const custom_1$2 = "85%";
const custom_2$2 = "80%";
const opacity = {
	"opacity.invisible": "0%",
	"opacity.disabled": "30%",
	"opacity.enabled": "100%",
	custom_1: custom_1$2,
	custom_2: custom_2$2
};

const paragraphSpacing = {
	"paragraph-spacing.0": "0"
};

const semantic = {
	"color.bold.default.description": "Used for default focus and disable backgrounds",
	"color.bold.emphasised.description": "Used for hover bg",
	"color.bold.muted.description": "Used as fg on dissabled",
	"color.bold.subtle.description": "Used for the fg on pressed",
	"color.bold.discreet.description": "Used as fg on hover",
	"color.bold.on-bold.description": "Used on the default fg",
	"color.bold.disabled.description": "Used on the default fg"
};

const shadows = {
	"box-shadow.1.true": "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
	"box-shadow.false": "none"
};

const xxs$1 = "4";
const xs$1 = "8";
const s$1 = "12";
const base$1 = "16";
const m$1 = "24";
const l$1 = "32";
const xl$1 = "40";
const xxl$1 = "48";
const huge$1 = "64";
const massive$1 = "80";
const custom_1$1 = "120";
const custom_2$1 = "44";
const custom_3$1 = "28";
const custom_4$1 = "2";
const custom_5$1 = "1";
const custom_6$1 = "384";
const custom_7$1 = "156";
const custom_8$1 = "300";
const custom_9$1 = "102";
const custom_10$1 = "184";
const custom_11$1 = "56";
const custom_12$1 = "280";
const custom_13$1 = "312";
const custom_14$1 = "384";
const custom_15$1 = "6";
const custom_16$1 = "72";
const custom_17$1 = "560";
const custom_18$1 = "20";
const custom_19$1 = "10";
const custom_20$1 = "9";
const custom_21$1 = "15";
const custom_22$1 = "17";
const custom_23$1 = "7";
const custom_24$1 = "13";
const custom_25$1 = "18";
const custom_26 = "27";
const custom_27 = "584";
const custom_28 = "331";
const custom_29 = "33";
const custom_30 = "23";
const sizing = {
	xxs: xxs$1,
	xs: xs$1,
	s: s$1,
	base: base$1,
	m: m$1,
	l: l$1,
	xl: xl$1,
	xxl: xxl$1,
	huge: huge$1,
	massive: massive$1,
	custom_1: custom_1$1,
	custom_2: custom_2$1,
	custom_3: custom_3$1,
	custom_4: custom_4$1,
	custom_5: custom_5$1,
	custom_6: custom_6$1,
	custom_7: custom_7$1,
	custom_8: custom_8$1,
	custom_9: custom_9$1,
	custom_10: custom_10$1,
	custom_11: custom_11$1,
	custom_12: custom_12$1,
	custom_13: custom_13$1,
	custom_14: custom_14$1,
	custom_15: custom_15$1,
	custom_16: custom_16$1,
	custom_17: custom_17$1,
	custom_18: custom_18$1,
	custom_19: custom_19$1,
	custom_20: custom_20$1,
	custom_21: custom_21$1,
	custom_22: custom_22$1,
	custom_23: custom_23$1,
	custom_24: custom_24$1,
	custom_25: custom_25$1,
	custom_26: custom_26,
	custom_27: custom_27,
	custom_28: custom_28,
	custom_29: custom_29,
	custom_30: custom_30
};

const xxs = "4";
const xs = "8";
const s = "12";
const base = "16";
const m = "24";
const l = "32";
const xl = "40";
const xxl = "48";
const huge = "64";
const massive = "80";
const custom_1 = "1";
const stepper_horizontal = "{$platform.stepper_horizontal}";
const custom_2 = "11";
const custom_3 = "128";
const custom_4 = "2";
const custom_5 = "0";
const custom_6 = "84";
const custom_7 = "88";
const custom_8 = "42";
const custom_9 = "10";
const custom_10 = "38";
const custom_11 = "26";
const custom_12 = "30";
const custom_13 = "22";
const custom_14 = "28";
const custom_15 = "20";
const custom_16 = "3";
const custom_17 = "5";
const custom_18 = "6";
const custom_19 = "56";
const custom_20 = "46";
const custom_21 = "110";
const custom_22 = "114";
const custom_23 = "15";
const custom_24 = "31";
const custom_25 = "17";
const spacing = {
	xxs: xxs,
	xs: xs,
	s: s,
	base: base,
	m: m,
	l: l,
	xl: xl,
	xxl: xxl,
	huge: huge,
	massive: massive,
	custom_1: custom_1,
	"desktop.stepper_horizontal": "{massive}",
	"tablet.stepper_horizontal": "{m}",
	"mobile.stepper_horizontal": "{m}",
	stepper_horizontal: stepper_horizontal,
	custom_2: custom_2,
	custom_3: custom_3,
	custom_4: custom_4,
	custom_5: custom_5,
	custom_6: custom_6,
	custom_7: custom_7,
	custom_8: custom_8,
	custom_9: custom_9,
	custom_10: custom_10,
	custom_11: custom_11,
	custom_12: custom_12,
	custom_13: custom_13,
	custom_14: custom_14,
	custom_15: custom_15,
	custom_16: custom_16,
	custom_17: custom_17,
	custom_18: custom_18,
	custom_19: custom_19,
	custom_20: custom_20,
	custom_21: custom_21,
	custom_22: custom_22,
	custom_23: custom_23,
	custom_24: custom_24,
	custom_25: custom_25
};

const overline = "{$lang.$platform.overline}";
const textCase = {
	"text-case.none": "none",
	"text-case.uppercasecase": "uppercase",
	"text-case.lowercase": "lowercase",
	"text-case.capitalize": "capitalize",
	"as.desktop.overline": "uppercase",
	"as.mobile.overline": "uppercase",
	"bn.desktop.overline": "uppercase",
	"bn.mobile.overline": "uppercase",
	"en.desktop.overline": "uppercase",
	"en.mobile.overline": "uppercase",
	"gu.desktop.overline": "uppercase",
	"gu.mobile.overline": "uppercase",
	"hi.desktop.overline": "uppercase",
	"hi.mobile.overline": "uppercase",
	"kn.desktop.overline": "uppercase",
	"kn.mobile.overline": "uppercase",
	"ml.desktop.overline": "uppercase",
	"mr.desktop.overline": "uppercase",
	"mr.mobile.overline": "uppercase",
	"or.desktop.overline": "uppercase",
	"pa.desktop.overline": "uppercase",
	"pa.mobile.overline": "uppercase",
	"ta.desktop.overline": "uppercase",
	"ta.mobile.overline": "uppercase",
	"te.desktop.overline": "uppercase",
	"te.mobile.overline": "uppercase",
	overline: overline
};

const textDecoration = {
	"text-decoration.none": "none",
	"text-decoration.underline": "underline",
	"text-decoration.line-through": "line-through",
	"text-decoration.overline": "overline",
	"max.lines.1": "1",
	"text-overflow.ellipsis": "ellipsis"
};

const easeRapid = "0.35, 0, 0.5, 1";
const easeQuick = "0.35, 0, 0.25, 1";
const easeJoyful = "0.35, 1.3, 0.3, 1";
const easeEntrance = "0, 0, 0.1, 1";
const easeExit = "0.35, 0, 0.8, 1";
const easeJoyfulEntrance = "0.15, 1.3, 0.3, 1";
const easeJoyfulExit = "0.7, -0.1, 0.6, 0.1";
const easeJoyfulentrance = "0.15, 1.3, 0.3, 1";
const easeJoyfulexit = "0.7, -0.1, 0.6, 0.1";
const transitions = {
	easeRapid: easeRapid,
	easeQuick: easeQuick,
	easeJoyful: easeJoyful,
	easeEntrance: easeEntrance,
	easeExit: easeExit,
	easeJoyfulEntrance: easeJoyfulEntrance,
	easeJoyfulExit: easeJoyfulExit,
	easeJoyfulentrance: easeJoyfulentrance,
	easeJoyfulexit: easeJoyfulexit
};

const rapid = "300";
const medium = "500";
const slow = "1000";
const transitionsDuration = {
	rapid: rapid,
	medium: medium,
	slow: slow
};

const typography = {
	
};

const index = {
  tokens: {
    borderRadius,
    borderWidth,
    color,
    fontFamilies,
    fontSizes,
    fontWeights,
    letterSpacing,
    lineHeights,
    opacity,
    paragraphSpacing,
    semantic,
    sizing,
    spacing,
    textCase,
    textDecoration,
    typography,
    layout,
    shadows,
    transitions,
    transitionsDuration
  },
  getComponentTokens
};

const accordionlist_base_container_width = "{size.max}";
const AccordionListTokens = {
	"accordionlist_base_root-container_flex-direction": "{flexDirection.column}",
	"accordionlist_base_root-container_width": "{size.max}",
	"accordionlist_base_container_flex-direction": "{flexDirection.column}",
	accordionlist_base_container_width: accordionlist_base_container_width
};

const avatar_base_container_width$1 = "{xl}";
const avatar_base_container_height$1 = "{xl}";
const avatar_variant_size_small_container_width$1 = "{l}";
const avatar_variant_size_small_container_height$1 = "{l}";
const avatar_variant_size_large_container_width$1 = "{xxl}";
const avatar_variant_size_large_container_height$1 = "{xxl}";
const avatar_base_container_opacity$1 = "{opacity.enabled}";
const avatar_variant_disabled_true_container_opacity$1 = "{opacity.disabled}";
const avatar_combination_true_image_container_behavior_hover_opacity = "{opacity.disabled}";
const avatar_combination_true_image_container_behavior_focus_opacity = "{opacity.disabled}";
const AvatarTokens = {
	avatar_base_container_width: avatar_base_container_width$1,
	avatar_base_container_height: avatar_base_container_height$1,
	"avatar_base_container_flex-direction": "{flexDirection.row}",
	"avatar_base_container_justify-content": "{justifyContent.center}",
	"avatar_base_container_align-items": "{alignItems.center}",
	"avatar_base_container_background-color": "{primary20}",
	"avatar_base_container_border-radius": "{pill}",
	"avatar_base_container_border-width": "{border_none}",
	"avatar_base_container_border-color": "{primary80}",
	"avatar_variant_size_xtra-small_container_width": "{m}",
	"avatar_variant_size_xtra-small_container_height": "{m}",
	avatar_variant_size_small_container_width: avatar_variant_size_small_container_width$1,
	avatar_variant_size_small_container_height: avatar_variant_size_small_container_height$1,
	avatar_variant_size_large_container_width: avatar_variant_size_large_container_width$1,
	avatar_variant_size_large_container_height: avatar_variant_size_large_container_height$1,
	"avatar_variant_size_xtra-xtra-large_container_width": "{custom_1}",
	"avatar_variant_size_xtra-xtra-large_container_height": "{custom_1}",
	avatar_base_container_opacity: avatar_base_container_opacity$1,
	avatar_variant_disabled_true_container_opacity: avatar_variant_disabled_true_container_opacity$1,
	"avatar_variant_kind_initials_container_background-color": "{sparkle20}",
	"avatar_combination_true_icon_container_behavior_focus_border-width": "{border_focus}",
	"avatar_combination_true_initials_container_behavior_hover_background-color": "{sparkle40}",
	"avatar_combination_true_initials_container_behavior_focus_border-width": "{border_focus}",
	"avatar_combination_true_initials_container_behavior_focus_background-color": "{sparkle40}",
	avatar_combination_true_image_container_behavior_hover_opacity: avatar_combination_true_image_container_behavior_hover_opacity,
	"avatar_combination_true_image_container_behavior_focus_border-width": "{border_focus}",
	avatar_combination_true_image_container_behavior_focus_opacity: avatar_combination_true_image_container_behavior_focus_opacity
};

const avatar_base_container_width = "{xl}";
const avatar_base_container_height = "{xl}";
const avatar_base_container_opacity = "{opacity.enabled}";
const avatar_base_icon_size = "{custom_3}";
const avatar_base_icon_color = "{primary60}";
const avatar_base_icon_behavior_hover_color = "{primary50}";
const avatar_base_icon_behavior_active_color = "{primary70}";
const avatar_variant_size_small_container_width = "{l}";
const avatar_variant_size_small_container_height = "{l}";
const avatar_variant_size_large_container_width = "{xxl}";
const avatar_variant_size_large_container_height = "{xxl}";
const avatar_variant_size_small_icon_size = "{m}";
const avatar_variant_size_large_icon_size = "{l}";
const avatar_variant_disabled_true_container_opacity = "{opacity.disabled}";
const avatar_variant_kind_image_jds_image_behavior_hover_opacity = "{opacity.disabled}";
const avatar_variant_kind_image_jds_image_behavior_active_opacity = "{opacity.disabled}";
const AvatarV2DefaultTokens = {
	avatar_base_container_width: avatar_base_container_width,
	avatar_base_container_height: avatar_base_container_height,
	"avatar_base_container_flex-direction": "{flexDirection.row}",
	"avatar_base_container_justify-content": "{justifyContent.center}",
	"avatar_base_container_align-items": "{alignItems.center}",
	"avatar_base_container_background-color": "{primary20}",
	"avatar_base_container_border-radius": "{pill}",
	"avatar_base_container_border-width": "{border_none}",
	"avatar_base_container_border-color": "{primary60}",
	avatar_base_container_opacity: avatar_base_container_opacity,
	"avatar_base_container_behavior_active_background-color": "{primary30}",
	"avatar_base_container_behavior_focus_border-width": "{border_focus}",
	avatar_base_icon_size: avatar_base_icon_size,
	avatar_base_icon_color: avatar_base_icon_color,
	avatar_base_icon_behavior_hover_color: avatar_base_icon_behavior_hover_color,
	avatar_base_icon_behavior_active_color: avatar_base_icon_behavior_active_color,
	"avatar_variant_size_xtra-small_container_width": "{m}",
	"avatar_variant_size_xtra-small_container_height": "{m}",
	avatar_variant_size_small_container_width: avatar_variant_size_small_container_width,
	avatar_variant_size_small_container_height: avatar_variant_size_small_container_height,
	avatar_variant_size_large_container_width: avatar_variant_size_large_container_width,
	avatar_variant_size_large_container_height: avatar_variant_size_large_container_height,
	"avatar_variant_size_xtra-large_container_width": "{custom_11}",
	"avatar_variant_size_xtra-large_container_height": "{custom_11}",
	"avatar_variant_size_xtra-xtra-large_container_width": "{custom_1}",
	"avatar_variant_size_xtra-xtra-large_container_height": "{custom_1}",
	"avatar_variant_size_xtra-small_icon_size": "{base}",
	avatar_variant_size_small_icon_size: avatar_variant_size_small_icon_size,
	avatar_variant_size_large_icon_size: avatar_variant_size_large_icon_size,
	"avatar_variant_size_xtra-large_icon_size": "{xl}",
	"avatar_variant_size_xtra-xtra-large_icon_size": "{xxl}",
	avatar_variant_disabled_true_container_opacity: avatar_variant_disabled_true_container_opacity,
	"avatar_variant_kind_initials_container_background-color": "{sparkle20}",
	avatar_variant_kind_image_jds_image_behavior_hover_opacity: avatar_variant_kind_image_jds_image_behavior_hover_opacity,
	"avatar_variant_kind_image_container_behavior_hover_background-color": "{primaryBackground}",
	avatar_variant_kind_image_jds_image_behavior_active_opacity: avatar_variant_kind_image_jds_image_behavior_active_opacity,
	"avatar_variant_kind_image_container_behavior_active_background-color": "{primaryGrey80}"
};

const actionbutton_base_container_opacity = "{opacity.enabled}";
const actionbutton_base_loader_color = "{primary50}";
const actionbutton_base_loader_opacity = "{opacity.enabled}";
const actionbutton_base_loader_size = "{m}";
const actionbutton_variant_size_small_loader_size = "{m}";
const actionbutton_variant_size_large_loader_size = "{m}";
const actionbutton_variant_state_loading_jds_text_opacity = "{opacity.invisible}";
const actionbutton_combination_false_small_loader_size = "{base}";
const actionbutton_combination_false_large_loader_size = "{m}";
const actionbutton_combination_true_true_container_width = "{size.max}";
const ActionButtonTokens = {
	"actionbutton_base_container_background-color": "{global.transparent}",
	actionbutton_base_container_opacity: actionbutton_base_container_opacity,
	"actionbutton_base_container_flex-direction": "{flexDirection.stack}",
	"actionbutton_base_container_align-items": "{alignItems.center}",
	"actionbutton_base_container_justify-content": "{justifyContent.center}",
	"actionbutton_base_container_border-radius": "{pill}",
	"actionbutton_base_inner-container_background-color": "{primary50}",
	"actionbutton_base_inner-container_flex-direction": "{flexDirection.row}",
	"actionbutton_base_inner-container_align-items": "{alignItems.center}",
	"actionbutton_base_inner-container_justify-content": "{justifyContent.center}",
	"actionbutton_base_inner-container_border-radius": "{pill}",
	"actionbutton_base_inner-container_padding-top": "{xs}",
	"actionbutton_base_inner-container_padding-right": "{base}",
	"actionbutton_base_inner-container_padding-bottom": "{xs}",
	"actionbutton_base_inner-container_padding-left": "{base}",
	"actionbutton_base_inner-container_gap": "{xs}",
	"actionbutton_base_inner-container_behavior_hover_background-color": "{primary30}",
	"actionbutton_base_inner-container_behavior_active_background-color": "{primary60}",
	"actionbutton_base_inner-container_behavior_focus_border-width": "{border_focus}",
	"actionbutton_base_inner-container_behavior_focus_border-color": "{primary60}",
	actionbutton_base_loader_color: actionbutton_base_loader_color,
	"actionbutton_base_loader_background-color": "{global.transparent}",
	"actionbutton_base_loader_track-color": "{primaryGrey40}",
	"actionbutton_base_loader_border-width": "{border_focus}",
	"actionbutton_base_inner-container_border-width": "{border_none}",
	actionbutton_base_loader_opacity: actionbutton_base_loader_opacity,
	actionbutton_base_loader_size: actionbutton_base_loader_size,
	"actionbutton_base_left-icon_size": "{m}",
	"actionbutton_base_left-icon_color": "{primaryInverse}",
	"actionbutton_base_left-icon_behavior_hover_color": "{primary70}",
	"actionbutton_base_left-icon_behavior_active_color": "{primaryInverse}",
	"actionbutton_base_right-icon_size": "{m}",
	"actionbutton_base_right-icon_color": "{primaryInverse}",
	"actionbutton_base_right-icon_behavior_hover_color": "{primary70}",
	"actionbutton_base_right-icon_behavior_active_color": "{primaryInverse}",
	"actionbutton_variant_size_small_inner-container_padding-top": "{xxs}",
	"actionbutton_variant_size_small_inner-container_padding-right": "{s}",
	"actionbutton_variant_size_small_inner-container_padding-bottom": "{xxs}",
	"actionbutton_variant_size_small_inner-container_padding-left": "{s}",
	"actionbutton_variant_size_small_inner-container_gap": "{xxs}",
	"actionbutton_variant_size_small_left-icon_size": "{base}",
	"actionbutton_variant_size_small_right-icon_size": "{base}",
	actionbutton_variant_size_small_loader_size: actionbutton_variant_size_small_loader_size,
	"actionbutton_variant_size_large_inner-container_padding-top": "{s}",
	"actionbutton_variant_size_large_inner-container_padding-left": "{m}",
	"actionbutton_variant_size_large_inner-container_padding-bottom": "{s}",
	"actionbutton_variant_size_large_inner-container_padding-right": "{m}",
	"actionbutton_variant_size_large_inner-container_gap": "{xs}",
	"actionbutton_variant_size_large_left-icon_size": "{m}",
	"actionbutton_variant_size_large_right-icon_size": "{m}",
	actionbutton_variant_size_large_loader_size: actionbutton_variant_size_large_loader_size,
	"actionbutton_variant_size_extra-large_inner-container_padding-top": "{base}",
	"actionbutton_variant_size_extra-large_inner-container_padding-right": "{l}",
	"actionbutton_variant_size_extra-large_inner-container_padding-bottom": "{base}",
	"actionbutton_variant_size_extra-large_inner-container_padding-left": "{l}",
	"actionbutton_variant_size_extra-large_inner-container_gap": "{xs}",
	"actionbutton_variant_size_extra-large_left-icon_size": "{l}",
	"actionbutton_variant_size_extra-large_right-icon_size": "{l}",
	"actionbutton_variant_size_extra-large_loader_size": "{xxl}",
	"actionbutton_variant_state_loading_inner-container_opacity": "{opacity.disabled}",
	"actionbutton_variant_state_loading_left-icon_opacity": "{opacity.invisible}",
	"actionbutton_variant_state_loading_right-icon_opacity": "{opacity.invisible}",
	actionbutton_variant_state_loading_jds_text_opacity: actionbutton_variant_state_loading_jds_text_opacity,
	"actionbutton_variant_state_disabled_inner-container_opacity": "{opacity.disabled}",
	"actionbutton_base_inner-container_opacity": "{opacity.enabled}",
	"actionbutton_combination_normal_secondary_inner-container_background-color": "{global.transparent}",
	"actionbutton_combination_normal_secondary_inner-container_border-width": "{border_thin}",
	"actionbutton_combination_normal_secondary_inner-container_border-color": "{primaryGrey60}",
	"actionbutton_combination_normal_secondary_inner-container_behavior_hover_background-color": "{primary20}",
	"actionbutton_combination_normal_secondary_inner-container_behavior_active_background-color": "{primary30}",
	"actionbutton_combination_normal_secondary_inner-container_behavior_focus_border-width": "{border_focus}",
	"actionbutton_combination_normal_secondary_inner-container_behavior_focus_border-color": "{primary60}",
	"actionbutton_combination_normal_secondary_left-icon_color": "{primary60}",
	"actionbutton_combination_normal_secondary_left-icon_behavior_hover_color": "{primary60}",
	"actionbutton_combination_normal_secondary_left-icon_behavior_active_color": "{primary70}",
	"actionbutton_combination_normal_secondary_right-icon_color": "{primary60}",
	"actionbutton_combination_normal_secondary_right-icon_behavior_hover_color": "{primary60}",
	"actionbutton_combination_normal_secondary_right-icon_behavior_active_color": "{primary70}",
	"actionbutton_combination_normal_tertiary_inner-container_background-color": "{global.transparent}",
	"actionbutton_combination_normal_tertiary_inner-container_behavior_hover_background-color": "{global.transparent}",
	"actionbutton_combination_normal_tertiary_inner-container_behavior_active_background-color": "{global.transparent}",
	"actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-width": "{border_focus}",
	"actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-radius": "{custom_1}",
	"actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
	"actionbutton_combination_normal_tertiary_left-icon_color": "{primary60}",
	"actionbutton_combination_normal_tertiary_left-icon_behavior_hover_color": "{primary50}",
	"actionbutton_combination_normal_tertiary_left-icon_behavior_active_color": "{primary70}",
	"actionbutton_combination_normal_tertiary_right-icon_color": "{primary60}",
	"actionbutton_combination_normal_tertiary_right-icon_behavior_hover_color": "{primary50}",
	"actionbutton_combination_normal_tertiary_right-icon_behavior_active_color": "{primary70}",
	"actionbutton_combination_positive_primary_inner-container_background-color": "{feedbackSuccess50}",
	"actionbutton_combination_positive_primary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
	"actionbutton_combination_positive_primary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_primary_inner-container_behavior_focus_border-color": "{primary60}",
	"actionbutton_combination_positive_primary_left-icon_color": "{global.white}",
	"actionbutton_combination_positive_primary_left-icon_behavior_hover_color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_primary_left-icon_behavior_active_color": "{primaryBackground}",
	"actionbutton_combination_positive_primary_right-icon_color": "{global.white}",
	"actionbutton_combination_positive_primary_right-icon_behavior_hover_color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_primary_right-icon_behavior_active_color": "{primaryBackground}",
	"actionbutton_combination_positive_secondary_inner-container_background-color": "{global.transparent}",
	"actionbutton_combination_positive_secondary_inner-container_border-width": "{border_thin}",
	"actionbutton_combination_positive_secondary_inner-container_border-color": "{primaryGrey60}",
	"actionbutton_combination_positive_secondary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
	"actionbutton_combination_positive_secondary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_secondary_inner-container_behavior_focus_border-color": "{primary60}",
	"actionbutton_combination_positive_secondary_left-icon_color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_secondary_left-icon_behavior_hover_color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_secondary_left-icon_behavior_active_color": "{primaryBackground}",
	"actionbutton_combination_positive_secondary_right-icon_color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_secondary_right-icon_behavior_hover_color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_secondary_right-icon_behavior_active_color": "{primaryBackground}",
	"actionbutton_combination_positive_tertiary_inner-container_background-color": "{global.transparent}",
	"actionbutton_combination_positive_tertiary_inner-container_border-radius": "{custom_1}",
	"actionbutton_combination_positive_tertiary_inner-container_behavior_hover_background-color": "{global.transparent}",
	"actionbutton_combination_positive_tertiary_inner-container_behavior_active_background-color": "{global.transparent}",
	"actionbutton_combination_positive_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
	"actionbutton_combination_positive_tertiary_left-icon_color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_tertiary_left-icon_behavior_hover_color": "{feedbackSuccess50}",
	"actionbutton_combination_positive_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
	"actionbutton_combination_positive_tertiary_right-icon_color": "{feedbackSuccess80}",
	"actionbutton_combination_positive_tertiary_right-icon_behavior_hover_color": "{feedbackSuccess50}",
	"actionbutton_combination_positive_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
	"actionbutton_combination_negative_primary_inner-container_background-color": "{feedbackError50}",
	"actionbutton_combination_negative_primary_inner-container_behavior_hover_background-color": "{feedbackError20}",
	"actionbutton_combination_negative_primary_inner-container_behavior_active_background-color": "{feedbackError80}",
	"actionbutton_combination_negative_primary_inner-container_behavior_focus_border-color": "{primary60}",
	"actionbutton_combination_negative_primary_left-icon_color": "{global.white}",
	"actionbutton_combination_negative_primary_left-icon_behavior_hover_color": "{feedbackError80}",
	"actionbutton_combination_negative_primary_left-icon_behavior_active_color": "{primaryBackground}",
	"actionbutton_combination_negative_primary_right-icon_color": "{global.white}",
	"actionbutton_combination_negative_primary_right-icon_behavior_hover_color": "{feedbackError80}",
	"actionbutton_combination_negative_primary_right-icon_behavior_active_color": "{primaryBackground}",
	"actionbutton_combination_negative_secondary_inner-container_background-color": "{global.transparent}",
	"actionbutton_combination_negative_secondary_inner-container_border-width": "{border_thin}",
	"actionbutton_combination_negative_secondary_inner-container_border-color": "{primaryGrey60}",
	"actionbutton_combination_negative_secondary_inner-container_behavior_hover_background-color": "{feedbackError20}",
	"actionbutton_combination_negative_secondary_inner-container_behavior_active_background-color": "{feedbackError80}",
	"actionbutton_combination_negative_secondary_inner-container_behavior_focus_border-color": "{primary60}",
	"actionbutton_combination_negative_secondary_left-icon_color": "{feedbackError80}",
	"actionbutton_combination_negative_secondary_left-icon_behavior_hover_color": "{feedbackError80}",
	"actionbutton_combination_negative_secondary_left-icon_behavior_active_color": "{primaryBackground}",
	"actionbutton_combination_negative_secondary_right-icon_color": "{feedbackError80}",
	"actionbutton_combination_negative_secondary_right-icon_behavior_hover_color": "{feedbackError80}",
	"actionbutton_combination_negative_secondary_right-icon_behavior_active_color": "{primaryBackground}",
	"actionbutton_combination_negative_tertiary_inner-container_background-color": "{global.transparent}",
	"actionbutton_combination_negative_tertiary_inner-container_border-radius": "{pill}",
	"actionbutton_combination_negative_tertiary_inner-container_behavior_hover_background-color": "{global.transparent}",
	"actionbutton_combination_negative_tertiary_inner-container_behavior_active_background-color": "{global.transparent}",
	"actionbutton_combination_negative_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
	"actionbutton_combination_negative_tertiary_left-icon_color": "{feedbackError80}",
	"actionbutton_combination_negative_tertiary_left-icon_behavior_hover_color": "{feedbackError50}",
	"actionbutton_combination_negative_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
	"actionbutton_combination_negative_tertiary_right-icon_color": "{feedbackError80}",
	"actionbutton_combination_negative_tertiary_right-icon_behavior_hover_color": "{feedbackError50}",
	"actionbutton_combination_negative_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_primary_inner-container_background-color": "{primaryBackground}",
	"actionbutton_combination_contrast_primary_inner-container_behavior_hover_background-color": "{primary20}",
	"actionbutton_combination_contrast_primary_inner-container_behavior_active_background-color": "{primary30}",
	"actionbutton_combination_contrast_primary_inner-container_behavior_focus_border-color": "{primary50}",
	"actionbutton_combination_contrast_primary_left-icon_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_primary_left-icon_behavior_hover_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_primary_left-icon_behavior_active_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_primary_right-icon_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_primary_right-icon_behavior_hover_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_primary_right-icon_behavior_active_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_secondary_inner-container_background-color": "{global.transparent}",
	"actionbutton_combination_contrast_secondary_inner-container_border-width": "{border_thin}",
	"actionbutton_combination_contrast_secondary_inner-container_border-color": "{primaryGrey60}",
	"actionbutton_combination_contrast_secondary_inner-container_behavior_hover_background-color": "{primary20}",
	"actionbutton_combination_contrast_secondary_inner-container_behavior_active_background-color": "{primary30}",
	"actionbutton_combination_contrast_secondary_inner-container_behavior_focus_border-width": "{border_focus}",
	"actionbutton_combination_contrast_secondary_inner-container_behavior_focus_border-color": "{primary50}",
	"actionbutton_combination_contrast_secondary_left-icon_color": "{primaryBackground}",
	"actionbutton_combination_contrast_secondary_left-icon_behavior_hover_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_secondary_left-icon_behavior_active_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_secondary_right-icon_color": "{primaryBackground}",
	"actionbutton_combination_contrast_secondary_right-icon_behavior_hover_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_secondary_right-icon_behavior_active_color": "{primaryGrey100}",
	"actionbutton_combination_contrast_tertiary_inner-container_background-color": "{global.transparent}",
	"actionbutton_combination_contrast_tertiary_inner-container_border-radius": "{pill}",
	"actionbutton_combination_contrast_tertiary_inner-container_behavior_hover_background-color": "{global.transparent}",
	"actionbutton_combination_contrast_tertiary_inner-container_behavior_active_background-color": "{global.transparent}",
	"actionbutton_combination_contrast_tertiary_inner-container_behavior_focus_border-width": "{border_focus}",
	"actionbutton_combination_contrast_tertiary_inner-container_behavior_focus_border-color": "{primary50}",
	"actionbutton_combination_contrast_tertiary_left-icon_color": "{primaryBackground}",
	"actionbutton_combination_contrast_tertiary_left-icon_behavior_hover_color": "{primary20}",
	"actionbutton_combination_contrast_tertiary_left-icon_behavior_active_color": "{primary30}",
	"actionbutton_combination_contrast_tertiary_right-icon_color": "{primaryBackground}",
	"actionbutton_combination_contrast_tertiary_right-icon_behavior_hover_color": "{primary20}",
	"actionbutton_combination_contrast_tertiary_right-icon_behavior_active_color": "{primary30}",
	"actionbutton_combination_false_small_left-icon_size": "{base}",
	actionbutton_combination_false_small_loader_size: actionbutton_combination_false_small_loader_size,
	"actionbutton_combination_false_large_left-icon_size": "{m}",
	actionbutton_combination_false_large_loader_size: actionbutton_combination_false_large_loader_size,
	"actionbutton_combination_false_extra-large_left-icon_size": "{l}",
	"actionbutton_combination_false_extra-large_loader_size": "{l}",
	actionbutton_combination_true_true_container_width: actionbutton_combination_true_true_container_width,
	"actionbutton_combination_true_true_inner-container_width": "{size.max}"
};

const accordion_base_container_width = "{size.max}";
const accordion_base_container_opacity = "{opacity.enabled}";
const accordion_variant_disabled_true_container_opacity = "{opacity.disabled}";
const accordion_combination_plus_true_jds_button_icon = "ic_minus";
const accordion_combination_plus_false_jds_button_icon = "ic_add";
const accordion_combination_chevron_true_jds_button_icon = "ic_chevron_up";
const accordion_combination_chevron_false_jds_button_icon = "ic_chevron_down";
const AccordionTokens = {
	"accordion_base_container_flex-direction": "{flexDirection.column}",
	accordion_base_container_width: accordion_base_container_width,
	"accordion_base_accordion-header-container_flex-direction": "{flexDirection.row}",
	"accordion_base_accordion-header-container_align-items": "{alignItems.center}",
	"accordion_base_accordion-header-container_justify-content": "{justifyContent.start}",
	"accordion_base_accordion-header-container_width": "{size.max}",
	"accordion_base_accordion-header-container_padding-top": "{xxs}",
	"accordion_base_accordion-header-container_gap": "{s}",
	"accordion_base_text-container_flex-direction": "{flexDirection.column}",
	"accordion_base_text-container_justify-content": "{justifyContent.start}",
	"accordion_base_text-container_align-items": "{alignItems.start}",
	"accordion_base_text-container_gap": "{xxs}",
	"accordion_base_children-container_padding-top": "0",
	"accordion_base_children-container_width": "{size.max}",
	"accordion_base_child-content-container_width": "{size.max}",
	accordion_base_container_opacity: accordion_base_container_opacity,
	"accordion_variant_expandedPanel_true_children-container_padding-top": "{base}",
	accordion_variant_disabled_true_container_opacity: accordion_variant_disabled_true_container_opacity,
	accordion_combination_plus_true_jds_button_icon: accordion_combination_plus_true_jds_button_icon,
	accordion_combination_plus_false_jds_button_icon: accordion_combination_plus_false_jds_button_icon,
	accordion_combination_chevron_true_jds_button_icon: accordion_combination_chevron_true_jds_button_icon,
	accordion_combination_chevron_false_jds_button_icon: accordion_combination_chevron_false_jds_button_icon
};

const badge_base_container_gap = "{xxs}";
const badge_base_icon_size = "{base}";
const badge_base_icon_color = "{sparkleGrey20}";
const badge_base_text_color = "{sparkleGrey20}";
const badge_variant_kind_service_container_gap = "{xs}";
const badge_variant_kind_service_text_color = "{global.white}";
const badge_variant_kind_service_icon_size = "{m}";
const badge_variant_kind_service_icon_color = "{custom_color_1}";
const badge_combination_normal_small_icon_size = "{s}";
const badge_combination_normal_large_container_gap = "{xs}";
const badge_combination_normal_large_icon_size = "{m}";
const BadgeTokens = {
	"badge_base_container_flex-direction": "{flexDirection.row}",
	"badge_base_container_justify-content": "{justifyContent.center}",
	"badge_base_container_align-items": "{alignItems.center}",
	"badge_base_container_padding-top": "{xxs}",
	"badge_base_container_padding-left": "{xs}",
	"badge_base_container_padding-right": "{xs}",
	"badge_base_container_padding-bottom": "{xxs}",
	badge_base_container_gap: badge_base_container_gap,
	"badge_base_container_background-color": "{sparkle60}",
	"badge_base_container_border-radius": "{medium}",
	badge_base_icon_size: badge_base_icon_size,
	badge_base_icon_color: badge_base_icon_color,
	"badge_base_icon_justify-content": "{justifyContent.start}",
	"badge_base_icon_align-items": "{alignItems.start}",
	"badge_base_text_font-family": "{bodySBold}",
	"badge_base_text_font-size": "{bodySBold}",
	"badge_base_text_line-height": "{bodySBold}",
	"badge_base_text_letter-spacing": "{bodySBold}",
	"badge_base_text_font-weight": "{bodySBold}",
	badge_base_text_color: badge_base_text_color,
	"badge_base_text_text-transform": "{text-case.uppercase}",
	"badge_variant_kind_service_container_border-radius": "{pill}",
	"badge_variant_kind_service_container_background-color": "{custom_color_2}",
	"badge_variant_kind_service_container_padding-top": "{xxs}",
	"badge_variant_kind_service_container_padding-left": "{xxs}",
	"badge_variant_kind_service_container_padding-right": "{s}",
	"badge_variant_kind_service_container_padding-bottom": "{xxs}",
	badge_variant_kind_service_container_gap: badge_variant_kind_service_container_gap,
	"badge_variant_kind_service_text_font-family": "{bodyMBold}",
	"badge_variant_kind_service_text_font-size": "{bodyMBold}",
	"badge_variant_kind_service_text_line-height": "{bodyMBold}",
	"badge_variant_kind_service_text_letter-spacing": "{bodyMBold}",
	"badge_variant_kind_service_text_font-weight": "{bodyMBold}",
	badge_variant_kind_service_text_color: badge_variant_kind_service_text_color,
	badge_variant_kind_service_icon_size: badge_variant_kind_service_icon_size,
	badge_variant_kind_service_icon_color: badge_variant_kind_service_icon_color,
	"badge_combination_normal_small_container_border-radius": "{small}",
	badge_combination_normal_small_icon_size: badge_combination_normal_small_icon_size,
	"badge_combination_normal_small_text_font-family": "{bodyXxsBold}",
	"badge_combination_normal_small_text_font-size": "{bodyXxsBold}",
	"badge_combination_normal_small_text_line-height": "{bodyXxsBold}",
	"badge_combination_normal_small_text_letter-spacing": "{bodyXxsBold}",
	"badge_combination_normal_small_text_font-weight": "{bodyXxsBold}",
	"badge_combination_normal_large_container_padding-left": "{s}",
	"badge_combination_normal_large_container_padding-right": "{s}",
	badge_combination_normal_large_container_gap: badge_combination_normal_large_container_gap,
	badge_combination_normal_large_icon_size: badge_combination_normal_large_icon_size,
	"badge_combination_normal_large_text_font-family": "{bodyLBold}",
	"badge_combination_normal_large_text_font-size": "{bodyLBold}",
	"badge_combination_normal_large_text_line-height": "{bodyLBold}",
	"badge_combination_normal_large_text_letter-spacing": "{bodyLBold}",
	"badge_combination_normal_large_text_font-weight": "{bodyLBold}"
};

const badgev2brand_base_container_gap = "{xxs}";
const badgev2brand_variant_kind_circle_container_padding = "{custom_5}";
const badgev2brand_variant_kind_square_container_padding = "{custom_5}";
const badgev2brand_combination_circle_medium_container_padding = "{custom_5}";
const badgev2brand_combination_circle_large_container_padding = "{custom_5}";
const badgev2brand_combination_square_medium_container_padding = "{custom_5}";
const badgev2brand_combination_square_large_container_padding = "{custom_5}";
const BadgeV2BrandTokens = {
	"badgev2brand_base_container_flex-direction": "{flexDirection.row}",
	"badgev2brand_base_container_justify-content": "{justifyContent.center}",
	"badgev2brand_base_container_align-items": "{alignItems.center}",
	"badgev2brand_base_container_background-color": "{primary50}",
	badgev2brand_base_container_gap: badgev2brand_base_container_gap,
	"badgev2brand_base_container_border-radius": "{pill}",
	"badgev2brand_base_container_padding-left": "{xs}",
	"badgev2brand_base_container_padding-right": "{s}",
	"badgev2brand_base_container_padding-top": "{xxs}",
	"badgev2brand_base_container_padding-bottom": "{xxs}",
	"badgev2brand_base_image-container_border-radius": "{pill}",
	"badgev2brand_base_image-container_size": "{custom_18}",
	"badgev2brand_variant_kind_square_image-container_border-radius": "{medium}",
	"badgev2brand_variant_kind_square-container_border-radius": "{medium}",
	"badgev2brand_variant_kind_square_brand-jds_image_border-radius": "{medium}",
	"badgev2brand_variant_kind_square-label_container_border-radius": "{medium}",
	"badgev2brand_variant_kind_square-label_image-container_border-radius": "{small}",
	"badgev2brand_variant_size_medium_container_padding-left": "{xxs}",
	"badgev2brand_variant_size_medium_container_padding-right": "{xxs}",
	"badgev2brand_variant_size_medium_container_padding-top": "{custom_5}",
	"badgev2brand_variant_size_medium_container_padding-bottom": "{custom_5}",
	"badgev2brand_variant_size_medium_image-container_size": "{s}",
	"badgev2brand_variant_size_large_container_padding-left": "{xxs}",
	"badgev2brand_variant_size_large_container_padding-right": "{xs}",
	"badgev2brand_variant_size_large_container_padding-top": "{custom_4}",
	"badgev2brand_variant_size_large_container_padding-bottom": "{custom_4}",
	"badgev2brand_variant_size_large_image-container_size": "{s}",
	"badgev2brand_variant_size_xtra-large_container_padding-left": "{xxs}",
	"badgev2brand_variant_size_xtra-large_container_padding-right": "{xs}",
	"badgev2brand_variant_size_xtra-large_container_padding-top": "{custom_4}",
	"badgev2brand_variant_size_xtra-large_container_padding-bottom": "{custom_4}",
	"badgev2brand_variant_size_xtra-large_image-container_size": "{base}",
	"badgev2brand_variant_size_xtra-xtra-large_container_padding-left": "{xxs}",
	"badgev2brand_variant_size_xtra-xtra-large_container_padding-right": "{xs}",
	"badgev2brand_variant_size_xtra-xtra-large_container_padding-top": "{xxs}",
	"badgev2brand_variant_size_xtra-xtra-large_container_padding-bottom": "{xxs}",
	"badgev2brand_variant_size_xtra-xtra-large_image-container_size": "{custom_18}",
	"badgev2brand_variant_size_xtra-xtra-xtra-xtra-large_container_padding": "{xs}",
	"badgev2brand_variant_size_xtra-xtra-xtra-xtra-large_image-container_size": "{custom_3}",
	"badgev2brand_variant_emphasis_bold_container_background-color": "{primary60}",
	badgev2brand_variant_kind_circle_container_padding: badgev2brand_variant_kind_circle_container_padding,
	badgev2brand_variant_kind_square_container_padding: badgev2brand_variant_kind_square_container_padding,
	badgev2brand_combination_circle_medium_container_padding: badgev2brand_combination_circle_medium_container_padding,
	"badgev2brand_combination_circle_medium_image-container_size": "{base}",
	badgev2brand_combination_circle_large_container_padding: badgev2brand_combination_circle_large_container_padding,
	"badgev2brand_combination_circle_large_image-container_size": "{custom_18}",
	"badgev2brand_combination_circle_xtra-large_container_padding": "{custom_5}",
	"badgev2brand_combination_circle_xtra-large_image-container_size": "{m}",
	"badgev2brand_combination_circle_xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2brand_combination_circle_xtra-xtra-large_image-container_size": "{custom_3}",
	"badgev2brand_combination_circle_xtra-xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2brand_combination_circle_xtra-xtra-xtra-large_image-container_size": "{l}",
	"badgev2brand_combination_circle_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2brand_combination_circle_xtra-xtra-xtra-xtra-large_image-container_size": "{xl}",
	"badgev2brand_combination_square_medium_container_border-radius": "{small}",
	badgev2brand_combination_square_medium_container_padding: badgev2brand_combination_square_medium_container_padding,
	"badgev2brand_combination_square_medium_image-container_size": "{base}",
	"badgev2brand_combination_square_medium_image-container_border-radius": "{small}",
	"badgev2brand_combination_square_large_container_border-radius": "{small}",
	badgev2brand_combination_square_large_container_padding: badgev2brand_combination_square_large_container_padding,
	"badgev2brand_combination_square_large_image-container_size": "{custom_18}",
	"badgev2brand_combination_square_large_image-container_border-radius": "{small}",
	"badgev2brand_combination_square_xtra-large_container_border-radius": "{small}",
	"badgev2brand_combination_square_xtra-large_container_padding": "{custom_5}",
	"badgev2brand_combination_square_xtra-large_image-container_size": "{m}",
	"badgev2brand_combination_square_xtra-large_image-container_border-radius": "{small}",
	"badgev2brand_combination_square_xtra-xtra-large_container_border-radius": "{small}",
	"badgev2brand_combination_square_xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2brand_combination_square_xtra-xtra-large_image-container_size": "{custom_3}",
	"badgev2brand_combination_square_xtra-xtra-large_image-container_border-radius": "{small}",
	"badgev2brand_combination_square_xtra-xtra-xtra-large_image-container_size": "{l}",
	"badgev2brand_combination_square_xtra-xtra-xtra-xtra-large_image-container_size": "{xl}",
	"badgev2brand_combination_square-label_xtra-xtra-xtra-xtra-large_image-container_border-radius": "{medium}",
	"badgev2brand_combination_square-label_medium_container_border-radius": "{small}",
	"badgev2brand_combination_square-label_large_container_border-radius": "{small}",
	"badgev2brand_combination_square-label_large_container_padding-right": "{xxs}",
	"badgev2brand_combination_square-label_xtra-large_container_border-radius": "{small}",
	"badgev2brand_combination_square-label_xtra-large_container_padding-right": "{xxs}",
	"badgev2brand_combination_square-label_xtra-xtra-large_container_padding-left": "{xs}",
	"badgev2brand_combination_square-label_xtra-xtra-large_image-container_size": "{base}",
	"badgev2brand_combination_square-label_xtra-xtra-xtra-large_container_padding-right": "{xs}",
	"badgev2brand_combination_square-label_xtra-xtra-large_container_border-radius": "{small}",
	"badgev2brand_combination_square-label_xtra-xtra-xtra-xtra-large_container_padding-right": "{xs}"
};

const badgev2information_base_container_gap = "{xxs}";
const badgev2information_base_icon_color = "{primaryBackground}";
const badgev2information_base_icon_size = "{base}";
const badgev2information_variant_color_secondary_icon_color = "{primaryBackground}";
const badgev2information_variant_size_small_icon_size = "{s}";
const badgev2information_variant_size_medium_icon_size = "{s}";
const badgev2information_variant_border_true_container_padding = "{custom_16}";
const badgev2information_combination_icon_small_container_padding = "{custom_5}";
const badgev2information_combination_icon_small_icon_size = "{s}";
const badgev2information_combination_icon_medium_container_padding = "{custom_5}";
const badgev2information_combination_icon_medium_icon_size = "{base}";
const badgev2information_combination_icon_large_container_padding = "{custom_5}";
const badgev2information_combination_icon_large_icon_size = "{custom_18}";
const badgev2information_combination_label_small_container_size = "{base}";
const badgev2information_combination_label_medium_container_size = "{base}";
const badgev2information_combination_label_large_container_size = "{custom_18}";
const badgev2information_combination_subtle_default_icon_color = "{sparkle60}";
const badgev2information_combination_subtle_positive_icon_color = "{feedbackSuccess50}";
const badgev2information_combination_subtle_warning_icon_color = "{feedbackWarning50}";
const badgev2information_combination_subtle_negative_icon_color = "{feedbackError50}";
const badgev2information_combination_subtle_neutral_icon_color = "{primaryGrey80}";
const badgev2information_combination_icon_bold_default_icon_color = "{sparkle60}";
const badgev2information_combination_icon_bold_positive_icon_color = "{feedbackSuccess50}";
const badgev2information_combination_icon_bold_warning_icon_color = "{feedbackWarning50}";
const badgev2information_combination_icon_bold_negative_icon_color = "{feedbackError50}";
const badgev2information_combination_icon_bold_neutral_icon_color = "{primaryGrey80}";
const badgev2information_combination_icon_subtle_default_icon_color = "{sparkle60}";
const badgev2information_combination_icon_subtle_positive_icon_color = "{feedbackSuccess50}";
const badgev2information_combination_icon_subtle_warning_icon_color = "{feedbackWarning50}";
const badgev2information_combination_icon_subtle_negative_icon_color = "{feedbackError50}";
const badgev2information_combination_icon_subtle_neutral_icon_color = "{primaryGrey80}";
const badgev2information_combination_true_small_container_padding = "{custom_4}";
const badgev2information_combination_true_medium_container_padding = "{custom_4}";
const badgev2information_combination_true_large_container_padding = "{custom_16}";
const badgev2information_combination_icon_subtle_secondary_icon_color = "{secondary60}";
const badgev2information_combination_icon_bold_secondary_icon_color = "{secondary60}";
const badgev2information_combination_subtle_secondary_icon_color = "{secondary60}";
const badgev2information_combination_true_icon_container_padding = "{custom_5}";
const BadgeV2InformationTokens = {
	"badgev2information_base_outer-container_border-radius": "{small}",
	"badgev2information_base_outer-container_align-items": "{alignItems.center}",
	"badgev2information_base_container_flex-direction": "{flexDirection.row}",
	"badgev2information_base_container_justify-content": "{justifyContent.center}",
	"badgev2information_base_container_align-items": "{alignItems.center}",
	"badgev2information_base_container_background-color": "{sparkle60}",
	badgev2information_base_container_gap: badgev2information_base_container_gap,
	"badgev2information_base_container_border-radius": "{small}",
	"badgev2information_base_container_padding-left": "{xxs}",
	"badgev2information_base_container_padding-right": "{xs}",
	"badgev2information_base_container_padding-top": "{custom_4}",
	"badgev2information_base_container_padding-bottom": "{custom_4}",
	"badgev2information_base_icon-container_flex-direction": "{flexDirection.row}",
	"badgev2information_base_icon-container_justify-content": "{justifyContent.center}",
	"badgev2information_base_icon-container_align-items": "{alignItems.center}",
	"badgev2information_base_icon-container_size": "{base}",
	badgev2information_base_icon_color: badgev2information_base_icon_color,
	badgev2information_base_icon_size: badgev2information_base_icon_size,
	"badgev2information_base_image-container_flex-direction": "{flexDirection.row}",
	"badgev2information_base_image-container_justify-content": "{justifyContent.center}",
	"badgev2information_base_image-container_align-items": "{alignItems.center}",
	"badgev2information_base_image-container_size": "{base}",
	"badgev2information_variant_color_secondary_container_background-color": "{secondary60}",
	"badgev2information_variant_color_secondary_icon-container_background-color": "{secondary60}",
	badgev2information_variant_color_secondary_icon_color: badgev2information_variant_color_secondary_icon_color,
	"badgev2information_variant_size_xtra-small_inner-container_padding-right": "{xxs}",
	"badgev2information_variant_size_xtra-small_inner-container_padding-top": "{custom_5}",
	"badgev2information_variant_size_xtra-small_inner-container_padding-bottom": "{custom_5}",
	"badgev2information_variant_size_xtra-small_icon-container_size": "{s}",
	"badgev2information_variant_size_xtra-small_icon_size": "{s}",
	"badgev2information_variant_size_xtra-small_image-container_size": "{s}",
	"badgev2information_variant_size_small_inner-container_padding-right": "{xxs}",
	"badgev2information_variant_size_small_inner-container_padding-top": "{custom_5}",
	"badgev2information_variant_size_small_inner-container_padding-bottom": "{custom_5}",
	"badgev2information_variant_size_small_icon-container_size": "{s}",
	badgev2information_variant_size_small_icon_size: badgev2information_variant_size_small_icon_size,
	"badgev2information_variant_size_small_image-container_size": "{s}",
	"badgev2information_variant_size_medium_inner-container_padding-right": "{xxs}",
	"badgev2information_variant_size_medium_inner-container_padding-top": "{custom_5}",
	"badgev2information_variant_size_medium_inner-container_padding-bottom": "{custom_5}",
	"badgev2information_variant_size_medium_icon-container_size": "{s}",
	badgev2information_variant_size_medium_icon_size: badgev2information_variant_size_medium_icon_size,
	"badgev2information_variant_size_medium_image-container_size": "{s}",
	"badgev2information_variant_size_xtra-xtra-large_inner-container_padding-left": "{xs}",
	"badgev2information_variant_size_xtra-xtra-large_inner-container_padding-top": "{xxs}",
	"badgev2information_variant_size_xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
	"badgev2information_variant_size_xtra-xtra-xtra-large_container_border-radius": "{medium}",
	"badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_border-radius": "{medium}",
	"badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-left": "{xs}",
	"badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-top": "{xxs}",
	"badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
	"badgev2information_variant_size_xtra-xtra-xtra-large_icon-container_size": "{custom_18}",
	"badgev2information_variant_size_xtra-xtra-xtra-large_icon_size": "{custom_18}",
	"badgev2information_variant_size_xtra-xtra-xtra-large_image-container_size": "{custom_18}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_container_border-radius": "{medium}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_border-radius": "{medium}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-left": "{xs}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-right": "{s}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-top": "{xxs}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_icon-container_size": "{custom_3}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_icon_size": "{custom_3}",
	"badgev2information_variant_size_xtra-xtra-xtra-xtra-large_image-container_size": "{custom_3}",
	"badgev2information_variant_color_positive_container_background-color": "{feedbackSuccess50}",
	"badgev2information_variant_color_positive_icon-container_background-color": "{feedbackSuccess50}",
	"badgev2information_variant_color_warning_container_background-color": "{feedbackWarning50}",
	"badgev2information_variant_color_warning_icon-container_background-color": "{feedbackWarning50}",
	"badgev2information_variant_color_negative_container_background-color": "{feedbackError50}",
	"badgev2information_variant_color_negative_icon-container_background-color": "{feedbackError50}",
	"badgev2information_variant_color_neutral_container_background-color": "{primaryGrey80}",
	"badgev2information_variant_color_neutral_icon-container_background-color": "{global.transparent}",
	badgev2information_variant_border_true_container_padding: badgev2information_variant_border_true_container_padding,
	"badgev2information_variant_border_true_container_border-color": "{primaryBackground}",
	"badgev2information_combination_icon_xtra-small_container_padding": "{custom_5}",
	"badgev2information_combination_icon_xtra-small_icon-container_size": "{xs}",
	"badgev2information_combination_icon_xtra-small_icon_size": "{xs}",
	badgev2information_combination_icon_small_container_padding: badgev2information_combination_icon_small_container_padding,
	"badgev2information_combination_icon_small_icon-container_size": "{s}",
	badgev2information_combination_icon_small_icon_size: badgev2information_combination_icon_small_icon_size,
	badgev2information_combination_icon_medium_container_padding: badgev2information_combination_icon_medium_container_padding,
	"badgev2information_combination_icon_medium_icon-container_size": "{base}",
	badgev2information_combination_icon_medium_icon_size: badgev2information_combination_icon_medium_icon_size,
	badgev2information_combination_icon_large_container_padding: badgev2information_combination_icon_large_container_padding,
	"badgev2information_combination_icon_xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon_xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon_xtra-xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon_large_icon-container_size": "{custom_18}",
	badgev2information_combination_icon_large_icon_size: badgev2information_combination_icon_large_icon_size,
	"badgev2information_combination_icon_xtra-large_icon-container_size": "{m}",
	"badgev2information_combination_icon_xtra-large_icon_size": "{m}",
	"badgev2information_combination_icon_xtra-xtra-large_icon-container_size": "{custom_3}",
	"badgev2information_combination_icon_xtra-xtra-large_icon_size": "{custom_3}",
	"badgev2information_combination_icon_xtra-xtra-xtra-large_icon-container_size": "{l}",
	"badgev2information_combination_icon_xtra-xtra-xtra-large_icon_size": "{l}",
	"badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
	"badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_icon_size": "{xl}",
	"badgev2information_combination_icon-circle_xtra-small_outer-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-small_container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-small_container_padding": "{custom_5}",
	"badgev2information_combination_icon-circle_xtra-small_icon-container_size": "{s}",
	"badgev2information_combination_icon-circle_xtra-small_icon-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-small_icon_size": "{xs}",
	"badgev2information_combination_icon-circle_small_outer-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_small_container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_small_container_padding": "{custom_5}",
	"badgev2information_combination_icon-circle_small_icon-container_size": "{s}",
	"badgev2information_combination_icon-circle_small_icon-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_small_icon_size": "{xs}",
	"badgev2information_combination_icon-circle_medium_container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_medium_container_padding": "{custom_5}",
	"badgev2information_combination_icon-circle_medium_icon-container_size": "{base}",
	"badgev2information_combination_icon-circle_medium_icon-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_medium_icon_size": "{custom_19}",
	"badgev2information_combination_icon-circle_large_container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-circle_large_icon-container_size": "{custom_18}",
	"badgev2information_combination_icon-circle_large_icon-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_large_icon_size": "{s}",
	"badgev2information_combination_icon-circle_xtra-large_container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-circle_xtra-large_icon-container_size": "{m}",
	"badgev2information_combination_icon-circle_xtra-large_icon-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-large_icon_size": "{base}",
	"badgev2information_combination_icon-circle_xtra-xtra-large_container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-circle_xtra-xtra-large_icon-container_size": "{custom_3}",
	"badgev2information_combination_icon-circle_xtra-xtra-large_icon-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-xtra-large_icon_size": "{base}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-large_container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon-container_size": "{l}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon_size": "{custom_18}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon-container_border-radius": "{pill}",
	"badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon_size": "{m}",
	"badgev2information_combination_icon-square_xtra-small_outer-container_border-radius": "{small}",
	"badgev2information_combination_icon-square_xtra-small_container_border-radius": "{small}",
	"badgev2information_combination_icon-square_xtra-small_container_padding": "{custom_5}",
	"badgev2information_combination_icon-square_xtra-small_icon-container_size": "{s}",
	"badgev2information_combination_icon-square_xtra-small_icon-container_border-radius": "{small}",
	"badgev2information_combination_icon-square_xtra-small_icon_size": "{xs}",
	"badgev2information_combination_icon-square_small_container_border-radius": "{small}",
	"badgev2information_combination_icon-square_small_container_padding": "{custom_5}",
	"badgev2information_combination_icon-square_small_icon-container_size": "{s}",
	"badgev2information_combination_icon-square_small_icon-container_border-radius": "{small}",
	"badgev2information_combination_icon-square_small_icon_size": "{xs}",
	"badgev2information_combination_icon-square_medium_container_border-radius": "{small}",
	"badgev2information_combination_icon-square_medium_container_padding": "{custom_5}",
	"badgev2information_combination_icon-square_medium_icon-container_size": "{base}",
	"badgev2information_combination_icon-square_medium_icon-container_border-radius": "{small}",
	"badgev2information_combination_icon-square_medium_icon_size": "{custom_19}",
	"badgev2information_combination_icon-square_large_container_border-radius": "{small}",
	"badgev2information_combination_icon-square_large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-square_large_icon-container_size": "{custom_18}",
	"badgev2information_combination_icon-square_large_icon-container_border-radius": "{small}",
	"badgev2information_combination_icon-square_large_icon_size": "{s}",
	"badgev2information_combination_icon-square_xtra-large_container_border-radius": "{small}",
	"badgev2information_combination_icon-square_xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-square_xtra-large_icon-container_size": "{m}",
	"badgev2information_combination_icon-square_xtra-large_icon-container_border-radius": "{small}",
	"badgev2information_combination_icon-square_xtra-large_icon_size": "{base}",
	"badgev2information_combination_icon-square_xtra-xtra-large_container_border-radius": "{small}",
	"badgev2information_combination_icon-square_xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-square_xtra-xtra-large_icon-container_size": "{custom_3}",
	"badgev2information_combination_icon-square_xtra-xtra-large_icon-container_border-radius": "{small}",
	"badgev2information_combination_icon-square_xtra-xtra-large_icon_size": "{base}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-large_container_border-radius": "{medium}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon-container_size": "{l}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon-container_border-radius": "{medium}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon_size": "{custom_18}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_container_border-radius": "{custom_1}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon-container_border-radius": "{custom_1}",
	"badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon_size": "{m}",
	"badgev2information_combination_label_xtra-small_container_size": "{base}",
	badgev2information_combination_label_small_container_size: badgev2information_combination_label_small_container_size,
	badgev2information_combination_label_medium_container_size: badgev2information_combination_label_medium_container_size,
	badgev2information_combination_label_large_container_size: badgev2information_combination_label_large_container_size,
	"badgev2information_combination_label_large_inner-container_padding-left": "{xs}",
	"badgev2information_combination_label_xtra-large_container_size": "{m}",
	"badgev2information_combination_label_xtra-large_inner-container_padding-left": "{xs}",
	"badgev2information_combination_label_xtra-xtra-large_container_size": "{custom_3}",
	"badgev2information_combination_label_xtra-xtra-xtra-large_container_size": "{l}",
	"badgev2information_combination_label_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
	"badgev2information_combination_label_xtra-xtra-xtra-xtra-large_inner-container_padding-left": "{s}",
	"badgev2information_combination_label-icon_xtra-small_container_size": "{base}",
	"badgev2information_combination_label-icon_small_container_size": "{base}",
	"badgev2information_combination_label-icon_medium_container_size": "{base}",
	"badgev2information_combination_label-icon_large_container_size": "{custom_18}",
	"badgev2information_combination_label-icon_xtra-large_container_size": "{m}",
	"badgev2information_combination_label-icon_xtra-xtra-large_container_size": "{custom_3}",
	"badgev2information_combination_label-icon_xtra-xtra-xtra-large_container_size": "{l}",
	"badgev2information_combination_label-icon_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
	"badgev2information_combination_label-image_xtra-small_container_size": "{base}",
	"badgev2information_combination_label-image_small_container_size": "{base}",
	"badgev2information_combination_label-image_medium_container_size": "{base}",
	"badgev2information_combination_label-image_large_container_size": "{custom_18}",
	"badgev2information_combination_label-image_xtra-large_container_size": "{m}",
	"badgev2information_combination_label-image_xtra-xtra-large_container_size": "{custom_3}",
	"badgev2information_combination_label-image_xtra-xtra-xtra-large_container_size": "{l}",
	"badgev2information_combination_label-image_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
	"badgev2information_combination_subtle_default_container_background-color": "{sparkle20}",
	"badgev2information_combination_subtle_default_icon-container_background-color": "{sparkle20}",
	badgev2information_combination_subtle_default_icon_color: badgev2information_combination_subtle_default_icon_color,
	"badgev2information_combination_subtle_positive_container_background-color": "{feedbackSuccess20}",
	"badgev2information_combination_subtle_positive_icon-container_background-color": "{feedbackSuccess20}",
	badgev2information_combination_subtle_positive_icon_color: badgev2information_combination_subtle_positive_icon_color,
	"badgev2information_combination_subtle_warning_container_background-color": "{feedbackWarning20}",
	"badgev2information_combination_subtle_warning_icon-container_background-color": "{feedbackWarning20}",
	badgev2information_combination_subtle_warning_icon_color: badgev2information_combination_subtle_warning_icon_color,
	"badgev2information_combination_subtle_negative_container_background-color": "{feedbackError20}",
	"badgev2information_combination_subtle_negative_icon-container_background-color": "{feedbackError20}",
	badgev2information_combination_subtle_negative_icon_color: badgev2information_combination_subtle_negative_icon_color,
	"badgev2information_combination_subtle_neutral_container_background-color": "{primaryGrey20}",
	"badgev2information_combination_subtle_neutral_icon-container_background-color": "{primaryGrey20}",
	badgev2information_combination_subtle_neutral_icon_color: badgev2information_combination_subtle_neutral_icon_color,
	"badgev2information_combination_icon_bold_default_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_bold_default_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_bold_default_icon_color: badgev2information_combination_icon_bold_default_icon_color,
	"badgev2information_combination_icon_bold_positive_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_bold_positive_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_bold_positive_icon_color: badgev2information_combination_icon_bold_positive_icon_color,
	"badgev2information_combination_icon_bold_warning_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_bold_warning_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_bold_warning_icon_color: badgev2information_combination_icon_bold_warning_icon_color,
	"badgev2information_combination_icon_bold_negative_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_bold_negative_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_bold_negative_icon_color: badgev2information_combination_icon_bold_negative_icon_color,
	"badgev2information_combination_icon_bold_neutral_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_bold_neutral_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_bold_neutral_icon_color: badgev2information_combination_icon_bold_neutral_icon_color,
	"badgev2information_combination_icon_subtle_default_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_subtle_default_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_subtle_default_icon_color: badgev2information_combination_icon_subtle_default_icon_color,
	"badgev2information_combination_icon_subtle_positive_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_subtle_positive_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_subtle_positive_icon_color: badgev2information_combination_icon_subtle_positive_icon_color,
	"badgev2information_combination_icon_subtle_warning_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_subtle_warning_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_subtle_warning_icon_color: badgev2information_combination_icon_subtle_warning_icon_color,
	"badgev2information_combination_icon_subtle_negative_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_subtle_negative_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_subtle_negative_icon_color: badgev2information_combination_icon_subtle_negative_icon_color,
	"badgev2information_combination_icon_subtle_neutral_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_subtle_neutral_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_subtle_neutral_icon_color: badgev2information_combination_icon_subtle_neutral_icon_color,
	"badgev2information_combination_true_xtra-small_container_padding": "{custom_4}",
	badgev2information_combination_true_small_container_padding: badgev2information_combination_true_small_container_padding,
	badgev2information_combination_true_medium_container_padding: badgev2information_combination_true_medium_container_padding,
	badgev2information_combination_true_large_container_padding: badgev2information_combination_true_large_container_padding,
	"badgev2information_combination_true_xtra-xtra-large_container_padding": "{custom_16}",
	"badgev2information_combination_true_xtra-xtra-xtra-large_container_padding": "{custom_16}",
	"badgev2information_combination_true_xtra-xtra-xtra-xtra-large_container_padding": "{xxs}",
	"badgev2information_combination_true_icon-circle_large_container_padding": "{custom_4}",
	"badgev2information_combination_true_icon-square_large_container_padding": "{custom_4}",
	"badgev2information_combination_icon_subtle_secondary_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_subtle_secondary_icon-container_background-color": "{global.transparent}",
	badgev2information_combination_icon_subtle_secondary_icon_color: badgev2information_combination_icon_subtle_secondary_icon_color,
	"badgev2information_combination_icon_bold_secondary_container_background-color": "{global.transparent}",
	"badgev2information_combination_icon_bold_secondary_icon-container_background-color": "{global.tansparent}",
	badgev2information_combination_icon_bold_secondary_icon_color: badgev2information_combination_icon_bold_secondary_icon_color,
	"badgev2information_combination_subtle_secondary_container_background-color": "{secondary20}",
	"badgev2information_combination_subtle_secondary_icon-container_background-color": "{secondary20}",
	badgev2information_combination_subtle_secondary_icon_color: badgev2information_combination_subtle_secondary_icon_color,
	"badgev2information_combination_true_icon_container_border-color": "{global.transparent}",
	badgev2information_combination_true_icon_container_padding: badgev2information_combination_true_icon_container_padding
};

const badgev2notification_base_container_width = "{xs}";
const badgev2notification_base_container_height = "{xs}";
const badgev2notification_base_container_padding = "{custom_5}";
const badgev2notification_variant_size_small_container_padding = "{custom_4}";
const badgev2notification_variant_size_small_container_width = "{s}";
const badgev2notification_variant_size_small_container_height = "{s}";
const badgev2notification_variant_size_medium_container_width = "{base}";
const badgev2notification_variant_size_medium_container_height = "{base}";
const badgev2notification_variant_size_medium_container_padding = "{custom_4}";
const badgev2notification_variant_size_large_container_width = "{custom_18}";
const badgev2notification_variant_size_large_container_height = "{custom_18}";
const badgev2notification_variant_size_large_container_padding = "{custom_4}";
const badgev2notification_variant_border_true_container_padding = "{custom_1}";
const badgev2notification_combination_number_small_container_width = "{base}";
const badgev2notification_combination_number_small_container_height = "{base}";
const badgev2notification_combination_number_medium_container_width = "{base}";
const badgev2notification_combination_number_medium_container_height = "{base}";
const badgev2notification_combination_number_large_container_width = "{custom_18}";
const badgev2notification_combination_number_large_container_height = "{custom_18}";
const BadgeV2NotificationTokens = {
	"badgev2notification_base_container_flex-direction": "{flexDirection.row}",
	"badgev2notification_base_container_justify-content": "{justifyContent.center}",
	"badgev2notification_base_container_align-items": "{alignItems.center}",
	badgev2notification_base_container_width: badgev2notification_base_container_width,
	badgev2notification_base_container_height: badgev2notification_base_container_height,
	"badgev2notification_base_container_background-color": "{feedbackError50}",
	"badgev2notification_base_container_border-radius": "{pill}",
	badgev2notification_base_container_padding: badgev2notification_base_container_padding,
	"badgev2notification_base_container_border-color": "{primaryBackground}",
	badgev2notification_variant_size_small_container_padding: badgev2notification_variant_size_small_container_padding,
	badgev2notification_variant_size_small_container_width: badgev2notification_variant_size_small_container_width,
	badgev2notification_variant_size_small_container_height: badgev2notification_variant_size_small_container_height,
	badgev2notification_variant_size_medium_container_width: badgev2notification_variant_size_medium_container_width,
	badgev2notification_variant_size_medium_container_height: badgev2notification_variant_size_medium_container_height,
	badgev2notification_variant_size_medium_container_padding: badgev2notification_variant_size_medium_container_padding,
	badgev2notification_variant_size_large_container_width: badgev2notification_variant_size_large_container_width,
	badgev2notification_variant_size_large_container_height: badgev2notification_variant_size_large_container_height,
	badgev2notification_variant_size_large_container_padding: badgev2notification_variant_size_large_container_padding,
	"badgev2notification_variant_size_xtra-large_container_width": "{m}",
	"badgev2notification_variant_size_xtra-large_container_height": "{m}",
	"badgev2notification_variant_size_xtra-large_container_padding": "{custom_16}",
	"badgev2notification_variant_size_xtra-xtra-large_container_width": "{custom_3}",
	"badgev2notification_variant_size_xtra-xtra-large_container_height": "{custom_3}",
	"badgev2notification_variant_size_xtra-xtra-large_container_padding": "{custom_16}",
	"badgev2notification_variant_size_xtra-xtra-xtra-large_container_width": "{l}",
	"badgev2notification_variant_size_xtra-xtra-xtra-large_container_height": "{l}",
	"badgev2notification_variant_size_xtra-xtra-xtra-large_container_padding": "{custom_16}",
	"badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_width": "{xl}",
	"badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
	"badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_padding": "{xxs}",
	badgev2notification_variant_border_true_container_padding: badgev2notification_variant_border_true_container_padding,
	"badgev2notification_combination_number_xtra-small_container_width": "{base}",
	"badgev2notification_combination_number_xtra-small_container_height": "{base}",
	badgev2notification_combination_number_small_container_width: badgev2notification_combination_number_small_container_width,
	badgev2notification_combination_number_small_container_height: badgev2notification_combination_number_small_container_height,
	badgev2notification_combination_number_medium_container_width: badgev2notification_combination_number_medium_container_width,
	badgev2notification_combination_number_medium_container_height: badgev2notification_combination_number_medium_container_height,
	badgev2notification_combination_number_large_container_width: badgev2notification_combination_number_large_container_width,
	badgev2notification_combination_number_large_container_height: badgev2notification_combination_number_large_container_height,
	"badgev2notification_combination_number_xtra-large_container_width": "{m}",
	"badgev2notification_combination_number_xtra-large_container_height": "{m}",
	"badgev2notification_combination_number_xtra-xtra-large_container_width": "{custom_3}",
	"badgev2notification_combination_number_xtra-xtra-large_container_height": "{custom_3}",
	"badgev2notification_combination_number_xtra-xtra-xtra-large_container_width": "{l}",
	"badgev2notification_combination_number_xtra-xtra-xtra-large_container_height": "{l}",
	"badgev2notification_combination_number_xtra-xtra-xtra-xtra-large_container_width": "{xl}",
	"badgev2notification_combination_number_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
	"badgev2notification_combination_number-symbol_xtra-small_container_height": "{base}",
	"badgev2notification_combination_number-symbol_xtra-small_container_border-radius": "{small}",
	"badgev2notification_combination_number-symbol_xtra-small_container_padding-left": "{xxs}",
	"badgev2notification_combination_number-symbol_xtra-small_container_padding-right": "{xxs}",
	"badgev2notification_combination_number-symbol_small_container_height": "{base}",
	"badgev2notification_combination_number-symbol_small_container_border-radius": "{small}",
	"badgev2notification_combination_number-symbol_small_container_padding-left": "{xxs}",
	"badgev2notification_combination_number-symbol_small_container_padding-right": "{xxs}",
	"badgev2notification_combination_number-symbol_medium_container_height": "{base}",
	"badgev2notification_combination_number-symbol_medium_container_border-radius": "{small}",
	"badgev2notification_combination_number-symbol_medium_container_padding-left": "{xxs}",
	"badgev2notification_combination_number-symbol_medium_container_padding-right": "{xxs}",
	"badgev2notification_combination_number-symbol_large_container_height": "{custom_18}",
	"badgev2notification_combination_number-symbol_large_container_border-radius": "{small}",
	"badgev2notification_combination_number-symbol_large_container_padding-left": "{custom_18}",
	"badgev2notification_combination_number-symbol_large_container_padding-right": "{custom_18}",
	"badgev2notification_combination_number-symbol_xtra-large_container_height": "{m}",
	"badgev2notification_combination_number-symbol_xtra-large_container_border-radius": "{small}",
	"badgev2notification_combination_number-symbol_xtra-large_container_padding-left": "{custom_18}",
	"badgev2notification_combination_number-symbol_xtra-large_container_padding-right": "{custom_18}",
	"badgev2notification_combination_number-symbol_xtra-xtra-large_container_height": "{custom_3}",
	"badgev2notification_combination_number-symbol_xtra-xtra-large_container_border-radius": "{small}",
	"badgev2notification_combination_number-symbol_xtra-xtra-large_container_padding-left": "{custom_18}",
	"badgev2notification_combination_number-symbol_xtra-xtra-large_container_padding-right": "{custom_18}",
	"badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_height": "{l}",
	"badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_border-radius": "{medium}",
	"badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_padding-left": "{xs}",
	"badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_padding-right": "{xs}",
	"badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
	"badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_border-radius": "{medium}",
	"badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_padding-left": "{xs}",
	"badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_padding-right": "{xs}",
	"badgev2notification_combination_true_number_xtra-small_container_padding": "{custom_4}"
};

const badgev2status_base_container_gap = "{xs}";
const BadgeV2StatusTokens = {
	"badgev2status_base_container_flex-direction": "{flexDirection.row}",
	"badgev2status_base_container_justify-content": "{justifyContent.center}",
	"badgev2status_base_container_align-items": "{alignItems.center}",
	badgev2status_base_container_gap: badgev2status_base_container_gap,
	"badgev2status_base_status-container_flex-direction": "{flexDirection.row}",
	"badgev2status_base_status-container_justify-content": "{justifyContent.center}",
	"badgev2status_base_status-container_align-items": "{alignItems.center}",
	"badgev2status_base_status-container_size": "{m}",
	"badgev2status_base_status-container_border-radius": "{pill}",
	"badgev2status_base_status-container_background-color": "{feedbackSuccess50}",
	"badgev2status_base_status-icon_color": "{global.white}",
	"badgev2status_base_status-icon_size": "{base}",
	"badgev2status_variant_kind_dot_status-container_size": "{s}",
	"badgev2status_variant_kind_dot-label_status-container_size": "{s}",
	"badgev2status_variant_kind_label-container_container_border-radius": "{small}",
	"badgev2status_variant_kind_label-container_container_padding-left": "{xs}",
	"badgev2status_variant_kind_label-container_container_padding-right": "{xs}",
	"badgev2status_variant_kind_dot-label-container_container_border-radius": "{small}",
	"badgev2status_variant_kind_dot-label-container_container_padding-left": "{xs}",
	"badgev2status_variant_kind_dot-label-container_container_padding-right": "{xs}",
	"badgev2status_variant_kind_dot-label-container_status-container_size": "{s}",
	"badgev2status_variant_kind_icon-label-container_container_border-radius": "{small}",
	"badgev2status_variant_kind_icon-label-container_container_padding-left": "{xs}",
	"badgev2status_variant_kind_icon-label-container_container_padding-right": "{xs}",
	"badgev2status_variant_size_xtra-small_status-container_size": "{base}",
	"badgev2status_variant_size_xtra-small_status-icon_size": "{s}",
	"badgev2status_variant_size_medium_status-container_size": "{l}",
	"badgev2status_variant_size_medium_status-icon_size": "{m}",
	"badgev2status_variant_size_large_status-container_size": "{xl}",
	"badgev2status_variant_size_large_status-icon_size": "{custom_3}",
	"badgev2status_variant_status_error_status-container_background-color": "{feedbackError50}",
	"badgev2status_variant_status_warning_status-container_background-color": "{feedbackWarning50}",
	"badgev2status_variant_status_disabled_status-container_background-color": "{primaryGrey60}",
	"badgev2status_variant_border_true_container_border-color": "{primaryBackground}",
	"badgev2status_variant_border_true_status-container_border-color": "{primaryBackground}",
	"badgev2status_combination_dot_xtra-small_status-container_size": "{xs}",
	"badgev2status_combination_dot_medium_status-container_size": "{base}",
	"badgev2status_combination_dot_large_status-container_size": "{m}",
	"badgev2status_combination_dot_xtra-large_status-container_size": "{l}",
	"badgev2status_combination_dot-label_xtra-small_status-container_size": "{xs}",
	"badgev2status_combination_dot-label_medium_status-container_size": "{base}",
	"badgev2status_combination_dot-label_large_status-container_size": "{m}",
	"badgev2status_combination_dot-label_xtra-large_status-container_size": "{l}",
	"badgev2status_combination_icon-label_medium_status-container_size": "{m}",
	"badgev2status_combination_icon-label_medium_status-icon_size": "{base}",
	"badgev2status_combination_icon-label_large_status-container_size": "{m}",
	"badgev2status_combination_icon-label_large_status-icon_size": "{base}",
	"badgev2status_combination_label-container_medium_container_border-radius": "{medium}",
	"badgev2status_combination_label-container_large_container_border-radius": "{medium}",
	"badgev2status_combination_dot-label-container_xtra-small_status-container_size": "{xs}",
	"badgev2status_combination_dot-label-container_medium_container_border-radius": "{medium}",
	"badgev2status_combination_dot-label-container_medium_status-container_size": "{base}",
	"badgev2status_combination_dot-label-container_large_container_border-radius": "{medium}",
	"badgev2status_combination_dot-label-container_large_status-container_size": "{m}",
	"badgev2status_combination_dot-label-container_xtra-large_status-container_size": "{l}",
	"badgev2status_combination_icon-label-container_medium_container_border-radius": "{medium}",
	"badgev2status_combination_icon-label-container_medium_status-container_size": "{base}",
	"badgev2status_combination_icon-label-container_medium_status-icon_size": "{s}",
	"badgev2status_combination_icon-label-container_large_container_border-radius": "{medium}",
	"badgev2status_combination_icon-label-container_large_status-container_size": "{m}",
	"badgev2status_combination_icon-label-container_large_status-icon_size": "{base}",
	"badgev2status_combination_label-container_success_container_background-color": "{feedbackSuccess50}",
	"badgev2status_combination_label-container_error_container_background-color": "{feedbackError50}",
	"badgev2status_combination_label-container_warning_container_background-color": "{feedbackWarning50}",
	"badgev2status_combination_label-container_disabled_container_background-color": "{primaryGrey60}",
	"badgev2status_combination_dot-label-container_success_container_background-color": "{feedbackSuccess50}",
	"badgev2status_combination_dot-label-container_success_status-container_background-color": "{global.white}",
	"badgev2status_combination_dot-label-container_error_container_background-color": "{feedbackError50}",
	"badgev2status_combination_dot-label-container_error_status-container_background-color": "{global.white}",
	"badgev2status_combination_dot-label-container_warning_container_background-color": "{feedbackWarning50}",
	"badgev2status_combination_dot-label-container_warning_status-container_background-color": "{global.white}",
	"badgev2status_combination_dot-label-container_disabled_container_background-color": "{primaryGrey60}",
	"badgev2status_combination_dot-label-container_disabled_status-container_background-color": "{global.white}",
	"badgev2status_combination_icon-label-container_success_container_background-color": "{feedbackSuccess50}",
	"badgev2status_combination_icon-label-container_success_status-container_background-color": "{global.white}",
	"badgev2status_combination_icon-label-container_success_status-icon_color": "{feedbackSuccess50}",
	"badgev2status_combination_icon-label-container_error_container_background-color": "{feedbackError50}",
	"badgev2status_combination_icon-label-container_error_status-container_background-color": "{global.white}",
	"badgev2status_combination_icon-label-container_error_status-icon_color": "{feedbackError50}",
	"badgev2status_combination_icon-label-container_warning_container_background-color": "{feedbackWarning50}",
	"badgev2status_combination_icon-label-container_warning_status-container_background-color": "{global.white}",
	"badgev2status_combination_icon-label-container_warning_status-icon_color": "{feedbackWarning50}",
	"badgev2status_combination_icon-label-container_disabled_container_background-color": "{primaryGrey60}",
	"badgev2status_combination_icon-label-container_disabled_status-container_background-color": "{global.white}",
	"badgev2status_combination_icon-label-container_disabled_status-icon_color": "{primaryGrey60}",
	"badgev2status_combination_true_dot_xtra-small_status-container_border-width": "{border_normal}",
	"badgev2status_combination_true_dot_small_status-container_border-width": "{border_normal}",
	"badgev2status_combination_true_dot_medium_status-container_border-width": "{border_thick}",
	"badgev2status_combination_true_dot_large_status-container_border-width": "{border_thick}",
	"badgev2status_combination_true_dot_xtra-large_status-container_border-width": "{border_thick}",
	"badgev2status_combination_true_icon_xtra-small_status-container_border-width": "{border_normal}",
	"badgev2status_combination_true_icon_small_status-container_border-width": "{border_normal}",
	"badgev2status_combination_true_icon_medium_status-container_border-width": "{border_thick}",
	"badgev2status_combination_true_icon_large_status-container_border-width": "{border_thick}",
	"badgev2status_combination_true_icon_xtra-large_status-container_border-width": "{border_thick}",
	"badgev2status_combination_true_label-container_xtra-small_container_border-width": "{border_normal}",
	"badgev2status_combination_true_label-container_small_container_border-width": "{border_normal}",
	"badgev2status_combination_true_label-container_medium_container_border-width": "{border_thick}",
	"badgev2status_combination_true_label-container_large_container_border-width": "{border_thick}",
	"badgev2status_combination_true_label-container_xtra-large_container_border-width": "{border_thick}"
};

const breadcrumbs_base_container_height = "{m}";
const BreadcrumbsTokens = {
	"breadcrumbs_base_container_flex-direction": "{flexDirection.row}",
	"breadcrumbs_base_container_justify-content": "{justifyContent.start}",
	"breadcrumbs_base_container_align-items": "{alignItems.start}",
	breadcrumbs_base_container_height: breadcrumbs_base_container_height,
	"breadcrumbs_base_link-container_flex-direction": "{flexDirection.row}",
	"breadcrumbs_base_link-container_justify-content": "{justifyContent.start}",
	"breadcrumbs_base_link-container_align-items": "{alignItems.start}"
};

const MobileBottomSheetTokens = {
	"mobilebottomsheet_base_popup-container_flex-direction": "{flexDirection.stack}",
	"mobilebottomsheet_base_popup-container_justify-content": "{justifyContent.center}",
	"mobilebottomsheet_base_popup-container_align-items": "{alignItems.end}",
	"mobilebottomsheet_base_popup-container_size": "{size.max}",
	"mobilebottomsheet_base_popup-container_background-color": "{custom_color_3}",
	"mobilebottomsheet_base_root-container_flex-direction": "{flexDirection.column}",
	"mobilebottomsheet_base_root-container_justify-content": "{justifyContent.start}",
	"mobilebottomsheet_base_root-container_background-color": "{primaryBackground}",
	"mobilebottomsheet_base_root-container_align-items": "{alignItems.start}",
	"mobilebottomsheet_base_root-container_border-top-left-radius": "{xl}",
	"mobilebottomsheet_base_root-container_border-top-right-radius": "{xl}",
	"mobilebottomsheet_base_root-container_width": "{size.max}",
	"mobilebottomsheet_base_cancel-container_flex-direction": "{flexDirection.row}",
	"mobilebottomsheet_base_cancel-container_justify-content": "{justifyContent.end}",
	"mobilebottomsheet_base_cancel-container_align-items": "{alignItems.center}",
	"mobilebottomsheet_base_cancel-container_width": "{size.max}",
	"mobilebottomsheet_base_cancel-container_padding-top": "{xxs}",
	"mobilebottomsheet_base_cancel-container_padding-bottom": "{xxs}",
	"mobilebottomsheet_base_cancel-container_padding-left": "{xs}",
	"mobilebottomsheet_base_cancel-container_padding-right": "{s}",
	"mobilebottomsheet_base_cancel-container_gap": "{s}",
	"mobilebottomsheet_base_step-jds_text_padding-right": "{base}",
	"mobilebottomsheet_base_vertical-container_flex-direction": "{flexDirection.column}",
	"mobilebottomsheet_base_vertical-container_justify-content": "{justifyContent.start}",
	"mobilebottomsheet_base_vertical-container_align-items": "{alignItems.start}",
	"mobilebottomsheet_base_vertical-container_padding-left": "{m}",
	"mobilebottomsheet_base_vertical-container_padding-right": "{m}",
	"mobilebottomsheet_base_vertical-container_width": "{size.max}",
	"mobilebottomsheet_base_title-jds_text_padding-bottom": "{xs}",
	"mobilebottomsheet_base_description-jds_text_padding-bottom": "{m}",
	"mobilebottomsheet_base_cta-container_flex-direction": "{flexDirection.column}",
	"mobilebottomsheet_base_cta-container_gap": "{base}",
	"mobilebottomsheet_base_cta-container_width": "{size.max}",
	"mobilebottomsheet_base_cta-container_padding-bottom": "{m}",
	"mobilebottomsheet_base_cta-container_padding-top": "{m}",
	"mobilebottomsheet_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}"
};

const DesktopBottomSheetTokens = {
	"desktopbottomsheet_base_popup-container_flex-direction": "{flexDirection.row}",
	"desktopbottomsheet_base_popup-container_justify-content": "{justifyContent.end}",
	"desktopbottomsheet_base_popup-container_align-items": "{alignItems.end}",
	"desktopbottomsheet_base_popup-container_background-color": "{custom_color_3}",
	"desktopbottomsheet_base_popup-container_size": "{size.max}",
	"desktopbottomsheet_base_root-container_flex-direction": "{flexDirection.column}",
	"desktopbottomsheet_base_root-container_justify-content": "{justifyContent.start}",
	"desktopbottomsheet_base_root-container_background-color": "{primaryBackground}",
	"desktopbottomsheet_base_root-container_align-items": "{alignItems.start}",
	"desktopbottomsheet_base_root-container_border-top-left-radius": "{xl}",
	"desktopbottomsheet_base_root-container_border-top-right-radius": "{xl}",
	"desktopbottomsheet_base_cancel-container_flex-direction": "{flexDirection.row}",
	"desktopbottomsheet_base_cancel-container_justify-content": "{justifyContent.end}",
	"desktopbottomsheet_base_cancel-container_align-items": "{alignItems.center}",
	"desktopbottomsheet_base_cancel-container_width": "{size.max}",
	"desktopbottomsheet_base_cancel-container_padding-top": "{xxs}",
	"desktopbottomsheet_base_cancel-container_padding-bottom": "{xxs}",
	"desktopbottomsheet_base_cancel-container_padding-left": "{xs}",
	"desktopbottomsheet_base_cancel-container_padding-right": "{s}",
	"desktopbottomsheet_base_cancel-container_gap": "{s}",
	"desktopbottomsheet_base_vertical-container_flex-direction": "{flexDirection.column}",
	"desktopbottomsheet_base_vertical-container_justify-content": "{justifyContent.start}",
	"desktopbottomsheet_base_vertical-container_align-items": "{alignItems.start}",
	"desktopbottomsheet_base_vertical-container_padding-left": "{m}",
	"desktopbottomsheet_base_vertical-container_padding-right": "{m}",
	"desktopbottomsheet_base_vertical-container_width": "{size.max}",
	"desktopbottomsheet_base_title-jds_text_padding-bottom": "{xs}",
	"desktopbottomsheet_base_description-jds_text_padding-bottom": "{m}",
	"desktopbottomsheet_base_cta-container_flex-direction": "{flexDirection.column}",
	"desktopbottomsheet_base_cta-container_gap": "{base}",
	"desktopbottomsheet_base_cta-container_width": "{size.max}",
	"desktopbottomsheet_base_cta-container_padding-bottom": "{m}",
	"desktopbottomsheet_base_cta-container_padding-top": "{m}",
	"desktopbottomsheet_base_step-jds_text_padding-right": "{base}",
	"desktopbottomsheet_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}"
};

const carousel_base_container_gap = "{base}";
const carousel_base_container_width = "{size.max}";
const carousel_variant_density_condensed_container_gap = "{xs}";
const CarouselTokens = {
	"carousel_base_container_flex-direction": "{flexDirection.column}",
	"carousel_base_container_justify-content": "{justifyContent.center}",
	"carousel_base_container_align-items": "{alignItems.center}",
	carousel_base_container_gap: carousel_base_container_gap,
	carousel_base_container_width: carousel_base_container_width,
	"carousel_base_slider-container_width": "{size.max}",
	"carousel_base_control-container_flex-direction": "{flexDirection.row}",
	"carousel_base_control-container_justify-content": "{justifyContent.spaceBetween}",
	"carousel_base_control-container_align-items": "{alignItems.center}",
	"carousel_base_control-container_gap": "{base}",
	"carousel_base_control-container_width": "{size.max}",
	"carousel_base_left-container_max-width": "{size.max}",
	"carousel_base_left-container_flex-direction": "{flexDirection.row}",
	"carousel_base_left-container_justify-content": "{justifyContent.start}",
	"carousel_base_left-container_align-items": "{alignItems.center}",
	"carousel_base_left-container_gap": "{base}",
	"carousel_base_left-container_padding-top": "{xs}",
	"carousel_base_left-container_padding-bottom": "{xs}",
	"carousel_base_prefix-container_flex-direction": "{flexDirection.column}",
	"carousel_base_prefix-container_justify-content": "{justifyContent.center}",
	"carousel_base_prefix-container_align-items": "{alignItems.start}",
	"carousel_base_progress-container_flex-direction": "{flexDirection.stack}",
	"carousel_base_progress-container_justify-content": "{justifyContent.center}",
	"carousel_base_progress-container_align-items": "{alignItems.center}",
	"carousel_base_inner-container_flex-direction": "{flexDirection.row}",
	"carousel_base_inner-container_justify-content": "{justifyContent.start}",
	"carousel_base_inner-container_align-items": "{alignItems.start}",
	"carousel_base_right-container_max-width": "{size.max}",
	"carousel_base_right-container_flex-direction": "{flexDirection.row}",
	"carousel_base_right-container_justify-content": "{justifyContent.end}",
	"carousel_base_right-container_align-items": "{alignItems.start}",
	"carousel_base_right-container_gap": "{s}",
	"carousel_base_right-container_padding-top": "{xs}",
	"carousel_base_right-container_padding-bottom": "{xs}",
	carousel_variant_density_condensed_container_gap: carousel_variant_density_condensed_container_gap
};

const carouselpaginationitem_base_container_width = "{s}";
const carouselpaginationitem_base_container_height = "{s}";
const carouselpaginationitem_base_container_opacity = "{opacity.disabled}";
const carouselpaginationitem_base_container_behavior_hover_opacity = "{opacity.enabled}";
const carouselpaginationitem_base_container_behavior_active_opacity = "{opacity.enabled}";
const carouselpaginationitem_variant_density_condensed_container_height = "{xs}";
const carouselpaginationitem_variant_active_true_container_opacity = "{opacity.enabled}";
const carouselpaginationitem_combination_relaxed_false_normal_container_width = "{s}";
const carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width = "{xs}";
const carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height = "{xs}";
const carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width = "{custom_15}";
const carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height = "{custom_15}";
const carouselpaginationitem_combination_condensed_false_normal_container_width = "{xs}";
const carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width = "{custom_15}";
const carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height = "{custom_15}";
const carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width = "{xxs}";
const carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height = "{xxs}";
const carouselpaginationitem_combination_condensed_true_normal_container_width = "{m}";
const carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width = "{m}";
const carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width = "{m}";
const carouselpaginationitem_combination_relaxed_true_normal_container_width = "{l}";
const carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width = "{l}";
const carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width = "{l}";
const CarouselPaginationItemTokens = {
	carouselpaginationitem_base_container_width: carouselpaginationitem_base_container_width,
	carouselpaginationitem_base_container_height: carouselpaginationitem_base_container_height,
	"carouselpaginationitem_base_container_background-color": "{primary60}",
	carouselpaginationitem_base_container_opacity: carouselpaginationitem_base_container_opacity,
	"carouselpaginationitem_base_container_border-radius": "{pill}",
	"carouselpaginationitem_base_container_behavior_hover_background-color": "{primary40}",
	carouselpaginationitem_base_container_behavior_hover_opacity: carouselpaginationitem_base_container_behavior_hover_opacity,
	"carouselpaginationitem_base_container_behavior_active_background-color": "{primary60}",
	carouselpaginationitem_base_container_behavior_active_opacity: carouselpaginationitem_base_container_behavior_active_opacity,
	carouselpaginationitem_variant_density_condensed_container_height: carouselpaginationitem_variant_density_condensed_container_height,
	carouselpaginationitem_variant_active_true_container_opacity: carouselpaginationitem_variant_active_true_container_opacity,
	"carouselpaginationitem_variant_active_true_container_behavior_hover_background-color": "{primary70}",
	"carouselpaginationitem_variant_active_true_container_behavior_active_background-color": "{primary70}",
	carouselpaginationitem_combination_relaxed_false_normal_container_width: carouselpaginationitem_combination_relaxed_false_normal_container_width,
	carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width: carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width,
	carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height: carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height,
	carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width: carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width,
	carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height: carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height,
	carouselpaginationitem_combination_condensed_false_normal_container_width: carouselpaginationitem_combination_condensed_false_normal_container_width,
	carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width: carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width,
	carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height: carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height,
	carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width: carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width,
	carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height: carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height,
	carouselpaginationitem_combination_condensed_true_normal_container_width: carouselpaginationitem_combination_condensed_true_normal_container_width,
	carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width: carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width,
	carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width: carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width,
	carouselpaginationitem_combination_relaxed_true_normal_container_width: carouselpaginationitem_combination_relaxed_true_normal_container_width,
	carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width: carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width,
	carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width: carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width
};

const carouselpagination_base_container_gap = "{s}";
const carouselpagination_base_container_width = "{size.max}";
const carouselpagination_variant_density_condensed_container_gap = "{xs}";
const CarouselPaginationTokens = {
	"carouselpagination_base_container_flex-direction": "{flexDirection.row}",
	"carouselpagination_base_container_justify-content": "{justifyContent.center}",
	"carouselpagination_base_container_align-items": "{alignItems.center}",
	carouselpagination_base_container_gap: carouselpagination_base_container_gap,
	"carouselpagination_base_container_padding-top": "{xs}",
	carouselpagination_base_container_width: carouselpagination_base_container_width,
	"carouselpagination_base_container_padding-bottom": "{xs}",
	carouselpagination_variant_density_condensed_container_gap: carouselpagination_variant_density_condensed_container_gap
};

const button_base_container_opacity = "{opacity.enabled}";
const button_base_container_gap = "{xs}";
const button_base_loader_color = "{primaryInverse}";
const button_base_loader_opacity = "{opacity.enabled}";
const button_base_loader_size = "{base}";
const button_variant_fullWidth_true_container_width = "{size.max}";
const button_variant_disabled_true_container_opacity = "{opacity.disabled}";
const button_combination_primary_destructive_loader_color = "{feedbackError80}";
const button_combination_primary_positive_loader_color = "{feedbackSuccess80}";
const button_combination_secondary_normal_loader_color = "{primary60}";
const button_combination_secondary_destructive_loader_color = "{feedbackError80}";
const button_combination_secondary_positive_loader_color = "{feedbackSuccess80}";
const button_combination_tertiary_normal_loader_color = "{primary60}";
const button_combination_tertiary_destructive_loader_color = "{feedbackError80}";
const button_combination_tertiary_positive_loader_color = "{feedbackSuccess80}";
const button_combination_true_small_loader_size = "{base}";
const button_combination_true_medium_loader_size = "{m}";
const button_combination_true_large_loader_size = "{m}";
const button_combination_false_small_loader_size = "{base}";
const button_combination_false_medium_loader_size = "{m}";
const button_combination_false_large_loader_size = "{m}";
const ButtonTokens = {
	button_base_container_opacity: button_base_container_opacity,
	"button_base_container_background-color": "{primary50}",
	"button_base_container_flex-direction": "{flexDirection.row}",
	"button_base_container_align-items": "{alignItems.center}",
	"button_base_container_justify-content": "{justifyContent.center}",
	"button_base_container_border-radius": "{pill}",
	"button_base_container_border-width": "0",
	"button_base_container_border-color": "",
	button_base_container_gap: button_base_container_gap,
	"button_combination_tertiary_normal_container_border-width": 0,
	"button_base_container_behavior_hover_background-color": "{primary60}",
	"button_base_container_behavior_active_background-color": "{primary60}",
	"button_base_container_behavior_focus_border-width": "{border_focus}",
	"button_base_container_behavior_focus_border-color": "{primary80}",
	"button_base_left-container_flex-direction": "{flexDirection.row}",
	"button_base_left-container_align-items": "{alignItems.center}",
	"button_base_left-container_justify-content": "{justifyContent.start}",
	"button_base_left-container_gap": "{xs}",
	button_base_loader_color: button_base_loader_color,
	"button_base_loader_background-color": "{global.transparent}",
	"button_base_loader_border-width": "{border_focus}",
	button_base_loader_opacity: button_base_loader_opacity,
	button_base_loader_size: button_base_loader_size,
	"button_base_left-icon_size": "{m}",
	"button_base_left-icon_color": "{primaryInverse}",
	"button_base_right-icon_size": "{m}",
	"button_base_right-icon_color": "{primaryInverse}",
	button_variant_fullWidth_true_container_width: button_variant_fullWidth_true_container_width,
	"button_variant_fullWidth_true_container_justify-content": "{justifyContent.spaceBetween}",
	button_variant_disabled_true_container_opacity: button_variant_disabled_true_container_opacity,
	"button_combination_primary_normal_left-icon_behavior_active_color": "{primary30}",
	"button_combination_primary_normal_right-icon_behavior_active_color": "{primary30}",
	"button_combination_primary_destructive_container_background-color": "{feedbackError20}",
	"button_combination_primary_destructive_container_behavior_hover_background-color": "{feedbackError50}",
	"button_combination_primary_destructive_container_behavior_active_background-color": "{feedbackError80}",
	"button_combination_primary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
	button_combination_primary_destructive_loader_color: button_combination_primary_destructive_loader_color,
	"button_combination_primary_destructive_left-icon_color": "{feedbackError80}",
	"button_combination_primary_destructive_left-icon_behavior_hover_color": "{global.white}",
	"button_combination_primary_destructive_left-icon_behavior_active_color": "{feedbackError20}",
	"button_combination_primary_destructive_right-icon_behavior_hover_color": "{global.white}",
	"button_combination_primary_destructive_right-icon_color": "{feedbackError80}",
	"button_combination_primary_destructive_right-icon_behavior_active_color": "{feedbackError20}",
	"button_combination_primary_positive_container_background-color": "{feedbackSuccess20}",
	"button_combination_primary_positive_container_behavior_hover_background-color": "{feedbackSuccess50}",
	"button_combination_primary_positive_container_behavior_active_background-color": "{feedbackSuccess80}",
	"button_combination_primary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
	button_combination_primary_positive_loader_color: button_combination_primary_positive_loader_color,
	"button_combination_primary_positive_left-icon_color": "{feedbackSuccess80}",
	"button_combination_primary_positive_left-icon_behavior_hover_color": "{global.white}",
	"button_combination_primary_positive_left-icon_behavior_active_color": "{feedbackSuccess20}",
	"button_combination_primary_positive_right-icon_color": "{feedbackSuccess80}",
	"button_combination_primary_positive_right-icon_behavior_hover_color": "{global.white}",
	"button_combination_primary_positive_right-icon_behavior_active_color": "{feedbackSuccess20}",
	"button_combination_secondary_normal_container_background-color": "{global.transparent}",
	"button_combination_secondary_normal_container_border-width": "{border_thin}",
	"button_combination_secondary_normal_container_border-color": "{primaryGrey40}",
	"button_combination_secondary_normal_container_behavior_hover_border-color": "{primary60}",
	"button_combination_secondary_normal_container_behavior_hover_background-color": "{global.transparent}",
	"button_combination_secondary_normal_container_behavior_active_background-color": "{primary20}",
	"button_combination_secondary_normal_container_behavior_active_border-color": "{primary60}",
	"button_combination_secondary_normal_container_behavior_focus_border-color": "{primary80}",
	button_combination_secondary_normal_loader_color: button_combination_secondary_normal_loader_color,
	"button_combination_secondary_normal_left-icon_color": "{primary60}",
	"button_combination_secondary_normal_right-icon_color": "{primary60}",
	"button_combination_secondary_destructive_container_background-color": "{global.transparent}",
	"button_combination_secondary_destructive_container_border-width": "{border_thin}",
	"button_combination_secondary_destructive_container_border-color": "{primaryGrey40}",
	"button_combination_secondary_destructive_container_behavior_active_background-color": "{feedbackError20}",
	"button_combination_secondary_destructive_container_behavior_active_border-color": "{feedbackError80}",
	"button_combination_secondary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
	"button_combination_secondary_destructive_container_behavior_focus_border-width": "{border_focus}",
	button_combination_secondary_destructive_loader_color: button_combination_secondary_destructive_loader_color,
	"button_combination_secondary_destructive_left-icon_color": "{feedbackError80}",
	"button_combination_secondary_destructive_right-icon_color": "{feedbackError80}",
	"button_combination_secondary_positive_container_background-color": "{global.transparent}",
	"button_combination_secondary_positive_container_border-width": "{border_thin}",
	"button_combination_secondary_positive_container_border-color": "{primaryGrey40}",
	"button_combination_secondary_positive_container_behavior_active_background-color": "{feedbackSuccess20}",
	"button_combination_secondary_positive_container_behavior_active_border-color": "{feedbackSuccess80}",
	"button_combination_secondary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
	"button_combination_secondary_positive_container_behavior_focus_border-width": "{border_focus}",
	button_combination_secondary_positive_loader_color: button_combination_secondary_positive_loader_color,
	"button_combination_secondary_positive_left-icon_color": "{feedbackSuccess80}",
	"button_combination_secondary_positive_right-icon_color": "{feedbackSuccess80}",
	"button_combination_tertiary_normal_container_background-color": "{global.transparent}",
	"button_combination_tertiary_normal_container_behavior_hover_background-color": "{primary20}",
	"button_combination_tertiary_normal_container_behavior_active_background-color": "{primary30}",
	"button_combination_tertiary_normal_container_behavior_focus_border-color": "{primary80}",
	"button_combination_tertiary_normal_container_behavior_focus_background-color": "{primary20}",
	button_combination_tertiary_normal_loader_color: button_combination_tertiary_normal_loader_color,
	"button_combination_tertiary_normal_left-icon_color": "{primary60}",
	"button_combination_tertiary_normal_right-icon_color": "{primary60}",
	"button_combination_tertiary_destructive_container_background-color": "{global.transparent}",
	"button_combination_tertiary_destructive_container_behavior_hover_background-color": "{feedbackError20}",
	"button_combination_tertiary_destructive_container_behavior_active_background-color": "{feedbackError80}",
	"button_combination_tertiary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
	"button_combination_tertiary_destructive_container_behavior_focus_border-width": "{border_focus}",
	"button_combination_tertiary_destructive_container_behavior_focus_background-color": "{feedbackError20}",
	button_combination_tertiary_destructive_loader_color: button_combination_tertiary_destructive_loader_color,
	"button_combination_tertiary_destructive_left-icon_color": "{feedbackError80}",
	"button_combination_tertiary_destructive_right-icon_color": "{feedbackError80}",
	"button_combination_tertiary_positive_container_background-color": "{global.transparent}",
	"button_combination_tertiary_positive_container_behavior_active_background-color": "{feedbackSuccess20}",
	"button_combination_tertiary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
	"button_combination_tertiary_positive_container_behavior_focus_border-width": "{border_focus}",
	button_combination_tertiary_positive_loader_color: button_combination_tertiary_positive_loader_color,
	"button_combination_tertiary_positive_left-icon_color": "{feedbackSuccess80}",
	"button_combination_tertiary_positive_right-icon_color": "{feedbackSuccess80}",
	"button_combination_true_small_container_padding-top": "{xxs}",
	"button_combination_true_small_container_padding-right": "{base}",
	"button_combination_true_small_container_padding-bottom": "{xxs}",
	"button_combination_true_small_container_padding-left": "{base}",
	"button_combination_true_small_left-icon_size": "{base}",
	"button_combination_true_small_right-icon_size": "{base}",
	button_combination_true_small_loader_size: button_combination_true_small_loader_size,
	"button_combination_true_medium_container_padding-top": "{s}",
	"button_combination_true_medium_container_padding-right": "{base}",
	"button_combination_true_medium_container_padding-bottom": "{s}",
	"button_combination_true_medium_container_padding-left": "{base}",
	"button_combination_true_medium_left-icon_size": "{m}",
	"button_combination_true_medium_right-icon_size": "{m}",
	button_combination_true_medium_loader_size: button_combination_true_medium_loader_size,
	"button_combination_true_large_container_padding-top": "{base}",
	"button_combination_true_large_container_padding-left": "{m}",
	"button_combination_true_large_container_padding-bottom": "{base}",
	"button_combination_true_large_container_padding-right": "{m}",
	"button_combination_true_large_left-icon_size": "{m}",
	"button_combination_true_large_right-icon_size": "{m}",
	button_combination_true_large_loader_size: button_combination_true_large_loader_size,
	"button_combination_false_small_container_min-height": "{l}",
	"button_combination_false_small_container_min-width": "{l}",
	"button_combination_false_small_left-icon_size": "{base}",
	"button_combination_false_small_right-icon_size": "{base}",
	button_combination_false_small_loader_size: button_combination_false_small_loader_size,
	"button_combination_false_medium_container_min-height": "{xxl}",
	"button_combination_false_medium_container_min-width": "{xxl}",
	"button_combination_false_medium_left-icon_size": "{m}",
	"button_combination_false_medium_right-icon_size": "{m}",
	button_combination_false_medium_loader_size: button_combination_false_medium_loader_size,
	"button_combination_false_large_left-icon_size": "{m}",
	"button_combination_false_large_right-icon_size": "{m}",
	button_combination_false_large_loader_size: button_combination_false_large_loader_size,
	"button_combination_true_true_true_false_false_container_justify-content": "{justifyContent.center}",
	"button_combination_true_true_true_false_true_container_justify-content": "{justifyContent.center}",
	"button_combination_true_false_false_true_false_container_justify-content": "{justifyContent.center}",
	"button_combination_true_false_false_false_true_container_justify-content": "{justifyContent.center}",
	"button_combination_true_false_true_true_false_container_justify-content": "{justifyContent.center}"
};

const ContentCardTokens = {
	"contentcard_base_root-container_width": "{size.max}",
	"contentcard_base_root-container_border-radius": "{xl}",
	"contentcard_base_root-container_flex-direction": "{flexDirection.column}",
	"contentcard_base_root-container_justify-content": "{justifyContent.start}",
	"contentcard_base_root-container_align-items": "{alignItems.start}",
	"contentcard_base_root-container_background-color": "{primaryBackground}",
	"contentcard_base_header-container_justify-content": "{justifyContent.start}",
	"contentcard_base_header-container_align-items": "{alignItems.start}",
	"contentcard_base_header-container_width": "{size.max}",
	"contentcard_base_header-container_padding-left": "{base}",
	"contentcard_base_header-container_padding-right": "{base}",
	"contentcard_base_header-container_padding-top": "{base}",
	"contentcard_base_children-container_justify-content": "{justifyContent.start}",
	"contentcard_base_children-container_align-items": "{alignItems.start}",
	"contentcard_base_children-container_width": "{size.max}",
	"contentcard_base_children-container_padding-left": "{base}",
	"contentcard_base_children-container_padding-right": "{base}",
	"contentcard_base_children-container_padding-bottom": "{base}",
	"contentcard_base_image-content-container_flex-direction": "{flexDirection.column}",
	"contentcard_base_image-content-container_width": "{size.max}",
	"contentcard_base_image-content-container_justify-content": "{justifyContent.start}",
	"contentcard_base_image-content-container_align-items": "{alignItems.start}",
	"contentcard_base_image-content-container_padding-top": "{base}",
	"contentcard_base_image-content-container_padding-bottom": "{base}",
	"contentcard_base_jds_content_block_padding-left": "{base}",
	"contentcard_base_jds_content_block_padding-right": "{base}",
	"contentcard_base_jds_content_block_padding-top": "{base}",
	"contentcard_base_footer-jds_text_padding-left": "{base}",
	"contentcard_base_footer-jds_text_padding-right": "{base}",
	"contentcard_base_footer-jds_text_padding-bottom": "{base}",
	"contentcard_combination_true_horizontal_image-content-container_padding-left": "{base}",
	"contentcard_combination_true_horizontal_image-content-container_padding-top": "{base}",
	"contentcard_combination_true_horizontal_image-content-container_flex-direction": "{flexDirection.row}",
	"contentcard_combination_true_vertical_root-container_width": "{custom_10}",
	"contentcard_combination_false_horizontal_root-container_width": "{size.max}",
	"contentcard_combination_false_horizontal_image-content-container_padding-left": "{base}",
	"contentcard_combination_false_horizontal_image-content-container_padding-top": "{base}",
	"contentcard_combination_false_horizontal_image-content-container_flex-direction": "{flexDirection.row}",
	"contentcard_combination_true_vertical_mobile_root-container_width": "{size.max}"
};

const carouselslide_base_container_width = "{size.max}";
const carouselslide_base_jds_image_width = "{size.max}";
const CarouselSlideTokens = {
	carouselslide_base_container_width: carouselslide_base_container_width,
	"carouselslide_base_container_border-radius": "{small}",
	carouselslide_base_jds_image_width: carouselslide_base_jds_image_width
};

const ContentBlockTokens = {
	"contentblock_base_root-container_flex-direction": "{flexDirection.column}",
	"contentblock_base_root-container_align-items": "{alignItems.start}",
	"contentblock_base_root-container_justify-content": "{justifyContent.start}",
	"contentblock_base_root-container_width": "{size.max}",
	"contentblock_base_inner-container_flex-direction": "{flexDirection.column}",
	"contentblock_base_inner-container_align-items": "{alignItems.start}",
	"contentblock_base_inner-container_justify-content": "{justifyContent.start}",
	"contentblock_base_inner-container_width": "{size.max}",
	"contentblock_base_caption-container_padding-bottom": "{xs}",
	"contentblock_base_title-jds_text_padding-bottom": "{xxs}",
	"contentblock_base_description-jds_text_padding-bottom": "{m}",
	"contentblock_base_children-container_padding-bottom": "{m}",
	"contentblock_base_button-container_flex-direction": "{flexDirection.row}",
	"contentblock_base_button-container_width": "{size.max}",
	"contentblock_base_button-container_gap": "{xs}",
	"contentblock_variant_size_small_title-jds_text_padding-bottom": "{s}",
	"contentblock_variant_size_medium_caption-container_padding-bottom": "{s}",
	"contentblock_variant_size_medium_title-jds_text_padding-bottom": "{s}",
	"contentblock_variant_size_medium_button-container_gap": "{s}",
	"contentblock_variant_size_large_caption-container_padding-bottom": "{base}",
	"contentblock_variant_size_large_title-jds_text_padding-bottom": "{base}",
	"contentblock_variant_size_large_children-container_padding-bottom": "{l}",
	"contentblock_variant_size_large_button-container_gap": "{s}",
	"contentblock_variant_size_xtra-large_caption-container_padding-bottom": "{base}",
	"contentblock_variant_size_xtra-large_title-jds_text_padding-bottom": "{base}",
	"contentblock_variant_size_xtra-large_children-container_padding-bottom": "{l}",
	"contentblock_variant_size_xtra-large_button-container_gap": "{s}",
	"contentblock_variant_ctaWrap_vertical_button-container_flex-direction": "{flexDirection.column}",
	"contentblock_variant_singleButton_false_inner-container_width": "{size.max}",
	"contentblock_variant_singleButton_false_button-container_width": "{size.max}",
	"contentblock_combination_desktop_medium_title-jds_text_padding-bottom": "{base}",
	"contentblock_combination_desktop_large_title-jds_text_padding-bottom": "{m}",
	"contentblock_combination_desktop_xtra-large_title-jds_text_padding-bottom": "{m}",
	"contentblock_combination_true_xtra-xtra-small_root-container_flex-direction": "{flexDirection.row}",
	"contentblock_combination_true_xtra-xtra-small_root-container_justify-content": "{justifyContent.spaceBetween}",
	"contentblock_combination_true_xtra-xtra-small_root-container_align-items": "{alignItems.center}",
	"contentblock_combination_true_xtra-xtra-small_button-container_flex-direction": "{flexDirection.row}",
	"contentblock_combination_true_xtra-xtra-small_button-container_justify-content": "{justifyContent.end}",
	"contentblock_combination_true_xtra-xtra-small_button-container_align-items": "{alignItems.center}"
};

const CheckboxTokens = {
	"checkbox_base_vertical-container_flex-direction": "{flexDirection.column}",
	"checkbox_base_vertical-container_justify-content": "{justifyContent.start}",
	"checkbox_base_vertical-container_align-items": "{alignItems.start}",
	"checkbox_base_vertical-container_gap": "{xs}",
	"checkbox_base_horizontal-container_flex-direction": "{flexDirection.row}",
	"checkbox_base_horizontal-container_justify-content": "{justifyContent.start}",
	"checkbox_base_horizontal-container_align-items": "{alignItems.center}",
	"checkbox_base_horizontal-container_gap": "{xs}",
	"checkbox_base_control-container_min-width": "{m}",
	"checkbox_base_control-container_min-height": "{m}",
	"checkbox_base_control-container_flex-direction": "{flexDirection.row}",
	"checkbox_base_control-container_justify-content": "{justifyContent.center}",
	"checkbox_base_control-container_align-items": "{alignItems.center}",
	"checkbox_base_control-container_background-color": "{global.transparent}",
	"checkbox_base_control-container_border-radius": "{small}",
	"checkbox_base_control-container_border-color": "{primaryGrey80}",
	"checkbox_base_control-container_behavior_hover_border-color": "{primary40}",
	"checkbox_base_control-container_behavior_active_border-color": "{primary60}",
	"checkbox_base_control-container_behavior_focus_border-color": "{primary60}",
	"checkbox_base_control-icon_size": "{base}",
	"checkbox_base_label-jds_text_text-align": "{textAlign.start}",
	"checkbox_variant_size_small_control-container_min-width": "{base}",
	"checkbox_variant_size_small_control-container_min-height": "{base}",
	"checkbox_variant_size_small_vertical-container_gap": "{xxs}",
	"checkbox_variant_size_small_control-icon_size": "{s}",
	"checkbox_variant_checked_true_control-icon_value": "ic_confirm",
	"checkbox_variant_checked_true_control-container_background-color": "{primary50}",
	"checkbox_variant_checked_true_control-container_behavior_hover_background-color": "{primary40}",
	"checkbox_variant_checked_true_control-container_behavior_active_background-color": "{primary60}",
	"checkbox_variant_checked_true_control-icon_color": "{primaryInverse}",
	"checkbox_variant_indeterminate_true_control-icon_value": "ic_minus",
	"checkbox_variant_indeterminate_true_control-container_background-color": "{primary50}",
	"checkbox_variant_indeterminate_true_control-container_behavior_hover_background-color": "{primary40}",
	"checkbox_variant_indeterminate_true_control-container_behavior_focus_background-color": "{primary50}",
	"checkbox_variant_indeterminate_true_control-icon_color": "{primaryInverse}",
	"checkbox_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
	"checkbox_base_vertical-container_opacity": "{opacity.enabled}"
};

const datepickercalendarbutton_base_container_width = "{xxl}";
const datepickercalendarbutton_base_container_height = "{xxl}";
const datepickercalendarbutton_variant_disabled_true_container_opacity = "{opacity.disabled}";
const DatepickerCalendarButtonTokens = {
	"datepickercalendarbutton_base_container_flex-direction": "{flexDirection.row}",
	"datepickercalendarbutton_base_container_justify-content": "{justifyContent.center}",
	"datepickercalendarbutton_base_container_align-items": "{alignItems.center}",
	datepickercalendarbutton_base_container_width: datepickercalendarbutton_base_container_width,
	datepickercalendarbutton_base_container_height: datepickercalendarbutton_base_container_height,
	"datepickercalendarbutton_base_button-container_flex-direction": "{flexDirection.row}",
	"datepickercalendarbutton_base_button-container_justify-content": "{justifyContent.center}",
	"datepickercalendarbutton_base_button-container_align-items": "{alignItems.center}",
	"datepickercalendarbutton_base_button-container_width": "{xxl}",
	"datepickercalendarbutton_base_button-container_height": "{xxl}",
	"datepickercalendarbutton_base_button-container_border-radius": "{pill}",
	"datepickercalendarbutton_base_button-container_border-color": "{primaryGrey100}",
	"datepickercalendarbutton_base_button-container_background-color": "{global.transparent}",
	"datepickercalendarbutton_base_button-container_behavior_hover_background-color": "{primary20}",
	"datepickercalendarbutton_base_button-container_behavior_active_background-color": "{primary40}",
	"datepickercalendarbutton_base_button-container_behavior_focus_background-color": "{primary20}",
	"datepickercalendarbutton_base_button-container_behavior_focus_border-width": "{border_focus}",
	"datepickercalendarbutton_variant_state_selected_button-container_background-color": "{primary50}",
	"datepickercalendarbutton_variant_state_current_button-container_background-color": "{primary20}",
	datepickercalendarbutton_variant_disabled_true_container_opacity: datepickercalendarbutton_variant_disabled_true_container_opacity
};

const datepickerbutton_base_container_height = "{xxl}";
const datepickerbutton_base_container_gap = "{xs}";
const datepickerbutton_variant_state_disabled_container_opacity = "{opacity.disabled}";
const DatepickerButtonTokens = {
	datepickerbutton_base_container_height: datepickerbutton_base_container_height,
	"datepickerbutton_base_container_max-width": "{custom_9}",
	"datepickerbutton_base_container_border-radius": "{pill}",
	"datepickerbutton_base_container_background-color": "{global.transparent}",
	"datepickerbutton_base_container_border-width": "{border_thin}",
	"datepickerbutton_base_container_border-color": "{primaryGrey40}",
	"datepickerbutton_base_container_flex-direction": "{flexDirection.row}",
	"datepickerbutton_base_container_justify-content": "{justifyContent.center}",
	"datepickerbutton_base_container_align-items": "{alignItems.center}",
	datepickerbutton_base_container_gap: datepickerbutton_base_container_gap,
	"datepickerbutton_base_container_padding-right": "{base}",
	"datepickerbutton_base_container_padding-left": "{base}",
	"datepickerbutton_base_container_behavior_hover_border-color": "{primary60}",
	"datepickerbutton_base_container_behavior_focus_border-color": "{primaryGrey100}",
	"datepickerbutton_base_container_behavior_focus_border-width": "{border_focus}",
	"datepickerbutton_base_container_behavior_active_border-color": "{primary60}",
	"datepickerbutton_base_container_behavior_active_background-color": "{primary20}",
	"datepickerbutton_variant_state_selected_container_background-color": "{primary20}",
	"datepickerbutton_variant_state_selected_container_border-color": "{primary60}",
	"datepickerbutton_variant_state_disabled_container_border-width": "{border_none}",
	datepickerbutton_variant_state_disabled_container_opacity: datepickerbutton_variant_state_disabled_container_opacity,
	"datepickerbutton_variant_state_text_only_container_border-width": "{border_none}"
};

const datepickercalendar_base_container_gap = "{s}";
const DatepickerCalendarTokens = {
	"datepickercalendar_base_container_flex-direction": "{flexDirection.column}",
	"datepickercalendar_base_container_justify-content": "{justifyContent.start}",
	"datepickercalendar_base_container_align-items": "{alignItems.center}",
	datepickercalendar_base_container_gap: datepickercalendar_base_container_gap,
	"datepickercalendar_base_rows-container_flex-direction": "{flexDirection.column}"
};

const datepickerheader_base_container_width = "{size.max}";
const datepickerheader_base_container_height = "{xxl}";
const DatepickerHeaderTokens = {
	datepickerheader_base_container_width: datepickerheader_base_container_width,
	datepickerheader_base_container_height: datepickerheader_base_container_height,
	"datepickerheader_base_container_flex-direction": "{flexDirection.row}",
	"datepickerheader_base_container_justify-content": "{justifyContent.spaceBetween}",
	"datepickerheader_base_container_align-items": "{alignItems.center}",
	"datepickerheader_base_inner-container_height": "{xxl}",
	"datepickerheader_base_inner-container_flex-direction": "{flexDirection.row}",
	"datepickerheader_base_inner-container_justify-content": "{justifyContent.center}",
	"datepickerheader_base_inner-container_align-items": "{alignItems.center}",
	"datepickerheader_base_inner-container_gap": "{s}"
};

const datepickerdesktop_base_container_opacity = "{opacity.invisible}";
const datapickerdesktop_variant_open_true_container_opacity = "{opacity.enabled}";
const DatepickerDesktopTokens = {
	"datepickerdesktop_base_popup-container_flex-direction": "{flexDirection.column}",
	"datepickerdesktop_base_popup-container_justify-content": "{justifyContent.start}",
	"datepickerdesktop_base_popup-container_align-items": "{alignItems.center}",
	datepickerdesktop_base_container_opacity: datepickerdesktop_base_container_opacity,
	"datepickerdesktop_base_container_background-color": "{primaryBackground}",
	"datepickerdesktop_base_container_flex-direction": "{flexDirection.column}",
	"datepickerdesktop_base_container_justify-content": "{justifyContent.start}",
	"datepickerdesktop_base_container_align-items": "{alignItems.center}",
	"datepickerdesktop_base_container_border-radius": "{xl}",
	"datepickerdesktop_base_top-container_flex-direction": "{flexDirection.row}",
	"datepickerdesktop_base_top-container_justify-content": "{justifyContent.end}",
	"datepickerdesktop_base_top-container_align-items": "{alignItems.center}",
	"datepickerdesktop_base_top-container_padding-top": "{xs}",
	"datepickerdesktop_base_top-container_padding-right": "{s}",
	"datepickerdesktop_base_top-container_padding-bottom": "{xs}",
	"datepickerdesktop_base_top-container_padding-left": "{s}",
	"datepickerdesktop_base_top-container_width": "{custom_6}",
	"datepickerdesktop_base_jds_datepicker_header_padding-right": "{m}",
	"datepickerdesktop_base_jds_datepicker_header_padding-left": "{m}",
	"datepickerdesktop_base_controls-container_flex-direction": "{flexDirection.column}",
	"datepickerdesktop_base_controls-container_justify-content": "{justifyContent.start}",
	"datepickerdesktop_base_controls-container_align-items": "{alignItems.center}",
	"datepickerdesktop_base_controls-container_gap": "{m}",
	"datepickerdesktop_base_calender-view-container_flex-direction": "{flexDirection.column}",
	"datepickerdesktop_base_calender-view-container_justify-content": "{justifyContent.start}",
	"datepickerdesktop_base_calender-view-container_align-items": "{alignItems.center}",
	"datepickerdesktop_base_calender-view-container_height": "{size.max}",
	"datepickerdesktop_base_calender-view-container_width": "{size.max}",
	"datepickerdesktop_base_jds_datepicker_calendar_padding-right": "{m}",
	"datepickerdesktop_base_jds_datepicker_calendar_padding-left": "{m}",
	"datepickerdesktop_base_jds_datepicker_calendar_padding-bottom": "{m}",
	datapickerdesktop_variant_open_true_container_opacity: datapickerdesktop_variant_open_true_container_opacity,
	"datepickerdesktop_variant_state_month_view_top-container_justify-content": "{justifyContent.spaceBetween}",
	"datepickerdesktop_variant_state_year_view_top-container_justify-content": "{justifyContent.spaceBetween}"
};

const datepickercalendarrow_base_container_width = "{size.max}";
const DatepickerCalendarRowTokens = {
	"datepickercalendarrow_base_container_flex-direction": "{flexDirection.row}",
	"datepickercalendarrow_base_container_justify-content": "{justifyContent.start}",
	"datepickercalendarrow_base_container_align-items": "{alignItems.center}",
	datepickercalendarrow_base_container_width: datepickercalendarrow_base_container_width
};

const datepickerviewbutton_base_container_height = "{xxl}";
const datepickerviewbutton_base_container_width = "{custom_7}";
const DatepickerViewButtonTokens = {
	"datepickerviewbutton_base_root-container_width": "{size.max}",
	"datepickerviewbutton_base_root-container_flex-direction": "{flexDirection.row}",
	"datepickerviewbutton_base_root-container_justify-content": "{justifyContent.center}",
	"datepickerviewbutton_base_root-container_align-items": "{alignItems.center}",
	datepickerviewbutton_base_container_height: datepickerviewbutton_base_container_height,
	datepickerviewbutton_base_container_width: datepickerviewbutton_base_container_width,
	"datepickerviewbutton_base_container_flex-direction": "{flexDirection.row}",
	"datepickerviewbutton_base_container_justify-content": "{justifyContent.center}",
	"datepickerviewbutton_base_container_align-items": "{alignItems.center}"
};

const datepickercalendarheader_base_container_width = "{size.max}";
const DatepickerCalendarHeaderTokens = {
	"datepickercalendarheader_base_container_flex-direction": "{flexDirection.row}",
	"datepickercalendarheader_base_container_justify-content": "{justifyContent.center}",
	"datepickercalendarheader_base_container_align-items": "{alignItems.center}",
	datepickercalendarheader_base_container_width: datepickercalendarheader_base_container_width
};

const datepickeryearview_base_container_width = "{size.max}";
const DatepickerYearViewTokens = {
	"datepickeryearview_base_container_flex-direction": "{flexDirection.column}",
	datepickeryearview_base_container_width: datepickeryearview_base_container_width,
	"datepickeryearview_base_container_align-items": "{alignItems.center}"
};

const datepickermobile_base_container_size = "{size.max}";
const DatepickerMobileTokens = {
	"datepickermobile_base_container_background-color": "{primaryBackground}",
	"datepickermobile_base_container_flex-direction": "{flexDirection.column}",
	"datepickermobile_base_container_justify-content": "{justifyContent.start}",
	"datepickermobile_base_container_align-items": "{alignItems.center}",
	datepickermobile_base_container_size: datepickermobile_base_container_size,
	"datepickermobile_base_top-container_flex-direction": "{flexDirection.row}",
	"datepickermobile_base_top-container_justify-content": "{justifyContent.end}",
	"datepickermobile_base_top-container_align-items": "{alignItems.center}",
	"datepickermobile_base_top-container_padding-top": "{xs}",
	"datepickermobile_base_top-container_padding-bottom": "{xs}",
	"datepickermobile_base_top-container_padding-left": "{s}",
	"datepickermobile_base_top-container_padding-right": "{s}",
	"datepickermobile_base_top-container_width": "{size.max}",
	"datepickermobile_base_controls-container_flex-direction": "{flexDirection.column}",
	"datepickermobile_base_controls-container_justify-content": "{justifyContent.start}",
	"datepickermobile_base_controls-container_align-items": "{alignItems.center}",
	"datepickermobile_base_controls-container_gap": "{m}",
	"datepickermobile_base_jds_datepicker_header_padding-left": "{s}",
	"datepickermobile_base_jds_datepicker_header_padding-right": "{s}",
	"datepickermobile_base_jds_datepicker_calendar_padding-left": "{s}",
	"datepickermobile_base_jds_datepicker_calendar_padding-right": "{s}",
	"datepickermobile_base_jds_datepicker_calendar_padding-bottom": "{m}",
	"datepickermobile_base_jds_datepicker_month_view_padding-left": "{s}",
	"datepickermobile_base_jds_datepicker_month_view_padding-right": "{s}",
	"datepickermobile_base_jds_datepicker_year_view_padding-left": "{s}",
	"datepickermobile_base_jds_datepicker_year_view_padding-right": "{s}",
	"datepickermobile_base_confirmation-container_padding-bottom": "{m}",
	"datepickermobile_base_confirmation-container_flex-direction": "{flexDirection.column}",
	"datepickermobile_base_confirmation-container_gap": "{s}",
	"datepickermobile_base_confirmation-container_justify-content": "{justifyContent.start}",
	"datepickermobile_base_confirmation-container_align-items": "{alignItems.center}",
	"datepickermobile_base_confirmation-container_width": "{size.max}",
	"datepickermobile_base_confirmation-group-container_padding-right": "{m}",
	"datepickermobile_base_confirmation-group-container_padding-left": "{m}",
	"datepickermobile_base_confirmation-group-container_flex-direction": "{flexDirection.column}",
	"datepickermobile_base_confirmation-group-container_justify-content": "{justifyContent.start}",
	"datepickermobile_base_confirmation-group-container_align-items": "{alignItems.center}",
	"datepickermobile_base_confirmation-group-container_gap": "{s}",
	"datepickermobile_base_confirmation-group-container_width": "{size.max}",
	"datepickermobile_variant_state_month_view_top-container_justify-content": "{justifyContent.spaceBetween}",
	"datepickermobile_variant_state_year_view_top-container_justify-content": "{justifyContent.spaceBetween}"
};

const datepickermonthview_base_container_height = "{custom_8}";
const datepickermonthview_base_container_width = "{size.max}";
const DatepickerMonthViewTokens = {
	"datepickermonthview_base_container_flex-direction": "{flexDirection.column}",
	datepickermonthview_base_container_height: datepickermonthview_base_container_height,
	datepickermonthview_base_container_width: datepickermonthview_base_container_width,
	"datepickermonthview_base_container_align-items": "{alignItems.center}"
};

const dropdownmenu_base_jds_search_box_width = "{size.max}";
const DropdownMenuTokens = {
	"dropdownmenu_base_popup_background-color": "{global.transparent}",
	"dropdownmenu_base_menu-container_background_color": "{primaryGrey20}",
	"dropdownmenu_base_menu-container_flex-direction": "{flexDirection.column}",
	"dropdownmenu_base_menu-group-container_flex-direction": "{flexDirection.column}",
	"dropdownmenu_base_menu-container_border-radius": "{large}",
	"dropdownmenu_base_menu-group-container_padding-top": "{xs}",
	"dropdownmenu_base_menu-group-container_padding-bottom": "{xs}",
	"dropdownmenu_base_search-container_padding-top": "{base}",
	"dropdownmenu_base_search-container_padding-left": "{base}",
	"dropdownmenu_base_search-container_padding-right": "{base}",
	"dropdownmenu_base_menu-container_box-shadow_color": "{custom_color_5}",
	"dropdownmenu_base_search-container_width": "{size.max}",
	dropdownmenu_base_jds_search_box_width: dropdownmenu_base_jds_search_box_width,
	"dropdownmenu_base_menu-group-container_width": "{size.max}",
	"dropdownmenu_variant__menuFullScreen_true_popup-container_size": "{size.max}",
	"dropdownmenu_variant__menuFullScreen_true_menu-container_size": "{size.max}",
	"dropdownmenu_base_menu-container_opacity": "{opacity.invisible}",
	"dropdownmenu_variant__menuContainerVisible_true_menu-container_opacity": "{opacity.enabled}"
};

const dropdownmenuitem_base_container_width = "{size.max}";
const dropdownmenuitem_base_container_gap = "{s}";
const dropdownmenuitem_base_icon_color = "{primary60}";
const dropdownmenuitem_base_icon_size = "{m}";
const dropdownmenuitem_base_icon_behaviour_active_color = "{primaryInverse}";
const dropdownmenuitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const DropdownMenuItemTokens = {
	dropdownmenuitem_base_container_width: dropdownmenuitem_base_container_width,
	"dropdownmenuitem_base_container_flex-direction": "{flexDirection.row}",
	"dropdownmenuitem_base_content-container_flex-direction": "{flexDirection.column}",
	dropdownmenuitem_base_container_gap: dropdownmenuitem_base_container_gap,
	"dropdownmenuitem_base_container_background-color": "{primaryGrey20}",
	"dropdownmenuitem_base_container_behavior_hover_background-color": "{primaryBackground}",
	"dropdownmenuitem_base_container_behavior_active_background-color": "{primary50}",
	"dropdownmenuitem_base_label-jds_text_behavior_color": "{primaryGrey100}",
	"dropdownmenuitem_base_container_padding-top": "{xs}",
	"dropdownmenuitem_base_container_padding-right": "{base}",
	"dropdownmenuitem_base_container_padding-bottom": "{xs}",
	"dropdownmenuitem_base_container_padding-left": "{base}",
	"dropdownmenuitem_variant_selected_true_container_background-color": "{primary50}",
	"dropdownmenuitem_variant_selected_true_container_behavior_active_background-color": "{primary50}",
	"dropdownmenuitem_base_content-container_justify-content": "{justifyContent.start}",
	"dropdownmenuitem_base_content-container_align-items": "{alignItems.start}",
	"dropdownmenuitem_base_container_align-items": "{alignItems.center}",
	"dropdownmenuitem_base_prefix-container_align-self": "{alignItems.start}",
	dropdownmenuitem_base_icon_color: dropdownmenuitem_base_icon_color,
	dropdownmenuitem_base_icon_size: dropdownmenuitem_base_icon_size,
	dropdownmenuitem_base_icon_behaviour_active_color: dropdownmenuitem_base_icon_behaviour_active_color,
	"dropdownmenuitem_variant_selected_true_icon-color": "{primaryInverse}",
	dropdownmenuitem_variant_disabled_true_container_opacity: dropdownmenuitem_variant_disabled_true_container_opacity,
	"dropdownmenuitem_base_container_behavior_focus_border-radius": "{small}",
	"dropdownmenuitem_base_root-container_width": "{size.max}"
};

const dropdownmenugroup_base_container_width = "{size.max}";
const DropdownMenuGroupTokens = {
	dropdownmenugroup_base_container_width: dropdownmenugroup_base_container_width,
	"dropdownmenugroup_base_container_flex-direction": "{flexDirection.column}",
	"dropdownmenugroup_base_menu-item-container_flex-direction": "{flexDirection.column}",
	"dropdownmenugroup_base_label-container_padding-top": "{xs}",
	"dropdownmenugroup_base_label-container_padding-left": "{base}",
	"dropdownmenugroup_base_label-container_padding-right": "{base}",
	"dropdownmenugroup_base_label-container_width": "{size.max}",
	"dropdownmenugroup_base_container_background-color": "{primaryGrey20}",
	"dropdownmenugroup_base_menu-item-container_width": "{size.max}"
};

const DropdownMenuSubMenuTokens = {
	"dropdownmenusubmenu_base_popup_background-color": "{global.transparent}",
	"dropdownmenusubmenu_base_menu-container_background_color": "{primaryGrey20}",
	"dropdownmenusubmenu_base_menu-container_flex-direction": "{flexDirection.column}",
	"dropdownmenusubmenu_base_menu-container_border-radius": "{large}",
	"dropdownmenusubmenu_base_menu-container_padding-top": "{xs}",
	"dropdownmenusubmenu_base_menu-container_padding-bottom": "{xs}",
	"dropdownmenusubmenu_base_menu-container_box-shadow_color": "{custom_color_5}",
	"dropdownmenu_variant__platform_mobile_popup-container_size": "{size.max}",
	"dropdownmenu_variant__platform_mobile_menu-container_size": "{size.max}",
	"dropdownmenusubmenu_base_menu-container_opacity": "{opacity.invisible}",
	"dropdownmenusubmenu_variant__menuContainerVisible_true_menu-container_opacity": "{opacity.enabled}"
};

const bottomfooter_base_container_background = "{global.transparent}";
const bottomfooter_variant__platform_desktop_container_width = "{size.max}";
const bottomfooter_variant__platform_mobile_container_gap = "{base}";
const BottomFooterTokens = {
	"bottomfooter_base_container_flex-direction": "{flexDirection.row}",
	"bottomfooter_base_container_justify-content": "{justifyContent.spaceBetween}",
	"bottomfooter_base_container_align-items": "{alignItems.center}",
	"bottomfooter_base_container_padding-top": "{base}",
	"bottomfooter_base_container_padding-right": "{huge}",
	"bottomfooter_base_container_padding-bottom": "{base}",
	"bottomfooter_base_container_padding-left": "{huge}",
	bottomfooter_base_container_background: bottomfooter_base_container_background,
	"bottomfooter_base_copyright-container_gap": "{base}",
	"bottomfooter_base_copyright-container_flex-direction": "{flexDirection.row}",
	"bottomfooter_base_copyright-container_align-items": "{alignItems.center}",
	"bottomfooter_base_informational-links-container_align-items": "{alignItems.center}",
	bottomfooter_variant__platform_desktop_container_width: bottomfooter_variant__platform_desktop_container_width,
	"bottomfooter_variant__platform_mobile_container_flex-direction": "{flexDirection.column}",
	"bottomfooter_variant__platform_mobile_container_justify-content": "{justifyContent.start}",
	"bottomfooter_variant__platform_mobile_container_align-items": "{alignItems.start}",
	"bottomfooter_variant__platform_mobile_container_padding-right": "{m}",
	"bottomfooter_variant__platform_mobile_container_padding-bottom": "{m}",
	"bottomfooter_variant__platform_mobile_container_padding-left": "{m}",
	bottomfooter_variant__platform_mobile_container_gap: bottomfooter_variant__platform_mobile_container_gap,
	"bottomfooter_variant__platform_mobile_copyright-container_flex-direction": "{flexDirection.column}",
	"bottomfooter_variant__platform_mobile_copyright-container_align-items": "{alignItems.start}",
	"bottomfooter_variant__platform_mobile_copyright-container_gap": "{base}"
};

const divider_base_container_gap = "{xs}";
const divider_variant_orientation_horizontal_container_width = "{size.max}";
const divider_variant_orientation_vertical_container_height = "{size.max}";
const DividerTokens = {
	"divider_base_container_background-color": "{global.transparent}",
	"divider_base_container_flex-direction": "{flexDirection.row}",
	"divider_base_container_justify-content": "{justifyContent.center}",
	"divider_base_container_align-items": "{alignItems.center}",
	divider_base_container_gap: divider_base_container_gap,
	"divider_base_container_padding-left": "{s}",
	"divider_base_container_padding-right": "{s}",
	"divider_base_container_padding-top": "{s}",
	"divider_base_container_padding-bottom": "{s}",
	"divider_base_start-container_min-height": "{custom_5}",
	"divider_base_start-container_min-width": "{custom_5}",
	"divider_base_start-container_flex-direction": "{flexDirection.row}",
	"divider_base_start-container_background-color": "{primaryGrey40}",
	"divider_base_start-container_border-radius": "{pill}",
	"divider_base_end-container_min-height": "{custom_5}",
	"divider_base_end-container_min-width": "{custom_5}",
	"divider_base_end-container_flex-direction": "{flexDirection.row}",
	"divider_base_end-container_background-color": "{primaryGrey40}",
	"divider_base_end-container_border-radius": "{pill}",
	"divider_variant_variant_stepper_start-container_background-color": "{sparkle50}",
	"divider_variant_variant_stepper_end-container_background-color": "{sparkle50}",
	divider_variant_orientation_horizontal_container_width: divider_variant_orientation_horizontal_container_width,
	divider_variant_orientation_vertical_container_height: divider_variant_orientation_vertical_container_height,
	"divider_variant_orientation_vertical_container_flex-direction": "{flexDirection.column}",
	"divider_variant_orientation_vertical_start-container_flex-direction": "{flexDirection.column}",
	"divider_variant_orientation_vertical_end-container_flex-direction": "{flexDirection.column}",
	"divider_combination_base_all_container_padding-left": "{base}",
	"divider_combination_base_all_container_padding-right": "{base}",
	"divider_combination_base_all_container_padding-top": "{base}",
	"divider_combination_base_all_container_padding-bottom": "{base}",
	"divider_combination_base_left_container_padding-left": "{base}",
	"divider_combination_base_right_container_padding-right": "{base}",
	"divider_combination_base_top_container_padding-top": "{base}",
	"divider_combination_base_bottom_container_padding-bottom": "{base}",
	"divider_combination_base_vertical_container_padding-top": "{base}",
	"divider_combination_base_vertical_container_padding-bottom": "{base}",
	"divider_combination_base_horizontal_container_padding-left": "{base}",
	"divider_combination_base_horizontal_container_padding-right": "{base}",
	"divider_combination_medium_all_container_padding-left": "{m}",
	"divider_combination_medium_all_container_padding-right": "{m}",
	"divider_combination_medium_all_container_padding-top": "{m}",
	"divider_combination_medium_all_container_padding-bottom": "{m}",
	"divider_combination_medium_left_container_padding-left": "{m}",
	"divider_combination_medium_right_container_padding-right": "{m}",
	"divider_combination_medium_top_container_padding-top": "{m}",
	"divider_combination_medium_bottom_container_padding-bottom": "{m}",
	"divider_combination_medium_vertical_container_padding-top": "{m}",
	"divider_combination_medium_vertical_container_padding-bottom": "{m}",
	"divider_combination_medium_horizontal_container_padding-left": "{m}",
	"divider_combination_medium_horizontal_container_padding-right": "{m}",
	"divider_combination_xtra-small_all_container_padding-left": "{xs}",
	"divider_combination_xtra-small_all_container_padding-right": "{xs}",
	"divider_combination_xtra-small_all_container_padding-top": "{xs}",
	"divider_combination_xtra-small_all_container_padding-bottom": "{xs}",
	"divider_combination_xtra-small_left_container_padding-left": "{xs}",
	"divider_combination_xtra-small_right_container_padding-right": "{xs}",
	"divider_combination_xtra-small_top_container_padding-top": "{xs}",
	"divider_combination_xtra-small_bottom_container_padding-bottom": "{xs}",
	"divider_combination_xtra-small_vertical_container_padding-top": "{xs}",
	"divider_combination_xtra-small_vertical_container_padding-bottom": "{xs}",
	"divider_combination_xtra-small_horizontal_container_padding-left": "{xs}",
	"divider_combination_xtra-small_horizontal_container_padding-right": "{xs}",
	"divider_combination_xtra-xtra-small_all_container_padding-left": "{xxs}",
	"divider_combination_xtra-xtra-small_all_container_padding-right": "{xxs}",
	"divider_combination_xtra-xtra-small_all_container_padding-top": "{xxs}",
	"divider_combination_xtra-xtra-small_all_container_padding-bottom": "{xxs}",
	"divider_combination_xtra-xtra-small_left_container_padding-left": "{xxs}",
	"divider_combination_xtra-xtra-small_right_container_padding-right": "{xxs}",
	"divider_combination_xtra-xtra-small_top_container_padding-top": "{xxs}",
	"divider_combination_xtra-xtra-small_bottom_container_padding-bottom": "{xxs}",
	"divider_combination_xtra-xtra-small_vertical_container_padding-top": "{xxs}",
	"divider_combination_xtra-xtra-small_vertical_container_padding-bottom": "{xxs}",
	"divider_combination_xtra-xtra-small_horizontal_container_padding-left": "{xxs}",
	"divider_combination_xtra-xtra-small_horizontal_container_padding-bottom": "{xxs}",
	"divider_combination_xtra-xtra-large_all_container_padding-left": "{xxl}",
	"divider_combination_xtra-xtra-large_all_container_padding-right": "{xxl}",
	"divider_combination_xtra-xtra-large_all_container_padding-top": "{xxl}",
	"divider_combination_xtra-xtra-large_all_container_padding-bottom": "{xxl}",
	"divider_combination_xtra-xtra-large_left_container_padding-left": "{xxl}",
	"divider_combination_xtra-xtra-large_right_container_padding-right": "{xxl}",
	"divider_combination_xtra-xtra-large_top_container_padding-top": "{xxl}",
	"divider_combination_xtra-xtra-large_bottom_container_padding-bottom": "{xxl}",
	"divider_combination_xtra-xtra-large_vertical_container_padding-top": "{xxl}",
	"divider_combination_xtra-xtra-large_vertical_container_padding-bottom": "{xxl}",
	"divider_combination_xtra-xtra-large_horizontal_container_padding-left": "{xxl}",
	"divider_combination_xtra-xtra-large_horizontal_container_padding-right": "{xxl}",
	"divider_combination_xtra-large_all_container_padding-left": "{xl}",
	"divider_combination_xtra-large_all_container_padding-right": "{xl}",
	"divider_combination_xtra-large_all_container_padding-top": "{xl}",
	"divider_combination_xtra-large_all_container_padding-bottom": "{xl}",
	"divider_combination_xtra-large_left_container_padding-left": "{xl}",
	"divider_combination_xtra-large_right_container_padding-right": "{xl}",
	"divider_combination_xtra-large_top_container_padding-top": "{xl}",
	"divider_combination_xtra-large_bottom_container_padding-bottom": "{xl}",
	"divider_combination_xtra-large_vertical_container_padding-top": "{xl}",
	"divider_combination_xtra-large_vertical_container_padding-bottom": "{xl}",
	"divider_combination_xtra-large_horizontal_container_padding-left": "{xl}",
	"divider_combination_xtra-large_horizontal_container_padding-right": "{xl}",
	"divider_combination_large_all_container_padding-left": "{l}",
	"divider_combination_large_all_container_padding-right": "{l}",
	"divider_combination_large_all_container_padding-top": "{l}",
	"divider_combination_large_all_container_padding-bottom": "{l}",
	"divider_combination_large_left_container_padding-left": "{l}",
	"divider_combination_large_right_container_padding-right": "{l}",
	"divider_combination_large_top_container_padding-top": "{l}",
	"divider_combination_large_bottom_container_padding-bottom": "{l}",
	"divider_combination_large_vertical_container_padding-top": "{l}",
	"divider_combination_large_vertical_container_padding-bottom": "{l}",
	"divider_combination_large_horizontal_container_padding-left": "{l}",
	"divider_combination_large_horizontal_container_padding-right": "{l}",
	"divider_combination_huge_all_container_padding-left": "{huge}",
	"divider_combination_huge_all_container_padding-right": "{huge}",
	"divider_combination_huge_all_container_padding-top": "{huge}",
	"divider_combination_huge_all_container_padding-bottom": "{huge}",
	"divider_combination_huge_left_container_padding-left": "{huge}",
	"divider_combination_huge_right_container_padding-right": "{huge}",
	"divider_combination_huge_top_container_padding-top": "{huge}",
	"divider_combination_huge_bottom_container_padding-bottom": "{huge}",
	"divider_combination_huge_vertical_container_padding-top": "{huge}",
	"divider_combination_huge_vertical_container_padding-bottom": "{huge}",
	"divider_combination_huge_horizontal_container_padding-left": "{huge}",
	"divider_combination_huge_horizontal_container_padding-right": "{huge}",
	"divider_combination_massive_all_container_padding-left": "{massive}",
	"divider_combination_massive_all_container_padding-right": "{massive}",
	"divider_combination_massive_all_container_padding-top": "{massive}",
	"divider_combination_massive_all_container_padding-bottom": "{massive}",
	"divider_combination_massive_left_container_padding-left": "{massive}",
	"divider_combination_massive_right_container_padding-right": "{massive}",
	"divider_combination_massive_top_container_padding-top": "{massive}",
	"divider_combination_massive_bottom_container_padding-bottom": "{massive}",
	"divider_combination_massive_vertical_container_padding-top": "{massive}",
	"divider_combination_massive_vertical_container_padding-bottom": "{massive}",
	"divider_combination_massive_horizontal_container_padding-left": "{massive}",
	"divider_combination_massive_horizontal_container_padding-right": "{massive}"
};

const fab_base_container_gap = "{xs}";
const fab_base_icon_size = "{m}";
const fab_base_icon_color = "{secondaryInverse}";
const fab_base_icon_behavior_active_color = "{secondary30}";
const FABTokens = {
	"fab_base_popup-container_flex-direction": "{flexDirection.stack}",
	"fab_base_popup-container_justify-content": "{justifyContent.end}",
	"fab_base_popup-container_align-items": "{alignItems.end}",
	"fab_base_popup-container_size": "{size.max}",
	"fab_base_popup-container_padding-right": "{base}",
	"fab_base_popup-container_padding-bottom": "{base}",
	"fab_base_container_background-color": "{secondary50}",
	"fab_base_container_flex-direction": "{flexDirection.row}",
	"fab_base_container_justify-content": "{justifyContent.center}",
	"fab_base_container_align-items": "{alignItems.center}",
	fab_base_container_gap: fab_base_container_gap,
	"fab_base_container_border-radius": "{pill}",
	"fab_base_container_padding-top": "{base}",
	"fab_base_container_padding-left": "{m}",
	"fab_base_container_padding-right": "{m}",
	"fab_base_container_padding-bottom": "{base}",
	"fab_base_container_border-color": "{primary80}",
	"fab_base_container_border-width": "{border_none}",
	"fab_base_container_behavior_hover_background-color": "{secondary60}",
	"fab_base_container_behavior_active_background-color": "{secondary60}",
	"fab_base_container_behavior_focus_background-color": "{secondary60}",
	"fab_base_container_behavior_focus_border-width": "{border_focus}",
	fab_base_icon_size: fab_base_icon_size,
	fab_base_icon_color: fab_base_icon_color,
	"fab_base_icon_border-radius": "{pill}",
	fab_base_icon_behavior_active_color: fab_base_icon_behavior_active_color,
	"fab_variant_extend_false_container_padding-left": "{base}",
	"fab_variant_extend_false_container_padding-right": "{base}"
};

const feedbackblock_base_container_gap = "{xs}";
const feedbackblock_base_icon_size = "{m}";
const feedbackblock_variant_size_s_icon_size = "{base}";
const FeedbackBlockTokens = {
	"feedbackblock_base_container_flex-direction": "{flexDirection.row}",
	"feedbackblock_base_container_justify-content": "{justifyContent.center}",
	"feedbackblock_base_container_align-items": "{alignItems.center}",
	feedbackblock_base_container_gap: feedbackblock_base_container_gap,
	"feedbackblock_variant_alignment_top_container_align-items": "{alignItems.start}",
	"feedbackblock_base_icon-flex-direction": "{flexDirection.row}",
	"feedbackblock_base_icon-container_justify-content": "{justifyContent.center}",
	"feedbackblock_base_icon-container_align-items": "{alignItems.center}",
	"feedbackblock_base_icon-container_height": "{m}",
	feedbackblock_base_icon_size: feedbackblock_base_icon_size,
	"feedbackblock_variant_size_s_icon-container_height": "{custom_18}",
	feedbackblock_variant_size_s_icon_size: feedbackblock_variant_size_s_icon_size
};

const dropdown_base_container_gap = "{xxs}";
const dropdown_base_container_width = "{size.max}";
const dropdown_variant_disabled_true_container_opacity = "{opacity.disabled}";
const dropdown_base_conatiner_opacity = "{opacity.enabled}";
const DropdownTokens = {
	"dropdown_base_container_flex-direction": "{flexDirection.column}",
	dropdown_base_container_gap: dropdown_base_container_gap,
	dropdown_base_container_width: dropdown_base_container_width,
	"dropdown_base_container_justify-content": "{justifyContent.start}",
	"dropdown_base_container_align-items": "{alignItems.start}",
	"dropdown_base_field-container_flex-direction": "{flexDirection.stack}",
	"dropdown_base_field-container_width": "{size.max}",
	"dropdown_base_field-container_align-items": "{alignItems.end}",
	"dropdown_base_field-container_justify-content": "{justifyContent.start}",
	"dropdown_base_field-container_padding-bottom": "{xxs}",
	"dropdown_base_text-container_flex-direction": "{flexDirection.row}",
	"dropdown_base_text-container_gap": "{xs}",
	"dropdown_base_select-container_flex-direction": "{flexDirection.row}",
	"dropdown_base_select-container_justify-content": "{justifyContent.end}",
	"dropdown_base_select-container_width": "{size.max}",
	"dropdown_base_select-container_align-items": "{alignItems.center}",
	"dropdown_base_active-line-container_flex-direction": "{flexDirection.column}",
	"dropdown_base_active-line-container_width": "{size.max}",
	"dropdown_base_active-line-container_align-items": "{alignItems.center}",
	"dropdown_base_feedback-container_width": "{size.max}",
	"dropdown_base_feedback-container_background-color": "{primaryGrey100}",
	"dropdown_base_feedback-container_behavior_hover_background-color": "{primary50}",
	"dropdown_base_feedback-container_behavior_focus_background-color": "{primary50}",
	"dropdown_base_feedback-container_behavior_active_background-color": "{primary50}",
	"dropdown_base_prefix-icon_size": "{m}",
	"dropdown_base_prefix-icon_color": "{primaryGrey80}",
	dropdown_variant_disabled_true_container_opacity: dropdown_variant_disabled_true_container_opacity,
	dropdown_base_conatiner_opacity: dropdown_base_conatiner_opacity,
	"dropdown_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
	"dropdown_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
	"dropdown_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
	"dropdown_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
	"dropdown_variant_state_error_feedback-container_background-color": "{feedbackError50}",
	"dropdown_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
	"dropdown_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
	"dropdown_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
	"dropdown_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
	"dropdown_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
	"dropdown_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
	"dropdown_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
	"dropdown_combination_true_true_field-container_align-items": "{alignItems.start}",
	"dropdown_combination_true_false_field-container_align-items": "{alignItems.start}",
	"dropdown_combination_false_true_field-container_align-items": "{alignItems.end}",
	"dropdown_combination_false_true_label-jds_text_padding-left": "{l}",
	"dropdown_combination_false_false_field-container_align-items": "{alignItems.end}",
	"dropdown_combination_none_true_feedback-container_background-color": "{primary60}"
};

const bottomfooterlinkitem_base_container_gap = "{base}";
const BottomFooterLinkItemTokens = {
	bottomfooterlinkitem_base_container_gap: bottomfooterlinkitem_base_container_gap
};

const footer_base_container_size = "{size.max}";
const FooterTokens = {
	"footer_base_container_flex-direction": "{flexDirection.column}",
	"footer_base_container_align-items": "{alignItems.center}",
	footer_base_container_size: footer_base_container_size,
	"footer_base_container_background-color": "{primaryGrey20}",
	"footer_base_main-container_flex-direction": "{flexDirection.row}",
	"footer_base_main-container_justify-content": "{justifyContent.spaceBetween}",
	"footer_base_main-container_align-items": "{alignItems.start}",
	"footer_base_main-container_gap": "{base}",
	"footer_base_main-container_size": "{size.max}",
	"footer_base_main-container_padding-top": "{xl}",
	"footer_base_main-container_padding-bottom": "{xl}",
	"footer_base_main-container_padding-left": "{huge}",
	"footer_base_main-container_padding-right": "{huge}",
	"footer_base_social-links-container_padding-top": "{xs}",
	"footer_base_social-links-container_flex-direction": "{flexDirection.column}",
	"footer_base_social-links-container_gap": "{l}",
	"footer_base_bottom-container_flex-direction": "{flexDirection.column}",
	"footer_base_bottom-container_align-items": "{alignItems.start}",
	"footer_base_bottom-container_width": "{size.max}",
	"footer_base_content-container_width": "{size.max}",
	"footer_base_content-slot_width": "{size.max}",
	"footer_variant__platform_mobile_bottom-container_gap": "{m}",
	"footer_variant__platform_mobile_main-container_flex-direction": "{flexDirection.column}",
	"footer_variant__platform_mobile_main-container_justify-content": "{justifyContent.start}",
	"footer_variant__platform_mobile_main-container_padding-top": "{m}",
	"footer_variant__platform_mobile_main-container_padding-bottom": "{xl}",
	"footer_variant__platform_mobile_main-container_padding-left": "{m}",
	"footer_variant__platform_mobile_main-container_padding-right": "{m}",
	"footer_base_social-links-container_width": "{custom_17}"
};

const footerlinksgrid_base_container_size = "{size.max}";
const footerlinksgrid_base_container_gap = "{base}";
const FooterLinksGridTokens = {
	"footerlinksgrid_base_container_flex-direction": "{flexDirection.row}",
	footerlinksgrid_base_container_size: footerlinksgrid_base_container_size,
	footerlinksgrid_base_container_gap: footerlinksgrid_base_container_gap
};

const footericonlinks_base_container_gap = "{base}";
const FooterIconLinksTokens = {
	footericonlinks_base_container_gap: footericonlinks_base_container_gap,
	"footericonlinks_base_container_flex-direction": "{flexDirection.column}",
	"footericonlinks_base_container_align-items": "{alignItems.start}",
	"footericonlinks_base_icons-container_flex-direction": "{flexDirection.row}",
	"footericonlinks_base_icons-container_gap": "{base}"
};

const footermarketlinks_base_container_gap = "{base}";
const FooterMarketLinksTokens = {
	footermarketlinks_base_container_gap: footermarketlinks_base_container_gap,
	"footermarketlinks_base_container_flex-direction": "{flexDirection.column}",
	"footermarketlinks_base_container_align-items": "{alignItems.start}",
	"footermarketlinks_base_assets-container_flex-direction": "{flexDirection.row}",
	"footermarketlinks_base_assets-container_align-items": "{alignItems.center}",
	"footermarketlinks_base_assets-container_gap": "{base}"
};

const footerlinks_base_container_size = "{size.max}";
const FooterLinksTokens = {
	"footerlinks_base_container_flex-direction": "{flexDirection.column}",
	"footerlinks_base_container_align-items": "{alignItems.start}",
	footerlinks_base_container_size: footerlinks_base_container_size,
	"footerlinks_base_link-item-container_size": "{size.max}",
	"footerlinks_base_link-item-container_padding-top": "{xs}",
	"footerlinks_base_link-item-container_padding-bottom": "{xs}",
	"footerlinks_base_link-item-container_flex-direction": "{flexDirection.column}",
	"footerlinks_base_link-item-container_justify-content": "{justifyContent.start}",
	"footerlinks_base_link-item-container_align-items": "{alignItems.start}",
	"footerlinks_base_link-item-container_background-color": "{global.transparent}",
	"footerlinks_base_link-item-container_behavior_hover_background-color": "{primaryGrey40}",
	"footerlinks_base_title-jds_text_padding-top": "{xs}",
	"footerlinks_base_title-jds_text_padding-bottom": "{xs}",
	"footerlinks_base_links-container_padding-top": "{s}",
	"footerlinks_base_links-container_size": "{size.max}",
	"footerlinks_base_links-container_flex-direction": "{flexDirection.column}"
};

const icon_base_container_size = "{m}";
const icon_base_icon_size = "{m}";
const icon_base_icon_color = "{custom_color_1}";
const icon_variant_color_primary_50_icon_color = "{primary50}";
const icon_variant_color_primary_30_icon_color = "{primary30}";
const icon_variant_color_primary_60_icon_color = "{primary60}";
const icon_variant_color_primary_70_icon_color = "{primary70}";
const icon_variant_color_primary_background_icon_color = "{primaryBackground}";
const icon_variant_color_secondary_50_icon_color = "{secondary50}";
const icon_variant_color_sparkle_50_icon_color = "{sparkle50}";
const icon_variant_color_primary_grey_60_icon_color = "{primaryGrey60}";
const icon_variant_color_primary_grey_80_icon_color = "{primaryGrey80}";
const icon_variant_color_primary_grey_100_icon_color = "{primaryGrey100}";
const icon_variant_color_feedback_success_icon_color = "{feedbackSuccess50}";
const icon_variant_color_feedback_error_icon_color = "{feedbackError50}";
const icon_variant_color_feedback_warning_icon_color = "{feedbackWarning50}";
const icon_variant_color_white_icon_color = "{global.white}";
const icon_variant_size_small_container_size = "{base}";
const icon_variant_size_small_icon_size = "{base}";
const icon_variant_size_large_container_size = "{l}";
const icon_variant_size_large_icon_size = "{l}";
const icon_variant_size_fill_container_size = "{size.max}";
const icon_variant_size_fill_icon_size = "{size.max}";
const icon_combination_background_bold_primary_50_icon_color = "{primaryInverse}";
const icon_combination_background_bold_primary_30_icon_color = "{primary30}";
const icon_combination_background_bold_primary_60_icon_color = "{primaryInverse}";
const icon_combination_background_bold_primary_70_icon_color = "{primaryInverse}";
const icon_combination_background_bold_primary_background_icon_color = "{primaryInverse}";
const icon_combination_background_bold_secondary_50_icon_color = "{secondaryInverse}";
const icon_combination_background_bold_sparkle_50_icon_color = "{sparkleInverse}";
const icon_combination_background_bold_primary_grey_60_icon_color = "{primaryInverse}";
const icon_combination_background_bold_primary_grey_80_icon_color = "{primaryInverse}";
const icon_combination_background_bold_primary_grey_100_icon_color = "{primaryInverse}";
const icon_combination_background_bold_white_icon_color = "{global.white}";
const icon_combination_background_bold_feedback_success_50_icon_color = "{primaryInverse}";
const icon_combination_background_bold_feedback_error_50_icon_color = "{primaryInverse}";
const icon_combination_background_bold_feedback_warning_50_icon_color = "{primaryInverse}";
const icon_combination_medium_background_container_size = "{m}";
const icon_combination_medium_background_icon_size = "{base}";
const icon_combination_small_background_container_size = "{base}";
const icon_combination_small_background_icon_size = "{base}";
const icon_combination_large_background_container_size = "{l}";
const icon_combination_large_background_icon_size = "{m}";
const icon_combination_small_background_bold_primary_50_icon_color = "{primary50}";
const icon_combination_small_background_bold_primary_30_icon_color = "{primary30}";
const icon_combination_small_background_bold_primary_60_icon_color = "{primary60}";
const icon_combination_small_background_bold_primary_70_icon_color = "{primary70}";
const icon_combination_small_background_bold_primary_background_icon_color = "{primaryBackground}";
const icon_combination_small_background_bold_secondary_50_icon_color = "{secondary50}";
const icon_combination_small_background_bold_sparkle_50_icon_color = "{sparkle50}";
const icon_combination_small_background_bold_primary_grey_60_icon_color = "{primaryGrey60}";
const icon_combination_small_background_bold_primary_grey_80_icon_color = "{primaryGrey80}";
const icon_combination_small_background_bold_primary_grey_100_icon_color = "{primaryGrey100}";
const icon_combination_small_background_bold_white_icon_color = "{global.white}";
const icon_combination_small_background_bold_feedback_success_50_icon_color = "{feedbackSuccess50}";
const icon_combination_small_background_bold_feedback_error_50_icon_color = "{feedbackError50}";
const icon_combination_small_background_bold_feedback_warning_50_icon_color = "{feedbackWarning50}";
const icon_combination_medium_background_bold_container_size = "{m}";
const icon_combination_medium_background_bold_icon_size = "{base}";
const icon_combination_small_background_bold_container_size = "{base}";
const icon_combination_small_background_bold_icon_size = "{base}";
const icon_combination_large_background_bold_container_size = "{l}";
const icon_combination_large_background_bold_icon_size = "{m}";
const icon_combination_medium_background_feedback_success_container_size = "{m}";
const icon_combination_medium_background_feedback_error_container_size = "{m}";
const icon_combination_medium_background_feedback_warning_container_size = "{m}";
const icon_combination_medium_background_feedback_success_icon_size = "{m}";
const icon_combination_medium_background_feedback_error_icon_size = "{m}";
const icon_combination_medium_background_feedback_warning_icon_size = "{m}";
const icon_combination_medium_background_bold_feedback_success_container_size = "{m}";
const icon_combination_medium_background_bold_feedback_error_container_size = "{m}";
const icon_combination_medium_background_bold_feedback_warning_container_size = "{m}";
const icon_combination_medium_background_bold_feedback_success_icon_size = "{m}";
const icon_combination_medium_background_bold_feedback_error_icon_size = "{m}";
const icon_combination_medium_background_bold_feedback_warning_icon_size = "{m}";
const icon_combination_large_background_feedback_success_container_size = "{l}";
const icon_combination_large_background_feedback_error_container_size = "{l}";
const icon_combination_large_background_feedback_warning_container_size = "{l}";
const icon_combination_large_background_feedback_success_icon_size = "{l}";
const icon_combination_large_background_feedback_error_icon_size = "{l}";
const icon_combination_large_background_feedback_warning_icon_size = "{l}";
const icon_combination_large_background_bold_feedback_success_container_size = "{l}";
const icon_combination_large_background_bold_feedback_error_container_size = "{l}";
const icon_combination_large_background_bold_feedback_warning_container_size = "{l}";
const icon_combination_large_background_bold_feedback_success_icon_size = "{l}";
const icon_combination_large_background_bold_feedback_error_icon_size = "{l}";
const icon_combination_large_background_bold_feedback_warning_icon_size = "{l}";
const IconTokens = {
	"icon_base_container_background-color": "{global.transparent}",
	"icon_base_container_border-radius": "{pill}",
	icon_base_container_size: icon_base_container_size,
	"icon_base_container_justify-content": "{justifyContent.center}",
	"icon_base_container_align-items": "{alignItems.center}",
	icon_base_icon_size: icon_base_icon_size,
	icon_base_icon_color: icon_base_icon_color,
	icon_variant_color_primary_50_icon_color: icon_variant_color_primary_50_icon_color,
	icon_variant_color_primary_30_icon_color: icon_variant_color_primary_30_icon_color,
	icon_variant_color_primary_60_icon_color: icon_variant_color_primary_60_icon_color,
	icon_variant_color_primary_70_icon_color: icon_variant_color_primary_70_icon_color,
	icon_variant_color_primary_background_icon_color: icon_variant_color_primary_background_icon_color,
	icon_variant_color_secondary_50_icon_color: icon_variant_color_secondary_50_icon_color,
	icon_variant_color_sparkle_50_icon_color: icon_variant_color_sparkle_50_icon_color,
	icon_variant_color_primary_grey_60_icon_color: icon_variant_color_primary_grey_60_icon_color,
	icon_variant_color_primary_grey_80_icon_color: icon_variant_color_primary_grey_80_icon_color,
	icon_variant_color_primary_grey_100_icon_color: icon_variant_color_primary_grey_100_icon_color,
	icon_variant_color_feedback_success_icon_color: icon_variant_color_feedback_success_icon_color,
	icon_variant_color_feedback_error_icon_color: icon_variant_color_feedback_error_icon_color,
	icon_variant_color_feedback_warning_icon_color: icon_variant_color_feedback_warning_icon_color,
	icon_variant_color_white_icon_color: icon_variant_color_white_icon_color,
	icon_variant_size_small_container_size: icon_variant_size_small_container_size,
	icon_variant_size_small_icon_size: icon_variant_size_small_icon_size,
	icon_variant_size_large_container_size: icon_variant_size_large_container_size,
	icon_variant_size_large_icon_size: icon_variant_size_large_icon_size,
	"icon_variant_size_xtra-large_container_size": "{xl}",
	"icon_variant_size_xtra-large_icon_size": "{xl}",
	"icon_variant_size_xtra-xtra-large_container_size": "{xxl}",
	"icon_variant_size_xtra-xtra-large_icon_size": "{xxl}",
	icon_variant_size_fill_container_size: icon_variant_size_fill_container_size,
	icon_variant_size_fill_icon_size: icon_variant_size_fill_icon_size,
	"icon_combination_background_primary_50_container_background-color": "{primary20}",
	"icon_combination_background_primary_30_container_background-color": "{primary20}",
	"icon_combination_background_primary_60_container_background-color": "{primary20}",
	"icon_combination_background_primary_70_container_background-color": "{primary20}",
	"icon_combination_background_primary_background_container_background-color": "{primary20}",
	"icon_combination_background_secondary_50_container_background-color": "{secondary20}",
	"icon_combination_background_sparkle_50_container_background-color": "{sparkle20}",
	"icon_combination_background_primary_grey_60_container_background-color": "{primaryGrey20}",
	"icon_combination_background_primary_grey_80_container_background-color": "{primaryGrey20}",
	"icon_combination_background_primary_grey_100_container_background-color": "{primaryGrey20}",
	"icon_combination_background_white_container_background-color": "{primary20}",
	"icon_combination_background_feedback_success_50_container_background-color": "{feedbackSuccess20}",
	"icon_combination_background_feedback_error_50_container_background-color": "{feedbackError20}",
	"icon_combination_background_feedback_warning_50_container_background-color": "{feedbackWarning20}",
	"icon_combination_background_bold_primary_50_container_background-color": "{primary50}",
	icon_combination_background_bold_primary_50_icon_color: icon_combination_background_bold_primary_50_icon_color,
	"icon_combination_background_bold_primary_30_container_background-color": "{primary30}",
	icon_combination_background_bold_primary_30_icon_color: icon_combination_background_bold_primary_30_icon_color,
	"icon_combination_background_bold_primary_60_container_background-color": "{primary60}",
	icon_combination_background_bold_primary_60_icon_color: icon_combination_background_bold_primary_60_icon_color,
	"icon_combination_background_bold_primary_70_container_background-color": "{primary70}",
	icon_combination_background_bold_primary_70_icon_color: icon_combination_background_bold_primary_70_icon_color,
	"icon_combination_background_bold_primary_background_container_background-color": "{primaryBackground}",
	icon_combination_background_bold_primary_background_icon_color: icon_combination_background_bold_primary_background_icon_color,
	"icon_combination_background_bold_secondary_50_container_background-color": "{secondary50}",
	icon_combination_background_bold_secondary_50_icon_color: icon_combination_background_bold_secondary_50_icon_color,
	"icon_combination_background_bold_sparkle_50_container_background-color": "{sparkle50}",
	icon_combination_background_bold_sparkle_50_icon_color: icon_combination_background_bold_sparkle_50_icon_color,
	"icon_combination_background_bold_primary_grey_60_container_background-color": "{primaryGrey60}",
	icon_combination_background_bold_primary_grey_60_icon_color: icon_combination_background_bold_primary_grey_60_icon_color,
	"icon_combination_background_bold_primary_grey_80_container_background-color": "{primaryGrey80}",
	icon_combination_background_bold_primary_grey_80_icon_color: icon_combination_background_bold_primary_grey_80_icon_color,
	"icon_combination_background_bold_primary_grey_100_container_background-color": "{primaryGrey100}",
	icon_combination_background_bold_primary_grey_100_icon_color: icon_combination_background_bold_primary_grey_100_icon_color,
	"icon_combination_background_bold_white_container_background-color": "{global.white}",
	icon_combination_background_bold_white_icon_color: icon_combination_background_bold_white_icon_color,
	"icon_combination_background_bold_feedback_success_50_container_background-color": "{feedbackSuccess50}",
	icon_combination_background_bold_feedback_success_50_icon_color: icon_combination_background_bold_feedback_success_50_icon_color,
	"icon_combination_background_bold_feedback_error_50_container_background-color": "{feedbackError50}",
	icon_combination_background_bold_feedback_error_50_icon_color: icon_combination_background_bold_feedback_error_50_icon_color,
	"icon_combination_background_bold_feedback_warning_50_container_background-color": "{feedbackWarning50}",
	icon_combination_background_bold_feedback_warning_50_icon_color: icon_combination_background_bold_feedback_warning_50_icon_color,
	icon_combination_medium_background_container_size: icon_combination_medium_background_container_size,
	icon_combination_medium_background_icon_size: icon_combination_medium_background_icon_size,
	icon_combination_small_background_container_size: icon_combination_small_background_container_size,
	"icon_combination_small_background_container_background-color": "{global.transparent}",
	icon_combination_small_background_icon_size: icon_combination_small_background_icon_size,
	icon_combination_large_background_container_size: icon_combination_large_background_container_size,
	icon_combination_large_background_icon_size: icon_combination_large_background_icon_size,
	"icon_combination_xtra-large_background_container_size": "{xl}",
	"icon_combination_xtra-large_background_icon_size": "{custom_3}",
	"icon_combination_xtra-xtra-large_background_container_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_icon_size": "{l}",
	"icon_combination_small_background_bold_primary_50_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_primary_50_icon_color: icon_combination_small_background_bold_primary_50_icon_color,
	"icon_combination_small_background_bold_primary_30_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_primary_30_icon_color: icon_combination_small_background_bold_primary_30_icon_color,
	"icon_combination_small_background_bold_primary_60_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_primary_60_icon_color: icon_combination_small_background_bold_primary_60_icon_color,
	"icon_combination_small_background_bold_primary_70_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_primary_70_icon_color: icon_combination_small_background_bold_primary_70_icon_color,
	"icon_combination_small_background_bold_primary_background_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_primary_background_icon_color: icon_combination_small_background_bold_primary_background_icon_color,
	"icon_combination_small_background_bold_secondary_50_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_secondary_50_icon_color: icon_combination_small_background_bold_secondary_50_icon_color,
	"icon_combination_small_background_bold_sparkle_50_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_sparkle_50_icon_color: icon_combination_small_background_bold_sparkle_50_icon_color,
	"icon_combination_small_background_bold_primary_grey_60_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_primary_grey_60_icon_color: icon_combination_small_background_bold_primary_grey_60_icon_color,
	"icon_combination_small_background_bold_primary_grey_80_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_primary_grey_80_icon_color: icon_combination_small_background_bold_primary_grey_80_icon_color,
	"icon_combination_small_background_bold_primary_grey_100_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_primary_grey_100_icon_color: icon_combination_small_background_bold_primary_grey_100_icon_color,
	"icon_combination_small_background_bold_white_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_white_icon_color: icon_combination_small_background_bold_white_icon_color,
	"icon_combination_small_background_bold_feedback_success_50_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_feedback_success_50_icon_color: icon_combination_small_background_bold_feedback_success_50_icon_color,
	"icon_combination_small_background_bold_feedback_error_50_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_feedback_error_50_icon_color: icon_combination_small_background_bold_feedback_error_50_icon_color,
	"icon_combination_small_background_bold_feedback_warning_50_container_background-color": "{global.transparent}",
	icon_combination_small_background_bold_feedback_warning_50_icon_color: icon_combination_small_background_bold_feedback_warning_50_icon_color,
	icon_combination_medium_background_bold_container_size: icon_combination_medium_background_bold_container_size,
	icon_combination_medium_background_bold_icon_size: icon_combination_medium_background_bold_icon_size,
	icon_combination_small_background_bold_container_size: icon_combination_small_background_bold_container_size,
	icon_combination_small_background_bold_icon_size: icon_combination_small_background_bold_icon_size,
	icon_combination_large_background_bold_container_size: icon_combination_large_background_bold_container_size,
	icon_combination_large_background_bold_icon_size: icon_combination_large_background_bold_icon_size,
	"icon_combination_xtra-large_background_bold_container_size": "{xl}",
	"icon_combination_xtra-large_background_bold_icon_size": "{custom_3}",
	"icon_combination_xtra-xtra-large_background_bold_container_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_bold_icon_size": "{l}",
	icon_combination_medium_background_feedback_success_container_size: icon_combination_medium_background_feedback_success_container_size,
	icon_combination_medium_background_feedback_error_container_size: icon_combination_medium_background_feedback_error_container_size,
	icon_combination_medium_background_feedback_warning_container_size: icon_combination_medium_background_feedback_warning_container_size,
	icon_combination_medium_background_feedback_success_icon_size: icon_combination_medium_background_feedback_success_icon_size,
	icon_combination_medium_background_feedback_error_icon_size: icon_combination_medium_background_feedback_error_icon_size,
	icon_combination_medium_background_feedback_warning_icon_size: icon_combination_medium_background_feedback_warning_icon_size,
	icon_combination_medium_background_bold_feedback_success_container_size: icon_combination_medium_background_bold_feedback_success_container_size,
	icon_combination_medium_background_bold_feedback_error_container_size: icon_combination_medium_background_bold_feedback_error_container_size,
	icon_combination_medium_background_bold_feedback_warning_container_size: icon_combination_medium_background_bold_feedback_warning_container_size,
	icon_combination_medium_background_bold_feedback_success_icon_size: icon_combination_medium_background_bold_feedback_success_icon_size,
	icon_combination_medium_background_bold_feedback_error_icon_size: icon_combination_medium_background_bold_feedback_error_icon_size,
	icon_combination_medium_background_bold_feedback_warning_icon_size: icon_combination_medium_background_bold_feedback_warning_icon_size,
	icon_combination_large_background_feedback_success_container_size: icon_combination_large_background_feedback_success_container_size,
	icon_combination_large_background_feedback_error_container_size: icon_combination_large_background_feedback_error_container_size,
	icon_combination_large_background_feedback_warning_container_size: icon_combination_large_background_feedback_warning_container_size,
	icon_combination_large_background_feedback_success_icon_size: icon_combination_large_background_feedback_success_icon_size,
	icon_combination_large_background_feedback_error_icon_size: icon_combination_large_background_feedback_error_icon_size,
	icon_combination_large_background_feedback_warning_icon_size: icon_combination_large_background_feedback_warning_icon_size,
	icon_combination_large_background_bold_feedback_success_container_size: icon_combination_large_background_bold_feedback_success_container_size,
	icon_combination_large_background_bold_feedback_error_container_size: icon_combination_large_background_bold_feedback_error_container_size,
	icon_combination_large_background_bold_feedback_warning_container_size: icon_combination_large_background_bold_feedback_warning_container_size,
	icon_combination_large_background_bold_feedback_success_icon_size: icon_combination_large_background_bold_feedback_success_icon_size,
	icon_combination_large_background_bold_feedback_error_icon_size: icon_combination_large_background_bold_feedback_error_icon_size,
	icon_combination_large_background_bold_feedback_warning_icon_size: icon_combination_large_background_bold_feedback_warning_icon_size,
	"icon_combination_xtra-large_background_feedback_success_container_size": "{xl}",
	"icon_combination_xtra-large_background_feedback_error_container_size": "{xl}",
	"icon_combination_xtra-large_background_feedback_warning_container_size": "{xl}",
	"icon_combination_xtra-large_background_feedback_success_icon_size": "{xl}",
	"icon_combination_xtra-large_background_feedback_error_icon_size": "{xl}",
	"icon_combination_xtra-large_background_feedback_warning_icon_size": "{xl}",
	"icon_combination_xtra-large_background_bold_feedback_success_container_size": "{xl}",
	"icon_combination_xtra-large_background_bold_feedback_error_container_size": "{xl}",
	"icon_combination_xtra-large_background_bold_feedback_warning_container_size": "{xl}",
	"icon_combination_xtra-large_background_bold_feedback_success_icon_size": "{xl}",
	"icon_combination_xtra-large_background_bold_feedback_error_icon_size": "{xl}",
	"icon_combination_xtra-large_background_bold_feedback_warning_icon_size": "{xl}",
	"icon_combination_xtra-xtra-large_background_feedback_success_container_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_feedback_error_container_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_feedback_warning_container_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_feedback_success_icon_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_feedback_error_icon_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_feedback_warning_icon_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_bold_feedback_success_container_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_bold_feedback_error_container_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_bold_feedback_warning_container_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_bold_feedback_success_icon_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_bold_feedback_error_icon_size": "{xxl}",
	"icon_combination_xtra-xtra-large_background_bold_feedback_warning_icon_size": "{xxl}"
};

const image_base_container_width = "{size.min}";
const image_base_container_height = "{size.min}";
const image_base_image_width = "{size.max}";
const image_base_lottie_size = "{size.max}";
const image_base_icon_size = "{l}";
const image_base_icon_color = "{primaryGrey80}";
const image_variant_state_loading_image_opacity = "{opacity.invisible}";
const image_variant_state_empty_image_opacity = "{opacity.invisible}";
const image_variant_state_error_image_opacity = "{opacity.invisible}";
const ImageTokens = {
	"image_base_container_background-color": "{global.transparent}",
	"image_base_container_flex-direction": "{flexDirection.stack}",
	"image_base_container_justify-content": "{justifyContent.center}",
	"image_base_container_align-items": "{alignItems.center}",
	image_base_container_width: image_base_container_width,
	image_base_container_height: image_base_container_height,
	"image_base_container_border-radius": "{xl}",
	"image_base_image_aspect-ratio": "{aspect_ratio.1.1}",
	"image_base_image_border-radius": "{xl}",
	image_base_image_width: image_base_image_width,
	image_base_lottie_size: image_base_lottie_size,
	image_base_icon_size: image_base_icon_size,
	image_base_icon_color: image_base_icon_color,
	"image_base_provider-slot_width": "{size.max}",
	"image_base_skeleton-container_aspect-ratio": "{aspect_ratio.1.1}",
	"image_base_skeleton-container_width": "{size.max}",
	"image_base_skeleton-slot_size": "{size.max}",
	"image_variant_state_loading_container_background-color": "{primaryGrey20}",
	image_variant_state_loading_image_opacity: image_variant_state_loading_image_opacity,
	"image_variant_state_empty_container_background-color": "{primaryGrey20}",
	image_variant_state_empty_image_opacity: image_variant_state_empty_image_opacity,
	"image_variant_state_error_container_background-color": "{primaryGrey20}",
	image_variant_state_error_image_opacity: image_variant_state_error_image_opacity,
	"image_combination_horizontal_4_3_true_image_aspect-ratio": "{aspect_ratio.4.3}",
	"image_combination_horizontal_4_3_true_skeleton-container_aspect-ratio": "{aspect_ratio.4.3}",
	"image_combination_horizontal_4_3_false_image_aspect-ratio": "{aspect_ratio.4.3}",
	"image_combination_horizontal_4_3_false_skeleton-container_aspect-ratio": "{aspect_ratio.4.3}",
	"image_combination_horizontal_5_4_true_image_aspect-ratio": "{aspect_ratio.5.4}",
	"image_combination_horizontal_5_4_true_skeleton-container_aspect-ratio": "{aspect_ratio.5.4}",
	"image_combination_horizontal_5_4_false_image_aspect-ratio": "{aspect_ratio.5.4}",
	"image_combination_horizontal_5_4_false_skeleton-container_aspect-ratio": "{aspect_ratio.5.4}",
	"image_combination_horizontal_16_9_true_image_aspect-ratio": "{aspect_ratio.16.9}",
	"image_combination_horizontal_16_9_true_skeleton-container_aspect-ratio": "{aspect_ratio.16.9}",
	"image_combination_horizontal_16_9_false_image_aspect-ratio": "{aspect_ratio.16.9}",
	"image_combination_horizontal_16_9_false_skeleton-container_aspect-ratio": "{aspect_ratio.16.9}",
	"image_combination_vertical_4_5_true_image_aspect-ratio": "{aspect_ratio.4.5}",
	"image_combination_vertical_4_5_true_skeleton-container_aspect-ratio": "{aspect_ratio.4.5}",
	"image_combination_vertical_4_5_false_image_aspect-ratio": "{aspect_ratio.4.5}",
	"image_combination_vertical_4_5_false_skeleton-container_aspect-ratio": "{aspect_ratio.4.5}",
	"image_combination_vertical_3_4_true_image_aspect-ratio": "{aspect_ratio.3.4}",
	"image_combination_vertical_3_4_true_skeleton-container_aspect-ratio": "{aspect_ratio.3.4}",
	"image_combination_vertical_3_4_false_image_aspect-ratio": "{aspect_ratio.3.4}",
	"image_combination_vertical_3_4_false_skeleton-container_aspect-ratio": "{aspect_ratio.3.4}",
	"image_combination_vertical_9_16_true_image_aspect-ratio": "{aspect_ratio.9.16}",
	"image_combination_vertical_9_16_true_skeleton-container_aspect-ratio": "{aspect_ratio.9.16}",
	"image_combination_vertical_9_16_false_image_aspect-ratio": "{aspect_ratio.9.16}",
	"image_combination_vertical_9_16_false_skeleton-container_aspect-ratio": "{aspect_ratio.9.16}",
	"image_combination_horizontal_2_75__1_true_image_aspect-ratio": "{aspect_ratio.2_75.1}",
	"image_combination_horizontal_2_75__1_true_skeleton-container_aspect-ratio": "{aspect_ratio.2_75.1}",
	"image_combination_horizontal_2_75__1_false_image_aspect-ratio": "{aspect_ratio.2_75.1}",
	"image_combination_horizontal_2_75__1_false_skeleton-container_aspect-ratio": "{aspect_ratio.2_75.1}"
};

const inputcode_base_container_width = "{size.max}";
const inputcode_base_container_gap = "{xs}";
const inputcode_variant_disabled_true_container_opacity = "{opacity.disabled}";
const inputcode_base_container_opacity = "{opacity.enabled}";
const InputCodeTokens = {
	"inputcode_base_container_flex-direction": "{flexDirection.column}",
	"inputcode_base_container_justify-content": "{justifyContent.start}",
	"inputcode_base_container_align-items": "{alignItems.start}",
	inputcode_base_container_width: inputcode_base_container_width,
	inputcode_base_container_gap: inputcode_base_container_gap,
	"inputcode_base_field-container_flex-direction": "{flexDirection.row}",
	"inputcode_base_field-container_justify-content": "{justifyContent.center}",
	"inputcode_base_field-container_align-items": "{alignItems.center}",
	"inputcode_base_field-container_width": "{size.max}",
	"inputcode_base_field-container_gap": "{xs}",
	inputcode_variant_disabled_true_container_opacity: inputcode_variant_disabled_true_container_opacity,
	inputcode_base_container_opacity: inputcode_base_container_opacity
};

const input_base_input_width = "{size.max}";
const input_variant_disabled_true_input_opacity = "{opacity.disabled}";
const InputTokens = {
	"input_base_input_text-align": "{textAlign.start}",
	"input_base_input_placeholder-color": "{primaryGrey60}",
	"input_base_input_placeholder-font-family": "{bodyS}",
	"input_base_input_placeholder-font-size": "{bodyS}",
	"input_base_input_placeholder-font-weight": "{bodyS}",
	"input_base_input_placeholder-line-height": "{bodyS}",
	"input_base_input_placeholder-letter-spacing": "{bodyS}",
	"input_base_input_input-color": "{primaryGrey100}",
	"input_base_input_input-font-family": "{bodyS}",
	"input_base_input_input-font-size": "{bodyS}",
	"input_base_input_input-font-weight": "{bodyS}",
	"input_base_input_input-line-height": "{bodyS}",
	"input_base_input_input-letter-spacing": "{bodyS}",
	"input_base_input_cursor-color": "{primaryGrey100}",
	input_base_input_width: input_base_input_width,
	input_variant_disabled_true_input_opacity: input_variant_disabled_true_input_opacity,
	"input_variant_textAlign_center_input_text-align": "{textAlign.center}",
	"input_variant_textAlign_end_input_text-align": "{textAlign.end}",
	"input_variant_textAlign_justify_input_text-align": "{textAlign.justify}",
	"input_variant_textSize_large_input_placeholder-font-family": "{bodyL}",
	"input_variant_textSize_large_input_placeholder-font-size": "{bodyL}",
	"input_variant_textSize_large_input_placeholder-line-height": "{bodyL}",
	"input_variant_textSize_large_input_placeholder-font-weight": "{bodyL}",
	"input_variant_textSize_large_input_input-font-family": "{bodyL}",
	"input_variant_textSize_large_input_input-font-size": "{bodyL}",
	"input_variant_textSize_large_input_input-line-height": "{bodyL}",
	"input_variant_textSize_large_input_input-font-weight": "{bodyL}"
};

const inputdate_base_container_gap = "{xs}";
const inputdate_base_container_width = "{size.max}";
const inputdate_variant_disabled_true_container_opacity = "{opacity.disabled}";
const InputDateTokens = {
	"inputdate_base_container_flex-direction": "{flexDirection.column}",
	"inputdate_base_container_align-items": "{alignItems.start}",
	inputdate_base_container_gap: inputdate_base_container_gap,
	inputdate_base_container_width: inputdate_base_container_width,
	"inputdate_base_outer-container_flex-direction": "{flexDirection.row}",
	"inputdate_base_outer-container_width": "{size.max}",
	"inputdate_base_outer-container_align-items": "{alignItems.center}",
	"inputdate_base_field-container_flex-direction": "{flexDirection.column}",
	"inputdate_base_field-container_width": "{size.max}",
	"inputdate_base_field-container_align-items": "{alignItems.start}",
	"inputdate_base_input-container_width": "{size.max}",
	"inputdate_base_input-container_gap": "{s}",
	"inputdate_base_input-container_align-items": "{alignItems.stretch}",
	"inputdate_base_dd-container_flex-direction": "{flexDirection.column}",
	"inputdate_base_dd-container_gap": "{xs}",
	"inputdate_base_dd-container_align-items": "{alignItems.start}",
	"inputdate_base_dd-jds_input_textAlign": "{textAlign.start}",
	"inputdate_base_dd-active-line-container_width": "{size.max}",
	"inputdate_base_dd-feedback-container_width": "{size.max}",
	"inputdate_base_dd-feedback-container_background-color": "{primaryGrey80}",
	"inputdate_base_left-slash-container_background-color": "{primaryGrey60}",
	"inputdate_base_mm-container_flex-direction": "{flexDirection.column}",
	"inputdate_base_mm-container_gap": "{xs}",
	"inputdate_base_mm-container_align-items": "{alignItems.start}",
	"inputdate_base_mm-jds_input_textAlign": "{textAlign.start}",
	"inputdate_base_mm-active-line-container_width": "{size.max}",
	"inputdate_base_mm-feedback-container_width": "{size.max}",
	"inputdate_base_mm-feedback-container_background-color": "{primaryGrey80}",
	"inputdate_base_right-slash-container_background-color": "{primaryGrey60}",
	"inputdate_base_yy-container_flex-direction": "{flexDirection.column}",
	"inputdate_base_yy-container_gap": "{xs}",
	"inputdate_base_yy-container_align-items": "{alignItems.start}",
	"inputdate_base_yy-jds_input_textAlign": "{textAlign.start}",
	"inputdate_base_yy-active-line-container_width": "{size.max}",
	"inputdate_base_yy-feedback-container_width": "{size.max}",
	"inputdate_base_yy-feedback-container_background-color": "{primaryGrey80}",
	"inputdate_base_calendar-container_justify-content": "{justifyContent.center}",
	"inputdate_base_calendar-container_align-items": "{alignItems.center}",
	inputdate_variant_disabled_true_container_opacity: inputdate_variant_disabled_true_container_opacity,
	"inputdate_variant_error_true_dd-feedback-container_background-color": "{feedbackError50}",
	"inputdate_variant_error_true_mm-feedback-container_background-color": "{feedbackError50}",
	"inputdate_variant_error_true_yy-feedback-container_background-color": "{feedbackError50}",
	"inputdate_variant_ddError_true_dd-feedback-container_background-color": "{feedbackError50}",
	"inputdate_variant_mmError_true_mm-feedback-container_background-color": "{feedbackError50}",
	"inputdate_variant_yyError_true_yy-feedback-container_background-color": "{feedbackError50}"
};

const inputcodeitem_base_jds_input_width = "{size.max}";
const InputCodeItemTokens = {
	"inputcodeitem_base_input-container_flex-direction": "{flexDirection.column}",
	"inputcodeitem_base_input-container_justify-content": "{justifyContent.center}",
	"inputcodeitem_base_input-container_align-items": "{alignItems.center}",
	"inputcodeitem_base_input-container_gap": "{xs}",
	"inputcodeitem_base_input-container_input_width": "{size.max}",
	inputcodeitem_base_jds_input_width: inputcodeitem_base_jds_input_width,
	"inputcodeitem_base_active-line-container_flex-direction": "{flexDirection.column}",
	"inputcodeitem_base_active-line-container_justify-content": "{justifyContent.center}",
	"inputcodeitem_base_active-line-container_align-items": "{alignItems.center}",
	"inputcodeitem_base_active-line-container_width": "{size.max}",
	"inputcodeitem_base_active-line-container_padding-top": "{custom_1}",
	"inputcodeitem_base_active-line-container_padding-bottom": "{custom_1}",
	"inputcodeitem_base_feedback-container_width": "{size.max}",
	"inputcodeitem_base_feedback-container_height": "{custom_4}",
	"inputcodeitem_base_feedback-container_background-color": "{primaryGrey100}",
	"inputcodeitem_base_feedback-container_border-radius": "{custom_2}",
	"inputcodeitem_base_feedback-container_behavior_hover_background-color": "{primary50}",
	"inputcodeitem_base_feedback-container_behavior_focus_background-color": "{primary50}",
	"inputcodeitem_base_feedback-container_behavior_active_background-color": "{primary50}",
	"inputcodeitem_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
	"inputcodeitem_variant_state_error_feedback-container_background-color": "{feedbackError50}",
	"inputcodeitem_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
	"inputcodeitem_combination_none_true_feedback-container_background-color": "{primary60}"
};

const fileuploader_base_container_width = "{size.max}";
const fileuploader_base_container_gap = "{xs}";
const fileuploader_base_container_opacity = "{opacity.enabled}";
const FileUploaderTokens = {
	"fileuploader_base_container_flex-direction": "{flexDirection.column}",
	"fileuploader_base_container_justify-content": "{justifyContent.start}",
	"fileuploader_base_container_align-items": "{alignItems.start}",
	fileuploader_base_container_width: fileuploader_base_container_width,
	fileuploader_base_container_gap: fileuploader_base_container_gap,
	fileuploader_base_container_opacity: fileuploader_base_container_opacity
};

const fileuploadercontrol_base_container_gap = "{xxs}";
const fileuploadercontrol_base_container_width = "{size.max}";
const fileuploadercontrol_base_container_opacity = "{opacity.enabled}";
const FileUploaderControlTokens = {
	"fileuploadercontrol_base_container_flex-direction": "{flexDirection.column}",
	"fileuploadercontrol_base_container_justify-content": "{justifyContent.start}",
	"fileuploadercontrol_base_container_align-items": "{alignItems.start}",
	fileuploadercontrol_base_container_gap: fileuploadercontrol_base_container_gap,
	fileuploadercontrol_base_container_width: fileuploadercontrol_base_container_width,
	fileuploadercontrol_base_container_opacity: fileuploadercontrol_base_container_opacity,
	"fileuploadercontrol_base_label-container_flex-direction": "{flexDirection.row}",
	"fileuploadercontrol_base_label-container_justify-content": "{justifyContent.start}",
	"fileuploadercontrol_base_label-container_align-items": "{alignItems.center}",
	"fileuploadercontrol_base_label-container_gap": "{xxs}"
};

const fileuploaderitem_base_container_width = "{size.max}";
const fileuploaderitem_base_container_opacity = "{opacity.enabled}";
const FileUploaderItemTokens = {
	"fileuploaderitem_base_container_flex-direction": "{flexDirection.column}",
	"fileuploaderitem_base_container_justify-content": "{justifyContent.start}",
	"fileuploaderitem_base_container_align-items": "{alignItems.start}",
	fileuploaderitem_base_container_width: fileuploaderitem_base_container_width,
	fileuploaderitem_base_container_opacity: fileuploaderitem_base_container_opacity,
	"fileuploaderitem_base_container_background-color": "{primaryGrey20}",
	"fileuploaderitem_base_file-container_flex-direction": "{flexDirection.row}",
	"fileuploaderitem_base_file-container_justify-content": "{justifyContent.spaceBetween}",
	"fileuploaderitem_base_file-container_align-items": "{alignItems.center}",
	"fileuploaderitem_base_file-container_gap": "{xs}",
	"fileuploaderitem_base_file-container_padding-left": "{s}",
	"fileuploaderitem_base_file-container_width": "{size.max}",
	"fileuploaderitem_base_state-container_flex-direction": "{flexDirection.row}",
	"fileuploaderitem_base_state-container_justify-content": "{justifyContent.start}",
	"fileuploaderitem_base_state-container_align-items": "{alignItems.center}",
	"fileuploaderitem_base_state-container_gap": "{xs}",
	"fileuploaderitem_base_button-container_align-items": "{alignItems.center}"
};

const fileuploaderlist_base_container_width = "{size.max}";
const fileuploaderlist_base_container_opacity = "{opacity.enabled}";
const FileUploaderListTokens = {
	"fileuploaderlist_base_container_flex-direction": "{flexDirection.column}",
	"fileuploaderlist_base_container_justify-content": "{justifyContent.start}",
	"fileuploaderlist_base_container_align-items": "{alignItems.start}",
	fileuploaderlist_base_container_width: fileuploaderlist_base_container_width,
	fileuploaderlist_base_container_opacity: fileuploaderlist_base_container_opacity,
	"fileuploaderlist_base_container_background-color": "{primaryGrey20}",
	"fileuploaderlist_base_container_border-radius": "{large}"
};

const fileuploaderpanel_base_container_width = "{size.max}";
const fileuploaderpanel_base_container_opacity = "{opacity.enabled}";
const FileUploaderPanelTokens = {
	"fileuploaderpanel_base_container_flex-direction": "{flexDirection.column}",
	"fileuploaderpanel_base_container_justify-content": "{justifyContent.start}",
	"fileuploaderpanel_base_container_align-items": "{alignItems.start}",
	fileuploaderpanel_base_container_width: fileuploaderpanel_base_container_width,
	fileuploaderpanel_base_container_opacity: fileuploaderpanel_base_container_opacity,
	"fileuploaderpanel_base_container_background-color": "{primaryGrey20}",
	"fileuploaderpanel_base_container_border-radius": "{large}",
	"fileuploaderpanel_base_container_padding-top": "{xs}",
	"fileuploaderpanel_base_container_padding-bottom": "{xs}",
	"fileuploaderpanel_base_inner-container_padding-top": "{xs}",
	"fileuploaderpanel_base_inner-container_padding-bottom": "{xs}",
	"fileuploaderpanel_base_inner-container_padding-left": "{s}",
	"fileuploaderpanel_base_inner-container_padding-right": "{s}",
	"fileuploaderpanel_base_inner-container_width": "{size.max}"
};

const textarea_base_container_gap = "{xxs}";
const textarea_base_container_width = "{size.max}";
const textarea_base_input_width = "{size.max}";
const textarea_variant_disabled_true_container_opacity = "{opacity.disabled}";
const textarea_base_container_opacity = "{opacity.enabled}";
const TextareaTokens = {
	"textarea_base_container_flex-direction": "{flexDirection.column}",
	"textarea_base_container_justify-content": "{justifyContent.start}",
	"textarea_base_container_align-items": "{alignItems.start}",
	textarea_base_container_gap: textarea_base_container_gap,
	textarea_base_container_width: textarea_base_container_width,
	"textarea_base_field-container_flex-direction": "{flexDirection.stack}",
	"textarea_base_field-container_width": "{size.max}",
	"textarea_base_field-container_padding-bottom": "{xxs}",
	"textarea_base_field-container_justify-content": "{justifyContent.start}",
	"textarea_base_field-container_align-items": "{alignItems.end}",
	"textarea_base_input-container_flex-direction": "{flexDirection.row}",
	"textarea_base_input-container_justify-content": "{justifyContent.start}",
	"textarea_base_input-container_width": "{size.max}",
	"textarea_base_input-container_align-items": "{alignItems.center}",
	"textarea_base_input_text-align": "{textAlign.start}",
	"textarea_base_input_placeholder-color": "{primaryGrey60}",
	"textarea_base_input_placeholder-font-family": "{bodyS}",
	"textarea_base_input_placeholder-font-size": "{bodyS}",
	"textarea_base_input_placeholder-line-height": "{bodyS}",
	"textarea_base_input_placeholder-letter-spacing": "{bodyS}",
	"textarea_base_input_placeholder-font-weight": "{bodyS}",
	"textarea_base_input_input-color": "{primaryGrey100}",
	"textarea_base_input_input-font-family": "{bodyS}",
	"textarea_base_input_input-font-size": "{bodyS}",
	"textarea_base_input_input-line-height": "{bodyS}",
	"textarea_base_input_input-letter-spacing": "{bodyS}",
	"textarea_base_input_input-font-weight": "{bodyS}",
	"textarea_base_input_resize-color": "{primaryGrey100}",
	"textarea_base_input_cursor-color": "{primaryGrey100}",
	textarea_base_input_width: textarea_base_input_width,
	"textarea_base_input_behavior_hover_resize-color": "{primary50}",
	"textarea_base_input_behavior_focus_resize-color": "{primary60}",
	"textarea_base_input_behavior_active_resize-color": "{primary60}",
	"textarea_base_active-line-container_flex-direction": "{flexDirection.column}",
	"textarea_base_active-line-container_width": "{size.max}",
	"textarea_base_active-line-container_align-items": "{alignItems.center}",
	"textarea_base_feedback-container_width": "{size.max}",
	"textarea_base_feedback-container_background-color": "{primaryGrey100}",
	"textarea_base_feedback-container_behavior_hover_background-color": "{primary50}",
	"textarea_base_feedback-container_behavior_focus_background-color": "{primary60}",
	"textarea_base_feedback-container_behavior_active_background-color": "{primary60}",
	textarea_variant_disabled_true_container_opacity: textarea_variant_disabled_true_container_opacity,
	textarea_base_container_opacity: textarea_base_container_opacity,
	"textarea_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
	"textarea_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
	"textarea_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
	"textarea_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
	"textarea_variant_state_success_input_resize-color": "{feedbackSuccess50}",
	"textarea_variant_state_success_input_behavior_hover_resize-color": "{feedbackSuccess50}",
	"textarea_variant_state_success_input_behavior_focus_resize-color": "{feedbackSuccess50}",
	"textarea_variant_state_success_input_behavior_active_resize-color": "{feedbackSuccess50}",
	"textarea_variant_state_error_feedback-container_background-color": "{feedbackError50}",
	"textarea_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
	"textarea_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
	"textarea_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
	"textarea_variant_state_error_input_resize-color": "{feedbackError50}",
	"textarea_variant_state_error_input_behavior_hover_resize-color": "{feedbackError50}",
	"textarea_variant_state_error_input_behavior_focus_resize-color": "{feedbackError50}",
	"textarea_variant_state_error_input_behavior_active_resize-color": "{feedbackError50}",
	"textarea_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
	"textarea_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
	"textarea_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
	"textarea_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
	"textarea_variant_state_warning_input_resize-color": "{feedbackWarning50}",
	"textarea_variant_state_warning_input_behavior_hover_resize-color": "{feedbackWarning50}",
	"textarea_variant_state_warning_input_behavior_focus_resize-color": "{feedbackWarning50}",
	"textarea_variant_state_warning_input_behavior_active_resize-color": "{feedbackWarning50}",
	"textarea_variant__labelFocus_true_field-container_align-items": "{alignItems.start}",
	"textarea_combination_none_true_feedback-container_background-color": "{primary60}",
	"textarea_combination_none_true_input_resize-color": "{primary60}"
};

const LinkTokens = {
	"link_base_container_background-color": "{global.transparent}",
	"link_base_container_flex-direction": "{flexDirection.row}",
	"link_base_container_justify-content": "{justifyContent.center}",
	"link_base_container_align-items": "{alignItems.center}",
	"link_base_container_behavior_focus_border-radius": "{small}",
	"link_base_container_behavior_focus_border-width": "{border_normal}",
	"link_base_container_behavior_focus_border-color": "{primary60}",
	"link_variant_kind_header_container_behavior_focus_border-color": "{primary30}",
	"link_variant_kind_submenu_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}",
	"link_variant_kind_header_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}",
	"link_variant_kind_rich_text_jds_text_text-decoration": "{text-decoration.underline}",
	"link_variant_kind_rich_text_jds_text_behavior_hover_text-decoration": "{text-decoration.none}",
	"link_combination_default_none_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}"
};

const menublock_base_container_width = "{intrinsicSize.max}";
const MenuBlockTokens = {
	"menublock_base_popup_background-color": "{global.transparent}",
	"menublock_base_popup-container_flex-direction": "{flexDirection.stack}",
	"menublock_base_popup-container_width": "{size.max}",
	menublock_base_container_width: menublock_base_container_width,
	"menublock_base_container_background-color": "{primaryBackground}",
	"menublock_base_container_flex-direction": "{flexDirection.column}",
	"menublock_base_container_border-radius": "{medium}",
	"menublock_base_popup-container_max-height": "{size.max}"
};

const inputfield_base_container_gap = "{xxs}";
const inputfield_base_container_width = "{size.max}";
const inputfield_base_jds_input_textAlign = "{textAlign.start}";
const inputfield_variant_disabled_true_container_opacity = "{opacity.disabled}";
const inputfield_base_container_opacity = "{opacity.enabled}";
const InputFieldTokens = {
	"inputfield_base_container_flex-direction": "{flexDirection.column}",
	inputfield_base_container_gap: inputfield_base_container_gap,
	inputfield_base_container_width: inputfield_base_container_width,
	"inputfield_base_container_justify-content": "{justifyContent.start}",
	"inputfield_base_container_align-items": "{alignItems.start}",
	"inputfield_base_field-container_flex-direction": "{flexDirection.stack}",
	"inputfield_base_field-container_width": "{size.max}",
	"inputfield_base_field-container_align-items": "{alignItems.end}",
	"inputfield_base_field-container_justify-content": "{justifyContent.start}",
	"inputfield_base_field-container_padding-bottom": "{xxs}",
	"inputfield_base_input-container_flex-direction": "{flexDirection.row}",
	"inputfield_base_input-container_justify-content": "{justifyContent.start}",
	"inputfield_base_input-container_width": "{size.max}",
	"inputfield_base_input-container_gap": "{xs}",
	"inputfield_base_input-container_align-items": "{alignItems.center}",
	"inputfield_base_prefix-icon_size": "{m}",
	"inputfield_base_prefix-icon_color": "{primaryGrey80}",
	inputfield_base_jds_input_textAlign: inputfield_base_jds_input_textAlign,
	"inputfield_base_suffix-icon_size": "{m}",
	"inputfield_base_suffix-icon_color": "{primaryGrey80}",
	"inputfield_base_suffix-icon_behavior_hover_color": "{primary60}",
	"inputfield_base_active-line-container_flex-direction": "{flexDirection.column}",
	"inputfield_base_active-line-container_width": "{size.max}",
	"inputfield_base_active-line-container_align-items": "{alignItems.center}",
	"inputfield_base_feedback-container_width": "{size.max}",
	"inputfield_base_feedback-container_background-color": "{primaryGrey80}",
	"inputfield_base_feedback-container_behavior_hover_background-color": "{primary50}",
	"inputfield_base_feedback-container_behavior_focus_background-color": "{primary60}",
	"inputfield_base_feedback-container_behavior_active_background-color": "{primary60}",
	inputfield_variant_disabled_true_container_opacity: inputfield_variant_disabled_true_container_opacity,
	inputfield_base_container_opacity: inputfield_base_container_opacity,
	"inputfield_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
	"inputfield_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
	"inputfield_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
	"inputfield_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
	"inputfield_variant_state_error_feedback-container_background-color": "{feedbackError50}",
	"inputfield_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
	"inputfield_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
	"inputfield_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
	"inputfield_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
	"inputfield_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
	"inputfield_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
	"inputfield_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
	"inputfield_combination_true_true_field-container_align-items": "{alignItems.start}",
	"inputfield_combination_true_false_field-container_align-items": "{alignItems.start}",
	"inputfield_combination_false_true_field-container_align-items": "{alignItems.end}",
	"inputfield_combination_false_true_input_label-jds_text_padding-left": "{l}",
	"inputfield_combination_false_false_field-container_align-items": "{alignItems.end}",
	"inputfield_combination_none_true_feedback-container_background-color": "{primary60}"
};

const inputfieldv2_base_container_width = "{size.max}";
const inputfieldv2_base_container_opacity = "{opacity.enabled}";
const inputfieldv2_base_jds_input_textAlign = "{textAlign.start}";
const inputfieldv2_variant_disabled_true_container_opacity = "{opacity.disabled}";
const InputFieldV2Tokens = {
	"inputfieldv2_variant_noPrefix_input-container_padding-left": "{s}",
	"inputfieldv2_base_container_flex-direction": "{flexDirection.column}",
	inputfieldv2_base_container_width: inputfieldv2_base_container_width,
	"inputfieldv2_base_container_justify-content": "{justifyContent.start}",
	"inputfieldv2_base_container_align-items": "{alignItems.start}",
	inputfieldv2_base_container_opacity: inputfieldv2_base_container_opacity,
	"inputfieldv2_base_label-container_flex-direction": "{flexDirection.row}",
	"inputfieldv2_base_label-container_justify-content": "{justifyContent.start}",
	"inputfieldv2_base_label-container_align-items": "{alignItems.center}",
	"inputfieldv2_base_label-container_gap": "{xxs}",
	"inputfieldv2_base_label-container_padding-left": "{xs}",
	"inputfieldv2_base_label-container_padding-right": "{xs}",
	"inputfieldv2_base_label-container_padding-bottom": "{xxs}",
	"inputfieldv2_base_input-container_flex-direction": "{flexDirection.row}",
	"inputfieldv2_base_input-container_justify-content": "{justifyContent.start}",
	"inputfieldv2_base_input-container_align-items": "{alignItems.center}",
	"inputfieldv2_base_input-container_width": "{size.max}",
	"inputfieldv2_base_input-container_height": "{xl}",
	"inputfieldv2_base_input-container_gap": "{xs}",
	"inputfieldv2_base_input-container_padding-left": "{xs}",
	"inputfieldv2_base_input-container_padding-right": "{xs}",
	"inputfieldv2_base_input-container_padding-top": "{xs}",
	"inputfieldv2_base_input-container_padding-bottom": "{xs}",
	"inputfieldv2_base_input-container_border-width": "{border_thin}",
	"inputfieldv2_base_input-container_border-color": "{primaryGrey60}",
	"inputfieldv2_base_input-container_border-radius": "{medium}",
	"inputfieldv2_base_input-container_behavior_hover_border-color": "{primary50}",
	"inputfieldv2_base_input-container_behavior_active_border-color": "{primary60}",
	"inputfieldv2_base_input-container_behavior_focus_border-color": "{primary60}",
	inputfieldv2_base_jds_input_textAlign: inputfieldv2_base_jds_input_textAlign,
	"inputfieldv2_base_helper-container_flex-direction": "{flexDirection.column}",
	"inputfieldv2_base_helper-container_justify-content": "{justifyContent.start}",
	"inputfieldv2_base_helper-container_align-items": "{alignItems.start}",
	"inputfieldv2_base_helper-container_gap": "{xxs}",
	"inputfieldv2_base_dynamic-container_gap": "{xxs}",
	"inputfieldv2_base_helper-container_padding-left": "{xs}",
	"inputfieldv2_base_helper-container_padding-right": "{xs}",
	"inputfieldv2_base_helper-container_padding-top": "{xxs}",
	"inputfieldv2_base_dynamic-container_flex-direction": "{flexDirection.row}",
	"inputfieldv2_base_dynamic-container_justify-content": "{justifyContent.start}",
	"inputfieldv2_base_dynamic-container_align-items": "{alignItems.center}",
	"inputfieldv2_base_dynamic-container_padding-left": "{xs}",
	"inputfieldv2_base_dynamic-container_padding-right": "{xs}",
	inputfieldv2_variant_disabled_true_container_opacity: inputfieldv2_variant_disabled_true_container_opacity,
	"inputfieldv2_variant_state_success_input-container_border-color": "{feedbackSuccess50}",
	"inputfieldv2_variant_state_success_input-container_behavior_hover_border-color": "{feedbackSuccess50}",
	"inputfieldv2_variant_state_success_input-container_behavior_focus_border-color": "{feedbackSuccess50}",
	"inputfieldv2_variant_state_success_input-container_behavior_active_border-color": "{feedbackSuccess50}",
	"inputfieldv2_variant_state_error_input-container_border-color": "{feedbackError50}",
	"inputfieldv2_variant_state_error_input-container_behavior_hover_border-color": "{feedbackError50}",
	"inputfieldv2_variant_state_error_input-container_behavior_focus_border-color": "{feedbackError50}",
	"inputfieldv2_variant_state_error_input-container_behavior_active_border-color": "{feedbackError50}",
	"inputfieldv2_variant_state_warning_input-container_border-color": "{feedbackWarning50}",
	"inputfieldv2_variant_state_warning_input-container_behavior_hover_border-color": "{feedbackWarning50}",
	"inputfieldv2_variant_state_warning_input-container_behavior_focus_border-color": "{feedbackWarning50}",
	"inputfieldv2_variant_state_warning_input-container_behavior_active_border-color": "{feedbackWarning50}",
	"inputfieldv2_variant_size_small_input-container_height": "{l}",
	"inputfieldv2_variant_size_small_input-container_padding-top": "{xxs}",
	"inputfieldv2_variant_size_small_input-container_padding-bottom": "{xxs}",
	"inputfieldv2_variant_size_large_input-container_height": "{xxl}",
	"inputfieldv2_variant_size_large_input-container_gap": "{s}",
	"inputfieldv2_variant_size_large_input-container_padding-top": "{s}",
	"inputfieldv2_variant_size_large_input-container_padding-bottom": "{s}",
	"inputfieldv2_variant_size_large_helper-container_gap": "{xs}",
	"inputfieldv2_variant_size_large_helper-container_padding-top": "{xs}"
};

const menublockitem_base_container_opacity = "{opacity.enabled}";
const menublockitem_base_container_width = "{size.max}";
const menublockitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const MenuBlockItemTokens = {
	menublockitem_base_container_opacity: menublockitem_base_container_opacity,
	"menublockitem_base_container_background-color": "{global.transparent}",
	menublockitem_base_container_width: menublockitem_base_container_width,
	"menublockitem_base_entry-container_background-color": "{global.transparent}",
	"menublockitem_base_entry-container_width": "{size.max}",
	"menublockitem_base_entry-container_padding-top": "{xs}",
	"menublockitem_base_entry-container_padding-right": "{base}",
	"menublockitem_base_entry-container_padding-bottom": "{xs}",
	"menublockitem_base_entry-container_padding-left": "{base}",
	"menublockitem_base_entry-container_flex-direction": "{flexDirection.row}",
	"menublockitem_base_entry-container_align-items": "{alignItems.center}",
	"menublockitem_base_entry-container_justify-content": "{justifyContent.spaceBetween}",
	"menublockitem_base_entry-container_border-color": "{global.transparent}",
	"menublockitem_base_entry-container_behavior_hover_background-color": "{primaryGrey20}",
	"menublockitem_base_entry-container_behavior_focus_border-color": "{primary60}",
	"menublockitem_base_entry-container_behavior_focus_border-radius": "{small}",
	"menublockitem_base_divider-container_width": "{size.max}",
	"menublockitem_base_heading-container_padding-top": "{xs}",
	"menublockitem_base_heading-container_padding-right": "{base}",
	"menublockitem_base_heading-container_padding-bottom": "{xs}",
	"menublockitem_base_heading-container_padding-left": "{base}",
	"menublockitem_base_heading-container_width": "{size.max}",
	"menublockitem_base_heading-container_align-items": "{alignItems.center}",
	"menublockitem_base_heading-container_justify-content": "{justifyContent.start}",
	"menublockitem_base_left-container_gap": "{xs}",
	"menublockitem_base_left-container_flex-direction": "{flexDirection.row}",
	"menublockitem_base_left-container_align-items": "{alignItems.center}",
	"menublockitem_variant_selected_true_container_background-color": "{primaryGrey20}",
	menublockitem_variant_disabled_true_container_opacity: menublockitem_variant_disabled_true_container_opacity,
	"menublockitem_variant_hasIcon_true_heading-container_padding-left": "{xxl}"
};

const ListBlockTokens = {
	"listblock_base_root-container_flex-direction": "{flexDirection.column}",
	"listblock_base_root-container_width": "{size.max}",
	"listblock_base_root-container_justify-content": "{justifyContent.start}",
	"listblock_base_root-container_align-items": "{alignItems.start}",
	"listblock_base_root-container_gap": "{xs}",
	"listblock_base_root-container_padding-top": "{xs}",
	"listblock_base_root-container_padding-bottom": "{xs}",
	"listblock_base_main-container_flex-direction": "{flexDirection.row}",
	"listblock_base_main-container_width": "{size.max}",
	"listblock_base_main-container_gap": "{base}",
	"listblock_base_main-container_justify-content": "{justifyContent.start}",
	"listblock_base_main-container_align-items": "{alignItems.center}",
	"listblock_base_block-container_flex-direction": "{flexDirection.column}",
	"listblock_base_block-container_gap": "{xxs}",
	"listblock_base_block-container_justify-content": "{justifyContent.start}",
	"listblock_base_block-container_align-items": "{alignItems.start}",
	"listblock_base_caption-container_flex-direction": "{flexDirection.row}",
	"listblock_base_caption-container_width": "{size.max}",
	"listblock_base_caption-container_justify-content": "{justifyContent.spaceBetween}",
	"listblock_base_caption-container_align-items": "{alignItems.center}",
	"listblock_base_caption-container_gap": "{s}",
	"listblock_base_inner-caption-container_flex-direction": "{flexDirection.row}",
	"listblock_base_inner-caption-container_justify-content": "{justifyContent.start}",
	"listblock_base_inner-caption-container_align-items": "{alignItems.center}",
	"listblock_base_inner-caption-container_gap": "{s}",
	"listblock_base_title-container_flex-direction": "{flexDirection.row}",
	"listblock_base_title-container_width": "{size.max}",
	"listblock_base_title-container_justify-content": "{justifyContent.spaceBetween}",
	"listblock_base_title-container_align-items": "{alignItems.center}",
	"listblock_base_title-container_gap": "{s}",
	"listblock_base_inner-title-container_flex-direction": "{flexDirection.row}",
	"listblock_base_inner-title-container_justify-content": "{justifyContent.start}",
	"listblock_base_inner-title-container_align-items": "{alignItems.center}",
	"listblock_base_inner-title-container_gap": "{s}",
	"listblock_base_helper-container_flex-direction": "{flexDirection.row}",
	"listblock_base_helper-container_width": "{size.max}",
	"listblock_base_helper-container_justify-content": "{justifyContent.spaceBetween}",
	"listblock_base_helper-container_align-items": "{alignItems.center}",
	"listblock_base_helper-container_gap": "{s}",
	"listblock_base_inner-helper-container_flex-direction": "{flexDirection.row}",
	"listblock_base_inner-helper-container_justify-content": "{justifyContent.start}",
	"listblock_base_inner-helper-container_align-items": "{alignItems.center}",
	"listblock_base_inner-helper-container_gap": "{s}",
	"listblock_variant_spacing_small_main-container_gap": "{s}",
	"listblock_variant_spacing_small_root-container_gap": "{xxs}",
	"listblock_variant_verticalAlignment_top_main-container_align-items": "{alignItems.start}"
};

const bottomnavigation_base_container_width = "{size.max}";
const bottomnavigation_base_container_gap = "{m}";
const BottomNavigationTokens = {
	bottomnavigation_base_container_width: bottomnavigation_base_container_width,
	"bottomnavigation_base_container_flex-direction": "{flexDirection.row}",
	"bottomnavigation_base_container_justify-content": "{justifyContent.center}",
	"bottomnavigation_base_container_align-items": "{alignItems.center}",
	"bottomnavigation_base_container_background-color": "{primaryBackground}",
	"bottomnavigation_base_container_padding-left": "{m}",
	"bottomnavigation_base_container_padding-top": "{base}",
	"bottomnavigation_base_container_padding-right": "{m}",
	"bottomnavigation_base_container_padding-bottom": "{base}",
	bottomnavigation_base_container_gap: bottomnavigation_base_container_gap,
	"bottomnavigation_base_container_box-shadow_color": "{primaryGrey40}"
};

const ModalDesktopTokens = {
	"modaldesktop_base_popup-container_flex-direction": "{flexDirection.stack}",
	"modaldesktop_base_popup-container_justify-content": "{justifyContent.center}",
	"modaldesktop_base_popup-container_align-items": "{alignItems.center}",
	"modaldesktop_base_popup-container_size": "{size.max}",
	"modaldesktop_base_overlay-container_size": "{size.max}",
	"modaldesktop_base_overlay-container_background-color": "{global.black}",
	"modaldesktop_base_overlay-container_opacity": "{custom_2}",
	"modaldesktop_base_root-container_flex-direction": "{flexDirection.column}",
	"modaldesktop_base_root-container_justify-content": "{justifyContent.start}",
	"modaldesktop_base_root-container_align-items": "{alignItems.start}",
	"modaldesktop_base_root-container_border-radius": "{xxl}",
	"modaldesktop_base_root-container_background-color": "{primaryBackground}",
	"modaldesktop_base_root-container_max-height": "{size.max}",
	"modaldesktop_base_cancel-container_flex-direction": "{flexDirection.row}",
	"modaldesktop_base_cancel-container_justify-content": "{justifyContent.end}",
	"modaldesktop_base_cancel-container_align-items": "{alignItems.center}",
	"modaldesktop_base_cancel-container_width": "{size.max}",
	"modaldesktop_base_cancel-container_padding-top": "{s}",
	"modaldesktop_base_cancel-container_padding-bottom": "{s}",
	"modaldesktop_base_cancel-container_padding-left": "{s}",
	"modaldesktop_base_cancel-container_padding-right": "{s}",
	"modaldesktop_base_vertical-container_flex-direction": "{flexDirection.column}",
	"modaldesktop_base_vertical-container_justify-content": "{justifyContent.start}",
	"modaldesktop_base_vertical-container_align-items": "{alignItems.start}",
	"modaldesktop_base_vertical-container_padding-left": "{l}",
	"modaldesktop_base_vertical-container_padding-right": "{l}",
	"modaldesktop_base_vertical-container_padding-bottom": "{l}",
	"modaldesktop_base_vertical-container_width": "{size.max}",
	"modaldesktop_base_vertical-container_overflow": "auto",
	"modaldesktop_base_custom-container_overflow": "auto",
	"modaldesktop_base_header-container_flex-direction": "{flexDirection.row}",
	"modaldesktop_base_header-container_justify-content": "{justifyContent.start}",
	"modaldesktop_base_header-container_align-items": "{alignItems.center}",
	"modaldesktop_base_header-container_width": "{size.max}",
	"modaldesktop_base_header-container_padding-bottom": "{base}",
	"modaldesktop_base_children-container_width": "{size.max}",
	"modaldesktop_base_children-container_overflow": "auto",
	"modaldesktop_base_button-container_width": "{size.max}",
	"modaldesktop_base_button-container_justify-content": "{justifyContent.end}",
	"modaldesktop_base_button-container_align-items": "{alignItems.start}",
	"modaldesktop_base_button-container_flex-direction": "{flexDirection.row}",
	"modaldesktop_base_button-container_gap": "{s}",
	"modaldesktop_base_button-container_padding-top": "{base}",
	"modaldesktop_base_custom-container_flex-direction": "{flexDirection.column}",
	"modaldesktop_base_custom-container_justify-content": "{justifyContent.start}",
	"modaldesktop_base_custom-container_align-items": "{alignItems.start}",
	"modaldesktop_base_custom-container_border-radius": "{xxl}",
	"modaldesktop_base_custom-container_background-color": "{primaryBackground}",
	"modaldesktop_base_custom-container_padding-left": "{l}",
	"modaldesktop_base_custom-container_padding-right": "{l}",
	"modaldesktop_base_custom-container_padding-top": "{l}",
	"modaldesktop_base_custom-container_padding-bottom": "{l}",
	"modaldesktop_base_custom-container_width": "{custom_27}",
	"modaldesktop_base_custom-container_max-height": "{size.max}",
	"modaldesktop_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
	"modaldesktop_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
	"modaldesktop_variant_size_small_vertical-container_padding-left": "{m}",
	"modaldesktop_variant_size_small_vertical-container_padding-right": "{m}",
	"modaldesktop_variant_size_small_vertical-container_padding-bottom": "{m}",
	"modaldesktop_combination_dialog_false_vertical-container_padding-top": "{l}",
	"modaldesktop_combination_acknowledgement_false_vertical-container_padding-top": "{l}"
};

const bottomnavigationitem_base_container_width = "{size.max}";
const bottomnavigationitem_base_container_gap = "{xxs}";
const bottomnavigationitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const bottomnavigationitem_variant_enabled_true_container_opacity = "{opacity.enabled}";
const BottomNavigationItemTokens = {
	bottomnavigationitem_base_container_width: bottomnavigationitem_base_container_width,
	"bottomnavigationitem_base_container_flex-direction": "{flexDirection.column}",
	"bottomnavigationitem_base_container_justify-content": "{justifyContent.center}",
	"bottomnavigationitem_base_container_align-items": "{alignItems.center}",
	bottomnavigationitem_base_container_gap: bottomnavigationitem_base_container_gap,
	bottomnavigationitem_variant_disabled_true_container_opacity: bottomnavigationitem_variant_disabled_true_container_opacity,
	bottomnavigationitem_variant_enabled_true_container_opacity: bottomnavigationitem_variant_enabled_true_container_opacity
};

const ModalMobileTokens = {
	"modalmobile_base_popup-container_flex-direction": "{flexDirection.stack}",
	"modalmobile_base_popup-container_justify-content": "{justifyContent.center}",
	"modalmobile_base_popup-container_align-items": "{alignItems.center}",
	"modalmobile_base_popup-container_size": "{size.max}",
	"modalmobile_base_overlay-container_size": "{size.max}",
	"modalmobile_base_overlay-container_background-color": "{global.black}",
	"modalmobile_base_overlay-container_opacity": "{custom_2}",
	"modalmobile_base_root-container_flex-direction": "{flexDirection.column}",
	"modalmobile_base_root-container_justify-content": "{justifyContent.start}",
	"modalmobile_base_root-container_align-items": "{alignItems.start}",
	"modalmobile_base_root-container_border-radius": "{xl}",
	"modalmobile_base_root-container_width": "{size.max}",
	"modalmobile_base_root-container_max-height": "{size.max}",
	"modalmobile_base_root-container_background-color": "{primaryBackground}",
	"modalmobile_base_outer-container_flex-direction": "{flexDirection.row}",
	"modalmobile_base_outer-container_justify-content": "{justifyContent.center}",
	"modalmobile_base_outer-container_align-items": "{alignItems.center}",
	"modalmobile_base_outer-container_border-radius": "{xl}",
	"modalmobile_base_outer-container_width": "{size.max}",
	"modalmobile_base_outer-container_max-height": "{size.max}",
	"modalmobile_base_outer-container_padding-top": "{m}",
	"modalmobile_base_outer-container_padding-bottom": "{m}",
	"modalmobile_base_outer-container_padding-left": "{m}",
	"modalmobile_base_outer-container_padding-right": "{m}",
	"modalmobile_base_cancel-container_flex-direction": "{flexDirection.row}",
	"modalmobile_base_cancel-container_justify-content": "{justifyContent.end}",
	"modalmobile_base_cancel-container_align-items": "{alignItems.center}",
	"modalmobile_base_cancel-container_width": "{size.max}",
	"modalmobile_base_cancel-container_padding-top": "{s}",
	"modalmobile_base_cancel-container_padding-bottom": "{s}",
	"modalmobile_base_cancel-container_padding-left": "{s}",
	"modalmobile_base_cancel-container_padding-right": "{s}",
	"modalmobile_base_vertical-container_flex-direction": "{flexDirection.column}",
	"modalmobile_base_vertical-container_justify-content": "{justifyContent.start}",
	"modalmobile_base_vertical-container_align-items": "{alignItems.start}",
	"modalmobile_base_vertical-container_width": "{size.max}",
	"modalmobile_base_vertical-container_padding-left": "{l}",
	"modalmobile_base_vertical-container_padding-right": "{l}",
	"modalmobile_base_vertical-container_padding-bottom": "{l}",
	"modalmobile_base_vertical-container_overflow": "auto",
	"modalmobile_base_header-container_flex-direction": "{flexDirection.row}",
	"modalmobile_base_header-container_justify-content": "{justifyContent.start}",
	"modalmobile_base_header-container_align-items": "{alignItems.center}",
	"modalmobile_base_header-container_width": "{size.max}",
	"modalmobile_base_header-container_padding-bottom": "{base}",
	"modalmobile_base_children-container_width": "{size.max}",
	"modalmobile_base_children-container_overflow": "auto",
	"modalmobile_base_button-container_width": "{size.max}",
	"modalmobile_base_button-container_justify-content": "{justifyContent.start}",
	"modalmobile_base_button-container_align-items": "{alignItems.start}",
	"modalmobile_base_button-container_flex-direction": "{flexDirection.column}",
	"modalmobile_base_button-container_gap": "{s}",
	"modalmobile_base_button-container_padding-top": "{base}",
	"modalmobile_base_custom-container_flex-direction": "{flexDirection.column}",
	"modalmobile_base_custom-container_justify-content": "{justifyContent.start}",
	"modalmobile_base_custom-container_align-items": "{alignItems.start}",
	"modalmobile_base_custom-container_border-radius": "{xl}",
	"modalmobile_base_custom-container_background-color": "{primaryBackground}",
	"modalmobile_base_custom-container_padding-left": "{l}",
	"modalmobile_base_custom-container_padding-right": "{l}",
	"modalmobile_base_custom-container_padding-top": "{l}",
	"modalmobile_base_custom-container_padding-bottom": "{l}",
	"modalmobile_base_custom-container_width": "{size.max}",
	"modalmobile_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
	"modalmobile_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
	"modalmobile_variant_size_small_vertical-container_padding-left": "{m}",
	"modalmobile_variant_size_small_vertical-container_padding-right": "{m}",
	"modalmobile_variant_size_small_vertical-container_padding-bottom": "{m}",
	"modalmobile_combination_dialog_false_vertical-container_padding-top": "{l}",
	"modalmobile_combination_acknowledgement_false_vertical-container_padding-top": "{l}"
};

const headermobile_variant_fullWidth_false_container_width = "{intrinsicSize.max}";
const HeaderMobileTokens = {
	"headermobile_base_container_min-width": "{size.max}",
	"headermobile_base_container_flex-direction": "{flexDirection.column}",
	"headermobile_base_header-container_min-width": "{size.max}",
	"headermobile_base_header-container_width": "{size.max}",
	"headermobile_base_header-container_background-color": "{primary50}",
	"headermobile_base_header-container_flex-direction": "{flexDirection.row}",
	"headermobile_base_header-container_justify-content": "{justifyContent.spaceBetween}",
	"headermobile_base_header-container_align-items": "{alignItems.center}",
	"headermobile_base_header-container_padding-left": "{s}",
	"headermobile_base_header-container_padding-top": "{xs}",
	"headermobile_base_header-container_padding-right": "{s}",
	"headermobile_base_header-container_padding-bottom": "{xs}",
	"headermobile_base_header-container_gap": "{base}",
	"headermobile_base_header-container_height": "{huge}",
	"headermobile_base_left-container_flex-direction": "{flexDirection.row}",
	"headermobile_base_left-container_justify-content": "{justifyContent.start}",
	"headermobile_base_left-container_align-items": "{alignItems.center}",
	"headermobile_base_left-container_gap": "{base}",
	"headermobile_base_prefix-container_flex-direction": "{flexDirection.row}",
	"headermobile_base_prefix-container_justify-content": "{justifyContent.start}",
	"headermobile_base_prefix-container_align-items": "{alignItems.center}",
	"headermobile_base_prefix-container_gap": "{xs}",
	"headermobile_base_logo-container_flex-direction": "{flexDirection.row}",
	"headermobile_base_logo-container_justify-content": "{justifyContent.center}",
	"headermobile_base_logo-container_align-items": "{alignItems.center}",
	"headermobile_base_logo-container_gap": "{xs}",
	"headermobile_base_links-container_flex-direction": "{flexDirection.row}",
	"headermobile_base_links-container_justify-content": "{justifyContent.start}",
	"headermobile_base_links-container_align-items": "{alignItems.center}",
	"headermobile_base_links-container_gap": "{l}",
	"headermobile_base_links-container_padding-left": "{huge}",
	"headermobile_base_right-container_flex-direction": "{flexDirection.row}",
	"headermobile_base_right-container_justify-content": "{justifyContent.end}",
	"headermobile_base_right-container_align-items": "{alignItems.center}",
	"headermobile_base_right-container_gap": "{s}",
	"headermobile_base_suffix-container_flex-direction": "{flexDirection.row}",
	"headermobile_base_suffix-container_justify-content": "{justifyContent.end}",
	"headermobile_base_suffix-container_align-items": "{alignItems.center}",
	"headermobile_base_suffix-container_gap": "{s}",
	"headermobile_base_icon-links-container_flex-direction": "{flexDirection.row}",
	"headermobile_base_icon-links-container_justify-content": "{justifyContent.center}",
	"headermobile_base_icon-links-container_align-items": "{alignItems.center}",
	"headermobile_base_icon-links-container_gap": "{s}",
	"headermobile_variant__platform_mobile_header-container_padding-left": "{s}",
	"headermobile_variant__platform_mobile_header-container_padding-right": "{s}",
	"headermobile_variant__platform_mobile_header-container_gap": "{xxs}",
	"headermobile_variant__platform_mobile_left-container_gap": "{xs}",
	"headermobile_variant__platform_mobile_right-container_gap": "{xs}",
	"headermobile_variant__platform_mobile_suffix-container_gap": "{xs}",
	headermobile_variant_fullWidth_false_container_width: headermobile_variant_fullWidth_false_container_width
};

const megamenu_base_container_width = "{size.max}";
const megamenu_base_container_gap = "{base}";
const MegaMenuTokens = {
	"megamenu_base_popup-container_flex-direction": "{flexDirection.row}",
	megamenu_base_container_width: megamenu_base_container_width,
	"megamenu_base_container_flex-direction": "{flexDirection.row}",
	"megamenu_base_container_justify-content": "{justifyContent.start}",
	"megamenu_base_container_align-items": "{alignItems.start}",
	"megamenu_base_container_background-color": "{primaryBackground}",
	"megamenu_base_container_padding-top": "{m}",
	"megamenu_base_container_padding-bottom": "{m}",
	"megamenu_base_container_padding-right": "{xxl}",
	"megamenu_base_container_padding-left": "{xxl}",
	megamenu_base_container_gap: megamenu_base_container_gap
};

const megamenublock_base_container_gap = "{base}";
const MegaMenuBlockTokens = {
	"megamenublock_base_container_flex-direction": "{flexDirection.column}",
	"megamenublock_base_container_justify-content": "{justifyContent.start}",
	"megamenublock_base_container_align-items": "{alignItems.start}",
	megamenublock_base_container_gap: megamenublock_base_container_gap,
	"megamenublock_base_links-container_flex-direction": "{flexDirection.column}",
	"megamenublock_base_links-container_justify-content": "{justifyContent.start}",
	"megamenublock_base_links-container_align-items": "{alignItems.start}",
	"megamenublock_base_heading-jds_text_padding-top": "{xs}"
};

const headerdesktop_base_header_container_height = "{custom_16}";
const headerdesktop_base_jds_search_box_width = "{size.max}";
const headerdesktop_variant__platform_mobile_header_container_height = "{huge}";
const headerdesktop_variant_variant_active_search_jds_search_box_width = "{size.max}";
const headerdesktop_variant_fullWidth_false_container_width = "{intrinsicSize.max}";
const HeaderDesktopTokens = {
	"headerdesktop_base_container_min-width": "{size.max}",
	"headerdesktop_base_container_flex-direction": "{flexDirection.column}",
	"headerdesktop_base_prefix-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_prefix-container_justify-content": "{justifyContent.start}",
	"headerdesktop_base_prefix-container_align-items": "{alignItems.center}",
	"headerdesktop_base_prefix-container_gap": "{xs}",
	"headerdesktop_base_header-container_min-width": "{size.max}",
	"headerdesktop_base_header-container_background-color": "{primary50}",
	"headerdesktop_base_header-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_header-container_justify-content": "{justifyContent.end}",
	"headerdesktop_base_header-container_align-items": "{alignItems.center}",
	"headerdesktop_base_header-container_padding-left": "{xxl}",
	"headerdesktop_base_header-container_padding-top": "{s}",
	"headerdesktop_base_header-container_padding-right": "{xxl}",
	"headerdesktop_base_header-container_padding-bottom": "{s}",
	"headerdesktop_base_header-container_gap": "{base}",
	headerdesktop_base_header_container_height: headerdesktop_base_header_container_height,
	"headerdesktop_base_left-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_left-container_justify-content": "{justifyContent.start}",
	"headerdesktop_base_left-container_align-items": "{alignItems.center}",
	"headerdesktop_base_left-container_gap": "{base}",
	"headerdesktop_base_logo-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_logo-container_justify-content": "{justifyContent.center}",
	"headerdesktop_base_logo-container_align-items": "{alignItems.center}",
	"headerdesktop_base_logo-container_gap": "{xs}",
	"headerdesktop_base_profile-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_profile-container_justify-content": "{justifyContent.center}",
	"headerdesktop_base_profile-container_align-items": "{alignItems.center}",
	"headerdesktop_base_profile-container_gap": "{xs}",
	"headerdesktop_base_links-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_links-container_justify-content": "{justifyContent.start}",
	"headerdesktop_base_links-container_align-items": "{alignItems.center}",
	"headerdesktop_base_links-container_gap": "{l}",
	"headerdesktop_base_links-container_padding-left": "{huge}",
	"headerdesktop_base_right-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_right-container_justify-content": "{justifyContent.end}",
	"headerdesktop_base_right-container_align-items": "{alignItems.center}",
	"headerdesktop_base_right-container_gap": "{s}",
	"headerdesktop_base_suffix-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_suffix-container_justify-content": "{justifyContent.end}",
	"headerdesktop_base_suffix-container_align-items": "{alignItems.center}",
	"headerdesktop_base_suffix-container_gap": "{s}",
	"headerdesktop_base_suffix-container_width": "{size.max}",
	"headerdesktop_base_icon-links-container_flex-direction": "{flexDirection.row}",
	"headerdesktop_base_icon-links-container_justify-content": "{justifyContent.center}",
	"headerdesktop_base_icon-links-container_align-items": "{alignItems.center}",
	"headerdesktop_base_icon-links-container_gap": "{s}",
	headerdesktop_base_jds_search_box_width: headerdesktop_base_jds_search_box_width,
	headerdesktop_variant__platform_mobile_header_container_height: headerdesktop_variant__platform_mobile_header_container_height,
	"headerdesktop_variant__platform_mobile_header-container_padding-left": "{s}",
	"headerdesktop_variant__platform_mobile_header-container_padding-right": "{s}",
	"headerdesktop_variant__platform_mobile_header-container_gap": "{s}",
	"headerdesktop_variant__platform_mobile_left-container_gap": "{xs}",
	"headerdesktop_variant__platform_mobile_right-container_gap": "{xs}",
	"headerdesktop_variant__platform_mobile_suffix-container_gap": "{xs}",
	"headerdesktop_variant_variant_default_left-container_width": "{size.max}",
	"headerdesktop_variant_variant_active_search_header-container_justify-content": "{justifyContent.spaceBetween}",
	headerdesktop_variant_variant_active_search_jds_search_box_width: headerdesktop_variant_variant_active_search_jds_search_box_width,
	headerdesktop_variant_fullWidth_false_container_width: headerdesktop_variant_fullWidth_false_container_width,
	"headerdesktop_combinaton_mobile_false_header-container_justify-content": "{justifyContent.spaceBetween}"
};

const sidepanel_base_container_height = "{size.max}";
const sidepanel_combination_true_desktop_container_width = "{size.max}";
const sidepanel_combination_true_mobile_container_width = "{size.max}";
const sidepanel_combination_false_mobile_container_width = 376;
const SidePanelTokens = {
	"sidepanel_base_popup-container_height": "{size.max}",
	"sidepanel_base_popup-container_width": "{size.max}",
	"sidepanel_base_popup-container_flex-direction": "{flexDirection.row}",
	"sidepanel_base_popup-container_justify-content": "{justifyContent.start}",
	"sidepanel_base_popup-container_align-items": "{alignItems.center}",
	sidepanel_base_container_height: sidepanel_base_container_height,
	"sidepanel_base_container_flex-direction": "{flexDirection.column}",
	"sidepanel_base_container_background-color": "{primaryBackground}",
	"sidepanel_base_section-container_height": "{size.max}",
	"sidepanel_base_section-container_width": "{size.max}",
	"sidepanel_base_section-container_flex-direction": "{flexDirection.column}",
	"sidepanel_base_section-container_justify-content": "{justifyContent.start}",
	"sidepanel_base_section-container_align-items": "{alignItems.center}",
	"sidepanel_base_section-container_padding-left": "{m}",
	"sidepanel_base_section-container_padding-top": "{m}",
	"sidepanel_base_section-container_padding-right": "{m}",
	"sidepanel_base_header-container_background-color": "{primary50}",
	"sidepanel_base_header-container_padding-top": "{s}",
	"sidepanel_base_header-container_padding-bottom": "{s}",
	"sidepanel_base_header-container_padding-right": "{m}",
	"sidepanel_base_header-container_padding-left": "{m}",
	"sidepanel_base_header-container_width": "{size.max}",
	"sidepanel_base_header-container_justify-content": "{justifyContent.spaceBetween}",
	"sidepanel_base_header-container_align-items": "{alignItems.center}",
	"sidepanel_base_left-container_flex-direction": "{flexDirection.row}",
	"sidepanel_base_left-container_gap": "{s}",
	"sidepanel_base_left-container_align-items": "{alignItems.center}",
	"sidepanel_variant_direction_right_popup-container_justify-content": "{justifyContent.end}",
	sidepanel_combination_true_desktop_container_width: sidepanel_combination_true_desktop_container_width,
	sidepanel_combination_true_mobile_container_width: sidepanel_combination_true_mobile_container_width,
	sidepanel_combination_false_mobile_container_width: sidepanel_combination_false_mobile_container_width
};

const MegaMenuItemTokens = {
	"megamenuitem_base_container_flex-direction": "{flexDirection.row}",
	"megamenuitem_base_container_justify-content": "{justifyContent.start}",
	"megamenuitem_base_container_align-items": "{alignItems.start}",
	"megamenuitem_base_container_padding-top": "{xs}",
	"megamenuitem_base_container_padding-bottom": "{xs}"
};

const sidepanelitem_base_container_width = "{size.max}";
const SidePanelItemTokens = {
	"sidepanelitem_base_heading-jds_text_padding-top": "{xl}",
	"sidepanelitem_base_heading-jds_text_padding-bottom": "{xs}",
	"sidepanelitem_base_container_flex-direction": "{flexDirection.row}",
	"sidepanelitem_base_container_justify-content": "{justifyContent.spaceBetween}",
	"sidepanelitem_base_container_align-items": "{alignItems.center}",
	sidepanelitem_base_container_width: sidepanelitem_base_container_width,
	"sidepanelitem_base_inner-container_flex-direction": "{flexDirection.row}",
	"sidepanelitem_base_inner-container_justify-content": "{justifyContent.start}",
	"sidepanelitem_base_inner-container_align-items": "{alignItems.center}",
	"sidepanelitem_base_inner-container_gap": "{base}",
	"sidepanelitem_base_inner-container_padding-top": "{s}",
	"sidepanelitem_base_inner-container_padding-bottom": "{s}"
};

const NotificationBannerTokens = {
	"notificationbanner_base_root-container_min-height": "{custom_11}",
	"notificationbanner_base_root-container_width": "{size.max}",
	"notificationbanner_base_root-container_flex-direction": "{flexDirection.column}",
	"notificationbanner_base_root-container_justify-content": "{justifyContent.center}",
	"notificationbanner_base_root-container_align-items": "{alignItems.center}",
	"notificationbanner_base_root-container_padding-top": "{base}",
	"notificationbanner_base_root-container_padding-right": "{base}",
	"notificationbanner_base_root-container_padding-bottom": "{base}",
	"notificationbanner_base_root-container_padding-left": "{base}",
	"notificationbanner_base_root-container_gap": "{base}",
	"notificationbanner_base_root-container_border-radius": "{large}",
	"notificationbanner_base_root-container_background-color": "{primaryGrey20}",
	"notificationbanner_base_main-container_flex-direction": "{flexDirection.row}",
	"notificationbanner_base_main-container_justify-content": "{justifyContent.start}",
	"notificationbanner_base_main-container_align-items": "{alignItems.start}",
	"notificationbanner_base_main-container_width": "{size.max}",
	"notificationbanner_base_main-container_gap": "{s}",
	"notificationbanner_base_text-container_justify-content": "{justifyContent.start}",
	"notificationbanner_base_text-container_align-items": "{alignItems.start}",
	"notificationbanner_base_text-container_flex-direction": "{flexDirection.column}",
	"notificationbanner_base_text-container_gap": "{xxs}",
	"notificationbanner_base_button-container_flex-direction": "{flexDirection.row}",
	"notificationbanner_base_button-container_gap": "{xs}",
	"notificationbanner_base_bottom-container_width": "{size.max}",
	"notificationbanner_base_bottom-container_flex-direction": "{flexDirection.row}",
	"notificationbanner_base_bottom-container_justify-content": "{justifyContent.end}",
	"notificationbanner_base_bottom-container_align-items": "{alignItems.center}",
	"notificationbanner_variant__hasDescription_false_main-container_align-items": "{alignItems.center}",
	"notificationbanner_combination_true_desktop_root-container_padding-left": "{custom_3}",
	"notificationbanner_combination_true_desktop_root-container_padding-right": "{custom_3}",
	"notificationbanner_combination_true_mobile_root-container_padding-left": "{m}",
	"notificationbanner_combination_true_mobile_root-container_padding-right": "{m}",
	"notificationbanner_combination_true_tablet_root-container_padding-left": "{l}",
	"notificationbanner_combination_true_tablet_root-container_padding-right": "{l}"
};

const notificationbutton_variant_isDisabled_true_container_opacity = "{opacity.disabled}";
const notificationbutton_base_icon_color = "{primary20}";
const notificationbutton_base_icon_size = "{base}";
const NotificationButtonTokens = {
	"notificationbutton_base_container_padding-top": "{xxs}",
	"notificationbutton_base_container_padding-right": "{base}",
	"notificationbutton_base_container_padding-bottom": "{xxs}",
	"notificationbutton_base_container_padding-left": "{base}",
	"notificationbutton_base_container_background-color": "{global.transparent}",
	"notificationbutton_base_container_border-color": "{primaryGrey60}",
	"notificationbutton_base_container_behavior_hover_border-color": "{primary20}",
	"notificationbutton_base_container_behavior_active_background-color": "{primary30}",
	"notificationbutton_base_container_behavior_focus_border-color": "{primary50}",
	notificationbutton_variant_isDisabled_true_container_opacity: notificationbutton_variant_isDisabled_true_container_opacity,
	"notificationbutton_variant_kind_tertiary_container_behavior_hover_background-color": "{primary30}",
	"notificationbutton_variant_kind_tertiary_container_behavior_active_background-color": "{primary40}",
	"notificationbutton_variant_kind_tertiary_container_behavior_focus_background-color": "{primary30}",
	notificationbutton_base_icon_color: notificationbutton_base_icon_color,
	notificationbutton_base_icon_size: notificationbutton_base_icon_size,
	"notificationbutton_variant__hasLabel_false_container_padding-top": "{xs}",
	"notificationbutton_variant__hasLabel_false_container_padding-bottom": "{xs}",
	"notificationbutton_variant__hasLabel_false_container_padding-left": "{xs}",
	"notificationbutton_variant__hasLabel_false_container_padding-right": "{xs}"
};

const notificationiconbutton_base_container_height = "{l}";
const notificationiconbutton_base_container_width = "{l}";
const notificationiconbutton_base_icon_size = "{base}";
const notificationiconbutton_base_icon_color = "{primary20}";
const notificationiconbutton_variant_isDisabled_true_container_opacity = "{opacity.disabled}";
const NotificationIconButtonTokens = {
	notificationiconbutton_base_container_height: notificationiconbutton_base_container_height,
	notificationiconbutton_base_container_width: notificationiconbutton_base_container_width,
	"notificationiconbutton_base_container_justify-content": "{justifyContent.center}",
	"notificationiconbutton_base_container_align-items": "{alignItems.center}",
	"notificationiconbutton_base_container_background-color": "{global.transparent}",
	"notificationiconbutton_base_container_border-color": "{global.transparent}",
	"notificationiconbutton_base_container_behavior_hover_background-color": "{primary30}",
	"notificationiconbutton_base_container_behavior_active_background-color": "{primary40}",
	"notificationiconbutton_base_container_behavior_focus_background-color": "{primary30}",
	"notificationiconbutton_base_container_behavior_focus_border-color": "{primary50}",
	notificationiconbutton_base_icon_size: notificationiconbutton_base_icon_size,
	notificationiconbutton_base_icon_color: notificationiconbutton_base_icon_color,
	notificationiconbutton_variant_isDisabled_true_container_opacity: notificationiconbutton_variant_isDisabled_true_container_opacity
};

const NudgeTokens = {
	"nudge_base_root-container_width": "{size.max}",
	"nudge_base_root-container_max-width": "{size.max}",
	"nudge_base_root-container_border-radius": "{xl}",
	"nudge_base_root-container_background-color": "{primaryGrey80}",
	"nudge_base_root-container_flex-direction": "{flexDirection.column}",
	"nudge_base_root-container_gap": "{base}",
	"nudge_base_root-container_padding-top": "{base}",
	"nudge_base_root-container_padding-right": "{base}",
	"nudge_base_root-container_padding-bottom": "{base}",
	"nudge_base_root-container_padding-left": "{base}",
	"nudge_base_base-container_gap": "{s}",
	"nudge_base_base-container_width": "{size.max}",
	"nudge_base_base-container_flex-direction": "{flexDirection.row}",
	"nudge_base_base-container_justify-content": "{justifyContent.start}",
	"nudge_base_base-container_align-items": "{alignItems.center}",
	"nudge_base_center-container_flex-direction": "{flexDirection.column}",
	"nudge_base_center-container_justify-content": "{justifyContent.start}",
	"nudge_base_center-container_align-items": "{alignItems.start}",
	"nudge_base_center-container_gap": "{s}",
	"nudge_base_buttons-container_width": "{size.max}",
	"nudge_base_buttons-container_gap": "{s}",
	"nudge_base_buttons-container_flex-direction": "{flexDirection.row}",
	"nudge_base_buttons-container_justify-content": "{justifyContent.end}",
	"nudge_variant__platform_tablet_root-container_max-width": "{custom_13}",
	"nudge_variant__platform_desktop_root-container_max-width": "{custom_14}"
};

const ToastTokens = {
	"toast_base_root-container_width": "{size.max}",
	"toast_base_root-container_max-width": "{size.max}",
	"toast_base_root-container_border-radius": "{xl}",
	"toast_base_root-container_background-color": "{primaryGrey80}",
	"toast_base_root-container_flex-direction": "{flexDirection.column}",
	"toast_base_root-container_gap": "{base}",
	"toast_base_root-container_padding-top": "{base}",
	"toast_base_root-container_padding-right": "{base}",
	"toast_base_root-container_padding-bottom": "{base}",
	"toast_base_root-container_padding-left": "{base}",
	"toast_base_base-container_gap": "{s}",
	"toast_base_base-container_width": "{size.max}",
	"toast_base_base-container_flex-direction": "{flexDirection.row}",
	"toast_base_base-container_justify-content": "{justifyContent.start}",
	"toast_base_base-container_align-items": "{alignItems.center}",
	"toast_base_center-container_flex-direction": "{flexDirection.column}",
	"toast_base_center-container_justify-content": "{justifyContent.start}",
	"toast_base_center-container_align-items": "{alignItems.start}",
	"toast_base_center-container_gap": "{xxs}",
	"toast_base_buttons-container_width": "{size.max}",
	"toast_base_buttons-container_gap": "{s}",
	"toast_base_buttons-container_flex-direction": "{flexDirection.row}",
	"toast_base_buttons-container_justify-content": "{justifyContent.end}",
	"toast_variant__platform_tablet_root-container_max-width": "{custom_13}",
	"toast_variant__platform_desktop_root-container_max-width": "{custom_14}"
};

const NudgeContainerTokens = {
	"nudgecontainer_base_popup-container_flex-direction": "{flexDirection.stack}",
	"nudgecontainer_base_popup-container_size": "{size.max}",
	"nudgecontainer_base_popup-container_padding-top": "{base}",
	"nudgecontainer_base_popup-container_padding-right": "{base}",
	"nudgecontainer_base_popup-container_padding-bottom": "{base}",
	"nudgecontainer_base_popup-container_padding-left": "{base}",
	"nudgecontainer_base_root-container_flex-direction": "{flexDirection.column}",
	"nudgecontainer_base_root-container_justify-content": "{justifyContent.start}",
	"nudgecontainer_base_root-container_align-items": "{alignItems.end}",
	"nudgecontainer_base_root-container_size": "{size.max}",
	"nudgecontainer_base_root-container_gap": "{xs}"
};

const ToastContainerTokens = {
	"toastcontainer_base_popup-container_flex-direction": "{flexDirection.stack}",
	"toastcontainer_base_popup-container_size": "{size.max}",
	"toastcontainer_base_popup-container_padding-top": "{base}",
	"toastcontainer_base_popup-container_padding-right": "{base}",
	"toastcontainer_base_popup-container_padding-bottom": "{base}",
	"toastcontainer_base_popup-container_padding-left": "{base}",
	"toastcontainer_base_root-container_flex-direction": "{flexDirection.column}",
	"toastcontainer_base_root-container_justify-content": "{justifyContent.end}",
	"toastcontainer_base_root-container_align-items": "{alignItems.start}",
	"toastcontainer_base_root-container_size": "{size.max}",
	"toastcontainer_base_root-container_gap": "{xs}"
};

const progressbar_base_container_gap = "{base}";
const progressbar_base_container_width = "{size.max}";
const ProgressBarTokens = {
	"progressbar_base_container_flex-direction": "{flexDirection.column}",
	"progressbar_base_container_justify-content": "{justifyContent.center}",
	"progressbar_base_container_align-items": "{alignItems.start}",
	progressbar_base_container_gap: progressbar_base_container_gap,
	progressbar_base_container_width: progressbar_base_container_width,
	"progressbar_base_container_background-color": "{global.transparent}",
	"progressbar_base_top-container_background-color": "{global.transparent}",
	"progressbar_base_top-container_flex-direction": "{flexDirection.row}",
	"progressbar_base_top-container_justify-content": "{justifyContent.spaceBetween}",
	"progressbar_base_top-container_align-items": "{alignItems.center}",
	"progressbar_base_top-container_width": "{size.max}",
	"progressbar_base_top-container_gap": "{m}",
	"progressbar_base_determinate-container_background-color": "{primaryGrey40}",
	"progressbar_base_determinate-container_height": "{xs}",
	"progressbar_base_determinate-container_width": "{size.max}",
	"progressbar_base_determinate-container_flex-direction": "{flexDirection.row}",
	"progressbar_base_determinate-container_justify-content": "{justifyContent.start}",
	"progressbar_base_determinate-container_align-items": "{alignItems.start}",
	"progressbar_base_determinate-container_border-radius": "{pill}",
	"progressbar_base_active-container_background-color": "{primary50}",
	"progressbar_base_active-container_height": "{xs}",
	"progressbar_base_active-container_border-radius": "{pill}",
	"progressbar_base_invisible-container_height": "{xs}",
	"progressbar_base_indeterminate-container_flex-direction": "{flexDirection.stack}",
	"progressbar_base_indeterminate-container_background-color": "{primaryGrey40}",
	"progressbar_base_indeterminate-container_height": "{xs}",
	"progressbar_base_indeterminate-container_width": "{size.max}",
	"progressbar_base_indeterminate-container_border-radius": "{pill}",
	"progressbar_base_track-container_height": "{size.max}",
	"progressbar_base_active-animatedContainer_height": "{size.max}",
	"progressbar_base_active-animatedContainer_width": "{massive}",
	"progressbar_base_active-animatedContainer_background-color": "{primary50}",
	"progressbar_base_active-animatedContainer_border-radius": "{pill}",
	"progressbar_variant_state_success_active-container_background-color": "{feedbackSuccess50}",
	"progressbar_variant_state_success_active-animatedContainer_background-color": "{feedbackSuccess50}",
	"progressbar_variant_state_error_active-container_background-color": "{feedbackError50}",
	"progressbar_variant_state_error_active-animatedContainer_background-color": "{feedbackError50}",
	"progressbar_variant_state_warning_active-container_background-color": "{feedbackWarning50}",
	"progressbar_variant_state_warning_active-animatedContainer_background-color": "{feedbackWarning50}",
	"progressbar_variant_labelPosition_center_top-container_justify-content": "{justifyContent.center}"
};

const pagination_base_container_width = "{size.max}";
const PaginationTokens = {
	"pagination_base_container_background-color": "{global.transparent}",
	"pagination_base_container_flex-direction": "{flexDirection.row}",
	"pagination_base_container_justify-content": "{alignItems.center}",
	"pagination_base_container_align-items": "{alignItems.center}",
	"pagination_base_container_padding-left": "{custom_25}",
	"pagination_base_container_padding-right": "{custom_25}",
	pagination_base_container_width: pagination_base_container_width,
	"pagination_base_container_min-height": "{xxl}",
	"pagination_base_basic-container_flex-direction": "{flexDirection.row}",
	"pagination_base_compact-container_flex-direction": "{flexDirection.row}",
	"pagination_base_compact-container_gap": "{xxs}",
	"pagination_base_compact-container_padding-left": "{base}",
	"pagination_base_compact-container_padding-right": "{base}"
};

const PromoCardTokens = {
	"promocard_base_root-container_background-color": "{global.white}",
	"promocard_base_root-container_flex-direction": "{flexDirection.column}",
	"promocard_base_root-container_width": "{size.max}",
	"promocard_base_root-container_justify-content": "{justifyContent.start}",
	"promocard_base_root-container_align-items": "{alignItems.start}",
	"promocard_base_root-container_border-radius": "{xl}",
	"promocard_base_vertical-container_flex-direction": "{flexDirection.column}",
	"promocard_base_vertical-container_align-items": "{alignItems.start}",
	"promocard_base_vertical-container_justify-content": "{justifyContent.start}",
	"promocard_base_vertical-container_width": "{size.max}",
	"promocard_base_vertical-container_border-radius": "{xl}",
	"promocard_base_vertical-container_background-color": "{primaryBackground}",
	"promocard_base_horizontal-container_flex-direction": "{flexDirection.row}",
	"promocard_base_horizontal-container_align-items": "{alignItems.stretch}",
	"promocard_base_horizontal-container_justify-content": "{justifyContent.start}",
	"promocard_base_horizontal-container_width": "{size.max}",
	"promocard_base_horizontal-container_border-radius": "{xl}",
	"promocard_base_horizontal-container_height": "{intrinsicSize.max}",
	"promocard_base_horizontal-container_background-color": "{primaryBackground}",
	"promocard_base_vertical-content-container_flex-direction": "{flexDirection.row}",
	"promocard_base_vertical-content-container_align-items": "{alignItems.start}",
	"promocard_base_vertical-content-container_justify-content": "{justifyContent.start}",
	"promocard_base_vertical-content-container_width": "{size.max}",
	"promocard_base_vertical-content-container_background-color": "{primaryBackground}",
	"promocard_base_vertical-content-container_border-bottom-left-radius": "{xl}",
	"promocard_base_vertical-content-container_border-bottom-right-radius": "{xl}",
	"promocard_base_vertical-content-container_padding-right": "{m}",
	"promocard_base_vertical-content-container_padding-bottom": "{m}",
	"promocard_base_vertical-content-container_padding-left": "{m}",
	"promocard_base_horizontal-content-container_flex-direction": "{flexDirection.row}",
	"promocard_base_horizontal-content-container_align-items": "{alignItems.start}",
	"promocard_base_horizontal-content-container_justify-content": "{justifyContent.start}",
	"promocard_base_horizontal-content-container_height": "{size.max}",
	"promocard_base_horizontal-content-container_background-color": "{primaryBackground}",
	"promocard_base_horizontal-content-container_padding-top": "{m}",
	"promocard_base_horizontal-content-container_padding-right": "{m}",
	"promocard_base_horizontal-content-container_padding-bottom": "{m}",
	"promocard_base_horizontal-content-container_padding-left": "{m}",
	"promocard_base_vertical-image-container_width": "{size.max}",
	"promocard_base_vertical-image-container_flex-direction": "{flexDirection.stack}",
	"promocard_base_vertical-image-container_align-items": "{alignItems.end}",
	"promocard_base_horizontal-image-container_height": "{size.max}",
	"promocard_base_horizontal-image-container_flex-direction": "{flexDirection.stack}",
	"promocard_base_horizontal-image-container_align-items": "{alignItems.center}",
	"promocard_base_horizontal-image-container_justify-content": "{justifyContent.start}",
	"promocard_base_horizontal-image_height": "{size.max}",
	"promocard_base_vertical-promoCardArc_color": "{primaryBackground}",
	"promocard_base_vertical-promoCardArc_width": "{size.max}",
	"promocard_base_vertical-promoCardArc_height": "{xl}",
	"promocard_base_horizontal-promoCardArc_color": "{primaryBackground}",
	"promocard_base_horizontal-promoCardArc_height": "{size.max}",
	"promocard_base_horizontal-promoCardArc_width": "{xl}",
	"promocard_base_footer-container_color": "{primaryBackground}",
	"promocard_base_footer-container_width": "{size.max}",
	"promocard_base_footer-container_justify-content": "{justifyContent.spaceBetween}",
	"promocard_base_footer-container_align-items": "{alignItems.center}",
	"promocard_base_footer-container_flex-direction": "{flexDirection.row}",
	"promocard_base_footer-container_gap": "{base}",
	"promocard_base_footer-container_padding-left": "{m}",
	"promocard_base_footer-container_padding-right": "{m}",
	"promocard_base_footer-container_padding-top": "{base}",
	"promocard_base_footer-container_padding-bottom": "{base}",
	"promocard_variant_size_medium_horizontal-content-container_padding-top": "{l}",
	"promocard_variant_size_medium_horizontal-content-container_padding-right": "{l}",
	"promocard_variant_size_medium_horizontal-content-container_padding-bottom": "{l}",
	"promocard_variant_size_medium_horizontal-content-container_padding-left": "{l}",
	"promocard_variant_size_large_horizontal-content-container_padding-top": "{l}",
	"promocard_variant_size_large_horizontal-content-container_padding-right": "{l}",
	"promocard_variant_size_large_horizontal-content-container_padding-bottom": "{l}",
	"promocard_variant_size_large_horizontal-content-container_padding-left": "{l}"
};

const searchresultitem_base_container_gap = "{base}";
const searchresultitem_base_container_width = "{size.max}";
const searchresultitem_base_icon_size = "{l}";
const searchresultitem_base_icon_color = "{primaryGrey80}";
const SearchResultItemTokens = {
	"searchresultitem_base_container_flex-direction": "{flexDirection.row}",
	searchresultitem_base_container_gap: searchresultitem_base_container_gap,
	"searchresultitem_base_container_padding-top": "{xs}",
	"searchresultitem_base_container_padding-bottom": "{xs}",
	"searchresultitem_base_container_align-items": "{alignItems.center}",
	searchresultitem_base_container_width: searchresultitem_base_container_width,
	"searchresultitem_base_container_behavior_hover_background-color": "{primaryGrey20}",
	"searchresultitem_base_container_behavior_active_background-color": "{primaryGrey20}",
	"searchresultitem_base_container_behavior_focus_background-color": "{primaryGrey20}",
	searchresultitem_base_icon_size: searchresultitem_base_icon_size,
	searchresultitem_base_icon_color: searchresultitem_base_icon_color,
	"searchresultitem_base_text-container_flex-direction": "{flexDirection.row}",
	"searchresultitem_base_text-container_justify-content": "{justifyContent.start}",
	"searchresultitem_base_text-container_align-items": "{alignItems.center}"
};

const SearchResultTextTokens = {
	
};

const searchresults_base_container_width = "{size.max}";
const SearchResultsTokens = {
	"searchresults_base_popup_background-color": "{global.transparent}",
	"searchresults_base_popup-container_flex-direction": "{flexDirection.stack}",
	"searchresults_base_popup-container_justify-content": "{justifyContent.center}",
	"searchresults_base_popup-container_width": "{size.max}",
	"searchresults_base_popup-container_background-color": "{global.transparent}",
	"searchresults_base_root-container_background-color": "{primaryBackground}",
	"searchresults_base_root-container_flex-direction": "{flexDirection.column}",
	"searchresults_base_root-container_align-items": "{alignItems.center}",
	"searchresults_base_root-container_padding-top": "{base}",
	"searchresults_base_root-container_padding-right": "{base}",
	"searchresults_base_root-container_padding-bottom": "{base}",
	"searchresults_base_root-container_padding-left": "{base}",
	"searchresults_base_root-container_gap": "{base}",
	"searchresults_base_root-container_width": "{size.max}",
	searchresults_base_container_width: searchresults_base_container_width,
	"searchresults_base_container_flex-direction": "{flexDirection.column}",
	"searchresults_base_container_align-items": "{alignItems.center}",
	"searchresults_base_heading-container_flex-direction": "{flexDirection.row}",
	"searchresults_base_heading-container_justify-content": "{justifyContent.spaceBetween}",
	"searchresults_base_heading-container_align-items": "{alignItems.start}",
	"searchresults_base_heading-container_width": "{size.max}",
	"searchresults_base_results-container_flex-direction": "{flexDirection.column}",
	"searchresults_base_results-container_align-items": "{alignItems.start}",
	"searchresults_base_results-container_gap": "{base}",
	"searchresults_base_results-container_width": "{size.max}",
	"searchresults_variant_appearance_box_root-container_border-radius": "{xl}"
};

const RadioButtonTokens = {
	"radiobutton_base_vertical-container_flex-direction": "{flexDirection.column}",
	"radiobutton_base_vertical-container_justify-content": "{justifyContent.start}",
	"radiobutton_base_vertical-container_align-items": "{alignItems.start}",
	"radiobutton_base_vertical-container_gap": "{xs}",
	"radiobutton_base_horizontal-container_flex-direction": "{flexDirection.row}",
	"radiobutton_base_horizontal-container_justify-content": "{justifyContent.start}",
	"radiobutton_base_horizontal-container_align-items": "{alignItems.center}",
	"radiobutton_base_horizontal-container_gap": "{xs}",
	"radiobutton_base_outer-container_min-width": "{m}",
	"radiobutton_base_outer-container_min-height": "{m}",
	"radiobutton_base_outer-container_flex-direction": "{flexDirection.row}",
	"radiobutton_base_outer-container_justify-content": "{justifyContent.center}",
	"radiobutton_base_outer-container_align-items": "{alignItems.center}",
	"radiobutton_base_outer-container_background-color": "{global.transparent}",
	"radiobutton_base_outer-container_border-radius": "{pill}",
	"radiobutton_base_outer-container_border-color": "{primaryGrey80}",
	"radiobutton_base_outer-container_border-width": "{border_thin}",
	"radiobutton_variant_checked_true_outer-container_border-width": "{border_none}",
	"radiobutton_base_outer-container_behavior_hover_border-color": "{primary40}",
	"radiobutton_base_outer-container_behavior_active_border-color": "{primary60}",
	"radiobutton_base_outer-container_behavior_focus_border-color": "{primary60}",
	"radiobutton_base_inner-container_min-width": "{s}",
	"radiobutton_base_inner-container_min-height": "{s}",
	"radiobutton_base_inner-container_border-radius": "{pill}",
	"radiobutton_base_label-jds_text_text-align": "{textAlign.start}",
	"radiobutton_variant_size_small_outer-container_min-width": "{base}",
	"radiobutton_variant_size_small_outer-container_min-height": "{base}",
	"radiobutton_variant_size_small_vertical-container_gap": "{xxs}",
	"radiobutton_variant_size_small_inner-container_min-width": "{xs}",
	"radiobutton_variant_size_small_inner-container_min-height": "{xs}",
	"radiobutton_variant_checked_true_outer-container_background-color": "{primary50}",
	"radiobutton_variant_checked_true_outer-container_behavior_hover_background-color": "{primary40}",
	"radiobutton_variant_checked_true_outer-container_behavior_active_background-color": "{primary60}",
	"radiobutton_variant_checked_true_outer-container_behavior_focus_background-color": "{primary50}",
	"radiobutton_variant_checked_true_inner-container_background-color": "{primaryInverse}",
	"radiobutton_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
	"radiobutton_base_vertical-container_opacity": "{opacity.enabled}",
	"radiobutton_combination_true_success_inner-container_background-color": "{global.white}",
	"radiobutton_combination_true_error_inner-container_background-color": "{global.white}",
	"radiobutton_combination_true_warning_inner-container_background-color": "{global.white}"
};

const skeleton_variant_shape_heading_container_height = "{xxl}";
const skeleton_variant_shape_paragraph_container_height = "{base}";
const skeleton_variant_shape_custom_container_width = "{size.max}";
const skeleton_variant_shape_custom_container_height = "{size.max}";
const SkeletonTokens = {
	"skeleton_base_container_background-color": "{primaryGrey20}",
	"skeleton_base_skeletonLoader_primary-color": "{primaryGrey20}",
	"skeleton_base_skeletonLoader_secondary-color": "{primaryGrey40}",
	"skeleton_variant_shape_circle_container_border-radius": "{pill}",
	skeleton_variant_shape_heading_container_height: skeleton_variant_shape_heading_container_height,
	"skeleton_variant_shape_heading_container_border-radius": "{pill}",
	"skeleton_variant_shape_paragraph_container_border-radius": "{pill}",
	skeleton_variant_shape_paragraph_container_height: skeleton_variant_shape_paragraph_container_height,
	"skeleton_variant_shape_rectangle_container_border-radius": "{xl}",
	"skeleton_variant_shape_square_container_border-radius": "{xxl}",
	skeleton_variant_shape_custom_container_width: skeleton_variant_shape_custom_container_width,
	skeleton_variant_shape_custom_container_height: skeleton_variant_shape_custom_container_height
};

const selector_variant_stretch_true_container_width = "{size.max}";
const SelectorTokens = {
	"selector_base_container_flex-direction": "{flexDirection.stack}",
	"selector_base_selector-container_opacity": "{opacity.enabled}",
	"selector_base_selector-container_align-items": "{alignItems.center}",
	"selector_base_selector-container_justify-content": "{justifyContent.center}",
	"selector_base_selector-container_border-radius": "{pill}",
	"selector_base_selector-container_padding-top": "{xxs}",
	"selector_base_selector-container_padding-right": "{xxs}",
	"selector_base_selector-container_padding-bottom": "{xxs}",
	"selector_base_selector-container_padding-left": "{xxs}",
	"selector_base_outer-container_padding-top": "{xxs}",
	"selector_base_outer-container_padding-right": "{xxs}",
	"selector_base_outer-container_padding-bottom": "{xxs}",
	"selector_base_outer-container_padding-left": "{xxs}",
	"selector_base_outer-container_background-color": "{primaryGrey20}",
	"selector_base_outer-container_border-radius": "{pill}",
	"selector_base_selector-container_gap": "{xxs}",
	"selector_base_selector-container_flex-direction": "{flexDirection.row}",
	"selector_base_outer-container_width": "{size.max}",
	"selector_base_outer-container_height": "{intrinsicSize.max}",
	"selector_base_outer-container_justify-content": "{justifyContent.start}",
	"selector_base_outer-container_align-items": "{alignItems.center}",
	"selector_base_inner-container_background-color": "{primary50}",
	"selector_base_inner-container_border-radius": "{pill}",
	selector_variant_stretch_true_container_width: selector_variant_stretch_true_container_width,
	"selector_variant_stretch_true_selector-container_width": "{size.max}",
	"selector_variant__animating_true_inner-container_background-color": "{primary50}"
};

const selectoritem_base_container_opacity = "{opacity.enabled}";
const selectoritem_base_container_gap = "{xs}";
const selectoritem_base_icon_size = "{m}";
const selectoritem_base_icon_color = "{primary60}";
const selectoritem_variant_selected_true_icon_color = "{primaryInverse}";
const selectoritem_variant_selected_true_icon_behavior_active_color = "{primary30}";
const selectoritem_variant_stretch_true_container_width = "{size.max}";
const selectoritem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const selectoritem_variant_wrap_vertical_container_gap = "{xxs}";
const SelectorItemTokens = {
	selectoritem_base_container_opacity: selectoritem_base_container_opacity,
	"selectoritem_base_container_background-color": "{global.transparent}",
	"selectoritem_base_container_flex-direction": "{flexDirection.row}",
	"selectoritem_base_container_align-items": "{alignItems.center}",
	"selectoritem_base_container_justify-content": "{justifyContent.center}",
	"selectoritem_base_container_border-radius": "{pill}",
	selectoritem_base_container_gap: selectoritem_base_container_gap,
	"selectoritem_base_container_padding-top": "{xs}",
	"selectoritem_base_container_padding-right": "{base}",
	"selectoritem_base_container_padding-bottom": "{xs}",
	"selectoritem_base_container_padding-left": "{base}",
	"selectoritem_base_container_behavior_focus_background-color": "{primary20}",
	"selectoritem_base_container_behavior_focus_box-shadow_spread": "{xxs}",
	"selectoritem_base_container_behavior_focus_box-shadow_color": "{primary60}",
	"selectoritem_base_container_behavior_hover_background-color": "{primary20}",
	"selectoritem_base_container_behavior_active_background-color": "{primary30}",
	selectoritem_base_icon_size: selectoritem_base_icon_size,
	selectoritem_base_icon_color: selectoritem_base_icon_color,
	"selectoritem_variant_selected_true_container_background-color": "{primary50}",
	"selectoritem_variant_selected_true_container_behavior_hover_background-color": "{primary60}",
	"selectoritem_variant_selected_true_container_behavior_active_background-color": "{primary60}",
	"selectoritem_variant_selected_true_container_behavior_focus_background-color": "{primary50}",
	selectoritem_variant_selected_true_icon_color: selectoritem_variant_selected_true_icon_color,
	selectoritem_variant_selected_true_icon_behavior_active_color: selectoritem_variant_selected_true_icon_behavior_active_color,
	"selectoritem_variant_wrap_vertical_container_flex-direction": "{flexDirection.column}",
	selectoritem_variant_stretch_true_container_width: selectoritem_variant_stretch_true_container_width,
	selectoritem_variant_disabled_true_container_opacity: selectoritem_variant_disabled_true_container_opacity,
	selectoritem_variant_wrap_vertical_container_gap: selectoritem_variant_wrap_vertical_container_gap
};

const servicecard_base_jds_content_block_width = "{size.max}";
const ServiceCardTokens = {
	"servicecard_base_root-container_flex-direction": "{flexDirection.stack}",
	"servicecard_base_inner-stack-container_flex-direction": "{flexDirection.stack}",
	"servicecard_base_root-container_size": "{size.max}",
	"servicecard_base_inner-stack-container_size": "{size.max}",
	"servicecard_base_root-container_justify-content": "{justifyContent.start}",
	"servicecard_base_inner-stack-container_justify-content": "{justifyContent.start}",
	"servicecard_base_root-container_align-items": "{alignItems.start}",
	"servicecard_base_root-container_border-radius": "{xl}",
	"servicecard_base_blur-image_height": "{size.max}",
	"servicecard_base_blur-image_width": "{size.max}",
	"servicecard_base_blur-image_blur-radius": "{xl}",
	"servicecard_base_blur-image_aspect-ratio": "{aspect_ratio.16.9}",
	"servicecard_base_internal-vertical-container_flex-direction": "{flexDirection.column}",
	"servicecard_base_internal-vertical-container_size": "{size.max}",
	"servicecard_base_internal-vertical-container_justify-content": "{justifyContent.start}",
	"servicecard_base_internal-vertical-container_align-items": "{alignItems.start}",
	"servicecard_base_image-container_flex-direction": "{flexDirection.row}",
	"servicecard_base_image-container_justify-content": "{justifyContent.start}",
	"servicecard_base_image-container_align-items": "{alignItems.start}",
	"servicecard_base_image-container_height": "{size.max}",
	"servicecard_base_image-container_width": "{size.max}",
	"servicecard_base_jds_badge_padding-top": "{base}",
	"servicecard_base_jds_badge_padding-left": "{base}",
	"servicecard_base_content-block-container_background-color": "{custom_color_4}",
	"servicecard_base_content-block-container_width": "{size.max}",
	"servicecard_base_content-block-container_padding-top": "{base}",
	"servicecard_base_content-block-container_padding-bottom": "{base}",
	"servicecard_base_content-block-container_padding-left": "{base}",
	"servicecard_base_content-block-container_padding-right": "{base}",
	servicecard_base_jds_content_block_width: servicecard_base_jds_content_block_width,
	"servicecard_variant_imageRatio_square_blur_image_aspect-ratio": "{aspect_ratio.1.1}",
	"servicecard_variant_imageRatio_landscape_blur_image_aspect-ratio": "{aspect_ratio.4.3}",
	"servicecard_variant_imageRatio_portrait_blur_image_aspect-ratio": "{aspect_ratio.4.5}"
};

const slider_base_container_width = "{size.max}";
const slider_base_container_gap = "{xs}";
const slider_base_slider_width = "{size.max}";
const slider_variant_disabled_true_container_opacity = "{opacity.disabled}";
const SliderTokens = {
	"slider_base_container_flex-direction": "{flexDirection.column}",
	"slider_base_container_justify-content": "{justifyContent.start}",
	"slider_base_container_align-items": "{alignItems.start}",
	slider_base_container_width: slider_base_container_width,
	slider_base_container_gap: slider_base_container_gap,
	"slider_base_top-container_flex-direction": "{flexDirection.row}",
	"slider_base_top-container_justify-content": "{justifyContent.start}",
	"slider_base_top-container_align-items": "{alignItems.center}",
	"slider_base_top-container_width": "{size.max}",
	"slider_base_top-container_gap": "{xs}",
	"slider_base_label-jds_text_justify-content": "{justifyContent.start}",
	"slider_base_label-jds_text_align-items": "{alignItems.center}",
	"slider_base_inner-container_align-items": "{alignItems.center}",
	"slider_base_inner-container_padding-left": "{xs}",
	"slider_base_inner-container_padding-right": "{xs}",
	"slider_base_inner-container_border-width": "{border_thin}",
	"slider_base_inner-container_border-color": "{primaryGrey80}",
	"slider_base_inner-container_border-radius": "{medium}",
	slider_base_slider_width: slider_base_slider_width,
	"slider_base_slider_track-height": "{xxs}",
	"slider_base_slider_inactive-color": "{primaryGrey40}",
	"slider_base_slider_active-color": "{primary50}",
	"slider_base_slider_ball-color": "{primary50}",
	"slider_base_slider_ball-border-color": "{primary80}",
	"slider_base_slider_border-radius": "{small}",
	"slider_base_slider_behavior_hover_ball-color": "{primary60}",
	"slider_base_slider_behavior_active_active-color": "{primary60}",
	"slider_base_slider_behavior_active_ball-color": "{primary60}",
	"slider_base_slider_behavior_focus_ball-border-width": "{border_focus}",
	"slider_base_bottom-container_flex-direction": "{flexDirection.row}",
	"slider_base_bottom-container_justify-content": "{justifyContent.spaceBetween}",
	"slider_base_bottom-container_align-items": "{alignItems.center}",
	"slider_base_bottom-container_width": "{size.max}",
	"slider_variant_state_success_inner-container_border-color": "{feedbackSuccess50}",
	"slider_variant_state_error_inner-container_border-color": "{feedbackError50}",
	"slider_variant_state_warning_inner-container_border-color": "{feedbackWarning50}",
	slider_variant_disabled_true_container_opacity: slider_variant_disabled_true_container_opacity,
	"slider_variant_disabled_true_slider_behavior_hover_ball-color": "{primary50}",
	"slider_variant_disabled_true_slider_behavior_active_active-color": "{primary50}",
	"slider_variant_disabled_true_slider_behavior_active_ball-color": "{primary50}"
};

const paginationbutton_base_container_size = "{xxl}";
const PaginationButtonTokens = {
	paginationbutton_base_container_size: paginationbutton_base_container_size,
	"paginationbutton_base_container_justify-content": "{justifyContent.center}",
	"paginationbutton_base_container_align-items": "{alignItems.center}",
	"paginationbutton_base_inner-container_background-color": "{global.transparent}",
	"paginationbutton_base_inner-container_flex-direction": "{flexDirection.row}",
	"paginationbutton_base_inner-container_justify-content": "{justifyContent.center}",
	"paginationbutton_base_inner-container_align-items": "{alignItems.center}",
	"paginationbutton_base_inner-container_border-radius": "{pill}",
	"paginationbutton_base_inner-container_width": "{l}",
	"paginationbutton_base_inner-container_height": "{l}",
	"paginationbutton_base_inner-container_opacity": "{opacity.enabled}",
	"paginationbutton_base_inner-container_gap": "{xs}",
	"paginationbutton_base_inner-container_border-color": "{primary80}",
	"paginationbutton_base_inner-container_behavior_hover_background-color": "{primary20}",
	"paginationbutton_base_inner-container_behavior_active_background-color": "{primary30}",
	"paginationbutton_base_inner-container_behavior_focus_border-width": "{border_focus}",
	"paginationbutton_variant_state_selected_inner-container_background-color": "{primary70}",
	"paginationbutton_variant_state_ellipsis_inner-container_background-color": "{global.transparent}"
};

const searchbox_base_container_width = "{size.max}";
const searchbox_base_container_height = "{xl}";
const searchbox_base_container_gap = "{s}";
const searchbox_base_container_opacity = "{opacity.enabled}";
const searchbox_variant_disabled_true_container_opacity = "{opacity.disabled}";
const SearchBoxTokens = {
	"searchbox_base_container_background-color": "{primaryGrey20}",
	"searchbox_base_container_flex-direction": "{flexDirection.row}",
	"searchbox_base_container_justify-content": "{justifyContent.start}",
	"searchbox_base_container_align-items": "{alignItems.center}",
	"searchbox_base_container_padding-right": "{s}",
	"searchbox_base_container_padding-left": "{s}",
	searchbox_base_container_width: searchbox_base_container_width,
	searchbox_base_container_height: searchbox_base_container_height,
	"searchbox_base_container_border-radius": "{pill}",
	searchbox_base_container_gap: searchbox_base_container_gap,
	searchbox_base_container_opacity: searchbox_base_container_opacity,
	"searchbox_base_container_behavior_focus_border-color": "{primary60}",
	"searchbox_base_container_behavior_focus_border-width": "{border_focus}",
	"searchbox_base_container_behavior_active_background-color": "{primaryGrey40}",
	"searchbox_base_input_text-align": "{textAlign.start}",
	"searchbox_base_input_placeholder-color": "{primaryGrey100}",
	"searchbox_base_input_placeholder-font-family": "{bodyS}",
	"searchbox_base_input_placeholder-font-size": "{bodyS}",
	"searchbox_base_input_placeholder-line-height": "{bodyS}",
	"searchbox_base_input_placeholder-letter-spacing": "{bodyS}",
	"searchbox_base_input_placeholder-font-weight": "{bodyS}",
	"searchbox_base_input_input-color": "{primaryGrey100}",
	"searchbox_base_input_input-font-family": "{bodyS}",
	"searchbox_base_input_input-font-size": "{bodyS}",
	"searchbox_base_input_input-line-height": "{bodyS}",
	"searchbox_base_input_input-letter-spacing": "{bodyS}",
	"searchbox_base_input_input-font-weight": "{bodyS}",
	"searchbox_base_input_cursor-color": "{primary60}",
	"searchbox_base_input_behavior_hover_placeholder-color": "{primary60}",
	"searchbox_base_input_behavior_focus_placeholder-color": "{primary60}",
	"searchbox_base_input_behavior_active_placeholder-color": "{primary60}",
	"searchbox_base_prefix-container_flex-direction": "{flexDirection.row}",
	"searchbox_base_prefix-container_justify-content": "{justifyContent.center}",
	"searchbox_base_prefix-container_align-items": "{alignItems.center}",
	"searchbox_base_prefix-icon_size": "{m}",
	"searchbox_base_prefix-icon_color": "{primaryGrey100}",
	"searchbox_base_prefix-icon_behavior_hover_color": "{primary60}",
	"searchbox_base_prefix-icon_behavior_focus_color": "{primary60}",
	"searchbox_base_prefix-icon_behavior_active_color": "{primaryGrey80}",
	"searchbox_base_suffix-container_flex-direction": "{flexDirection.row}",
	"searchbox_base_suffix-container_justify-content": "{justifyContent.center}",
	"searchbox_base_suffix-container_align-items": "{alignItems.center}",
	"searchbox_base_suffix-icon_size": "{m}",
	"searchbox_base_suffix-icon_color": "{primary60}",
	"searchbox_base_suffix-icon_behavior_hover_color": "{primary60}",
	"searchbox_base_suffix-icon_behavior_focus_color": "{primary60}",
	"searchbox_base_suffix-icon_behavior_active_color": "{primaryGrey100}",
	"searchbox_variant_kind_header_container_background-color": "{primary60}",
	"searchbox_variant_kind_header_container_behavior_focus_border-color": "{primary80}",
	"searchbox_variant_kind_header_container_behavior_active_background-color": "{primary70}",
	"searchbox_variant_kind_header_prefix-icon_color": "{primaryBackground}",
	"searchbox_variant_kind_header_prefix-icon_behavior_hover_color": "{primary30}",
	"searchbox_variant_kind_header_prefix-icon_behavior_active_color": "{primary30}",
	"searchbox_variant_kind_header_suffix-icon_color": "{primaryBackground}",
	"searchbox_variant_kind_header_suffix-icon_behavior_hover_color": "{primary30}",
	"searchbox_variant_kind_header_suffix-icon_behavior_active_color": "{primary30}",
	"searchbox_variant_kind_header_input_input-color": "{primaryBackground}",
	"searchbox_variant_kind_header_input_placeholder-color": "{primary40}",
	"searchbox_variant_kind_header_input_cursor-color": "{primary30}",
	"searchbox_variant_kind_header_input_behavior_hover_placeholder-color": "{primary30}",
	"searchbox_variant_kind_light_background_container_background-color": "{primaryBackground}",
	"searchbox_variant_kind_light_background_container_border-color": "{primaryGrey60}",
	"searchbox_variant_kind_light_background_container_behavior_hover_border-color": "{primary50}",
	"searchbox_variant_kind_light_background_container_behavior_focus_border-color": "{primary80}",
	"searchbox_variant_kind_light_background_container_behavior_active_border-color": "{primary60}",
	"searchbox_variant_kind_light_background_container_border-width": "{border_thin}",
	"searchbox_variant_kind_light_background_container_behavior_focus_border-width": "{border_focus}",
	"searchbox_variant_kind_light_background_input_input-color": "{primaryGrey100}",
	"searchbox_variant_kind_light_background_input_cursor-color": "{primary60}",
	"searchbox_variant_kind_light_background_input_behavior_active_placeholder-color": "{primaryGrey100}",
	"searchbox_variant_kind_light_background_prefix-icon_color": "{primaryGrey100}",
	"searchbox_variant_kind_light_background_prefix-icon_behavior_hover_color": "{primary60}",
	"searchbox_variant_kind_light_background_prefix-icon_behavior_focus_color": "{primary60}",
	"searchbox_variant_kind_light_background_prefix-icon_behavior_active_color": "{primaryGrey100}",
	"searchbox_variant_kind_light_background_suffix-icon_color": "{primary60}",
	"searchbox_variant_kind_light_background_suffix-icon_behavior_active_color": "{primary60}",
	searchbox_variant_disabled_true_container_opacity: searchbox_variant_disabled_true_container_opacity,
	"searchbox_variant__isValueEmpty_false_suffix-icon_color": "{primaryGrey80}",
	"searchbox_combination_header_false_suffix-icon_color": "{primary30}",
	"searchbox_variant__inputFocus_true_input_placeholder-color": "{primaryGrey60}",
	"searchbox_combination_light_background_false_suffix-icon_color": "{primaryGrey80}",
	"searchbox_combination_light_background_true_container_border-color": "{primary60}"
};

const spinner_base_container_gap = "{base}";
const spinner_variant_size_small_container_gap = "{s}";
const SpinnerTokens = {
	"spinner_base_container_background-color": "{global.transparent}",
	spinner_base_container_gap: spinner_base_container_gap,
	"spinner_base_container_justify-content": "{justifyContent.center}",
	"spinner_base_container_align-items": "{alignItems.center}",
	"spinner_base_container_flex-direction": "{flexDirection.row}",
	"spinner_base_spinner-container_size": "{xxl}",
	"spinner_base_arc-container_flex-direction": "{flexDirection.stack}",
	"spinner_base_arc-container_justify-content": "{justifyContent.center}",
	"spinner_base_arc-container_align-items": "{alignItems.center}",
	"spinner_base_arc-container_size": "{size.max}",
	"spinner_base_base-arc_fill": "{primaryGrey40}",
	"spinner_base_base-arc_radius": "{m}",
	"spinner_base_base-arc_arcWidth": "{xs}",
	"spinner_base_base-arc_start": 0,
	"spinner_base_base-arc_end": 360,
	"spinner_base_normal-arc_fill": "{primary50}",
	"spinner_base_normal-arc_radius": "{m}",
	"spinner_base_normal-arc_arcWidth": "{xs}",
	"spinner_base_normal-arc_start": 0,
	"spinner_base_normal-arc_end": 120,
	"spinner_base_normal-arc_animation-duration": "1000",
	"spinner_base_first-arc_fill": "{primary50}",
	"spinner_base_first-arc_radius": "{m}",
	"spinner_base_first-arc_arcWidth": "{xs}",
	"spinner_base_first-arc_start": 0,
	"spinner_base_first-arc_end": 360,
	"spinner_base_first-arc_animation-delay": "300",
	"spinner_base_first-arc_animation-duration": "1300",
	"spinner_base_second-arc_fill": "{secondary50}",
	"spinner_base_second-arc_radius": "{m}",
	"spinner_base_second-arc_arcWidth": "{xs}",
	"spinner_base_second-arc_start": 0,
	"spinner_base_second-arc_end": 360,
	"spinner_base_second-arc_animation-delay": "150",
	"spinner_base_second-arc_animation-duration": "1300",
	"spinner_base_third-arc_fill": "{sparkle50}",
	"spinner_base_third-arc_radius": "{m}",
	"spinner_base_third-arc_arcWidth": "{xs}",
	"spinner_base_third-arc_start": 0,
	"spinner_base_third-arc_end": 360,
	"spinner_base_third-arc_animation-duration": "1300",
	"spinner_variant_labelPosition_bottom_container_flex-direction": "{flexDirection.column}",
	spinner_variant_size_small_container_gap: spinner_variant_size_small_container_gap,
	"spinner_variant_size_small_spinner-container_size": "{m}",
	"spinner_variant_size_small_base-arc_arcWidth": "{xxs}",
	"spinner_variant_size_small_base-arc_radius": "{s}",
	"spinner_variant_size_small_normal-arc_arcWidth": "{xxs}",
	"spinner_variant_size_small_normal-arc_radius": "{s}",
	"spinner_variant_size_small_first-arc_arcWidth": "{xxs}",
	"spinner_variant_size_small_first-arc_radius": "{s}",
	"spinner_variant_size_small_second-arc_arcWidth": "{xxs}",
	"spinner_variant_size_small_second-arc_radius": "{s}",
	"spinner_variant_size_small_third-arc_arcWidth": "{xxs}",
	"spinner_variant_size_small_third-arc_radius": "{s}",
	"spinner_combination_false_inline_normal-arc_fill": "{primaryGrey80}",
	"spinner_combination_small_bottom_container_flex-direction": "{flexDirection.row}"
};

const selectorbutton_base_container_gap = "{xs}";
const selectorbutton_base_container_opacity = "{opacity.enabled}";
const selectorbutton_variant_disabled_true_container_opacity = "{opacity.disabled}";
const selectorbutton_combination_false_small_container_width = "{l}";
const selectorbutton_combination_false_small_container_height = "{l}";
const selectorbutton_combination_false_medium_container_width = "{xl}";
const selectorbutton_combination_false_medium_container_height = "{xl}";
const selectorbutton_combination_false_large_container_width = "{xxl}";
const selectorbutton_combination_false_large_container_height = "{xxl}";
const selectorbutton_combination_false_extra_large_container_width = "{huge}";
const selectorbutton_combination_false_extra_large_container_height = "{huge}";
const selectorbutton_combination_true_true_container_width = "{size.max}";
const SelectorButtonTokens = {
	"selectorbutton_base_container_background-color": "{primary50}",
	"selectorbutton_base_container_flex-direction": "{flexDirection.row}",
	"selectorbutton_base_container_justify-content": "{justifyContent.center}",
	"selectorbutton_base_container_align-items": "{alignItems.center}",
	"selectorbutton_base_container_border-radius": "{pill}",
	"selectorbutton_base_container_padding-bottom": "{xs}",
	"selectorbutton_base_container_padding-top": "{xs}",
	"selectorbutton_base_container_padding-left": "{base}",
	"selectorbutton_base_container_padding-right": "{base}",
	"selectorbutton_base_container_border-width": "{border_none}",
	selectorbutton_base_container_gap: selectorbutton_base_container_gap,
	selectorbutton_base_container_opacity: selectorbutton_base_container_opacity,
	"selectorbutton_base_container_behavior_hover_background-color": "{primary30}",
	"selectorbutton_base_container_behavior_active_background-color": "{primary60}",
	"selectorbutton_base_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_base_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_base_left-icon_size": "{m}",
	"selectorbutton_base_left-icon_color": "{primaryInverse}",
	"selectorbutton_base_left-icon_behavior_hover_color": "{primary70}",
	"selectorbutton_base_right-icon_size": "{m}",
	"selectorbutton_base_right-icon_color": "{primaryInverse}",
	"selectorbutton_base_right-icon_behavior_hover_color": "{primary70}",
	selectorbutton_variant_disabled_true_container_opacity: selectorbutton_variant_disabled_true_container_opacity,
	"selectorbutton_combination_normal_primary_true_container_background-color": "{primary60}",
	"selectorbutton_combination_normal_primary_true_container_behavior_hover_background-color": "{primary50}",
	"selectorbutton_combination_normal_primary_true_container_behavior_active_background-color": "{primary70}",
	"selectorbutton_combination_normal_primary_true_container_behavior_focus_border-color": "{primary70}",
	"selectorbutton_combination_normal_secondary_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_normal_secondary_false_container_border-width": "{border_thin}",
	"selectorbutton_combination_normal_secondary_false_container_border-color": "{primaryGrey60}",
	"selectorbutton_combination_normal_secondary_false_container_behavior_hover_background-color": "{primary20}",
	"selectorbutton_combination_normal_secondary_false_container_behavior_hover_border-color": "{primary60}",
	"selectorbutton_combination_normal_secondary_false_container_behavior_active_background-color": "{primary20}",
	"selectorbutton_combination_normal_secondary_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_normal_secondary_false_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_normal_secondary_false_left-icon_color": "{primary60}",
	"selectorbutton_combination_normal_secondary_false_right-icon_color": "{primary60}",
	"selectorbutton_combination_normal_secondary_true_container_background-color": "{primary20}",
	"selectorbutton_combination_normal_secondary_true_container_border-width": "{border_thin}",
	"selectorbutton_combination_normal_secondary_true_container_border-color": "{primaryGrey60}",
	"selectorbutton_combination_normal_secondary_true_container_behavior_hover_border-color": "{primary60}",
	"selectorbutton_combination_normal_secondary_true_container_behavior_active_background-color": "{primary30}",
	"selectorbutton_combination_normal_secondary_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_normal_secondary_true_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_normal_secondary_true_left-icon_color": "{primary60}",
	"selectorbutton_combination_normal_secondary_true_left-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_normal_secondary_true_right-icon_color": "{primary60}",
	"selectorbutton_combination_normal_secondary_true_right-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_normal_tertiary_true_container_background-color": "{primary20}",
	"selectorbutton_combination_normal_tertiary_true_container_behavior_hover_background-color": "{primary20}",
	"selectorbutton_combination_normal_tertiary_true_container_behavior_hover_border-color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_true_container_behavior_hover_border-width": "{border_thin}",
	"selectorbutton_combination_normal_tertiary_true_container_behavior_active_background-color": "{primary30}",
	"selectorbutton_combination_normal_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_normal_tertiary_true_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_true_left-icon_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_true_left-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_normal_tertiary_true_left-icon_behavior_hover_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_true_right-icon_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_true_right-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_normal_tertiary_true_right-icon_behavior_hover_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_normal_tertiary_false_container_behavior_hover_border-width": "{border_thin}",
	"selectorbutton_combination_normal_tertiary_false_container_behavior_hover_border-color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_false_container_behavior_hover_background-color": "{primary20}",
	"selectorbutton_combination_normal_tertiary_false_container_behavior_active_background-color": "{primary20}",
	"selectorbutton_combination_normal_tertiary_false_left-icon_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_false_left-icon_behavior_active_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_false_left-icon_behavior_hover_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_false_right-icon_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_false_right-icon_behavior_active_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_false_right-icon_behavior_hover_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_narrow_true_container_background-color": "{global.transparent}",
	"selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
	"selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_active_background-color": "{global.transparent}",
	"selectorbutton_combination_normal_tertiary_narrow_true_left-icon_color": "{primary70}",
	"selectorbutton_combination_normal_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_narrow_true_left-icon_behavior_active_color": "{primary80}",
	"selectorbutton_combination_normal_tertiary_narrow_true_right-icon_color": "{primary70}",
	"selectorbutton_combination_normal_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_narrow_true_right-icon_behavior_active_color": "{primary80}",
	"selectorbutton_combination_normal_tertiary_narrow_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_normal_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
	"selectorbutton_combination_normal_tertiary_narrow_false_container_behavior_active_background-color": "{global.transparent}",
	"selectorbutton_combination_normal_tertiary_narrow_false_left-icon_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary50}",
	"selectorbutton_combination_normal_tertiary_narrow_false_left-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_normal_tertiary_narrow_false_right-icon_color": "{primary60}",
	"selectorbutton_combination_normal_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary50}",
	"selectorbutton_combination_normal_tertiary_narrow_false_right-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_grey_scale_primary_false_container_background-color": "{primaryGrey80}",
	"selectorbutton_combination_grey_scale_primary_false_container_behavior_hover_background-color": "{primary30}",
	"selectorbutton_combination_grey_scale_primary_false_container_behavior_active_background-color": "{primary50}",
	"selectorbutton_combination_grey_scale_primary_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_grey_scale_primary_false_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_primary_false_left-icon_color": "{primaryBackground}",
	"selectorbutton_combination_grey_scale_primary_false_left-icon_behavior_hover_color": "{primary70}",
	"selectorbutton_combination_grey_scale_primary_false_left-icon_behavior_active_color": "{primaryInverse}",
	"selectorbutton_combination_grey_scale_primary_false_right-icon_color": "{primaryBackground}",
	"selectorbutton_combination_grey_scale_primary_false_right-icon_behavior_hover_color": "{primary70}",
	"selectorbutton_combination_grey_scale_primary_false_right-icon_behavior_active_color": "{primaryInverse}",
	"selectorbutton_combination_grey_scale_secondary_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_grey_scale_secondary_false_container_border-width": "{border_thin}",
	"selectorbutton_combination_grey_scale_secondary_false_container_border-color": "{primaryGrey60}",
	"selectorbutton_combination_grey_scale_secondary_false_container_behavior_hover_background-color": "{primary20}",
	"selectorbutton_combination_grey_scale_secondary_false_container_behavior_hover_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_secondary_false_container_behavior_active_background-color": "{primary20}",
	"selectorbutton_combination_grey_scale_secondary_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_grey_scale_secondary_false_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_secondary_false_left-icon_color": "{primaryGrey80}",
	"selectorbutton_combination_grey_scale_secondary_false_right-icon_color": "{primaryGrey80}",
	"selectorbutton_combination_grey_scale_secondary_true_container_background-color": "{primary20}",
	"selectorbutton_combination_grey_scale_secondary_true_container_border-color": "{primaryGrey60}",
	"selectorbutton_combination_grey_scale_secondary_true_container_behavior_hover_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_secondary_true_container_behavior_active_background-color": "{primary30}",
	"selectorbutton_combination_grey_scale_secondary_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_grey_scale_secondary_true_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_secondary_true_left-icon_color": "{primary60}",
	"selectorbutton_combination_grey_scale_secondary_true_left-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_grey_scale_secondary_true_right-icon_color": "{primary60}",
	"selectorbutton_combination_grey_scale_secondary_true_right-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_grey_scale_tertiary_true_container_background-color": "{primary20}",
	"selectorbutton_combination_grey_scale_tertiary_true_container_behavior_hover_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_true_container_behavior_hover_border-width": "{border_thin}",
	"selectorbutton_combination_grey_scale_tertiary_true_container_behavior_active_background-color": "{primary30}",
	"selectorbutton_combination_grey_scale_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_grey_scale_tertiary_true_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_true_left-icon_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_true_left-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_grey_scale_tertiary_true_right-icon_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_true_right-icon_behavior_active_color": "{primary70}",
	"selectorbutton_combination_grey_scale_tertiary_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_border-width": "{border_thin}",
	"selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_background-color": "{primary20}",
	"selectorbutton_combination_grey_scale_tertiary_false_container_behavior_active_background-color": "{primary20}",
	"selectorbutton_combination_grey_scale_tertiary_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_grey_scale_tertiary_false_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_false_left-icon_color": "{primaryGrey80}",
	"selectorbutton_combination_grey_scale_tertiary_false_left-icon_hover_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_false_left-icon_active_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_false_right-icon_color": "{primaryGrey80}",
	"selectorbutton_combination_grey_scale_tertiary_false_right-icon_hover_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_false_right-icon_active_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_container_background-color": "{global.transparent}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary50}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_behavior_active_color": "{primary80}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary50}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_behavior_active_color": "{primary80}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_focus_border-color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_color": "{primaryGrey80}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary50}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_behavior_active_color": "{primary60}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_color": "{primaryGrey80}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary50}",
	"selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_behavior_active_color": "{primary60}",
	"selectorbutton_combination_contrast_primary_false_container_background-color": "{primaryBackground}",
	"selectorbutton_combination_contrast_primary_false_container_behavior_hover_background-color": "{primary30}",
	"selectorbutton_combination_contrast_primary_false_container_behavior_active_background-color": "{primary50}",
	"selectorbutton_combination_contrast_primary_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_contrast_primary_false_container_behavior_focus_border-color": "{primary50}",
	"selectorbutton_combination_contrast_primary_false_left-icon_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_primary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_primary_false_left-icon_behavior_focus_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_primary_false_left-icon_behavior_active_color": "{primaryInverse}",
	"selectorbutton_combination_contrast_primary_false_right-icon_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_primary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_primary_false_right-icon_behavior_focus_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_primary_false_right-icon_behavior_active_color": "{primaryInverse}",
	"selectorbutton_combination_contrast_primary_true_container_background-color": "{primary50}",
	"selectorbutton_combination_contrast_primary_true_container_behavior_hover_background-color": "{primary30}",
	"selectorbutton_combination_contrast_primary_true_container_behavior_active_background-color": "{primary60}",
	"selectorbutton_combination_contrast_primary_true_container_behavior_focus_background-color": "{primary50}",
	"selectorbutton_combination_contrast_primary_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_contrast_primary_true_container_behavior_focus_border-color": "{primary40}",
	"selectorbutton_combination_contrast_primary_true_left-icon_color": "{primaryInverse}",
	"selectorbutton_combination_contrast_primary_true_left-icon_behavior_hover_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_primary_true_right-icon_color": "{primaryInverse}",
	"selectorbutton_combination_contrast_primary_true_right-icon_behavior_hover_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_secondary_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_contrast_secondary_false_container_border-width": "{border_thin}",
	"selectorbutton_combination_contrast_secondary_false_container_border-color": "{primaryGrey60}",
	"selectorbutton_combination_contrast_secondary_false_container_behavior_hover_background-color": "{primary30}",
	"selectorbutton_combination_contrast_secondary_false_container_behavior_hover_border-color": "{primary50}",
	"selectorbutton_combination_contrast_secondary_false_container_behavior_active_background-color": "{primary30}",
	"selectorbutton_combination_contrast_secondary_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_contrast_secondary_false_container_behavior_focus_border-color": "{primary50}",
	"selectorbutton_combination_contrast_secondary_false_left-icon_color": "{primaryBackground}",
	"selectorbutton_combination_contrast_secondary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_secondary_false_left-icon_behavior_active_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_secondary_false_right-icon_color": "{primaryBackground}",
	"selectorbutton_combination_contrast_secondary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_secondary_false_right-icon_behavior_active_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_secondary_true_container_background-color": "{primary30}",
	"selectorbutton_combination_contrast_secondary_true_container_border-color": "{primaryGrey60}",
	"selectorbutton_combination_contrast_secondary_true_container_behavior_hover_border-color": "{primary50}",
	"selectorbutton_combination_contrast_secondary_true_container_behavior_active_background-color": "{primary50}",
	"selectorbutton_combination_contrast_secondary_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_contrast_secondary_true_container_behavior_focus_border-color": "{primary50}",
	"selectorbutton_combination_contrast_secondary_true_left-icon_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_secondary_true_left-icon_behavior_active_color": "{primaryInverse}",
	"selectorbutton_combination_contrast_secondary_true_right-icon_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_secondary_true_right-icon_behavior_active_color": "{primaryInverse}",
	"selectorbutton_combination_contrast_tertiary_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_contrast_tertiary_false_container_behavior_hover_background-color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_false_container_behavior_hover_border-color": "{primary50}",
	"selectorbutton_combination_contrast_tertiary_false_container_behavior_active_background-color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_contrast_tertiary_false_container_behavior_focus_border-color": "{primary50}",
	"selectorbutton_combination_contrast_tertiary_false_left-icon_color": "{primaryBackground}",
	"selectorbutton_combination_contrast_tertiary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_tertiary_false_left-icon_behavior_active_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_tertiary_false_right-icon_color": "{primaryBackground}",
	"selectorbutton_combination_contrast_tertiary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_tertiary_false_right-icon_behavior_active_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_tertiary_true_container_background-color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_true_container_behavior_hover_border-color": "{primary50}",
	"selectorbutton_combination_contrast_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_contrast_tertiary_true_container_behavior_focus_border-color": "{primary50}",
	"selectorbutton_combination_contrast_tertiary_true_container_behavior_active_background-color": "{primary50}",
	"selectorbutton_combination_contrast_tertiary_true_left-icon_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_tertiary_true_left-icon_behavior_active_background-color": "{primaryInverse}",
	"selectorbutton_combination_contrast_tertiary_true_right-icon_color": "{primaryGrey100}",
	"selectorbutton_combination_contrast_tertiary_true_right-icon_behavior_active_background-color": "{primaryInverse}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_container_background-color": "{global.transparent}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_focus_border-color": "{primary50}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_active_background-color": "{global.transparent}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_color": "{primaryBackground}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary20}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_behavior_active_color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_color": "{primaryBackground}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary20}",
	"selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_behavior_active_color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_container_background-color": "{global.transparent}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_focus_border-color": "{primary50}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_active_background-color": "{global.transparent}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary20}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_active_color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_focus_color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary20}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_active_color": "{primary30}",
	"selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_focus_color": "{primary30}",
	"selectorbutton_combination_tertiary_narrow_small_container_padding-bottom": "{xxs}",
	"selectorbutton_combination_tertiary_narrow_small_container_padding-top": "{xxs}",
	"selectorbutton_combination_tertiary_narrow_medium_container_padding-bottom": "{xs}",
	"selectorbutton_combination_tertiary_narrow_medium_container_padding-top": "{xs}",
	"selectorbutton_combination_tertiary_narrow_large_container_padding-bottom": "{s}",
	"selectorbutton_combination_tertiary_narrow_large_container_padding-top": "{s}",
	"selectorbutton_combination_tertiary_narrow_extra_large_container_padding-bottom": "{base}",
	"selectorbutton_combination_tertiary_narrow_extra_large_container_padding-top": "{base}",
	"selectorbutton_combination_true_small_container_padding-top": "{xxs}",
	"selectorbutton_combination_true_small_container_padding-bottom": "{xxs}",
	"selectorbutton_combination_true_small_left-icon_size": "{base}",
	"selectorbutton_combination_true_small_right-icon_size": "{base}",
	"selectorbutton_combination_true_large_container_padding-top": "{s}",
	"selectorbutton_combination_true_large_container_padding-left": "{m}",
	"selectorbutton_combination_true_large_container_padding-bottom": "{s}",
	"selectorbutton_combination_true_large_container_padding-right": "{m}",
	"selectorbutton_combination_true_large_left-icon_size": "{m}",
	"selectorbutton_combination_true_large_right-icon_size": "{m}",
	"selectorbutton_combination_true_extra_large_container_padding-top": "{base}",
	"selectorbutton_combination_true_extra_large_container_padding-right": "{l}",
	"selectorbutton_combination_true_extra_large_container_padding-bottom": "{base}",
	"selectorbutton_combination_true_extra_large_container_padding-left": "{l}",
	"selectorbutton_combination_true_extra_large_left-icon_size": "{l}",
	"selectorbutton_combination_true_extra_large_right-icon_size": "{l}",
	selectorbutton_combination_false_small_container_width: selectorbutton_combination_false_small_container_width,
	selectorbutton_combination_false_small_container_height: selectorbutton_combination_false_small_container_height,
	"selectorbutton_combination_false_small_left-icon_size": "{base}",
	selectorbutton_combination_false_medium_container_width: selectorbutton_combination_false_medium_container_width,
	selectorbutton_combination_false_medium_container_height: selectorbutton_combination_false_medium_container_height,
	selectorbutton_combination_false_large_container_width: selectorbutton_combination_false_large_container_width,
	selectorbutton_combination_false_large_container_height: selectorbutton_combination_false_large_container_height,
	"selectorbutton_combination_false_large_left-icon_size": "{m}",
	selectorbutton_combination_false_extra_large_container_width: selectorbutton_combination_false_extra_large_container_width,
	selectorbutton_combination_false_extra_large_container_height: selectorbutton_combination_false_extra_large_container_height,
	"selectorbutton_combination_false_extra_large_left-icon_size": "{l}",
	selectorbutton_combination_true_true_container_width: selectorbutton_combination_true_true_container_width,
	"selectorbutton_combination_true_true_container_justify-content": "{justifyContent.spaceBetween}",
	"selectorbutton_combination_grey_scale_secondary_false_left-icon_behavior_hover_color": "{primary60}",
	"selectorbutton_combination_grey_scale_secondary_false_right-icon_behavior_hover_color": "{primary60}"
};

const HorizontalStepItemTokens = {
	"horizontalstepitem_base_stepper-outer-container_flex-direction": "{flexDirection.column}",
	"horizontalstepitem_base_stepper-outer-container_align-items": "{alignItems.center}",
	"horizontalstepitem_base_stepper-outer-container_justify-content": "{justifyContent.start}",
	"horizontalstepitem_base_stepper-outer-container_size": "{size.max}",
	"horizontalstepitem_base_stepper-outer-container_gap": "{xs}",
	"horizontalstepitem_base_stepper-inner-container_flex-direction": "{flexDirection.row}",
	"horizontalstepitem_base_stepper-inner-container_width": "{size.max}",
	"horizontalstepitem_base_stepper-inner-container_align-items": "{alignItems.center}",
	"horizontalstepitem_base_stepper-inner-container_gap": "{xs}",
	"horizontalstepitem_base_label-jds_text_padding-right": "{xs}",
	"horizontalstepitem_base_label-jds_text_padding-left": "{xs}",
	"horizontalstepitem_base_start-jds_divider_opacity": "{opacity.enabled}",
	"horizontalstepitem_base_end-jds_divider_opacity": "{opacity.enabled}",
	"horizontalstepitem_variant_direction_start_end-jds_divider_opacity": "{opacity.invisible}",
	"horizontalstepitem_variant_direction_end_start-jds_divider_opacity": "{opacity.invisible}"
};

const stepperdot_base_icon_color = "{sparkleGrey60}";
const stepperdot_base_icon_size = "{base}";
const stepperdot_combination_warning_active_icon_color = "{sparkle60}";
const stepperdot_combination_warning_complete_icon_color = "{sparkle60}";
const StepperDotTokens = {
	"stepperdot_base_step-icon-container_background-color": "{global.transparent}",
	"stepperdot_base_step-icon-container_border-width": "{border_thin}",
	"stepperdot_base_step-icon-container_border-color": "{sparkleGrey60}",
	"stepperdot_base_step-icon-container_min-height": "{l}",
	"stepperdot_base_step-icon-container_min-width": "{l}",
	"stepperdot_base_step-icon-container_justify-content": "{justifyContent.center}",
	"stepperdot_base_step-icon-container_align-items": "{alignItems.center}",
	"stepperdot_base_step-icon-container_border-radius": "{pill}",
	stepperdot_base_icon_color: stepperdot_base_icon_color,
	stepperdot_base_icon_size: stepperdot_base_icon_size,
	"stepperdot_base_complete-icon_color": "{sparkle60}",
	"stepperdot_base_complete-icon_size": "{base}",
	"stepperdot_base_dot-container_background-color": "{sparkleGrey60}",
	"stepperdot_base_dot-container_width": "{xs}",
	"stepperdot_base_dot-container_height": "{xs}",
	"stepperdot_base_dot-container_border-radius": "{pill}",
	"stepperdot_variant_state_active_step-icon-container_background-color": "{sparkle50}",
	"stepperdot_variant_state_active_step-icon-container_border-color": "{sparkle50}",
	"stepperdot_variant_state_active_icon-color": "{sparkleInverse}",
	"stepperdot_variant_state_active_dot-container_background-color": "{sparkleInverse}",
	"stepperdot_variant_state_complete_step-icon-container_background-color": "{sparkle20}",
	"stepperdot_variant_state_complete_step-icon-container_border-color": "{sparkle50}",
	"stepperdot_variant_itemsType_icon_step-icon-container_height": "{l}",
	"stepperdot_variant_itemsType_icon_step-icon-container_width": "{l}",
	stepperdot_combination_warning_active_icon_color: stepperdot_combination_warning_active_icon_color,
	stepperdot_combination_warning_complete_icon_color: stepperdot_combination_warning_complete_icon_color,
	"stepperdot_variant_state_disabled_step-icon-container_opacity": "{opacity.disabled}"
};

const VerticalStepItemTokens = {
	"verticalstepitem_base_stepper-outer-container_flex-direction": "{flexDirection.column}",
	"verticalstepitem_base_stepper-outer-container_justify-content": "{justifyContent.start}",
	"verticalstepitem_base_stepper-outer-container_align-items": "{alignItems.start}",
	"verticalstepitem_base_stepper-outer-container_gap": "{xs}",
	"verticalstepitem_base_stepper-outer-container_size": "{size.max}",
	"verticalstepitem_base_end-container_opacity": "{opacity.enabled}",
	"verticalstepitem_base_content-child-container_flex-direction": "{flexDirection.row}",
	"verticalstepitem_base_content-child-container_justify-content": "{justifyContent.start}",
	"verticalstepitem_base_content-child-container_align-items": "{alignItems.center}",
	"verticalstepitem_base_step-indicator-container_height": "{intrinsicSize.max}",
	"verticalstepitem_base_step-indicator-container_flex-direction": "{flexDirection.row}",
	"verticalstepitem_base_step-indicator-container_justify-content": "{justifyContent.start}",
	"verticalstepitem_base_step-indicator-container_align-items": "{alignItems.stretch}",
	"verticalstepitem_base_step-indicator-container_min-height": "{l}",
	"verticalstepitem_base_step-indicator-container_padding-left": "{custom_23}",
	"verticalstepitem_base_step-dot-container_flex-direction": "{flexDirection.row}",
	"verticalstepitem_base_step-dot-container_justify-content": "{justifyContent.start}",
	"verticalstepitem_base_step-dot-container_align-items": "{alignItems.center}",
	"verticalstepitem_base_step-dot-container_gap": "{base}",
	"verticalstepitem_base_content-container_padding-top": "0",
	"verticalstepitem_base_content-container_padding-bottom": "0",
	"verticalstepitem_base_content-container_padding-left": "{custom_24}",
	"verticalstepitem__hideChild_true_content-container_padding-top": "{xs}",
	"verticalstepitem__hideChild_true_content-container_padding-bottom": "{m}",
	"verticalstepitem_variant_direction_start_end-jds_divider_opacity": "{opacity.invisible}"
};

const verticalstepper_base_container_size = "{size.max}";
const verticalstepper_base_container_gap = "{xs}";
const VerticalStepperTokens = {
	"verticalstepper_base_container_flex-direction": "{flexDirection.column}",
	"verticalstepper_base_container_justify-content": "{justifyContent.start}",
	"verticalstepper_base_container_align-items": "{alignItems.start}",
	verticalstepper_base_container_size: verticalstepper_base_container_size,
	verticalstepper_base_container_gap: verticalstepper_base_container_gap
};

const horizontalstepper_base_container_gap = "{stepper_horizontal}";
const horizontalstepper_base_container_size = "{size.max}";
const HorizontalStepperTokens = {
	horizontalstepper_base_container_gap: horizontalstepper_base_container_gap,
	"horizontalstepper_base_container_flex-direction": "{flexDirection.column}",
	horizontalstepper_base_container_size: horizontalstepper_base_container_size,
	"horizontalstepper_base_step-indicator-container_flex-direction": "{flexDirection.row}",
	"horizontalstepper_base_step-indicator-container_justify-content": "{justifyContent.center}",
	"horizontalstepper_base_step-indicator-container_align-items": "{alignItems.center}",
	"horizontalstepper_base_step-indicator-container_size": "{size.max}",
	"horizontalstepper_base_step-indicator-container_padding-left": "{l}",
	"horizontalstepper_base_step-indicator-container_padding-right": "{l}",
	"horizontalstepper_base_stepper-children-container_size": "{size.max}",
	"horizontalstepper_base_stepper-children-container_flex-direction": "{flexDirection.row}",
	"horizontalstepper_base_stepper-children-container_justify-content": "{justifyContent.start}",
	"horizontalstepper_base_stepper-children-container_align-items": "{alignItems.center}"
};

const tablebody_base_container_width = "{size.max}";
const tablebody_variant_fullWidth_container_width = "{size.max}";
const TableBodyTokens = {
	tablebody_base_container_width: tablebody_base_container_width,
	"tablebody_base_container_flex-direction": "{flexDirection.row}",
	tablebody_variant_fullWidth_container_width: tablebody_variant_fullWidth_container_width
};

const table_base_container_width = "{size.max}";
const table_variant_fullWidth_container_width = "{size.max}";
const TableTokens = {
	"table_base_container_flex-direction": "{flexDirection.column}",
	table_base_container_width: table_base_container_width,
	"table_base_container_border-radius": "{medium}",
	"table_base_container_border-width": "{border_thin}",
	"table_base_container_border-color": "{primaryGrey40}",
	table_variant_fullWidth_container_width: table_variant_fullWidth_container_width
};

const tablerow_base_container_width = "{size.max}";
const tablerow_variant_fullWidth_container_width = "{size.max}";
const TableRowTokens = {
	"tablerow_base_container_flex-direction": "{flexDirection.column}",
	tablerow_base_container_width: tablerow_base_container_width,
	tablerow_variant_fullWidth_container_width: tablerow_variant_fullWidth_container_width
};

const TableCellTokens = {
	"tablecell_base_container_flex-direction": "{flexDirection.row}",
	"tablecell_base_container_justify-content": "{justifyContent.start}",
	"tablecell_base_container_align-items": "{alignItems.center}",
	"tablecell_base_container_background-color": "{global.transparent}",
	"tablecell_base_container_padding-left": "{base}",
	"tablecell_base_container_padding-right": "{base}",
	"tablecell_base_container_padding-top": "{base}",
	"tablecell_base_container_padding-bottom": "{base}",
	"tablecell_base_container_border-color": "{primaryGrey40}",
	"tablecell_variant_density_condensed_container_padding-left": "{xs}",
	"tablecell_variant_density_condensed_container_padding-right": "{xs}",
	"tablecell_variant_density_condensed_container_padding-top": "{xs}",
	"tablecell_variant_density_condensed_container_padding-bottom": "{xs}",
	"tablecell_combination_header_true_container_background-color": "{primary50}",
	"tablecell_combination_header_true_container_border-color": "{primary60}",
	"tablecell_combination_cell_true_container_background-color": "{primaryGrey20}"
};

const tabbar_base_container_width = "{size.max}";
const TabBarTokens = {
	"tabbar_base_container_flex-direction": "{flexDirection.stack}",
	tabbar_base_container_width: tabbar_base_container_width,
	"tabbar_base_indicator-container_width": "{size.max}",
	"tabbar_base_container_justify-content": "{justifyContent.start}",
	"tabbar_base_container_align-items": "{alignItems.end}",
	"tabbar_base_tab-container_width": "{size.max}",
	"tabbar_base_tab-container_opacity": "{opacity.enabled}",
	"tabbar_base_tab-container_background-color": "{global.transparent}",
	"tabbar_base_tab-container_align-items": "{alignItems.center}",
	"tabbar_base_tab-container_justify-content": "{justifyContent.start}",
	"tabbar_base_tab-container_gap": "{xxs}",
	"tabbar_base_tab-container_flex-direction": "{flexDirection.row}",
	"tabbar_base_outer-container_flex-direction": "{flexDirection.row}",
	"tabbar_base_outer-container_justify-content": "{justifyContent.start}",
	"tabbar_base_outer-container_align-items": "{alignItems.center}",
	"tabbar_base_outer-container_width": "{size.max}",
	"tabbar_base_inner-container_border-radius": "{pill}",
	"tabbar_base_inner-container_background-color": "{primary50}",
	"tabbar_base_inner-container_height": "{xxs}",
	"tabbar_variant_overflow_fit_tab-container_width": "{size.max}",
	"tabbar_variant_overflow_fit_tab-container_justify-content": "{justifyContent.center}",
	"tabbar_variant_appearance_tab_bar_tab-container_background-color": "{primary60}",
	"tabbar_variant_appearance_tab_bar_tab-container_padding-right": "{xxl}",
	"tabbar_variant_appearance_tab_bar_tab-container_padding-left": "{xxl}",
	"tabbar_variant_appearance_tab_bar_inner-container_background-color": "{custom_dark_primary_60}",
	"tabbar_combination_mobile_tab_bar_tab-container_padding-right": "{m}",
	"tabbar_combination_mobile_tab_bar_tab-container_padding-left": "{m}"
};

const tag_base_container_gap = "{xxs}";
const tag_base_icon_size = "{base}";
const tag_base_icon_color = "{primaryGrey100}";
const tag_base_icon_behavior_hover_color = "{sparkle80}";
const tag_base_icon_behavior_active_color = "{sparkle80}";
const tag_base_icon_behavior_focus_color = "{sparkle80}";
const tag_variant_active_true_icon_color = "{sparkle80}";
const tag_variant_disabled_true_container_opacity = "{opacity.disabled}";
const tag_base_container_opacity = "{opacity.enabled}";
const TagTokens = {
	"tag_base_container_flex-direction": "{flexDirection.row}",
	"tag_base_container_justify-content": "{justifyContent.start}",
	"tag_base_container_align-items": "{alignItems.center}",
	"tag_base_container_padding-top": "{xxs}",
	"tag_base_container_padding-left": "{s}",
	"tag_base_container_padding-right": "{s}",
	"tag_base_container_padding-bottom": "{xxs}",
	tag_base_container_gap: tag_base_container_gap,
	"tag_base_container_background-color": "{global.transparent}",
	"tag_base_container_border-radius": "{pill}",
	"tag_base_container_border-width": "{border_thin}",
	"tag_base_container_border-color": "{primaryGrey80}",
	"tag_base_container_behavior_hover_border-color": "{primaryGrey80}",
	"tag_base_container_behavior_active_border-color": "{sparkle20}",
	"tag_base_container_behavior_focus_border-color": "{sparkle80}",
	"tag_base_container_behavior_focus_border-width": "{border_focus}",
	tag_base_icon_size: tag_base_icon_size,
	tag_base_icon_color: tag_base_icon_color,
	tag_base_icon_behavior_hover_color: tag_base_icon_behavior_hover_color,
	tag_base_icon_behavior_active_color: tag_base_icon_behavior_active_color,
	tag_base_icon_behavior_focus_color: tag_base_icon_behavior_focus_color,
	"tag_variant_active_true_container_border-width": "{border_none}",
	"tag_variant_active_true_container_border-color": "{primaryGrey80}",
	"tag_variant_active_true_container_background-color": "{sparkle20}",
	"tag_variant_active_true_container_behavior_hover_background-color": "{sparkle30}",
	"tag_variant_active_true_container_behavior_active_background-color": "{global.transparent}",
	"tag_variant_active_true_container_behavior_active_border-color": "{primaryGrey40}",
	"tag_variant_active_true_container_behavior_focus_background-color": "{sparkle30}",
	tag_variant_active_true_icon_color: tag_variant_active_true_icon_color,
	tag_variant_disabled_true_container_opacity: tag_variant_disabled_true_container_opacity,
	tag_base_container_opacity: tag_base_container_opacity,
	"tag_variant_size_small_container_padding-top": "{custom_4}",
	"tag_variant_size_small_container_padding-left": "{xs}",
	"tag_variant_size_small_container_padding-right": "{xs}",
	"tag_variant_size_small_container_padding-bottom": "{custom_4}"
};

const tabsdesktop_base_container_width = "{size.max}";
const tabsdesktop_base_jds_tab_bar_width = "{size.max}";
const TabsDesktopTokens = {
	"tabsdesktop_base_container_flex-direction": "{flexDirection.column}",
	tabsdesktop_base_container_width: tabsdesktop_base_container_width,
	tabsdesktop_base_jds_tab_bar_width: tabsdesktop_base_jds_tab_bar_width,
	"tabsdesktop_base_header-container_flex-direction": "{flexDirection.row}",
	"tabsdesktop_base_header-container_width": "{size.max}",
	"tabsdesktop_base_header-container_align-items": "{alignItems.center}",
	"tabsdesktop_base_tablist-container_width": "{size.max}",
	"tabsdesktop_variant_overflow_arrows_header-container_gap": "{base}",
	"tabsdesktop_variant_appearance_tab_bar_header-container_background-color": "{primary60}"
};

const tabitem_base_container_gap = "{xs}";
const tabitem_base_icon_size = "{m}";
const tabitem_base_icon_color = "{primaryGrey80}";
const tabitem_base_icon_behavior_hover_color = "{primaryGrey100}";
const tabitem_base_icon_behavior_active_color = "{primary60}";
const tabitem_base_text_color = "{primaryGrey80}";
const tabitem_base_text_behavior_hover_color = "{primary60}";
const tabitem_variant_appearance_normal_text_behavior_hover_color = "{primaryGrey100}";
const tabitem_variant_appearance_normal_text_behavior_active_color = "{primary60}";
const tabitem_variant_appearance_tab_bar_icon_color = "{custom_dark_primary_grey_100}";
const tabitem_variant_appearance_tab_bar_icon_behavior_hover_color = "{custom_dark_primary_grey_80}";
const tabitem_variant_appearance_tab_bar_icon_behavior_active_color = "{custom_dark_primary_grey_100}";
const tabitem_variant_appearance_tab_bar_text_color = "{custom_dark_primary_grey_100}";
const tabitem_variant_appearance_tab_bar_text_behavior_hover_color = "{custom_dark_primary_grey_80}";
const tabitem_variant_appearance_tab_bar_text_behavior_active_color = "{custom_dark_primary_grey_100}";
const tabitem_combination_active_normal_icon_color = "{primaryGrey100}";
const tabitem_combination_active_normal_text_color = "{primaryGrey100}";
const TabItemTokens = {
	"tabitem_base_outer-container_background-color": "{global.transparent}",
	"tabitem_base_outer-container_flex-direction": "{flexDirection.column}",
	"tabitem_base_outer-container_align-items": "{alignItems.center}",
	"tabitem_base_outer-container_justify-content": "{justifyContent.center}",
	"tabitem_base_outer-container_min-height": "{xxl}",
	"tabitem_base_outer-container_width": "{intrinsicSize.max}",
	"tabitem_base_outer-container_height": "{intrinsicSize.max}",
	"tabitem_base_container_flex-direction": "{flexDirection.row}",
	"tabitem_base_container_align-items": "{alignItems.center}",
	"tabitem_base_container_justify-content": "{justifyContent.center}",
	tabitem_base_container_gap: tabitem_base_container_gap,
	"tabitem_base_container_padding-top": "{s}",
	"tabitem_base_container_padding-bottom": "{s}",
	"tabitem_base_container_padding-right": "{xs}",
	"tabitem_base_container_padding-left": "{xs}",
	"tabitem_base_container_behavior_focus_border-width": "{border_normal}",
	"tabitem_base_container_behavior_focus_border-color": "{primary80}",
	"tabitem_base_container_behavior_focus_border-radius": "{large}",
	tabitem_base_icon_size: tabitem_base_icon_size,
	tabitem_base_icon_color: tabitem_base_icon_color,
	tabitem_base_icon_behavior_hover_color: tabitem_base_icon_behavior_hover_color,
	tabitem_base_icon_behavior_active_color: tabitem_base_icon_behavior_active_color,
	tabitem_base_text_color: tabitem_base_text_color,
	"tabitem_base_text_font-size": "{bodyS}",
	"tabitem_base_text_font-family": "{bodyS}",
	"tabitem_base_text_font-weight": "{bodyS}",
	"tabitem_base_text_line-height": "{bodyS}",
	"tabitem_base_text_letter-spacing": "{bodyS}",
	tabitem_base_text_behavior_hover_color: tabitem_base_text_behavior_hover_color,
	"tabitem_base_indicator-container_background-color": "{global.transparent}",
	"tabitem_base_indicator-container_height": "{xxs}",
	"tabitem_base_indicator-container_width": "{size.max}",
	"tabitem_base_indicator-container_border-radius": "{pill}",
	"tabitem_base_outer-container_opacity": "{opacity.enabled}",
	"tabitem_variant_disabled_true_outer-container_opacity": "{opacity.disabled}",
	tabitem_variant_appearance_normal_text_behavior_hover_color: tabitem_variant_appearance_normal_text_behavior_hover_color,
	tabitem_variant_appearance_normal_text_behavior_active_color: tabitem_variant_appearance_normal_text_behavior_active_color,
	"tabitem_variant_appearance_tab_bar_container_behavior_active_background-color": "{custom_dark_primary_40}",
	"tabitem_variant_appearance_tab_bar_container_behavior_focus_border-color": "{custom_dark_primary_60}",
	tabitem_variant_appearance_tab_bar_icon_color: tabitem_variant_appearance_tab_bar_icon_color,
	tabitem_variant_appearance_tab_bar_icon_behavior_hover_color: tabitem_variant_appearance_tab_bar_icon_behavior_hover_color,
	tabitem_variant_appearance_tab_bar_icon_behavior_active_color: tabitem_variant_appearance_tab_bar_icon_behavior_active_color,
	tabitem_variant_appearance_tab_bar_text_color: tabitem_variant_appearance_tab_bar_text_color,
	tabitem_variant_appearance_tab_bar_text_behavior_hover_color: tabitem_variant_appearance_tab_bar_text_behavior_hover_color,
	tabitem_variant_appearance_tab_bar_text_behavior_active_color: tabitem_variant_appearance_tab_bar_text_behavior_active_color,
	tabitem_combination_active_normal_icon_color: tabitem_combination_active_normal_icon_color,
	tabitem_combination_active_normal_text_color: tabitem_combination_active_normal_text_color
};

const TooltipTokens = {
	"tooltip_base_popup-container_flex-direction": "{flexDirection.row}",
	"tooltip_base_popup-container_justify-content": "{justifyContent.start}",
	"tooltip_base_popup-container_align-items": "{alignItems.start}",
	"tooltip_base_root-container_flex-direction": "{flexDirection.row}",
	"tooltip_base_root-container_justify-content": "{justifyContent.start}",
	"tooltip_base_root-container_align-items": "{alignItems.center}",
	"tooltip_base_root-container_overflow": "hidden",
	"tooltip_base_text-container_border-radius": "{medium}",
	"tooltip_base_text-container_border-width": "{border_thin}",
	"tooltip_base_text-container_background-color": "{primaryGrey100}",
	"tooltip_base_start-tooltip_color": "{primaryGrey100}",
	"tooltip_base_end-tooltip_color": "{primaryGrey100}",
	"tooltip_base_text-container_padding-left": "{base}",
	"tooltip_base_text-container_padding-right": "{base}",
	"tooltip_base_text-container_padding-top": "{xs}",
	"tooltip_base_text-container_padding-bottom": "{xs}",
	"tooltip_variant_position_right_start_root-container_align-items": "{alignItems.start}",
	"tooltip_variant_position_right_start_start-tooltip_padding-top": "{xs}",
	"tooltip_variant_position_right_end_root-container_align-items": "{alignItems.end}",
	"tooltip_variant_position_right_end_start-tooltip_padding-bottom": "{xs}",
	"tooltip_variant_position_left_start_root-container_align-items": "{alignItems.start}",
	"tooltip_variant_position_left_start_end-tooltip_padding-top": "{xs}",
	"tooltip_variant_position_left_end_root-container_align-items": "{alignItems.end}",
	"tooltip_variant_position_left_end_end-tooltip_padding-bottom": "{xs}",
	"tooltip_variant_position_top_root-container_flex-direction": "{flexDirection.column}",
	"tooltip_variant_position_top_root-container_align-items": "{alignItems.center}",
	"tooltip_variant_position_top_start_root-container_flex-direction": "{flexDirection.column}",
	"tooltip_variant_position_top_start_root-container_align-items": "{alignItems.start}",
	"tooltip_variant_position_top_start_end-tooltip_padding-left": "{xs}",
	"tooltip_variant_position_top_end_root-container_flex-direction": "{flexDirection.column}",
	"tooltip_variant_position_top_end_root-container_align-items": "{alignItems.end}",
	"tooltip_variant_position_top_end_end-tooltip_padding-right": "{xs}",
	"tooltip_variant_position_bottom_root-container_flex-direction": "{flexDirection.column}",
	"tooltip_variant_position_bottom_root-container_align-items": "{alignItems.center}",
	"tooltip_variant_position_bottom_start_root-container_flex-direction": "{flexDirection.column}",
	"tooltip_variant_position_bottom_start_root-container_align-items": "{alignItems.start}",
	"tooltip_variant_position_bottom_start_start-tooltip_padding-left": "{xs}",
	"tooltip_variant_position_bottom_end_root-container_flex-direction": "{flexDirection.column}",
	"tooltip_variant_position_bottom_end_root-container_align-items": "{alignItems.end}",
	"tooltip_variant_position_bottom_end_start-tooltip_padding-right": "{xs}",
	"tooltip_base_text-container_min-height": "{xl}",
	"tooltip_base_text-container_align-items": "{alignItems.center}"
};

const ToggleTokens = {
	"toggle_base_prefix-icon-container_flex-direction": "{flexDirection.column}",
	"toggle_base_vertical-container_flex-direction": "{flexDirection.column}",
	"toggle_base_vertical-container_justify-content": "{justifyContent.start}",
	"toggle_base_vertical-container_align-items": "{alignItems.start}",
	"toggle_base_vertical-container_gap": "{xs}",
	"toggle_base_horizontal-container_flex-direction": "{flexDirection.row}",
	"toggle_base_horizontal-container_justify-content": "{justifyContent.start}",
	"toggle_base_horizontal-container_align-items": "{alignItems.center}",
	"toggle_base_horizontal-container_gap": "{xs}",
	"toggle_base_pill-container_min-width": "{custom_2}",
	"toggle_base_pill-container_min-height": "{m}",
	"toggle_base_pill-container_flex-direction": "{flexDirection.row}",
	"toggle_base_pill-container_justify-content": "{justifyContent.start}",
	"toggle_base_pill-container_align-items": "{alignItems.center}",
	"toggle_base_pill-container_padding-left": "{xxs}",
	"toggle_base_pill-container_padding-right": "{xxs}",
	"toggle_base_pill-container_background-color": "{global.transparent}",
	"toggle_base_pill-container_border-radius": "{pill}",
	"toggle_base_pill-container_border-width": "{border_thin}",
	"toggle_base_pill-container_border-color": "{primaryGrey80}",
	"toggle_base_pill-container_behavior_hover_border-color": "{primary40}",
	"toggle_base_pill-container_behavior_active_border-color": "{primary60}",
	"toggle_base_pill-container_behavior_focus_box-shadow_spread": "{xxs}",
	"toggle_base_pill-container_behavior_focus_box-shadow_color": "{primary60}",
	"toggle_base_pill-container_behavior_focus_border-width": "{border_none}",
	"toggle_base_ball-container_min-width": "{base}",
	"toggle_base_ball-container_min-height": "{base}",
	"toggle_base_ball-container_background-color": "{primaryGrey80}",
	"toggle_base_ball-container_border-radius": "{pill}",
	"toggle_base_left-jds_text_text-align": "{textAlign.start}",
	"toggle_variant_size_small_pill-container_min-width": "{custom_3}",
	"toggle_variant_size_small_pill-container_min-height": "{base}",
	"toggle_variant_size_small_vertical-container_gap": "{xxs}",
	"toggle_variant_size_small_ball-container_min-width": "{xs}",
	"toggle_variant_size_small_ball-container_min-height": "{xs}",
	"toggle_variant_checked_true_pill-container_justify-content": "{justifyContent.end}",
	"toggle_variant_checked_true_pill-container_background-color": "{primary50}",
	"toggle_variant_checked_true_pill-container_border-width": "{border_none}",
	"toggle_variant_checked_true_pill-container_behavior_hover_background-color": "{primary40}",
	"toggle_variant_checked_true_pill-container_behavior_active_background-color": "{primary60}",
	"toggle_variant_checked_true_ball-container_background-color": "{primaryInverse}",
	"toggle_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
	"toggle_base_vertical-container_opacity": "{opacity.enabled}"
};

const text_link_color = "{primary60}";
const text_base_text_color = "{primaryGrey100}";
const text_variant_color_primary_80_text_color = "{primary80}";
const text_variant_color_primary_70_text_color = "{primary70}";
const text_variant_color_primary_60_text_color = "{primary60}";
const text_variant_color_primary_50_text_color = "{primary50}";
const text_variant_color_primary_40_text_color = "{primary40}";
const text_variant_color_primary_30_text_color = "{primary30}";
const text_variant_color_primary_20_text_color = "{primary20}";
const text_variant_color_primary_inverse_text_color = "{primaryInverse}";
const text_variant_color_primary_background_text_color = "{primaryBackground}";
const text_variant_color_primary_grey_100_text_color = "{primaryGrey100}";
const text_variant_color_primary_grey_80_text_color = "{primaryGrey80}";
const text_variant_color_primary_grey_60_text_color = "{primaryGrey60}";
const text_variant_color_primary_grey_40_text_color = "{primaryGrey40}";
const text_variant_color_primary_grey_20_text_color = "{primaryGrey20}";
const text_variant_color_secondary_80_text_color = "{secondary80}";
const text_variant_color_secondary_70_text_color = "{secondary70}";
const text_variant_color_secondary_60_text_color = "{secondary60}";
const text_variant_color_secondary_50_text_color = "{secondary50}";
const text_variant_color_secondary_40_text_color = "{secondary40}";
const text_variant_color_secondary_30_text_color = "{secondary30}";
const text_variant_color_secondary_20_text_color = "{secondary20}";
const text_variant_color_secondary_inverse_text_color = "{secondaryInverse}";
const text_variant_color_secondary_background_text_color = "{secondaryBackground}";
const text_variant_color_secondary_grey_100_text_color = "{secondaryGrey100}";
const text_variant_color_secondary_grey_80_text_color = "{secondaryGrey80}";
const text_variant_color_secondary_grey_60_text_color = "{secondaryGrey60}";
const text_variant_color_secondary_grey_40_text_color = "{secondaryGrey40}";
const text_variant_color_secondary_grey_20_text_color = "{secondaryGrey20}";
const text_variant_color_sparkle_80_text_color = "{sparkle80}";
const text_variant_color_sparkle_70_text_color = "{sparkle70}";
const text_variant_color_sparkle_60_text_color = "{sparkle60}";
const text_variant_color_sparkle_50_text_color = "{sparkle50}";
const text_variant_color_sparkle_40_text_color = "{sparkle40}";
const text_variant_color_sparkle_30_text_color = "{sparkle30}";
const text_variant_color_sparkle_20_text_color = "{sparkle20}";
const text_variant_color_sparkle_inverse_text_color = "{sparkleInverse}";
const text_variant_color_sparkle_background_text_color = "{sparkleBackground}";
const text_variant_color_sparkle_grey_100_text_color = "{sparkleGrey100}";
const text_variant_color_sparkle_grey_80_text_color = "{sparkleGrey80}";
const text_variant_color_sparkle_grey_60_text_color = "{sparkleGrey60}";
const text_variant_color_sparkle_grey_40_text_color = "{sparkleGrey40}";
const text_variant_color_sparkle_grey_20_text_color = "{sparkleGrey20}";
const text_variant_color_feedback_error_80_text_color = "{feedbackError80}";
const text_variant_color_feedback_error_50_text_color = "{feedbackError50}";
const text_variant_color_feedback_error_20_text_color = "{feedbackError20}";
const text_variant_color_feedback_warning_80_text_color = "{feedbackWarning80}";
const text_variant_color_feedback_warning_50_text_color = "{feedbackWarning50}";
const text_variant_color_feedback_warning_20_text_color = "{feedbackWarning20}";
const text_variant_color_feedback_success_80_text_color = "{feedbackSuccess80}";
const text_variant_color_feedback_success_50_text_color = "{feedbackSuccess50}";
const text_variant_color_feedback_success_20_text_color = "{feedbackSuccess20}";
const text_variant_color_white_text_color = "{global.white}";
const text_variant_color_black_text_color = "{global.black}";
const text_variant_color_transparent_text_color = "{global.transparent}";
const TextTokens = {
	text_link_color: text_link_color,
	"text_base_text_font-family": "{bodyS}",
	text_base_text_color: text_base_text_color,
	"text_base_text_font-size": "{bodyS}",
	"text_base_text_line-height": "{bodyS}",
	"text_base_text_letter-spacing": "{bodyS}",
	"text_base_text_font-weight": "{bodyS}",
	"text_base_text_text-decoration": "{text-decoration.none}",
	"text_variant_textDecoration_underline_text_text-decoration": "{text-decoration.underline}",
	"text_variant_textDecoration_line-through_text_text-decoration": "{text-decoration.line-through}",
	"text_variant_textDecoration_overline_text_text-decoration": "{text-decoration.overline}",
	text_variant_color_primary_80_text_color: text_variant_color_primary_80_text_color,
	text_variant_color_primary_70_text_color: text_variant_color_primary_70_text_color,
	text_variant_color_primary_60_text_color: text_variant_color_primary_60_text_color,
	text_variant_color_primary_50_text_color: text_variant_color_primary_50_text_color,
	text_variant_color_primary_40_text_color: text_variant_color_primary_40_text_color,
	text_variant_color_primary_30_text_color: text_variant_color_primary_30_text_color,
	text_variant_color_primary_20_text_color: text_variant_color_primary_20_text_color,
	text_variant_color_primary_inverse_text_color: text_variant_color_primary_inverse_text_color,
	text_variant_color_primary_background_text_color: text_variant_color_primary_background_text_color,
	text_variant_color_primary_grey_100_text_color: text_variant_color_primary_grey_100_text_color,
	text_variant_color_primary_grey_80_text_color: text_variant_color_primary_grey_80_text_color,
	text_variant_color_primary_grey_60_text_color: text_variant_color_primary_grey_60_text_color,
	text_variant_color_primary_grey_40_text_color: text_variant_color_primary_grey_40_text_color,
	text_variant_color_primary_grey_20_text_color: text_variant_color_primary_grey_20_text_color,
	text_variant_color_secondary_80_text_color: text_variant_color_secondary_80_text_color,
	text_variant_color_secondary_70_text_color: text_variant_color_secondary_70_text_color,
	text_variant_color_secondary_60_text_color: text_variant_color_secondary_60_text_color,
	text_variant_color_secondary_50_text_color: text_variant_color_secondary_50_text_color,
	text_variant_color_secondary_40_text_color: text_variant_color_secondary_40_text_color,
	text_variant_color_secondary_30_text_color: text_variant_color_secondary_30_text_color,
	text_variant_color_secondary_20_text_color: text_variant_color_secondary_20_text_color,
	text_variant_color_secondary_inverse_text_color: text_variant_color_secondary_inverse_text_color,
	text_variant_color_secondary_background_text_color: text_variant_color_secondary_background_text_color,
	text_variant_color_secondary_grey_100_text_color: text_variant_color_secondary_grey_100_text_color,
	text_variant_color_secondary_grey_80_text_color: text_variant_color_secondary_grey_80_text_color,
	text_variant_color_secondary_grey_60_text_color: text_variant_color_secondary_grey_60_text_color,
	text_variant_color_secondary_grey_40_text_color: text_variant_color_secondary_grey_40_text_color,
	text_variant_color_secondary_grey_20_text_color: text_variant_color_secondary_grey_20_text_color,
	text_variant_color_sparkle_80_text_color: text_variant_color_sparkle_80_text_color,
	text_variant_color_sparkle_70_text_color: text_variant_color_sparkle_70_text_color,
	text_variant_color_sparkle_60_text_color: text_variant_color_sparkle_60_text_color,
	text_variant_color_sparkle_50_text_color: text_variant_color_sparkle_50_text_color,
	text_variant_color_sparkle_40_text_color: text_variant_color_sparkle_40_text_color,
	text_variant_color_sparkle_30_text_color: text_variant_color_sparkle_30_text_color,
	text_variant_color_sparkle_20_text_color: text_variant_color_sparkle_20_text_color,
	text_variant_color_sparkle_inverse_text_color: text_variant_color_sparkle_inverse_text_color,
	text_variant_color_sparkle_background_text_color: text_variant_color_sparkle_background_text_color,
	text_variant_color_sparkle_grey_100_text_color: text_variant_color_sparkle_grey_100_text_color,
	text_variant_color_sparkle_grey_80_text_color: text_variant_color_sparkle_grey_80_text_color,
	text_variant_color_sparkle_grey_60_text_color: text_variant_color_sparkle_grey_60_text_color,
	text_variant_color_sparkle_grey_40_text_color: text_variant_color_sparkle_grey_40_text_color,
	text_variant_color_sparkle_grey_20_text_color: text_variant_color_sparkle_grey_20_text_color,
	text_variant_color_feedback_error_80_text_color: text_variant_color_feedback_error_80_text_color,
	text_variant_color_feedback_error_50_text_color: text_variant_color_feedback_error_50_text_color,
	text_variant_color_feedback_error_20_text_color: text_variant_color_feedback_error_20_text_color,
	text_variant_color_feedback_warning_80_text_color: text_variant_color_feedback_warning_80_text_color,
	text_variant_color_feedback_warning_50_text_color: text_variant_color_feedback_warning_50_text_color,
	text_variant_color_feedback_warning_20_text_color: text_variant_color_feedback_warning_20_text_color,
	text_variant_color_feedback_success_80_text_color: text_variant_color_feedback_success_80_text_color,
	text_variant_color_feedback_success_50_text_color: text_variant_color_feedback_success_50_text_color,
	text_variant_color_feedback_success_20_text_color: text_variant_color_feedback_success_20_text_color,
	text_variant_color_white_text_color: text_variant_color_white_text_color,
	text_variant_color_black_text_color: text_variant_color_black_text_color,
	text_variant_color_transparent_text_color: text_variant_color_transparent_text_color,
	"text_variant_appearance_heading_xl_text_font-size": "{headingXl}",
	"text_variant_appearance_heading_xl_text_font-family": "{headingXl}",
	"text_variant_appearance_heading_xl_text_line-height": "{headingXl}",
	"text_variant_appearance_heading_xl_text_letter-spacing": "{headingXl}",
	"text_variant_appearance_heading_xl_text_font-weight": "{headingXl}",
	"text_variant_appearance_heading_l_text_font-size": "{headingL}",
	"text_variant_appearance_heading_l_text_font-family": "{headingL}",
	"text_variant_appearance_heading_l_text_line-height": "{headingL}",
	"text_variant_appearance_heading_l_text_letter-spacing": "{headingL}",
	"text_variant_appearance_heading_l_text_font-weight": "{headingL}",
	"text_variant_appearance_heading_m_text_font-size": "{headingM}",
	"text_variant_appearance_heading_m_text_font-family": "{headingM}",
	"text_variant_appearance_heading_m_text_line-height": "{headingM}",
	"text_variant_appearance_heading_m_text_letter-spacing": "{headingM}",
	"text_variant_appearance_heading_m_text_font-weight": "{headingM}",
	"text_variant_appearance_heading_s_text_font-size": "{headingS}",
	"text_variant_appearance_heading_s_text_font-family": "{headingS}",
	"text_variant_appearance_heading_s_text_line-height": "{headingS}",
	"text_variant_appearance_heading_s_text_letter-spacing": "{headingS}",
	"text_variant_appearance_heading_s_text_font-weight": "{headingS}",
	"text_variant_appearance_heading_xs_text_font-size": "{headingXs}",
	"text_variant_appearance_heading_xs_text_font-family": "{headingXs}",
	"text_variant_appearance_heading_xs_text_line-height": "{headingXs}",
	"text_variant_appearance_heading_xs_text_letter-spacing": "{headingXs}",
	"text_variant_appearance_heading_xs_text_font-weight": "{headingXs}",
	"text_variant_appearance_heading_xxs_text_font-size": "{headingXxs}",
	"text_variant_appearance_heading_xxs_text_font-family": "{headingXxs}",
	"text_variant_appearance_heading_xxs_text_line-height": "{headingXxs}",
	"text_variant_appearance_heading_xxs_text_letter-spacing": "{headingXxs}",
	"text_variant_appearance_heading_xxs_text_font-weight": "{headingXxs}",
	"text_variant_appearance_overline_text_font-size": "{overline}",
	"text_variant_appearance_overline_text_font-family": "{overline}",
	"text_variant_appearance_overline_text_line-height": "{overline}",
	"text_variant_appearance_overline_text_letter-spacing": "{overline}",
	"text_variant_appearance_overline_text_font-weight": "{overline}",
	"text_variant_appearance_overline_text_text-transform": "{overline}",
	"text_variant_appearance_body_l_text_font-size": "{bodyL}",
	"text_variant_appearance_body_l_text_font-family": "{bodyL}",
	"text_variant_appearance_body_l_text_line-height": "{bodyL}",
	"text_variant_appearance_body_l_text_letter-spacing": "{bodyL}",
	"text_variant_appearance_body_l_text_font-weight": "{bodyL}",
	"text_variant_appearance_body_l_bold_text_font-size": "{bodyLBold}",
	"text_variant_appearance_body_l_bold_text_font-family": "{bodyLBold}",
	"text_variant_appearance_body_l_bold_text_line-height": "{bodyLBold}",
	"text_variant_appearance_body_l_bold_text_letter-spacing": "{bodyLBold}",
	"text_variant_appearance_body_l_bold_text_font-weight": "{bodyLBold}",
	"text_variant_appearance_body_l_link_text_font-size": "{bodyLLink}",
	"text_variant_appearance_body_l_link_text_font-family": "{bodyLLink}",
	"text_variant_appearance_body_l_link_text_line-height": "{bodyLLink}",
	"text_variant_appearance_body_l_link_text_letter-spacing": "{bodyLLink}",
	"text_variant_appearance_body_l_link_text_font-weight": "{bodyLLink}",
	"text_variant_appearance_body_m_text_font-size": "{bodyM}",
	"text_variant_appearance_body_m_text_font-family": "{bodyM}",
	"text_variant_appearance_body_m_text_line-height": "{bodyM}",
	"text_variant_appearance_body_m_text_letter-spacing": "{bodyM}",
	"text_variant_appearance_body_m_text_font-weight": "{bodyM}",
	"text_variant_appearance_body_m_bold_text_font-size": "{bodyMBold}",
	"text_variant_appearance_body_m_bold_text_font-family": "{bodyMBold}",
	"text_variant_appearance_body_m_bold_text_line-height": "{bodyMBold}",
	"text_variant_appearance_body_m_bold_text_letter-spacing": "{bodyMBold}",
	"text_variant_appearance_body_m_bold_text_font-weight": "{bodyMBold}",
	"text_variant_appearance_body_m_link_text_font-size": "{bodyMLink}",
	"text_variant_appearance_body_m_link_text_font-family": "{bodyMLink}",
	"text_variant_appearance_body_m_link_text_line-height": "{bodyMLink}",
	"text_variant_appearance_body_m_link_text_letter-spacing": "{bodyMLink}",
	"text_variant_appearance_body_m_link_text_font-weight": "{bodyMLink}",
	"text_variant_appearance_body_s_text_font-size": "{bodyS}",
	"text_variant_appearance_body_s_text_font-family": "{bodyS}",
	"text_variant_appearance_body_s_text_line-height": "{bodyS}",
	"text_variant_appearance_body_s_text_letter-spacing": "{bodyS}",
	"text_variant_appearance_body_s_text_font-weight": "{bodyS}",
	"text_variant_appearance_body_s_bold_text_font-size": "{bodySBold}",
	"text_variant_appearance_body_s_bold_text_font-family": "{bodySBold}",
	"text_variant_appearance_body_s_bold_text_line-height": "{bodySBold}",
	"text_variant_appearance_body_s_bold_text_letter-spacing": "{bodySBold}",
	"text_variant_appearance_body_s_bold_text_font-weight": "{bodySBold}",
	"text_variant_appearance_body_s_link_text_font-size": "{bodySLink}",
	"text_variant_appearance_body_s_link_text_font-family": "{bodySLink}",
	"text_variant_appearance_body_s_link_text_line-height": "{bodySLink}",
	"text_variant_appearance_body_s_link_text_letter-spacing": "{bodySLink}",
	"text_variant_appearance_body_s_link_text_font-weight": "{bodySLink}",
	"text_variant_appearance_body_xs_text_font-size": "{bodyXs}",
	"text_variant_appearance_body_xs_text_font-family": "{bodyXs}",
	"text_variant_appearance_body_xs_text_line-height": "{bodyXs}",
	"text_variant_appearance_body_xs_text_letter-spacing": "{bodyXs}",
	"text_variant_appearance_body_xs_text_font-weight": "{bodyXs}",
	"text_variant_appearance_body_xs_bold_text_font-size": "{bodyXsBold}",
	"text_variant_appearance_body_xs_bold_text_font-family": "{bodyXsBold}",
	"text_variant_appearance_body_xs_bold_text_line-height": "{bodyXsBold}",
	"text_variant_appearance_body_xs_bold_text_letter-spacing": "{bodyXsBold}",
	"text_variant_appearance_body_xs_bold_text_font-weight": "{bodyXsBold}",
	"text_variant_appearance_body_xs_link_text_font-size": "{bodyXsLink}",
	"text_variant_appearance_body_xs_link_text_font-family": "{bodyXsLink}",
	"text_variant_appearance_body_xs_link_text_line-height": "{bodyXsLink}",
	"text_variant_appearance_body_xs_link_text_letter-spacing": "{bodyXsLink}",
	"text_variant_appearance_body_xs_link_text_font-weight": "{bodyXsLink}",
	"text_variant_appearance_body_xs_caps_text_font-family": "{bodyXs}",
	"text_variant_appearance_body_xs_caps_text_line-height": "{bodyXs}",
	"text_variant_appearance_body_xs_caps_text_text-transform": "{bodyS}",
	"text_variant_appearance_body_xs_caps_text_letter-spacing": "{bodyXs}",
	"text_variant_appearance_body_xs_caps_text_font-weight": "{bodyXs}",
	"text_variant_appearance_body_xxs_text_font-size": "{bodyXxs}",
	"text_variant_appearance_body_xxs_text_font-family": "{bodyXxs}",
	"text_variant_appearance_body_xxs_text_line-height": "{bodyXxs}",
	"text_variant_appearance_body_xxs_text_letter-spacing": "{bodyXxs}",
	"text_variant_appearance_body_xxs_text_font-weight": "{bodyXxs}",
	"text_variant_appearance_body_xxs_bold_text_font-size": "{bodyXxsBold}",
	"text_variant_appearance_body_xxs_bold_text_font-family": "{bodyXxsBold}",
	"text_variant_appearance_body_xxs_bold_text_line-height": "{bodyXxsBold}",
	"text_variant_appearance_body_xxs_bold_text_letter-spacing": "{bodyXxsBold}",
	"text_variant_appearance_body_xxs_bold_text_font-weight": "{bodyXxsBold}",
	"text_variant_appearance_body_xxs_link_text_font-size": "{bodyXxsLink}",
	"text_variant_appearance_body_xxs_link_text_font-family": "{bodyXxsLink}",
	"text_variant_appearance_body_xxs_link_text_line-height": "{bodyXxsLink}",
	"text_variant_appearance_body_xxs_link_text_letter-spacing": "{bodyXxsLink}",
	"text_variant_appearance_body_xxs_link_text_font-weight": "{bodyXxsLink}",
	"text_variant_appearance_list_title_text_font-size": "{listTitle}",
	"text_variant_appearance_list_title_text_font-family": "{listTitle}",
	"text_variant_appearance_list_title_text_line-height": "{listTitle}",
	"text_variant_appearance_list_title_text_letter-spacing": "{listTitle}",
	"text_variant_appearance_list_title_text_font-weight": "{listTitle}",
	"text_variant_appearance_button_text_font-size": "{button}",
	"text_variant_appearance_button_text_font-family": "{button}",
	"text_variant_appearance_button_text_line-height": "{button}",
	"text_variant_appearance_button_text_letter-spacing": "{button}",
	"text_variant_appearance_button_text_font-weight": "{button}",
	"text_variant_appearance_code_text_font-size": "{code}",
	"text_variant_appearance_code_text_font-family": "{code}",
	"text_variant_appearance_code_text_line-height": "{code}",
	"text_variant_appearance_code_text_letter-spacing": "{code}",
	"text_variant_appearance_code_text_font-weight": "{code}",
	"text_variant_appearance_body_s_regular_para_text_font-size": "{bodyS}",
	"text_variant_appearance_body_s_regular_para_text_line-height": "{bodyS}",
	"text_variant_appearance_body_s_regular_para_text_letter-spacing": "{bodyS}",
	"text_variant_appearance_body_s_regular_para_text_font-weight": "{bodyS}",
	"text_variant_appearance_body_s_regular_para_text_font-family": "{bodyS}"
};

const RatingBarTokens = {
	"ratingbar_base_vertical-container_flex-direction": "{flexDirection.column}",
	"ratingbar_base_vertical-container_align-items": "{alignItems.start}",
	"ratingbar_base_vertical-container_justify-content": "{justifyContent.start}",
	"ratingbar_base_vertical-container_gap": "{xxs}",
	"ratingbar_base_horizontal-container_flex-direction": "{flexDirection.row}",
	"align-items": "{alignItems.center}",
	"ratingbar_base_horizontal-container_justify-content": "{justifyContent.start}",
	"ratingbar_base_horizontal-container_gap": "{xs}",
	"ratingbar_base_rating-bar-container_flex-direction": "{flexDirection.row}",
	"ratingbar_variant_size_small_vertical-container_gap": "{xxs}",
	"ratingbar_variant_size_small_horizontal-container_gap": "{xs}",
	"ratingbar_variant_labelPosition_bottom_center_vertical-container_align-items": "{alignItems.center}",
	"ratingbar_variant_labelPosition_top_center_vertical-container_align-items": "{alignItems.center}",
	"ratingbar_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
	"ratingbar_combination_read_only_expanded_small_horizontal-container_gap": "{xxs}",
	"ratingbar_combination_read_only_expanded_small_vertical-container_gap": "{xxs}",
	"ratingbar_combination_read_only_expanded_medium_vertical-container_gap": "{xs}",
	"ratingbar_combination_read_only_expanded_medium_horizontal-container_gap": "{xs}",
	"ratingbar_combination_read_only_expanded_large_vertical-container_gap": "{xs}",
	"ratingbar_combination_read_only_expanded_large_horizontal-container_gap": "{xs}",
	"ratingbar_combination_read_only_compact_small_horizontal-container_gap": "{xxs}",
	"ratingbar_combination_read_only_compact_small_vertical-container_gap": "{xxs}",
	"ratingbar_combination_read_only_compact_medium_vertical-container_gap": "{xs}",
	"ratingbar_combination_read_only_compact_medium_horizontal-container_gap": "{xs}",
	"ratingbar_combination_read_only_compact_large_vertical-container_gap": "{xs}",
	"ratingbar_combination_read_only_compact_large_horizontal-container_gap": "{xs}",
	"ratingbar_base_horizontal-container_align-items": "{alignItems.center}"
};

const ratingBarItem_variant_size_small_start_icon_size = "{m}";
const ratingBarItem_variant_size_small_end_icon_size = "{m}";
const ratingBarItem_variant_size_large_start_icon_size = "{xl}";
const ratingBarItem_variant_size_large_end_icon_size = "{xl}";
const ratingBarItem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color = "{primaryGrey60}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color = "{primaryGrey60}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color = "{primaryGrey60}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color = "{primaryGrey60}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color = "{primaryGrey80}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color = "{primaryGrey80}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color = "{primaryGrey80}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color = "{primaryGrey80}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color = "{primaryGrey60}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color = "{primaryGrey60}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color = "{primary50}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color = "{primary50}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color = "{primary70}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color = "{primary70}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color = "{primary60}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color = "{primary60}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color = "{primary50}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color = "{primary50}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color = "{primary70}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color = "{primary70}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color = "{primary70}";
const ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color = "{primary70}";
const ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color = "{primaryGrey80}";
const ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color = "{primaryGrey60}";
const RatingBarItemTokens = {
	"ratingBarItem_base_container_flex-direction": "{flexDirection.stack}",
	"ratingBarItem_base_container_behavior_focus_border-width": "{border_focus}",
	"ratingBarItem_base_container_behavior_focus_border-color": "{primary60}",
	ratingBarItem_variant_size_small_start_icon_size: ratingBarItem_variant_size_small_start_icon_size,
	ratingBarItem_variant_size_small_end_icon_size: ratingBarItem_variant_size_small_end_icon_size,
	ratingBarItem_variant_size_large_start_icon_size: ratingBarItem_variant_size_large_start_icon_size,
	ratingBarItem_variant_size_large_end_icon_size: ratingBarItem_variant_size_large_end_icon_size,
	ratingBarItem_variant_disabled_true_container_opacity: ratingBarItem_variant_disabled_true_container_opacity,
	ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color,
	"ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_container_behavior_focus_border-width": "{border_focus}",
	"ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_container_behavior_focus_border-width": "{border_focus}",
	"ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_container_behavior_focus_border-color": "{primary60}",
	"ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_container_behavior_focus_border-color": "{primary60}",
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color,
	"ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_container_behavior_focus_border-color": "{primary60}",
	"ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_container_behavior_focus_border-color": "{primary60}",
	"ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_container_behavior_focus_border-width": "{border_focus}",
	"ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_container_behavior_focus_border-width": "{border_focus}",
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color,
	ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color: ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color,
	ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color: ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color,
	ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color: ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color
};

const JSON_MAP = {
  JDSActionButton: ActionButtonTokens,
  JDSAvatar: AvatarTokens,
  JDSAvatarV2Default: AvatarV2DefaultTokens,
  JDSAccordionList: AccordionListTokens,
  JDSMobileBottomSheet: MobileBottomSheetTokens,
  JDSMobileBottomSheetInternal: MobileBottomSheetTokens,
  JDSBadge: BadgeTokens,
  JDSBadgeV2Brand: BadgeV2BrandTokens,
  JDSBadgeV2Information: BadgeV2InformationTokens,
  JDSBadgeV2Notification: BadgeV2NotificationTokens,
  JDSBadgeV2Status: BadgeV2StatusTokens,
  JDSDesktopBottomSheet: DesktopBottomSheetTokens,
  JDSDesktopBottomSheetInternal: DesktopBottomSheetTokens,
  JDSBreadcrumbs: BreadcrumbsTokens,
  JDSCarousel: CarouselTokens,
  JDSCarouselPagination: CarouselPaginationTokens,
  JDSButton: ButtonTokens,
  JDSCarouselPaginationItem: CarouselPaginationItemTokens,
  JDSCarouselSlide: CarouselSlideTokens,
  JDSCheckbox: CheckboxTokens,
  JDSContentBlock: ContentBlockTokens,
  JDSDatepickerButton: DatepickerButtonTokens,
  JDSContentCard: ContentCardTokens,
  JDSDatepickerCalendarButton: DatepickerCalendarButtonTokens,
  JDSDatepickerCalendar: DatepickerCalendarTokens,
  JDSDatepickerCalendarRow: DatepickerCalendarRowTokens,
  JDSAccordion: AccordionTokens,
  JDSDatepickerCalendarHeader: DatepickerCalendarHeaderTokens,
  JDSDatepickerDesktop: DatepickerDesktopTokens,
  JDSDatepickerDesktopInternal: DatepickerDesktopTokens,
  JDSDatepickerHeader: DatepickerHeaderTokens,
  JDSDatepickerYearView: DatepickerYearViewTokens,
  JDSDatepickerMonthView: DatepickerMonthViewTokens,
  JDSDatepickerMobile: DatepickerMobileTokens,
  JDSDatepickerMobileInteral: DatepickerMobileTokens,
  JDSDivider: DividerTokens,
  JDSDatepickerViewButton: DatepickerViewButtonTokens,
  JDSFAB: FABTokens,
  JDSFABInternal: FABTokens,
  JDSDropdown: DropdownTokens,
  JDSDropdownMenu: DropdownMenuTokens,
  JDSDropdownMenuInternal: DropdownMenuTokens,
  JDSDropdownMenuItem: DropdownMenuItemTokens,
  JDSDropdownMenuItemMobile: DropdownMenuItemTokens,
  JDSDropdownMenuGroup: DropdownMenuGroupTokens,
  JDSDropdownMenuSubMenu: DropdownMenuSubMenuTokens,
  JDSFeedbackBlock: FeedbackBlockTokens,
  JDSBottomFooterLinkItem: BottomFooterLinkItemTokens,
  JDSFooterIconLinks: FooterIconLinksTokens,
  JDSFooter: FooterTokens,
  JDSBottomFooter: BottomFooterTokens,
  JDSFooterLinksGrid: FooterLinksGridTokens,
  JDSFooterLinks: FooterLinksTokens,
  JDSIcon: IconTokens,
  JDSFooterMarketLinks: FooterMarketLinksTokens,
  JDSImage: ImageTokens,
  JDSInput: InputTokens,
  JDSInputCodeItem: InputCodeItemTokens,
  JDSInputDate: InputDateTokens,
  JDSLink: LinkTokens,
  JDSFileUploader: FileUploaderTokens,
  JDSFileUploaderControl: FileUploaderControlTokens,
  JDSFileUploaderItem: FileUploaderItemTokens,
  JDSFileUploaderList: FileUploaderListTokens,
  JDSFileUploaderPanel: FileUploaderPanelTokens,
  JDSMenuBlock: MenuBlockTokens,
  JDSMenuBlockInternal: MenuBlockTokens,
  JDSListBlock: ListBlockTokens,
  JDSInputField: InputFieldTokens,
  JDSInputFieldV2: InputFieldV2Tokens,
  JDSModalDesktop: ModalDesktopTokens,
  JDSModalDesktopInternal: ModalDesktopTokens,
  JDSMenuBlockItem: MenuBlockItemTokens,
  JDSModalMobile: ModalMobileTokens,
  JDSModalMobileInternal: ModalMobileTokens,
  JDSHeaderDesktop: HeaderDesktopTokens,
  JDSBottomNavigation: BottomNavigationTokens,
  JDSBottomNavigationItem: BottomNavigationItemTokens,
  JDSMegaMenu: MegaMenuTokens,
  JDSMegaMenuInternal: MegaMenuTokens,
  JDSHeaderMobile: HeaderMobileTokens,
  JDSMegaMenuItem: MegaMenuItemTokens,
  JDSTextarea: TextareaTokens,
  JDSSidePanelItem: SidePanelItemTokens,
  JDSMegaMenuBlock: MegaMenuBlockTokens,
  JDSNotificationButton: NotificationButtonTokens,
  JDSNotificationBanner: NotificationBannerTokens,
  JDSNudgeContainer: NudgeContainerTokens,
  JDSToastContainer: ToastContainerTokens,
  JDSToast: ToastTokens,
  JDSNudge: NudgeTokens,
  JDSPagination: PaginationTokens,
  JDSPromoCard: PromoCardTokens,
  JDSSidePanel: SidePanelTokens,
  JDSSidePanelInternal: SidePanelTokens,
  JDSProgressBar: ProgressBarTokens,
  JDSSearchBox: SearchBoxTokens,
  JDSPaginationButton: PaginationButtonTokens,
  JDSSearchResultItem: SearchResultItemTokens,
  JDSSearchResultText: SearchResultTextTokens,
  JDSRadioButton: RadioButtonTokens,
  JDSSelector: SelectorTokens,
  JDSSelectorItem: SelectorItemTokens,
  JDSSearchResults: SearchResultsTokens,
  JDSSearchResultsInternal: SearchResultsTokens,
  JDSSkeleton: SkeletonTokens,
  JDSServiceCard: ServiceCardTokens,
  JDSNotificationIconButton: NotificationIconButtonTokens,
  JDSSpinner: SpinnerTokens,
  JDSSelectorButton: SelectorButtonTokens,
  JDSSlider: SliderTokens,
  JDSStepperDot: StepperDotTokens,
  JDSHorizontalStepItem: HorizontalStepItemTokens,
  JDSVerticalStepItem: VerticalStepItemTokens,
  JDSTableCell: TableCellTokens,
  JDSTableBody: TableBodyTokens,
  JDSTableRow: TableRowTokens,
  JDSTabBar: TabBarTokens,
  JDSVerticalStepper: VerticalStepperTokens,
  JDSTabItem: TabItemTokens,
  JDSTabsDesktop: TabsDesktopTokens,
  JDSTag: TagTokens,
  JDSHorizontalStepper: HorizontalStepperTokens,
  JDSTable: TableTokens,
  JDSToggle: ToggleTokens,
  JDSText: TextTokens,
  JDSTooltip: TooltipTokens,
  JDSTooltipInternal: TooltipTokens,
  JDSInputCode: InputCodeTokens,
  JDSRatingBar: RatingBarTokens,
  JDSRatingBarItem: RatingBarItemTokens
};

export { JSON_MAP, index as tokens };
